webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/DicBpo/%3F1718077835949&title=Then%20We%20Take%20Berlin&summary=%26ldquo%3BA%20stylish%20spy%20thriller%26rdquo%3B%20of%20postwar%20Berlin%26mdash%3Bthe%20first%20in%20a%20thrilling%20new%20series%20from%20the%20acclaimed%20author%20of%20the%20Inspector%20Troy%20Novels%20%28TheNew%20York%20Times%20Book%20Review%29.%20%26%23160%3B%20John%20Wilfrid%20Holderness%26mdash%3B&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/DicBpo/%3F1718077835949",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=%26ldquo%3BA%20stylish%20spy%20thriller%26rdquo%3B%20of%20postwar%20Berlin%26mdash%3Bthe%20first%20in%20a%20thrilling%20new%20series%20from%20the%20acclaimed%20author%20of%20the%20Inspector%20T%0Dhttps://textcafe.co/books/DicBpo/%3F1718077835949&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/DicBpo/%3F1718077835949&posttype=link&caption=%26ldquo%3BA%20stylish%20spy%20thriller%26rdquo%3B%20of%20postwar%20Berlin%26mdash%3Bthe%20first%20in%20a%20thrilling%20new%20series%20from%20the%20acclaimed%20author%20of%20the%20Inspector%20Troy%20Novels%20%28TheNew%20York%20Times%20Book%20Review%29.%20%26%23160%3B%20John%20Wilfrid%20Holderness%26mdash%3B",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/DicBpo/%3F1718077835949&description=%26ldquo%3BA%20stylish%20spy%20thriller%26rdquo%3B%20of%20postwar%20Berlin%26mdash%3Bthe%20first%20in%20a%20thrilling%20new%20series%20from%20the%20acclaimed%20author%20of%20the%20Inspector%20Troy%20Novels%20%28TheNew%20York%20Times%20Book%20Review%29.%20%26%23160%3B%20John%20Wilfrid%20Holderness%26mdash%3B&media=https://textcafe.co/books/DicBpo/tc-custom/9780802193087.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780802193087&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=dSBpTGnFR2QC&amp;rdid=book-dSBpTGnFR2QC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780802193087').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/DicBpo/tc-custom/9780802193087.jpg?1718077835949',
        alt: 'Then We Take Berlin'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "Epub4211", "groveatlanticlithub", "love_1", "Epub42111", "Epub42112", "Epub42113", "Epub42114", "Epub42115", "Epub42116", "Epub42117", "Epub42118", "Epub42119", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/DicBpo/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Epub4211__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Epub4211___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Epub4211__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_groveatlanticlithub__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_groveatlanticlithub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_groveatlanticlithub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Epub42111__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Epub42111___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Epub42111__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Epub42112__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Epub42112___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Epub42112__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Epub42113__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Epub42113___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Epub42113__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Epub42114__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Epub42114___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Epub42114__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Epub42115__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Epub42115___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Epub42115__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Epub42116__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Epub42116___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Epub42116__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Epub42117__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Epub42117___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Epub42117__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Epub42118__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Epub42118___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Epub42118__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Epub42119__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Epub42119___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Epub42119__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Epub421110__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Epub421110___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Epub421110__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Epub421111__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Epub421111___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Epub421111__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Epub421112__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Epub421112___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Epub421112__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_love_2__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_last__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_last__);
/*jshint esversion: 6 */























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/Epub4211",
    "name": "Epub4211",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_Epub4211___default.a
  }, {
    "path": "/groveatlanticlithub",
    "name": "groveatlanticlithub",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_groveatlanticlithub___default.a
  }, {
    "path": "/love_1",
    "name": "love_1",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_love_1___default.a
  }, {
    "path": "/Epub42111",
    "name": "Epub42111",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_Epub42111___default.a
  }, {
    "path": "/Epub42112",
    "name": "Epub42112",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_Epub42112___default.a
  }, {
    "path": "/Epub42113",
    "name": "Epub42113",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_Epub42113___default.a
  }, {
    "path": "/Epub42114",
    "name": "Epub42114",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Epub42114___default.a
  }, {
    "path": "/Epub42115",
    "name": "Epub42115",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Epub42115___default.a
  }, {
    "path": "/Epub42116",
    "name": "Epub42116",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Epub42116___default.a
  }, {
    "path": "/Epub42117",
    "name": "Epub42117",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Epub42117___default.a
  }, {
    "path": "/Epub42118",
    "name": "Epub42118",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Epub42118___default.a
  }, {
    "path": "/Epub42119",
    "name": "Epub42119",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Epub42119___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Lawton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Lawton is the author of ten novels, including "), _c('I', [_vm._v("Second Violin")]), _vm._v(", "), _c('I', [_vm._v("Flesh Wounds")]), _vm._v(", and "), _c('I', [_vm._v("Bluffing Mr. Churchill")]), _vm._v(". His thriller "), _c('I', [_vm._v("Black Out")]), _vm._v(" won a WH Smith Fresh Talent Award, "), _c('I', [_vm._v("A Little White Death")]), _vm._v(" was named a "), _c('I', [_vm._v("New York Times")]), _vm._v(" Notable Book, and his latest novel "), _c('I', [_vm._v("A Lily of the Field")]), _vm._v(" was named one of the best thrillers of the year by Marilyn Stasio of the"), _c('I', [_vm._v(" New York Times")]), _vm._v(". At the moment he lives in Derbyshire, England, but can often be found (or lost) elsewhere.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DicBpo/tc-custom/9780802193087.jpg?1718077835949",
      "alt": "This image is the cover for the book Then We Take Berlin"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Then We Take Berlin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A stylish spy thriller” of postwar Berlin—the first in a thrilling new series from the acclaimed author of the Inspector Troy Novels ("), _c('i', [_vm._v("The")]), _c('i', [_vm._v("New York Times Book Review")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" John Wilfrid Holderness—aka Joe Wilderness—was a young Cockney cardsharp surviving the London Blitz before he started crisscrossing war-torn Europe as an MI6 agent. With the war over, he’s become a “free-agent gumshoe” weathering Cold War fears and hard-luck times. But now he’s being drawn back into the secret ops business when an ex-CIA agent asks him to spearhead one last venture: smuggle a vulnerable woman out of East Berlin."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Arriving in Germany, Wilderness soon discovers he’s being played as a pawn in a deadly game of atomic proportions. To survive, he must follow a serpentine trail through his own past, into the confidence of an unexpected lover, and go dangerously deep into a black market scam the likes of which Berlin has never seen."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The author of the acclaimed Inspector Troy Novels, “Lawton’s gift for atmosphere, memorable characters and intelligent plotting has been compared to John le Carré. . . . Never mind the comparisons—Lawton can stand up on his own, and "), _c('i', [_vm._v("Then We Take Berlin")]), _vm._v(" is a gem” ("), _c('i', [_vm._v("The Seattle Times")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[The Joe Wilderness novels] are meticulously researched, tautly plotted, historical thrillers in the mold of . . . Alan Furst, Phillip Kerr, Eric Ambler, David Downing and Joseph Kanon.” —"), _c('i', [_vm._v("The Wall Street Journal")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[It] will thrill readers with an interest in WWII and the early Cold War era.” —"), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(", starred review"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “A wonderfully complex and nuanced thriller.” —"), _c('i', [_vm._v("Kirkus Reviews")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove/Atlantic Inc.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "THENWETAKEFront.jpg",
      "height": "633",
      "src": "images/THENWETAKEFront_fmt.jpeg",
      "width": "419"
    }
  })])])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-inside": "avoid",
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://link.lithub.com/join/signup?utm_campaign=9780802193087",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "grove-atlantic-lithub-creative.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-inside": "avoid",
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/freebook/index.html?q=5ab206872ad4b3e3d0ae34f3&utm_campaign=front",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "love-grove-atlantic.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-1.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("THEN WE "), _c('br'), _vm._v("TAKE BERLIN")])])])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Also by John Lawton")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("1963")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Black Out")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Old Flames")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("A Little White Death")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Bluffing Mr. Churchill")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Sweet Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flesh Wounds")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Second Violin")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("A Lily of the Field")])])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-3.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("THEN WE "), _c('br'), _vm._v("TAKE BERLIN")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("John Lawton")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-3"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "L-1.tif",
      "height": "23",
      "src": "images/L-1_fmt.png",
      "width": "26"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("Atlantic Monthly Press")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New York")])])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I para-style-override-4",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("Copyright © 2013 by John Lawton")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-5"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by "), _c('br'), _vm._v("any electronic or mechanical means, including information storage and retrieval "), _c('br'), _vm._v("systems, without permission in writing from the publisher, except by a reviewer, "), _c('br'), _vm._v("who may quote brief passages in a review. Scanning, uploading, and electronic "), _c('br'), _vm._v("distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, "), _c('br'), _vm._v("and do not participate in or encourage electronic piracy of copyrighted "), _c('br'), _vm._v("materials. Your support of the author’s rights is appreciated. Any member of "), _c('br'), _vm._v("educational institutions wishing to photocopy part or all of the work for "), _c('br'), _vm._v("classroom use, or anthology, should send inquiries to "), _c('br'), _vm._v("Grove/Atlantic, Inc., 154 West 14th Street, New York, NY 10011 or "), _c('br')]), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("permissions@groveatlantic.com")])]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("eBook ISBN-13: 978-0-8021-9308-7")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Atlantic Monthly Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("154 West 14th Street")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("New York, NY 10011")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-7"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Distributed by Publishers Group West")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-7"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("www.groveatlantic.com")])])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("for")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below para-style-override-8"
  }, [_c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("ore Vidal")])]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT para-style-override-9"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("1925–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("Who helped kick me into shape.")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("The planet has lost its ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("most barbed critic. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("The job of world-class ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("pain-in-the-arse is now vacant.")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-6.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("THEN WE "), _c('br'), _vm._v("TAKE BERLIN")])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-7.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-8"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("“ . . . Never tell all you feel, or (a better way still), feel very little . . ."), _c('br'), _vm._v("at any rate never have any feelings which may make you "), _c('br'), _vm._v("uncomfortable, or make any promises which you cannot at any ")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("required moment command and withdraw. That is the way to get on . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("William Makepeace Thackeray: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Vanity Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("1847")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-8"
  }, [_vm._v("“Wer spricht von Siegen? Überstehen ist Alles.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("Rainer Maria Rilke: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Requiem, für Wolf Graf von Kalckreuth")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("1908")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-8"
  }, [_vm._v("“The warriors are dead. The warriors died in two world wars. "), _c('br'), _vm._v("Those who remain are the barterers. They know the price of "), _c('br'), _vm._v("coffee and cocoa and sugar and flour in a defeated country.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("Kay Boyle: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Lovers of Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("1950")])])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-8.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-9"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "PT para-style-override-11"
  }, [_vm._v("First We Take Manhattan")]), _vm._v(" "), _c('p', {
    staticClass: "P-EPI-01"
  }, [_vm._v("“The city seen from the Queensboro Bridge is always")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02"
  }, [_vm._v("the city seen for the first time, in its first wild promise")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02"
  }, [_vm._v("of all the mystery and beauty in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("F. Scott Fitzgerald: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Great Gatsby")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-12"
  }, [_vm._v("1925")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§1")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("West Berlin")]), _vm._v(": May 1963 ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Christina Hélène von Raeder Burkhardt had too many names, so was known simply as Nell. She was attending the first of her twice weekly meetings with the mayor to agree an itinerary for the impending visit of President Kennedy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“McGeorge Bundy gives me a headache.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t get on with Bundy, Nell?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I get on very well with Bundy—one of the best—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or the brightest . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whichever . . . I get on well with him, but it does seem to me that his job is simply to say ‘no.’ Whatever I suggest he says cannot or should not be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Such as?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suggested a visit to Bernauer Straße . . . where the wall began, as it were . . . and where it claimed its first victims.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not a bad idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bundy won’t let the president do it—instead we get JFK’s sister. She’ll visit Bernauer Straße.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We agreed to that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course—it’s better than nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell . . . what is it you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a generous question. Mayor Brandt had his agenda for this visit—everyone had, from the man who swept the streets to the Chief of Police—yet still he was asking to hear hers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I want President Kennedy to visit "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("all")]), _vm._v(" the Berlins—all the Berlins I know as a Berliner. Berlin new and Berlin old. I would ask that he visit the city we rebuilt . . . to look at the Kurfürstendamm as well as the Reichstag ruins. I would ask that he see and be seen. I would ask that he visit Berlin West and Berlin East.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The East?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Through Checkpoint Charlie. He has every right to pass through.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Imagine the embarrassment when he’s asked to produce his passport.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would they dare?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. Nell, have you actually suggested a visit to the Soviet Sector?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes. Ages ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Bundy said it would be the one idea he’d never put before Kennedy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Russians never pass up a chance for a stunt. And if we did that we’d be pulling a stunt too. And the only point to a stunt is not to be upstaged. Going East would give them every opportunity to upstage us. And if we don’t go East . . . if we stay ‘home’ and peer over the wall they’ll still stage something. There’ll be an ‘incident’ of some sort. Imagine. Kennedy waves to Berliners through the Brandenburg Gate and Khrushchev waves back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell smiled at the image. So often Willy Brandt cracked a joke only as a prelude to the deadly serious.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Everything is ambivalent,” Brandt was saying. “Kennedy visits a Berlin renewed and a Berlin divided. A Berlin defiant and a Berlin besieged. Everything about this visit is double-edged. Except this . . . it’s going to be the biggest public spectacle Germany has seen since the Nuremburg rallies. And a Nuremburg rally is the last thing it can ever look like. The world will be watching. Nothing should remind them of the Reich. Ideally, this visit should pass without ‘incident.’ The world will be watching Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Incident. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Vorkommnis")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d been emphatic.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§2")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("London")]), _vm._v(": May 1963 ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("John Wilfrid Holderness had had many names. John to his parents—­naturally as they had chosen the name, and indeed had had him christened so in a Stepney church in the autumn of 1927—Wilf to his schoolmates—Joe to his old RAF pals . . . and Wilderness to his women.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He would not have answered the phone that night. It was gone ten, they were in bed, they’d made love and he was sleeping it off. His wife wasn’t. She answered.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She nudged him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wilderness. It’s Frank Spoleto.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness pretended to be asleep, but she wasn’t having any of it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She nudged him again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can’t be Frank,” he said through a yawn. “Last I heard he went back to Washington. Tell whoever it is to fuck off.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One hand curled around the mouthpiece to muffle their voices.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s Frank. He’s in New York, calling you person to person. It must be costing him a packet!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Person to person? What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bastard to bastard. Here, take the bloody phone!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto’s voice boomed at him, more like five feet than five thousand miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe. You old bugger!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was one of Spoleto’s delights from his time in London to use anglicisms, often at the wrong moment—his confusion between twit and twat had caused many a blush.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank? It’s nearly midnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s ten of eleven, Joe. Clock on my desk has faces for London, Paris and New York—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sounds like a bottle of cheap perfume to me, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And there’s a barman two blocks away getting ready to serve me my first martini of the weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t let me keep you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto laughed loudly at this. Wilderness held the phone away from his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, I need to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No problem, I’ll be here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I need to see you in New York.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness didn’t know why, but it was like a surge of adrenaline, hearing Spoleto say New York. He sat up. Switched the phone from one ear to the other, looked around for his wife, heard the sound of water running in the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Er . . . say again Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I need you here. I’ve booked you out on the one o’clock Pan Am to Idlewild on Tuesday. Tickets, and everything else you need to get here will be at the embassy on Monday morning. First class. All paid for. Hell, I even got you a room at the Gramercy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You couldn’t afford the Waldor"), _c('span', [_vm._v("f")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The only New York hotel of which he had ever heard.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He held the phone a moment or two after Spoleto had hung up, if only because it was never obvious with Frank when a conversation was over—it was over when Frank said it was over, no goodbyes, just his sense of an ending and the clunky silence on the line. He put the phone down, shuffled naked to the bathroom door. Tapped it gently open with his foot.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The wife sat naked on the lavatory, a wad of loo roll in her right hand, poised. Early in their marriage, six or seven years ago, he had to get over the fact that she would walk in while he pissed, and didn’t give a damn if he walked in on her. He chalked it up to their different backgrounds—the public nature of a private education (hers) versus a home which knew no privacy (his)—the only door with a lock had been the loo, and the loo had been out in the yard. He’d hardly ever not had a room to himself, and only at sporadic moments in his life had he ever been in dorm or barracks, but a room he could call his own (in the sense that if you put an object down in said room, it would still be in the same place the next time you looked, in the sense that you could lock the door and not be asked why) that had been rare, that had been precious and he’d given that up to marry Judy. And given it up gladly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She blotted herself, flushed the loo and settled in the bath.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What did the bastard want now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s a tough one. He wants me in New York next week.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That kind of tough I can live with. It’s not as though you’re a jetsetter is it? New York on expenses. Yeah—sounds really tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How did you know it was on expenses?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you even be thinking about it if it weren’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness settled on the edge of the bath.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I just thought . . . out of the blue after all this time . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s three or four years isn’t it? Can’t be much more. The two of you came back from Helsinki together.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I just thought . . . this wouldn’t have anything to do with Alec would it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Get in the bath, Wilderness. You’ll feel better and you’ll sleep better.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Er . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Just a grunt. Non-committal, out of nothing more than tiredness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just get in. You know what you’re like when you’re too tired to sleep. Those nights when your legs twitch. You’ll feel better. Trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He slipped in at the blunt end, the rounded knobs on the taps cold against his back. Her toes found their way to his armpits. Her nipples peeked at him through the foam.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Trusting you isn’t the problem. It’s trusting Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And my father?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Nah, I was just asking. Alec’s been good to me—I didn’t mean . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Didn’t mean what? Pa’s been good to you. Of course he has. But do I detect a hint of too much of a good thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a moment to sink beneath the water and blow bubbles at her, but only Hollywood had baths big enough for that.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She took the unspoken words from his silent lips. Pushed her breasts together and made an irresistible waterfall flow between them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Coochie coo,” she said, and he knew he was off the hook. Subject changed.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§3")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He’d never flown the Atlantic before. He’d flown plenty of times. His years in the RAF had seen to that. He’d scrounged flights almost like hitching car rides. But he’d never done a long haul. It was the stuff of Sunday colour supplement advertising. “International” was a positive in the adman’s world. It implied you were beyond the pettiness of nations, that you were post post-war, that you moved in a world peopled by the likes of Liz Taylor and Richard Burton, that you sat in the VIP lounge at airports, and had a bag emblazoned with the name of the airline. Things like that were coveted. It was chic to be seen with a cheap plastic hold-all marked BOAC, chic-er still to be seen with the one Wilderness now had bearing the Pan Am logo.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank hadn’t been mean with him. Whatever Frank’s faults—lies, tricks, half-truths—cheapness was not one of them. First class all the way. The hostess handed him a package as soon as he took his seat, saying “A present from Mr. Spoleto.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Inside were two books and a note in Frank’s hand saying, “Don’t get too bored.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the titles. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Ipcress File")]), _vm._v(". "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("King Rat")]), _vm._v(". An hour out of Heathrow he abandoned the former in favour of the latter. Too damn difficult. Fifty pages into the steamy jungle of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("King Rat")]), _vm._v(" he fell asleep. Woke, read another fifty and napped again. When he awoke the second time, the plane was over Newfoundland. Canada, America . . . New York.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As the Fasten Seat Belt sign came on, the man sitting next to him spoke. Overweight, balding, brimming with bonhomie, capable—­Wilderness thought—of rattling on for ages. But, they’d exchanged half a dozen pleasantries over the meal several hours ago, and then the man had slept the uninterrupted sleep of a seasoned traveller sedated on free champagne and Southern Comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“First time?” he asked. A question left over from the simple pleasantries that he hadn’t asked first time around.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is it that obvious?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You get so you can tell. Just the way a guy looks around. The way he talks to the hostesses.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Too nervous?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Too polite. Too grateful. We paid for all the stuff they thrust at us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or,” said Wilderness. “Somebody paid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Right. Who’d ever pay for their own ticket? Ought to be down as one of the rules in the game of life. Play it right and somebody else will always pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("It was a disappointment. For some reason, doubtless a stupid reason, he’d expected to be able to see skyscrapers the second they stepped out of the terminal. There were none, they were way out on Long Island in a big, flat nothing. Idlewild seemed to be the right name. He strained towards the western horizon, hoping at least for a glimpse of Manhattan.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stood next to the fat man in the queue for Checker cabs. Every one that pulled up made him feel a mile nearer to the city. A fleck of deep, warm yellow somehow just blown his way. They were at least six places away from getting a cab, when a tall, black man in a grey suit approached and asked if he were Mr. Holderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry to be late, sir. An accident on the expressway. Mr. Spoleto’s car is waiting. We’ll have you in Manhattan in no time at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness knew he should offer the fat man a ride, but he wanted to be selfish, to enter the city without the voice of experience jabbering in his ear. Manhattan was worth approaching in innocence. Find out for himself. He just shook his hand and said, “Thanks for the motto. I’ll treasure it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Motto? What motto?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Play it right and somebody else will always pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was still chuckling at his own wit as the Negro picked up the suitcase and led Wilderness across the lane to a Cadillac. A big car. A ridiculous car. Low-slung, fat, covered in chrome and sporting huge rear fins. It reminded him of a beached shark. Cadillac Deville Sedan, the driver replied, when Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank’s car?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank’s car, this year. Frank’s car for now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And next?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whatever the boss takes a shine to. I driven five models in three years.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Does Frank like to drive?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Naw. Frank likes to be driven.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness sat in the back, feeling he should have sat in the front, but the sense of protocol was palpable. The man drove, the man was paid to drive. The front seat was his. He doubted Frank ever sat in the front.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Manhattan loomed up so quickly it caught him unawares. Suddenly above the one- and two-storey buildings either side of the road there it was, shining pinnacles against a western sun, the sun all but eclipsed by the spire on the Chrysler Building, a corona of light sending the skyscraper into chiaroscuro. A black spike in a red sky.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Crossing the Queensboro Bridge he was entering something akin to a dream. He’d always dreamed of cities. He’d always fallen in love with ­cities—mostly because he’d never known anything else. Childhood trips to the seaside had palled before he was ten—how many sandcastles can you build for some bigger kid to knock down? And rarer trips out into the Essex countryside to visit great aunts—relics from another century, all aprons and safety pins, a generation and a gender that seemed always to be dusted with flour or wiping their hands—left him awkward and speechless, blushing as his resemblance to Uncle Harold or Cousin Alfred was rattled off, baffled as they wished for him a better fate than Cousin Tom—reduced to a red mist at Ypres—or Great-Uncle Brinsley—a petty thief, an incompetent burglar, his life wasted in and out of Queen Victoria’s prisons.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That was the beauty of a city. You entered anonymously. Who you were, with luck, with will, was who you could make yourself. You were not the sum parts, the flawed arithmetic of your own genealogy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They crossed several avenues, Wilderness wound down the window trying to see the names, but they seemed to be only numbers. Then in rapid succession, they crossed Lexington, Park and swung right on Madison to pull into the kerb a dozen blocks further on.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It wasn’t quite a skyscraper. It was thirty or forty floors. Bigger than anything London had to show. A long row of brass plates ran down each mock-classical column either side of the revolving door. The driver led Wilderness so quickly through the door and the lobby that he could take in next to nothing. They took the lift to the twenty-first floor, and as the doors opened a glass wall appeared, bearing the stencil “Carver, Sharma, and Dunn.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was tempting to ask when or if Frank’s name would ever appear, but he didn’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Reception was glass and leather. Glass-topped tables, Barcelona studded leather chairs, ashtrays on stilts that spirited fag ash away like a child’s spinning top at the press of a button. Furniture that defied suspension or the basic laws of physics to hang in space. It all screamed modern and it could scream all it liked. Wilderness was listening. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What screamed loudest hung on the wall, filling a space about seven feet by three between the receptionist’s desk and the door to the inner sanctum. He would not have known what it was but for his wife, but then that was true of so many things. He knew what he knew because Judy told him. He had no shame about it. If she was a willing teacher he was a willing pupil and it had been that way since the day they met the best part of ten years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This, and he had no doubts, was a Jackson Pollock. The kind of painting, the kind of artist to be featured on a highbrow BBC arts programme like "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Monitor")]), _vm._v(", on which Judy had often worked, and to be described by the critics as cutting edge or possibly postmodern (a phrase which made no sense to Wilderness) and as “looks like something my three-year-old would do” and “what a load of old bollocks” by the general public.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Just below it on the wall was a small typed label: “Early Autumn. October 1955.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was tempting to touch. The kind of thing that would get him thrown out of an art gallery, but this wasn’t an art gallery, this was . . . whatever it was . . . Frank’s office selling whatever it was Frank sold.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He ran the index and big fingers of his right hand along a spinal cord of red, a raised weal that ran almost the length of the painting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tactile, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A very pretty young woman, in a starched white blouse and tight, grey skirt. He hadn’t noticed her emerge from the inner office.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” he said. “You can almost feel the energy he put into it, as though the muscle was kind of locked into the gesture and then into paint.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knew he sounded a bit of a wanker, saying this, but sounding like a wanker really depended on who was listening.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She stood next to him now, blonde, a foot shorter than he was, looking up at the painting, while he looked at eye level.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never thought of it quite that way, but then I’ve never dared to touch. The temptation to pick at it like a scab would be too much. I might get fired. You won’t. I’m Frank’s secretary, by the way, Dorothy Shearer. And I’m here with an apology.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Already?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked directly at her for the first time, first impressions well confirmed. This one was a looker.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Happens a lot with Frank. Never a deal going down, always a dozen deals going down. Now tell me he’s had to nip out to a meeting and won’t be back today.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ve know Frank a long time, I take it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Since Berlin. Since 1947.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, he’s gone out to a meeting. He’s asked that, Greg—that’s your chauffeur—take you to the Gramercy. Frank will call you as soon as he’s free.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Greg hefted the suitcase.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What exactly is it Carver, Sharma, and Dunn do?” Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank didn’t tell you?” Dorothy Shearer replied. “I’m surprised. We’re an advertising agency. You’ve just stepped into dreamland Mr. Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Going back to street level, Wilderness thought that it was probably where Frank was always going to end up. What better career for an ex-con-man than advertising? A profession dedicated to convincing you that shit is toothpaste. What kind of shit would Frank be trying to sell him now?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was not yet six, a light spring evening. Down Park Avenue, around the helter-skelter that circumvented Grand Central, and on 42nd Street Wilderness asked Greg, “Would you pull over? I think I want to walk a while. I’ve had eight hours of sitting down.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Greg parked the Cadillac, swung around in the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I could take your bag to the hotel and you could walk from here, if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are the chances of me getting lost?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Greg pointed down Lexington.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“About zero. Just stay on Lex till it ends. Twenty blocks, not even twenty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can’t miss it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He found himself across the street from the Chrysler, looking up as it tapered away to infinity, at a jutting silver eagle that seemed to be a mile in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stood on the sidewalk of a new world. Hands in pockets, head back. Whatever he did next, wherever he went next, his first step would take him into dreamland.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§4")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("When he’d showered and changed and gone down to the lobby to look around, the girl on reception handed him a note.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("“I’ll be tied up all evening and most of the day tomorrow. Get out and see New York, kid. Remember to bring me the bill. FS.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He asked the Gramercy’s doorman—a tall, stout, fifty-ish black man in a big green coat with a row of medal ribbons across the left breast that told Wilderness the man’s war had been bloodier than his—how do you kill an evening in a city where being spoilt for choice left you helpless?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What would I do? I’m a jazz man, sir. I’d find me a jazz club, hope Monk or Coltrane turn up—and I’d belly up to the bar and get my ears filled.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are there any within walking distance?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. Across the square, down Third for about ten blocks. The Five Spot on St. Mark’s Place. Turn left off Third and you’re there. Won’t take you but fifteen minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness didn’t think it was to his taste, but his taste was on the back burner. Neither Monk nor Coltrane turned up, but the posters on the wall told him they had on several other occasions. As Eric Dolphy alternated between flute and saxophone, between harmony and dissonance, the sound that really mattered was the voice in his head that said, “I’m in a jazz club in New York.” And the voice in his head that resisted saying, “It’s a long way from Whitechapel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then the band launched into “On Green Dolphin Street,” and harmony and dissonance folded into each other and Whitechapel melted away from mind and memory leaving New York draped across his arm, whispering its seduction in his ears, in and out of the sax riffs and the drum beats.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§5")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He drifted all day. Over Fifth, across Washington Square and into Greenwich Village, the only Manhattan district he’d ever heard of apart from Harlem. He sat in coffee bars, he stood on street corners with his hands in his pockets and stared. He had lunch in an Italian restaurant at Carmine and Bleecker, drifted east again and decided to follow Broadway south just to see where it went. Where it went was down one side of Little Italy. Instinct told him to zigzag, onto Mulberry, down into Chinatown, back onto Broadway, past City Hall and out to Battery Park, the harbour and a distant view of the Statue of Liberty. He’d never imagined that it or she would be green. He found he was content with the distant view and had no desire to take a ferry out and look more closely. Proximity was not intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Around five he asked a cabdriver to take him to a book store, and found himself in the Strand at Broadway and 12th. He’d almost finished "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("King Rat")]), _vm._v(". He was probably never going to finish "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Ipcress File")]), _vm._v(". If Frank was going to string him out another day he’d need a book.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He checked in at the Gramercy an hour or so later. The desk clerk said a young woman was waiting for him in the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes, sir. Asked for Mr. Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In a booth on the Lexington side of the bar sat Dorothy Shearer, sipping at a white lady and smiling up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He stood me up again, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. But look at it this way. I could have just phoned in a message. But here I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And here am I.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“And we’re on expenses. Manhattan, if not the world, is our oyster.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s order before Frank’s credit runs out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Unlikely, but since you ask . . . I’ll have another white lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The waiter was already at their table. They were the only people in the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness ordered and asked for a scotch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Try harder,” Dorothy said. “Push the boat out. Experiment. Have something you wouldn’t have at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good point, but what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Waiter, please bring my friend a whiskey sour.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She noticed the bag of books he had placed on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Show me. I can’t resist knowing what people choose in book stores.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness pushed the bag in her direction. She pulled out Stendhal’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Le rouge et le noir")]), _vm._v(", a tatty Modern Library translation from the fifties.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know this book.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“I’ve been meaning to read it for years. An old friend once told me that if he’d read it at sixteen his life would have been totally different.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Did you buy anything American?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Keep trawling.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She pulled out Kerouac’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Lonesome Traveler")]), _vm._v(" and Harper Lee’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("To Kill a Mockingbird.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Indeed you did. In fact you may well have polarised the nation in a single bag. Frank thinks all these Beats and bums are pretty much the Antichrist. America in its decadence, heading for addiction and misery and death. To say nothing of homosexuality. I doubt there’s anything Frank hates more than faggots.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the other one?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh . . . America looks at something it’s done so very very badly and . . . and manages to redeem itself. Childhood threatened, childhood challenged and somehow innocence restored. Huck Finn, revisited. The nigger didn’t do it and the boogeyman at the dark end of the street ­really isn’t the boogeyman. And the guy in that white suit is your father. We all think better of ourselves after we read it. Besides, I could believe anything Gregory Peck says. I’d vote for him for president. I’d vote for the guy in the white suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The waiter set down the cocktails. Wilderness sipped at his and asked her what was in it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mostly they just add lemon juice to whiskey, maybe a hint of sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pure heresy in Scotland.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s OK, they make it with Kentucky bourbon. Do you actually like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, I could get used to it. There’s a lot about New York I could get used to.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When it came to discussing a meal, each of them turned around and looked around.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re still the only people here,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s Wednesday. Let’s go somewhere where it isn’t Wednesday.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Outside, Dorothy’s hand up for a cab, Wilderness said, “Let’s take the subway. I’ve never been on the subway.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. It just didn’t feel right. I caught one cab today and for the rest I just walked. The subway felt like it needed a guide.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She steered him over to Park Avenue. To the subway station at 23rd, the IRT Lexington Avenue local to Brooklyn Bridge. It was like whiskey sour, he could get used to it. The rattle and the roar, the pure, shrill screech of metal on metal as the train pulled into Union Square.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Walking down the side of the bridge, Wilderness began to think of New York as a city in the sky. Not simply the scale . . . more the perfection, although that was far from being precisely what he meant as he told her over dinner in a tiny restaurant boasting “the oldest bar in New York,” at the corner of"), _c('span'), _vm._v("Water Street.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“London’s far older than New York, but . . . all the bomb damage. The rubble sat around for years. I thought we’d look that way for ever. London’s like a bad set of teeth. There are gaps, there are bad dental bridges just about holding on and there are rotting stumps that needed to be pulled ages ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve never been to London,” she said. “And I get the feeling I’m going to have difficulty holding on to the dream.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll try not to ruin it for you. But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you will anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He shrugged this off. It was a thought so hard-won it had to be uttered.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now there’s new buildings—ugly, flat, featureless new buildings going up at a rate of knots. Paternoster Square, the district around St. Paul’s has gone from piles of rubble to a concrete nightmare. London lives with the old barbarism of the Blitz and the new barbarism of 1960s architecture fighting it out at street level. New York . . . the old and the new seem to sit together so much better. It seems like an American talent. One we don’t have back home. And I never realised New York would seem quite so old.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re surprised to find New York is old?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing has surprised me more in the last two days.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you just fell for the bridge, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And this afternoon I fell for the Statue of Liberty, and yesterday I fell for the Chrysler . . . I walked backwards down Lexington Avenue, just so I could keep it in sight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She giggled, a broad, beaming grin and a row of very American teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Backwards? Down Lex? You’re lucky you didn’t get arrested.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I got called an ‘asshole’ a few times, but mostly people turned to see what I was looking at, and when they saw they lost interest. As though everyone who’s new in town does something like that. Gets bedazzled by one building or another.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This sounds like the beginning of a fine romance. You and your new mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think it is. I even fell for your office furniture.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A coy look from her, a swift hint that they both knew what they were talking about and then a turning away of the head.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, if I were you I’d take Manhattan. Not sure I’d bother with the Bronx and Staten. Great rhyme, boring place. But if you really have fallen for the Brooklyn Bridge, there’s only one thing to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s that?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We walk it. From the other side. It’s a nice evening. Not too cool. But no more subways. Cabs or nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Walking back across the Brooklyn Bridge at dusk consummated the affair. He took Manhattan. Manhattan as it lit up for the night, Manhattan viewed through the pointed arches of the bridge, through the fishnet mesh made by the cables—it was like peeking in through the dressing room window as a nylon stocking was being rolled up from ankle to thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At the Gramercy, Dorothy let the cab go.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything else I can do for you, Joe?” she asked, blatant beyond a hint.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness never wore a wedding ring. He didn’t mind signalling that he was married; he simply didn’t care for jewellery on a man. The only jewellery he possessed were cuff links, and he’d bought none of those, they had all been given to him by his grandfather—stolen from he knew not whom. Right now, a wedding ring might have helped.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m married,” he said, knowing it sounded lame.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So’s Frank. In fact I have a Rolodex just to keep track of the ex-wives. And another for the girlfriends.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I meant happily married.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You think Frank isn’t? Nah, forget I said that. It’s unfair to him and probably to you too. Just kiss me good night and try not to blame a girl for asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Afterwards, alone in his room, Wilderness wondered why he had added the “happily.” To say he was married was the unalterable truth. The “happily” pushed the statement not into lies, but into ambivalence. It implied permanence, which might be the case, and it implied fidelity, which had not been the case. The definition of happily married for John Holderness and Judy Jones, was that each believed in being faithful to the other and each lapsed. And why he was not lapsing this warm Wednesday night was puzzling him. She was pleasant enough, her natural nosiness appealed to him. She was a looker, perhaps a little young for him—but something felt not quite right, and the something not quite right was Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§6")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The next morning Frank phoned while Wilderness was having coffee in his room.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry about last night, kid. Y’know things just ran away with me. But today is fine. Come over to the office around six when the buzz starts to go out of the place and you can hear yourself think. Steve’s at his best when the office quietens down.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Steve?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Steven Sharma. My partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What about Carver and Dunn?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I bought Nat Carver out. Pays not to change the name though. And Lewis Dunn is not so much a sleeping partner as a sailing partner. Spends most of his time on his yacht in Oyster Bay. Turns up if we hit a crisis and that’s about it. It’s my show. I’m not just the token goy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’re all Jews. Nat Carver had some Polish name so long I could never pronounce it. Steve Sharma was Thaddeus Stevens Scharmansky—jeez, you couldn’t make that up if you tried, like Abe Lincoln Cohen—and Lewis’s real name is Dunkelmann.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But it’s Steve I have to meet?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. Steve’s the one who wants to hire you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And before Wilderness could ask any more Frank was off the line.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He spent the day on the Upper West Side, visited a museum full of dinosaur skeletons, walked across Central Park to the Guggenheim, spiralled up, spiralled down, and ended up at Frank’s office on the dot of six.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A good day?” Dorothy Shearer asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A great day,” Wilderness replied.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank’ll be out in a minute. As you said, there’s always a dozen deals going down with Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank’s office door was closed. Through the glass wall Wilderness could see the back of his head, lolling on the headrest of the swivel chair, a telephone cradled between his ear and his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For all Frank had warned him about the office being noisy, it wasn’t. The mechanical rattle of an electric typewriter, occasionally, like bursts of rather gentle machine-gun fire—half-heard conversations drifting by from open doors, the floating of the ad-idea. All the same the most he could hear of Frank’s conversation through the thick glass wall was a muffled burr. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dorothy said, “You and Frank go back fifteen years or more?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I like working for Frank. He’s . . . well, he’s a gas . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can hear that ‘but’ waiting to burst on your lips.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe it shouldn’t. He’s entitled to my loyalty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is this where you feel you have to tell me that however affable, my old pal Frank is also a bit of a bastard?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It could be.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then stay loyal, Miss Shearer. All my adult life women have been warning me about Frank. Girlfriends, wives, even a gorgeous major in the NKVD. He is a bastard and he is a rogue. But perhaps I am too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Mr. Holderness. I don’t think you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The door was yanked open. Frank loomed large and happy. A big grin spreading out over his fat face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe! Bang on time, kid. Gimme thirty seconds and we’ll go see Steve.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dorothy and Wilderness were looking at each other, not at him, but he didn’t seem to notice.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§7")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Frank led him down a long, airy corridor. One wall was almost entirely glass. The other displayed framed posters of the products Carver, Sharma, and Dunn represented.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank paused by “Mountain Lites—the light, full-flavored cigarette . . . anyplace, anytime.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Remember these?” he said. “Tasted like shit. In fact they still taste like shit. How many do you reckon we sold back in Berlin in the old days?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The answer was not in hundreds, it was in thousands and might even top a hundred thousand. Wilderness did not reply, and walked on to the next poster.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rodgers & Rutgers R’n’R Coffee—the full-flavored roast.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you think we sold anything that wasn’t full-flavoured?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fucked if I know. I never read the labels. I never read the ads. Now I write the damn things.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Simply Silky Nylons—he’ll simply love you in Simply Silky.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know Frank I think you’ve inadvertently set up a museum of everything we nicked, smuggled or sold on the black market. If only you had Colonel Fogg’s Miniature Cigars, I think you’d have the full set.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah,” said Frank. “We’d still need all the butter and the sugar and the canned fish and the lipstick and the soap and you name it. Whatever fell off the back of the truck.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Soap? ‘Cadum for Madam.’ Was that one of your gems, Frank? Did you write that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank laughed out loud, one of his belly-jiggling snorts.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wish I had, Joe. Wish I had. Guy who penned that one probably made a fortune. More than I made smuggling the damn stuff. I’d give my left arm to have written that—that and ‘You can be sure of Shell.’ But I just break my balls trying to find a rhyme for Rutgers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A head appeared through the open door opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you two gonna reminisce all day? Or could you possibly find five minutes for business.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A small, balding, sixty-ish man in a suit that was worth triple anything Frank or Wilderness was wearing. A dark frown on his face, which dispersed like a blown cloud as a smile took over and a hand extended.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You must be Joe. Heard a lot about you. Steven Sharma. Senior partner. But that’s only to keep this bum from taking over the whole show.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then you have the advantage of me. I’m still a little in the dark here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank lightly put an arm around each of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then let’s put that right straightaway. Steve, we were just on our way to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good. Come in, park your ass, and rest your voice. It’s time Mr. Holderness and I got to know one another.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had never worked in an office in his life, but he knew from his wife that you could read the status in the room, and that a corner office with two views was what every pen pusher aspired to. Steve Sharma’s office boasted fine views over the building opposite, a peek at the treetops of Central Park, two sofas the size of pool tables, a pool table, half a dozen original Norman Rockwell covers for the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Saturday Evening Post")]), _vm._v(", and an antique desk the best part of eight foot across. What interested Frank was the drinks cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What can I get me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure, help yourself, why don’t you,” Steve said. “And while you’re helping yourself to my scotch, serve our guest.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then to Wilderness, “Bull in a china shop, but I figure you know that? What’s your poison, Joe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Scotch will be fine. Ask the bull not to flood it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You hear that, Frank? Man who likes his scotch too much to want it drowned!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. OK. You two, lay off me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank clutched three glasses of scotch between splayed fingers and set them down on the hammered brass, Indian-looking coffee table between sofas. He filled a glass dish with peanuts and then sat next to Steve, facing Wilderness, with the peanuts balanced on his knees while he scoffed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, just one thing. You’re among friends here. What gets said in this room, stays in this room? Am I right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course,” Steve said. Then, “Tell me a little about yourself Joe. Give me a taste of your . . . ” and here he paused. “Résumé.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Résumé was not a word Wilderness had heard before, but its meaning was obvious. And Steve made it clear where he meant him to begin. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank tells me you and he met in Berlin, after the war?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. I was an NCO in British Intelligence.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“MI5? MI6?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not at that point. I never knew what I was really in. I was a National Serviceman, doing what I was told, going where I was sent. Nominally the RAF. But I hardly saw a plane, certainly never flew one or serviced one. I was low-level intelligence—I interpreted, I translated written texts, and I eavesdropped. Occasionally they let me interrogate Germans in the hope I’d find a few Nazis.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And did you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes. No one in Berlin in 1947 was or ever had been a Nazi. Yet if you threw a stick up in the air you’d be pretty well bound to hit one when it fell back to earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Steve chuckled at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I had languages. I was getting fluent in German and Russian by then, and I’ve added some Arabic, French, Turkish, and Italian since. Even a smattering of Finnish. Frank was awful at languages, but I wasn’t in the same league as Frank. Frank was an officer, a captain, and unlike me he was quite certain what he was in—the Company.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shit. Why not rent a billboard in Times Square and paste it up in letters half a mile high?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Steve waved Frank’s faux anger away with the back of his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You said it yourself not five minutes ago, Frank. What gets said in here stays in here. But you did serve in . . . whatever the British call their Company?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Until a few years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you did get to know Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was there close to two years, and I’ve been back on many occasions since. It changes. It changes all the time, but there’s something about it that doesn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("“Plus ça change, plus c’est la même chose?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A touch of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And since you left your . . . ‘Company’?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve been private. What you would probably call a gumshoe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A good living?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A variably good living. Has its moments. I’ve worked for British Intelligence a few times since. They pay better now than they ever did when I was enlisted.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank tells me you know Berlin from the ground up?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank shot him a look across the rim of his glass. Wilderness did not know how to read it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“More than that,” Steve went on. “He tells me you know Berlin from the ground "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("down")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now he knew.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why not tell me what it is you want, Steve?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Steve paused. Wilderness did not think his question had taken the old man by surprise, but still he seemed to need to gather his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank. Freshen the drinks all round would you? Your legs are longer and younger than mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank bumbled through his bad impression of a waiter, topped them all up and refilled his dish with peanuts, which he still hogged.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("With a large, untouched scotch on the rocks in his hand, Steve was ready.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My wife has an aunt. Aunt Hannah. Hannah Schneider. Sixty-nine years old. Last of her generation in the family. Never married. She lives on her own in East Berlin. My wife Debbie is the only kin she has on earth. We’d like to get her out. To be exact—we’d like you to get her out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness just looked at him and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know we’ve missed chances. She could have left in 1933. But millions didn’t and millions died. There’s no wisdom in that particular hindsight. We could have brought her over any time after 1945. But we didn’t. And she wouldn’t. And who among us foresaw the Berlin Wall, the speed with which Khrushchev would be able to split the city? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course, we’ve been able to make contact with one of those student groups that have dug tunnels and such—but Frank tells me the Stasi, the Vopos, whatever, are pretty wise to that now. Kids get people out through the sewers, so they weld the sewers shut. Kids drum up fake passports, so they double- and triple-check everyone at the crossings. And they are kids. I think we can use them, I think they’re sincere, but they are kids. Nineteen and twenty. I think we need a man in charge who is not a kid. And I think that man is you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m flattered.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So obviously non-committal.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m in no hurry. She’s been stuck there for years already. A few more weeks won’t kill her. Take your time. Think about it for a day or two. It’s a business proposition. We’re both in business. I’ll meet your terms.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness hadn’t mentioned any terms. But neither had Steve or Frank.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What I’d like to avoid is incident. And this situation is fraught with possibilities. I don’t want Hannah exposed to anything . . . anything . . . well, like that old lady a couple of years back who seemed to be hanging off a building right on the sector line, in some kind of insane tug of war. Half the world looking up her skirt. Cop had her by the wrists, pulling her back up to the East, some guy looked like he was a fireman had her by the ankles and was trying to pull her down to the West, and she looked like she was about to fall and break her neck. I couldn’t expose Hannah to that. These kids are good kids, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("gerekhte")]), _vm._v(" kids, but they have no . . . discretion. Their pride gets in the way of discretion. They’re having too much fun not to want to boast about it. Discretion is a valuable commodity. You can get paid for discretion.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And for knowledge.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . you bring me to the point, Joe. Frank tells me you know of tunnels under Berlin deeper than the sewers, older than the sewers?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("a")]), _vm._v(" tunnel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And it’s possible the Reds don’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s possible. I think it might be more accurate to say they knew and have forgotten.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you haven’t forgotten?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean could I find it again? Oh yes. It’s seared into my memory. There are times I feel I spent a year of my life down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Steve made a circular motion with his right hand, reeling off a list as he did so.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The butter . . . and the sugar . . . and the canned fish . . . and the lipstick . . . and the soap?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He turned to Frank, a smile on his face. Frank grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. Me and my big mouth. What a good job I’m not paid for my discretion, eh? Of course we used it for smuggling. It’s what we did. It’s what everybody did. Everybody was in the black market. We were just better at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And now boys, you get to smuggle a person, a human being. How much more worthwhile than sardines and soap.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Steve stood up. The conversation was over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you boys will excuse me. I must get to Grand Central, or Debbie will meet every train at White Plains until I show up. Enjoy New York, Joe. It’s a feast. A feast for the eye, a feast for the mind, and a feast for the belly. We’ll talk again in a day or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank was still feasting on peanuts as the door closed behind Steve. He set down the empty dish, spoke through the last mouthful.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s eat,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§8")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("They took a cab uptown. Wilderness wondered why they hadn’t walked. When the cab pulled up they were no more than twenty blocks from Frank’s office—but it seemed to him that Frank probably didn’t walk anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the big yellow awning that spanned the pavement to meet any arriving cab in much the same colour. In sprawling italics it read “Elaine’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You heard of it?” Spoleto asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Should I have?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have I heard of Quaglino’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know, Frank. Have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto laughed. Gave him another of the hearty slaps that Wilderness was beginning to find wearing. Frank had always done this . . . expressive bonhomie . . . hail-buddy-well-met . . . but fifteen years ago, he’d weighed a lot less. Now, there was an extra thirty pounds behind every well-meant slap on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were early. About a third of the tables taken in a large, dim, brown room, the walls covered in reproductions of Italian masters and the occasional mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A young woman in her thirties, already running a little to fat, was seated at the bar, sipping a tall glass of white wine. She slipped off the stool, scarcely coming up to Spoleto’s chin and hugged him. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, I was beginning to think you’d forgotten me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Never. I even brought an old army buddy for you to make a fuss over. Elaine, this is Joe Holderness. Elaine Kaufman . . . one of the Big Apple’s success stories. Open less than a year and already you have to queue.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank. I have never known you to queue for anything. All the same, any friend of Frank’s . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Delighted,” said Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh Frankie, you brought me an Englishman!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now Wilderness got hugged.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Only he has no meat on his bones. My God, do they still have rationing over there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A table by the wall, seated at right angles to one another, so they both faced into the room, watching as the tables slowly filled up and the room began to swell with chatter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Everything’s good here. But whatever you have as a main course, don’t miss the cannoli when it comes to "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("dolci")]), _vm._v(". Out of this fuckin’ world.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By the time they got to "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("dolci")]), _vm._v(", Spoleto had run the gamut of small talk and got to what Wilderness thought might be the point. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto said, “You were kind of coy with Steve. But that I understand. We both have things that we should be discreet about even now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You didn’t say how often you’d been back to Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A lot. Most years in fact. It would be quicker if I named the years I wasn’t there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “You ever see Nell Breakheart?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Breakheart. Always Breakheart. Would he never drop the gag and pronounce her name properly?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No Frank, I’ve never seen Nell.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When were we last there together?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fifty-eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So it was. My God. Time doesn’t fly, it gets launched from Canaveral.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I didn’t go back at all between ’48 and ’51. In ’56 I was stuck in Tel Aviv monitoring traffic. Absolute waste of time. I damn near quit after that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Monitoring Russian airwaves is never a waste of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This was Suez, Frank. A total cock-up, and I wasn’t monitoring Russian communications, I was monitoring yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, well I guess that was pretty much the low point in the special relationship.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“From late ’58 to ’60 I was in Beirut. Now, that was fun. Pretending I was a stringer for "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Times ")]), _vm._v("and eavesdropping on every indiscretion in the St. George’s hotel bar. Getting rat-arsed with Kim Philby. Each of us pretending we didn’t know. I don’t know how I kept a straight face. Regular trips home, the occasional hop to Athens or Rome. Cairo or Istanbul. Didn’t exactly restore my faith in the service, but it kept me on board for a couple more years. Then in ’61 I was back in Berlin for the last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Before or after the wall?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“During. I flew out just a couple of days after they started putting up the barriers. In August. The British had me observe LBJ’s visit firsthand. I stayed on a month or so after that. When Steve mentioned the old lady hanging off the building in Bernauer Straße to us . . . well I was there. That was September ’61. I saw it happen. I saw her fall. Her name was Frieda Schulze.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But she lived, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes, she lived. But something in me died. It was watching her dangle, both sides tugging at her. I can’t translate it into precise words, but if ever there was a symbol, writ large, especially for me, that was it. It was then I knew it was all over. I went back home and put in my papers. They could hardly object. They’d called me up for two years in 1945 and got the best part of sixteen out of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And since then? You glossed over that too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I’ll gloss over it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Things ain’t been so good?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, they haven’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The low-heeled life of a gumshoe in a high-heeled country where nothing much really happens? A country where no one carries a gun, and what’s a gumshoe without a gun?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You could put it like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Divorces. You do divorces?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. I do divorces. I’m the guy who follows the errant lovers down to Brighton at a prearranged time and catches them in the glare of a flashbulb in a seaside hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Crummy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can think of worse words for it. I can think of more accurate words for it, but yes, crummy will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And yet you hesitate when Steve makes you the best offer you’ve had since you left the service.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing to this, waited while Spoleto waved for the check.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You see the guys at the centre table?” Spoleto said as he counted out dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The one on the left’s George Plimpton. Edits the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Paris Review")]), _vm._v(". Guy next to him is Lee Strasberg, runs the Actors Studio, y’know . . . Paul Newman, Marilyn Monroe, Eli Wallach. The guy next to him . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is Norman Mailer. Frank, do you honestly think I wouldn’t recognise Norman Mailer? His first novel came out while we were all in Berlin. I read it. Eddie Clark read it. Didn’t you read it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah. I don’t want to read about the war. I never wanted to read about the war. Hell, I didn’t even go to see "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("South Pacific")]), _vm._v(". I was probably the only guy in New York who didn’t. Look over to your right. See the big feller, lots of dark hair. That’s the Broadway producer Arthur Cantor, one of the big wheels on the Great White Way. And do you know the woman he’s with?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Cantor was with two women, one of whom he most certainly knew. But he sensed that Frank had not recognised her and was referring to the other.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought her face more than vaguely familiar—hair up, glasses, next-to-no makeup, the sense of a beauty contrivedly off-duty—but he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“C’mon. I’ll introduce you. Arthur and I go way back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto pushed back his chair and threaded his way through the tables.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Cantor got a Frank back-slap that jerked the linguine off the end of his fork.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Arthur, long time no see.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Cantor looked as though it had not been long enough and he might just be able to do without Frank for a year or two more, but good manners got the better of him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hello Frank. You know Ingrid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I never had the chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ingrid, Frank Spoleto—one of Madison avenue’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("shnorrers")]), _vm._v(". Frank, Ingrid Bergman.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Bergman nodded, a soft-spoken, “a pleasure” on her lips, but she was looking at Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spoleto slipped in quickly, “And my old English buddy"), _c('span', [_vm._v(",")]), _vm._v(" Joe Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She held out her hand for Wilderness to kiss. He was not one to resist the irresistible.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I believe you’ve met . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The other woman cut Cantor off with “Clarissa Troy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She too held out her hand, the kiss to the fingers claimed as a right, then she winked hammily at him. And still not a flicker of recognition from Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We were just making plans for "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Cherry Orchard")]), _vm._v(",” Cantor resumed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You own a cherry orchard? Jeez Artie, the things I don’t know about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s a play, stupid. Clarissa’s translating Chekhov for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you in New York for long, Mr. Holderness?” Bergman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was looking right up into his eyes now. It was a moment Wilderness would have strung out for ever if he could. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Probably not. I’ll be at the Gramercy for a day or two. All rather depends on Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank drowned out the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Say, Arthur, when am I going to get tickets for one of your plays?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When you pay for the last lot, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All this earned Cantor was a hearty guffaw from Spoleto. He was lucky, Wilderness thought, to be spared a second slap on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Outside, under the yellow awning, Spoleto said, “I wonder what got into him. Fuckin’ skinflint. He’s known as one of the wittiest guys in New York.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps you cramped his style, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And what the fuck’s a shn . . . shn . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("shnucker")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Shnorrer.")]), _vm._v(" You amaze me sometimes. How can you live in this city, work with men like Steve and not know a little more Yiddish? It means cheapskate.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cheapskate? He called me a fuckin’ cheapskate?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If the cap fits?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Spoleto was on the metal kerb of the sidewalk looking out for a downtown cab.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s walk a while, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh, what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But as Wilderness led off down Second Avenue, he was bound to follow or lose him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He zigzagged, down a couple of blocks, over a couple of blocks to Lexington. He stood on the corner and waited while Frank caught up with him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus H. Christ"), _c('span', [_vm._v(",")]), _vm._v(" Joe. Are you trying to give me a heart attack? I haven’t marched like this since I got out of the army.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When was that exactly, Frank? When did you leave the Company?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fifty-eight, about six weeks after we last met.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aha.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What the fuck does ‘aha’ mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, what are you up to?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought I was trying to offer you a job and buy you dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You could have bought me dinner two nights ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bullshit. You left me to drift around New York. You left me to get to like New York, you wanted me to taste New York. And maybe I did get a taste for New York. The Bronx is up, but I skipped that. The name alone could put you off. The Battery’s down and the view’s great. I even rode in a hole in the ground. But that’s exactly what you did Frank—you sent me out on the town. Dancing with Sinatra and Gene Kelly. And yes, I got the taste for New York—so damn good I could lick it. Then you sent your secretary round to fuck me. You dangled temptation in front of me. If Manhattan wasn’t enough there was Dorothy, and if Dorothy was not enough, there was dinner at Elaine’s. Tell me Frank, did you call ahead and see who had booked? Would we have gone somewhere else if Mailer and Ingrid Bergman hadn’t been in tonight? Would we have gone somewhere where you could be certain I’d taste the high life, where I’d be rubbing shoulders with Hollywood stars and best-selling writers? Because that’s what you’ve been doing. You’ve been dangling New York in front of me. Like a reward. One great big temptation.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . you never could resist temptation.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I did Frank. I was polite to Dorothy, but I sent her packing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dorothy wasn’t part of it. OK? Nothin’ to do with it. Manhattan, what you call the high life . . . sure. Why the fuck not? But Dorothy acted on her own. You must have said something to impress her. It wasn’t that damn painting in the lobby was it? Piece of fucking shit Nat Carver spent thousands of dollars of company money on. Only he and Dorothy ever liked it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing to this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tempting you with a taste of the high life? Of course I am. I’m trying to get you to see what life can be like with a little folding green in your pants pocket. I want you to take the job, for Christ’s sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I haven’t said no yet, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you haven’t said yes. Think about it, Joe. It’s a big opportunity. A really big one. Think big. Think back to Berlin. That day in the summer of ’47, when we sat round the table at the Paradise Club—the day you introduced me to Yuri—you, me, and Eddie . . . who was it said ‘we have to think bigger’? Sure as hell wasn’t me. You did think big, Joe, you did. How many times in ’48 did you tell me not to panic? To stick with it, to sell when I should sell and buy when I should buy. Joe, you had an unerring instinct for the right thing to do in a crisis. When the Russkis were bouncing us around like we were made of fuckin’ India rubber, closing this, closing that, printing money that fell apart in your fingers, trying to pay us in dogshit and sawdust, you stood your ground. Nothing intimidated you. You were the man. You were going places, the world was your fuckin’ oyster . . . you were the man . . . but Joe, don’t tell me that life since then has gone the way you wanted it . . . I’m the one with the fuckin’ Cadillac and an apartment on Park Avenue. I’m the one drivin’ the fuckin’ Cadillac!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sheer bluster seemed to exhaust him for a moment. He drew breath and resumed in a softer tone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You’re different. That’s undeniable. You’re not the Gorblimey kid I met fifteen years ago. There’s a sophistication about you that’s more than skin-deep. But . . . I know you’re not happy, you’re not satisfied, you’re not rich, you inch along with a blue-collar pride in your own independence, when you know damn well that without your wife’s BBC salary you’d be broke, and without Alec Burne-Jones looking out for you at every step you’d have had no career in the service after Berlin. And you know Joe, the real question is what career might you have had if you’d just blown him out, blown them all out after ’48 and taken your chances. I don’t know and you don’t know. The only time in your life you ever played safe. The only time you didn’t take a chance. All I’m saying is take one now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked around him for a moment, getting his bearings by the street signs, gazing up as he began to speak and then levelling to look straight at Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Gorblimey kid, eh? Frank, as you’re so fond of adopting slang, let me ask you this. When was the last time you stood at the corner of Seventy-First and Lexington and had somebody knock you on your "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("tuchus")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe . . . I’m not saying you blew it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, but you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. Maybe you blew it. Maybe you didn’t. But look at it this way . . . Steve and I are giving you what so few of us ever get in life. A second chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A second chance?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t make it sound like I tossed you a turd. This is big money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“So far you haven’t mentioned money. Is that because you wanted me softened up first? Receptive to your shady deal and your greenbacks?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fuck you, Joe, you never asked till now. And this is twenty grand we’re talking about.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was more, so much more than Wilderness had expected. It was more than he could earn in two years. And Frank had just taken the wind out of his sails.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re surprised, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And pleased?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I could be.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, it says how much Steve wants his aunt out. You’re the guy to do this. I’ve told him that all along. I told him you don’t come cheap. The guys on the Brighton line might get you cheap, but this is New York. He’ll pay ten grand. Guaranteed. Cash. All he wants to hear from me now is that you’ll do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Down the avenue thirty blocks away, the western light was turning the Chrysler into a shimmer of beaten Krupp titanium, a shining spear of pure, impulsive folly a quarter of a mile high. It seemed to Wilderness that the skyscraper was female, a woman—it had to be—and she’d just winked at him. Folly to folly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. I’ll do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Great. Great, Absolutely fuckin’ great. It’ll be like old times. Berlin ’48 all over again. Only this time we don’t get caught!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You didn’t get caught, Frank. I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§9")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He got back to the Gramercy late after another night at The Five Spot. Another note waiting for him at reception. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m in the bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No signature.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“She’s been there awhile,” the desk clerk said. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could handle one more drink with Dorothy Shearer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It wasn’t Dorothy Shearer, it was Clarissa Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She’d worn well, scarcely a sign that she had aged in fifteen years, and he reckoned she must be getting on for fifty. Big eyes, big tits, and an habitual, kissable (not that he ever had) pout. All this in a five foot package—a pocket Venus.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do I call you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Weeeellll kid, truth to tell I "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("am")]), _vm._v(" Mrs. Troy. That really is my moniker. But you can call me Tosca—just like you used to.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Frank really doesn’t recognise you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nope. That’s got to be the third time Arthur’s introduced us, and he’s never so much as blinked. He’s such a dumb fuck, which kinda brings me to the point. What the hell are you doing getting mixed up with Frank again?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s different. This time it’ll be different.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe . . . for fuck’s sake . . . you got caught . . . you damn near got killed. If it had been me I’d be crossing the sidewalk every time I saw Frank Spoleto heading my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh hell, kid. How much money has the bastard offered you?”")])])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-9.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-10"
    }
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "PT para-style-override-11"
  }, [_vm._v("Another Novel “Without a Hero”")]), _vm._v(" "), _c('p', {
    staticClass: "P-EPI-01"
  }, [_vm._v("If this is a novel without a hero,")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02"
  }, [_vm._v("at least let us lay claim to a heroine.")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("William Makepeace Thackeray: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Vanity Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("1847")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below para-style-override-14"
  }, [_vm._v("§10")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("London")]), _vm._v(": May 1941")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("His mother died much as she had lived. In a pub. A daylight raid on London in the spring of 1941 by the Luftwaffe had taken out the Blackamoor’s Head, Matlock Street, E14. It was half an hour after lunchtime closing and had the landlord closed on time, the death toll might have been less than total. When they dug through the rubble they found Lily Holderness upright at the bar, a large if dusty gin and lime in her hand, stone dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her husband, Harry, was training with the Fifth Battalion of the East Kent Regiment in Wales—a survivor of Dunkirk, an event he spoke of with neither pride nor optimism. He called it his post-debacle course or “how-not-to-fuck-it-all-up-twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her son, John, was thirteen. He could have been a scallywag of the streets, using parental neglect as the perfect excuse to run wild in the violent, ragged freedom of war. He was at school. He would never admit it, but he liked school. He hated teachers. One of the few things father and son would ever agree on was that the only good teacher was a dead one, but he liked learning and adored knowing. He collected knowledge without system, but imposing some sense of system was the job of universities and boys of John Holderness’s class did not go to universities, and rather than a butterfly mind he might best be described as having a jackdaw mind. Not admitting any of this saved him many a playground kicking.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The first he knew of his mother’s death was not when he got home to the empty flat in Maroon Street—that, after all, was the norm—but when she didn’t turn up to eat the meal he had cooked her before he went to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When the pubs closed—those that had survived another day in the Blitz—an ARP warden banged on the door to tell him through beery breath that his mum was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He ate her portion and went back to bed, only half-wondering if his dad would be recalled from Wales, and, if he was, how best to handle the bastard.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the morning, he dressed, ate the egg that Lily had set aside for herself, and was preparing to set off for school when his grandfather—his maternal grandfather, Abner Riley—let himself in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The buggers only told me an hour ago,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m fine, Grandad.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, son. No, you’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He sat down on the only armchair in the room, wedged between the cooker and the fireplace. Wilderness had no idea what the old man meant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s the flat, d’ye see? Council-owned. They’re going to want it back. And given how many poor buggers got bombed out these last six months they’re going to want it back sharpish.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But I live here. This is my home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Copper who banged on my door at first light this mornin’ sez you was like as not goin’ to a home. A hinstitution. On account as you was now a norphan. Bollox I tells him. The boy’s a norphan the day they nail me down in me box. So . . . you grab your things and you come back wi’ me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness did not see how he could be an orphan while his father still lived, but knew that the verbal shorthand said how little the neighbourhood thought of his father. They could not forget him—he had thumped too many heads for that—but they might prefer to. Whilst preferable to a London County Council orphanage, the prospect of life with Abner Riley was not pleasing. Wilderness liked him more than he had liked his daughter—Lily had been an impossible person, and hence impossible to like with any sustained affection—but he was a complete rogue and an habitual criminal. The great-aunts out in Essex were his sisters, the very best of a very bad bunch—better because settled, their parents having given up the gypsy life with its caravans and petty theft for a fixed abode and more serious theft about the time of the old Queen’s jubilee. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Ave yer much to pack, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought his grandfather, however well meaning, had little grasp of children. It had been woman’s work to men of his generation, and to their sons’ generation too. He could have said he’d pack his teddy and Abner would not have batted an eyelid. Instead, he stuffed his spare trousers into a cardboard suitcase along with a shirt, the rags that passed for underwear and the socks desperate for darning. He tied the laces of his football boots together and slung them around his neck. His books he bound up with a striped elastic belt with a snake-S buckle and stuffed under one arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Books, eh? You must take arter yer dad. No one on my side o’ the family ever cared much for readin’. Never learnt meself. Righty-ho, we’re orf.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness took a last look at the only home he had never known, and despite what he had said on the matter of “home” to Abner, he found no remnant of home that could even aspire to meaning. Two rooms, furniture that was scarcely better than matchwood, a khazi out in the yard, a single tap above the sink, wallpaper that peeled off in the damp, mouseholes in the skirting, black patches of mold in every cold corner. Two rooms that froze in winter, only to swelter in summer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He doubted too that Abner lived much better. He’d not been to his grandfather’s house since the last row between him and Lily sometime around 1936. It was a walk of only a couple of miles. He knew it by heart, by pace, by flagstone—he’d walked over from Maroon Street, Limehouse to Sidney Street in Whitechapel a hundred times without ever knocking on Abner’s door. If he passed Abner in the street, the old man—old? he was fifty-seven—would usually slip him a sixpence, ask after his mother and not listen to the boy’s answer. The gang to which he intermittently belonged had taken on one of the Sidney Street gangs half a dozen times in the last three years and had the shit kicked out of them every time. This time he trod their turf with impunity, escorted by the street’s hard man—Abner Riley, cracksman and burglar.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Sidney Street house was three storeys. A narrow blade of a house standing on a plot less than fifteen feet wide. A house, not a flat. A house with some sense of decoration, some substantial, heavyweight Victorian furniture and a sense of being lived in and looked after that his last home had always seemed to lack. A woman lived here. Not a drunken, life-­incapable excuse-for-a-woman like his mother, but someone who bothered from time to time. No one had ever mentioned a grandmother. For all he knew, the faeries had brought Lily one day in 1908. Or more likely Abner had stolen her—but then, why would he keep her? No, Abner had a girlfriend. It seemed unlikely, but more plausible than a lodger. Lodgers didn’t go with Abner’s job. Abner had a girlfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Odd, we never met, eh kid? Still can’t be our fault, can it? Name’s Merle. Me and yer grandad’s . . . y’know . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yes. He knew.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her name wasn’t Merle. It was Mary-Ann. When she and Abner had met she had been turning tricks up West and Merle (after Merle Oberon) carried less sense of violated virginity than any combination of names that included “Mary.” The fares preferred fucking a Merle to a Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The boy had his own room.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His own room. His own bed. A jug of water and a basin on the stand. A pot to piss in. No more sleeping on a roll-out on the kitchen floor. No more pissing in the sink. As he looked up at the moon peeping at him through two centuries of dirt caking the skylight, he found himself quietly grateful to Abner for creating a level of poverty a few fractions higher than his own. Grateful, still suspicious, still scared, still baffled, but also aware of lesson one in a course of which he had no need—but he learnt it all the same—crime pays.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The funeral was apt. The church itself—St. George’s-in-the-East—as blown to bollocks as any other house not so favoured by God. They’d swept the broken glass aside, made some attempt to shovel out the rubble and held what turned out to be an outdoor/indoor, roofless service in the ruins of Hawksmoor’s vision, followed by a swift burial in the church-yard under a peeping May sun, with the last draught of April tugging at their hair. Abner had no hair, Merle wore one of her many wigs, and Wilderness stood hatless in an ill-fitting blazer and even iller-fitting grey flannel trousers. He’d no idea where either had come from. Abner had simply produced them on the morning of the funeral and said, “Can’t see yer mum orf in rags, now can we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Of Herbert Henry Asquith Holderness, L/Cpl, 5th Batt., The Royal East Kents, there was no sign.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The wake was an equal absence.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Most of Lily’s friends had perished in the raid that killed her, and Wilderness had long ago worked out that the only friend an alcoholic has or needs comes in a bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was left to the three of them to mourn and blame.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I blame meself,” Abner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whyzat?” from Merle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I spoilt the kid. Never said no to her. Not from the moment she batted her blue eyes at me. And then when her mum died, it was just ’er an’ me . . . I spoilt her even more.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, well,” Merle said over her glass of stout. “Let’s not spoil this one, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Spoil ’im. I’s’ll thrash ’im night and day!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was obvious they were joking.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry Holderness was not.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His first act on stepping into Abner’s parlour was to knock the boy across the room with the back of his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Absence distorts. Wilderness had an idea of his father that was less than the reality. He’d always pictured a big man, and common sense told him that if he and Harry ever met again the man would appear proportionately smaller as he himself had grown.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But the bastard was huge. At least six two, barrel-chested, rippling with muscle and churning with rage.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No ’ard feelings. That’s just to let you know who’s who.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness picked himself up off the floor, wiped the blood from his mouth. Abner, at five two and eight stone, didn’t stand a chance against Harry. All the same he got between him and Wilderness with the bread knife in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hit him again Harry and I’ll gut yer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry righted one of the chairs he’d sent flying, sat down and stared at Abner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t be a silly bugger, Abner. I’ve killed more krauts than you’ve had hot mash and pies. Now, be a sweetheart and get that tart o’yours to put the kettle on. We’ve a lot to talk about, and I’ve only got a forty-eight hour pass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness heard the pop of the gas going on in the kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry asked inane questions about his wife’s death and funeral. Inane only because he did not seem to care about the answers. When Merle finally set a tea tray in front of him, he changed to the real subject of his visit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“About the boy . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m right here, Dad, I’m in the room.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you asking for another belt? Shut up. Your father is talking. About the boy, Abner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wot about him Harry? You suddenly remembered he exists?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry ignored this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you keep him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Already am. He’s got a home here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll see you right for the money. His Majesty pays me as a man with a dependant. You’ll get what’s due to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t doubt it, Harry.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The army’ll do the paperwork. All I need is a letter from you, and a copy of Lil’s death certificate for the Army Paymaster, then there’ll be a few bob each week for you at the Post Office.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner didn’t say he couldn’t read or write. Wilderness knew he’d be doing all that for the old man from now on.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So,” Harry went on. “All that’s left is what’s he gonna do between now and his call-up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Call-up? The boy’s only thirteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fourteen come August 3.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And . . . this war ain’t gonna last for ever now is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“From where I stand, in a pair of size twelve army boots, Abner, I can’t see no bleedin’ end to it. We got our arses kicked in France. The Russkis are sticking to their devil’s pact, and Uncle Sam as ever don’t want to know. We’re on our Jack Jones. Either Hitler invades us, or we invade him. So, I say again, what’s the boy gonna do?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Matriculate,” Wilderness said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle flinched, and he realised she had confused matriculate with masturbate. Abner looked baffled. The word was clearly new to him. But Harry knew what he’d meant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? Exams and that? You? You must be joking.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“It’s what they want at school,” Wilderness said. “They want me to matriculate. They want me to sit the exams, and they tell me I’ll pass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you believe ’em? What then? College? University? Oxford? The likes of you and me don’t get to go to places like Oxford, son. We leaves school and we gets ourselves a job.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was leaning forward now, reddening in the face, looming over Wilderness like a tethered barrage balloon, blotting out the rest of the room. It was a slapping moment. If he continued to argue, Harry would hit him again. So, he argued.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s what I want,” he said simply.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The first blow knocked him off his stool, the second, merely a spread hand against the chest, pushed Abner firmly back into his chair. Merle fled to the scullery.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry took off his belt, curled the buckle end around his fist and thrashed Wilderness. Every so often he’d turn to Abner and push him back down. Wilderness wished his grandfather would just leave, follow Merle and escape. Protest was pointless. The bastard was going to beat him until he ran out of energy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hours later. Darkness. The blackout. A couple of nightlights floating in saucers of water on the table. Wilderness examining his wounds. His ribs were black and blue. Harry had drawn blood on the back of his legs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sorry, son,” Abner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not your fault, Grandad. Not the first time and it won’t be the last.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Still it’ll be an age before he’s back. I shouldn’t think we’ll set eyes on yer dad again this side of the autumn.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I’m growing every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle heard innocence and childhood where there was none, and ruffled his hair.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _vm._v("’Course you are, Johnnie. Bigger every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I meant. One day I’ll be as big as him. And then I’ll fuckin’ kill him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t talk like that, son. He’s still yer dad arter all.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§11")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Merle had not yet peaked. Wilderness had seen prostitutes outside East End pubs so raddled they could but have charged in pence for the oldest service in history. Once, inside an East End pub, in search of his wayward mother, he had seen one cross her legs and raise her shoe in such a way that the price was visible in scrawled chalk on the sole, and his suspicion came close to confirmation—2/6d.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle was, as his mates would have said, a bit of a looker.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I put a stop to that game,” Abner said. “Can’t be doin’ with that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nominally, Merle worked in shops. None for long. A Debenham and Freebody up West would give way to a Woolworth’s back East and that in turn to a haberdasher’s in Hoxton. Wilderness liked her Woolworth’s phase the best—she’d come home with bags of stolen sweets from the confectionary counter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But she quit Woolworth’s. They’d asked her to scrape the green mould off biscuits before they were put on the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Disgustin’,” she said. “Absolutely fuckin’ disgustin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The haberdasher’s paid less. Some evenings, Merle would rummage through her collection of wigs, put on a colourful dress, ply her old trade and have a blazing row with Abner when he found out. Abner was above belting Merle. He would shout and swear but he never laid a finger on her. Merle was not above throwing crockery at Abner. Her aim was terrible, and it was not safe to be in the same room.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness would retreat to his own room. Retreat to his books. The only things in the room that in any way personalised it.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§12")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness left school in July. A warm summer. He had ten days to himself before turning fourteen would thrust him into the world of work—neither child nor adult. A wet summer. The Luftwaffe had given up. The raid that killed Lily had been among the last. It wasn’t clear why until the lightest night of June when Hitler invaded Russia. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He read the papers out loud to Abner. Panzers rolled across what was left of Poland, hammering at the gates of the Soviet Union. Stalin suffered a shift of meaning—now, and for years to come, he was “Uncle Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought it was Poland what was what we went to war on account of?” said Abner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It was, Grandad.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Did we ever get there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe we never will.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Abner got him a job on a stall in Whitechapel Market, right in front of the Underground station. An old pal from way back who’d take Wilderness on for next to no wages and teach him how to sell cheap china seconds. Keep him off the streets by placing him firmly down on just one of them.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("If it was a trade, Wilderness could not see it. Whatever there was to learn about packing and unpacking crates from Hanley or Burslem could be learnt in minutes. If there was a patter to be learnt he’d never learn it from Frankie Hodges. Frankie never took the fag from his lips long enough to make a pitch to anyone, and Wilderness soon concluded that if a patter had been required before the war, in a time of war—houses blown to smithereens, crockery reduced to confetti—it was superfluous. Frankie could shift his entire stock twice over every day without so much as a “roll-up roll-up.” The problem, if anything, was getting supplies in. Some Monday mornings Wilderness would unpack a single crate, the contents sold by lunchtime, and Frankie would slip him a shilling and turn him loose for the rest of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Many of Wilderness’s classmates were in the same age trap. Man-boys with not enough to do and not enough to spend. The East End filled up with gangs. Every bomb site became the object of a turf war, every street corner a territorial boundary. Every trespass an insult. Most of Wilderness’s mates, those cowards of discretion, would avoid this by killing time in matinees at the Troxy cinema. Wilderness went to the library.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§13")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("When the nights began to draw in, Abner embarked on a course of instruction. How to steal.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I only nick what I think I can shift. I never bothers with big stuff. Attracts too much attention, and if you can fence it at all, fence’ll make more’n you do and he’ll bore you to death bangin’ on about the risk he’s taking. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I never do a job on me own manor. Means travelling, but that’s no bovver.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was no bother because it was a major component in what Wilderness thought of as Abner’s modus operandi, and Abner as “me meffod.” Abner had elected to serve King and Country in the Heavy Rescue Squad. This had distinct advantages. To be an air raid warden was almost a full time job, even when there were no air raids, for air raid wardens dealt in possibilities. It would also have tied him to his own “manor” night after night. Fire watching carried the same restrictions, with none of the power that turned so many chief wardens into little Hitlers. No one swaggered about fire watching. Heavy Rescue went where it was needed. And when there were no raids, and there had been virtually none since Lily died, a man in a Heavy Rescue dark blue blouse might have nothing to do but was free to be seen or ignored almost anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Supposing I’m down Chelsea or up ’Ampstead? On me bike. I finds the shelter where the wardens drop in for a nightly cuppa and I sits down with ’em and has a brew up, and if anyone asks I been checkin’ out some building that looks unsafe in the next borough. Sounds kosher, and as I’m in uniform I’m almost one o’ them. They gets to talkin’ and pretty soon I finds out who’s locked up the house for the duration and buggered orf to Canada or who’s just asked them to keep an eye on the place while they has a weekend in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now . . . I suppose you think a burgliar . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner could no more pronounce burglar than coupon, which always resembled an utterance like “cyuoopon.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“ . . . I suppose you think of a burgliar as a bloke what works at dead of night, like I was on the cover of a penny dreadful, swingin’ orf the gutters at midnight in a striped jersey wiv a mask over me eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought no such thing but said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m what you might call a twilight Johnnie. I does my jobs around dusk, and in summer often in daylight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A crepuscular creeper,” Wilderness ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whatever, son . . . I don’t work at night. And you know why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could guess but let the old man have his moment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Too many buggers about when it’s dark and not enough buggers about when it’s dark. Didn’t use to be that way, but the war’s altered everything. You got coppers, always had coppers, but now every Tom, Dick an’ Harry’s in a fuckin’ uniform askin’ fuckin’ questions. And Joe Public stays at home for fear of being run over in the blackout or some such nonsense. It’s so much harder to move about. But . . . if I does a job at say five in the arternoon . . . I just gets on a bus or goes down the Underground like I was Norman Normal. Half past five is a good time to travel. You could lose Sherlock bleedin’ Holmes on the London Underground at half past five of a weekday. Camden Town in rush hour? You could lose Rommel and his fuckin’ Afrika Corps! Earl’s Court at six? Twelve Russian Divisions try followin’ you down to the Piccafuckindilly and are never seen again!”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness cut his teeth on a job in Belsize Park at 4:45 p.m. on a September afternoon in the autumn of 1941. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a Regency villa, bowfront—elegant ironwork, embraced by thick twists of wisteria—pale yellow paint flaking from the doors and windows, a scattering of dried blossom and browning leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But it was the interior that most struck Wilderness. He had never been inside a house so well, so richly furnished, nor had his reading furnished his imagination with an inkling. Persian carpets over polished boards, wall upon wall of bookshelves, a baby grand piano on the first floor, nestling in the curve of the bay.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner was ready for this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bedazzled, eh kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, Grandad.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t be. Take a look around, take it all in and then spit it all out. Get it outa yer system. You know how most toms get caught? Trying to make off with something too big and too beautiful that just happened to take his fancy and tipped the silly sod into a daydream. Or nickin’ something so unique every nark in London’s on the lookout for it and the first fence he tries turns him in for the reward. Third, and this is real stupid, opening the drinks cupboard, knockin’ back the toffs’ whisky and gin, and being caught rat-arsed on the job.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner had a preference for cash. Jewellery, as he told Wilderness repeatedly, was easily traced if left intact—he broke jewellery.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’d be surprised how many people don’t trust banks—how many of ’em keep large sums of money in the house. Especially now. They . . . they want readies to be readies. If you see wot I mean, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("A reading of the collected tales of E. W. Hornung had rightly informed Wilderness that the rich very often had safes—in walls, behind paintings, occasionally in the floor and more occasionally just standing pritch-kemp and defiant. What Mr. Hornung had not told Wilderness was that the average safe in any private house in London was old—donkey’s years old and had in all probability been bought by the first rich man in the family, when the richesse was still very nouveau, and thereafter handed down with heirlooms and antiques, until, by 1941, the safe itself was an antique. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not that a kid of six could crack them, but a kid of fourteen under instruction could.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything before 1890s doable. After that, gets a bit tough. Moves up a league. They start laminating—layers of iron, layers of steel. You can’t shatter steel and drilling iron is like sucking porridge up a straw. And you end up travelling with more and more tools. The light touch goes out of the job. You end up setting off like you’re fighting a German division, kitted up and mob-handed. But, like I said. Plenty of old uns just waiting for the likes of you and me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the study at the rear of the Belsize Park villa, half hidden by the desk, was a small safe. Less than three feet high, half as wide, in a chipped green finish the colour of verdigris, bearing a brass plate—Thomas Withers & Son, West Bromwich, England. Below the plate was an off-centre handle, much resembling a pinecone, and a pivoting keyhole cover.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I seen a lot older, but this is about 1880 summink. It ought to be a doddle.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In a workman’s grip Abner carried drills, hammers, lockpicks and jemmies, and, wrapped in hessian with their stoppers tied down, two small jars, one of H"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_vm._v("2")]), _vm._v("SO"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_vm._v("4—")]), _vm._v("clear, concentrated sulfuric acid, commonly known as vitriol—one of HNO"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_vm._v("3")]), _vm._v("—a seventy per cent solution of reddish-yellow anhydrous nitric acid, commonly known as aqua fortis—and an eyedropper.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who needs gelignite eh, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had been looking forward to gelignite, but had little expectation of it. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I used it a few times during the Blitz, when I was trying to crack some big bugger that just wouldn’t budge. But without the Jerries providing cover half London’d hear me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Thus began Wilderness’s education in cracksmanship.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He learnt rapidly how to open most makes of safe, both British and imported. The most common safe in the world was the Herring—made by the millions in the USA, but hardly much exported. The British competed with Withers and with Gores, with Milners and with Cartwrights—all of which could be found dotted around the far reaches of the Empire—while Europe’s safes—Richter and Heinz or Julius Schuler, both of Hamburg, whilst much favoured by the jewellers and diamond merchants of Hatton Garden, were not often to be found in private homes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His favourite was the Green Crocodile made by the Tiger Company. The words alone delighted him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They came across it six weeks later. An apartment on the top floor of a building next door to Baker Street Station. They had gone in wearing overalls looking like workmen about their work. Abner’s trick, his alibi, was to have a grubby piece of paper in the breast pocket of his overalls with the apartment number, a fake name and the address of the building next door written on it. If challenged, he would simply say, “Silly me. Wrong block of flats,” pick up his cracksman’s kit and saunter out much as he had sauntered in. They were not challenged. Most London blocks had had porters before the war, far fewer now when wages in factories paid better and most able-bodied men were in the forces.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said so. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do I give a monkey’s?” Abner replied. “What’s it matter what it looks like? It’s what’s inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a small safe, probably custom-made for jewellery, but with luck there might be a pile of white five-pound notes inside—still referred to by Abner as “Bradburys” even though Sir John Bradbury had not put his signature to a Bank of England note these twenty years or more. Abner when flush, when cash-happy, would often refer to himself as being “out of the shit and into the Bradbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was finished in deep green crocodile skin, so deep as to be almost black, fastened to the steel body with brass studs. The door had a decorative (it could hardly be functional) border in a yellow hardwood, which Wilderness, a boy for whom taxonomy was a private paradise, took to be yew or myrtle. Less than twenty inches high, it stood atop a long-legged table, ending in a burr-walnut pedestal and two carved tigers’ feet in lacquered gold. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shaddup and gimme the drill.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We can’t. Grandad, we can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They did. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Thieves there were who might have carted a safe so small back home with them and cracked it at their leisure. Abner was not one of those.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’d look a right pair of twats pushing this back to Whitechapel in a wheelbarrow, wouldn’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A chisel ripped the lock covers from their housing, and a razor blade edged with insulating tape sliced through the green leather down to the steel.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Part of the deterrent power of a safe is the illusion of thickness and strength. The Crocodile bore the inscription “Fire and Thief Proof,” which of itself might be considered an oxymoron—a word Wilderness knew and Abner didn’t. A safe that appeared to be three inches of solid steel might only be half an inch thick—the lining being made up of a mix of gypsum and alum or a layer of acid-washed chalk, which, so compressed, was just about the most fire-resistant material man had invented. The purchaser of a safe had, knowingly or not, a choice—was it to be fireproof or thiefproof? For as Abner said: ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can’t be fuckin’ both now can it?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And so saying he began to drill into the steel just above the first lock. A slow process, but patience is a criminal virtue. A quarter of an hour later, when he had drilled the second, they flipped the safe onto its back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Lots o’ brass on the outside. Bound to be a lot on the inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Brass locks were harder. Compared to steel an alloy like brass was hard to corrode; an ancient formula of copper and zinc, improved in recent times by the addition of tin or antimony or arsenic—all of which strengthened its resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Abner opened the jar of nitric acid, filled the eyedropper, emptied it into both the drilled holes and the keyholes and said, softly “Leg it!” as noxious yellow fumes and a foaming green slime oozed from the locks.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When the air had cleared, Wilderness deployed a tool Abner had made himself—a strong L-shaped hexagonal spanner, steel with a wooden handle, not unlike a docker’s hook. He inserted it into the keyholes and twisted it hard three or four times, feeling metal give as he did so. Abner flipped the safe upright, clouted the handle with a club hammer and the door flew open. Thiefproof no more.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The inside was no less beautiful than the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was like looking into a doll’s house. Rows of tiny drawers with pearl handles and inlays of fine marquetry.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner ripped them all out in seconds—wood splintering, hinges snapping and the contents spewing out across the floor. A pearl necklace, a couple of diamond rings and—holy of holies—a roll of Bradburys tied up with red string.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner said, “Must be a monkey here at least,” but did not stop to count. He had little interest in the jewellery. One glance at the necklace and he tossed it back on the carpet, crushed one end with the heel of his boot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cultured. Rubbish.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had picked up the rings.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Paste?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. Take ’em anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As they left—the diamonds in Wilderness’s pocket, the money in ­Abner’s—Wilderness looked back, a violation of one of Abner’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("un")]), _vm._v("spoken rules.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The scarred and mammocked safe. Scalped and raped. The pearls crushed to dust. The dribble of acid eating into the kelim rug. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He had ruined something beautiful. He had by this act reached childhood’s end—a moment which can come at any age, and at which a truth becomes inescapable . . . that what has been done cannot be undone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He felt he had tasted sin for the first time. He felt as though he should be punished—for the last time. And he was.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§14")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Harry made a point of thrashing Wilderness every time he came home on leave, just, as he had put it, to show him who was who. Wilderness could read his mood by the sound of his footsteps in the street, by the rhythm of his knocking at the door. Rage or calm registered in every pace and every tap. He learnt that “there are strange Hells within the minds War made.” Wilderness grew quickly, but never resisted. No gain in height or weight would ever have been enough to let him stand up to his father. There was the possibility Harry might kill him if he did. Wilderness would shield his face with his forearms, take what was coming to him. Abner left the house, and, as a rule, Merle would barricade herself in the bedroom or the scullery until it was all over and Wilderness tapped on the door. She would crack it open enough to see out, look at the boy, assess the bruising with a quick scan of his features and then say simply “Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s sleeping it off,” Wilderness would say.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We could slit the bastard’s throat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, we couldn’t, Merle. We could neither of us do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Then she would burst into floods of tears and be inconsolable until Abner reappeared, awash in the recognition of her own powerlessness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’d understand him more if he was drunk,” Abner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“What’s to understand?” Wilderness replied. “Drunk he’s as happy or as horrible as any other man. Sober . . . he’ll do what he’s going to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He weren’t always like this. Only since Dunkirk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And which of us is going to ask him about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner thought about this and came to the right conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re growin’ up a sight too quick for me, son. I can’t keep up with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The beatings stopped when Harry’s leave stopped, in the January of 1942. Wilderness had no idea where his father spent his embarkation leave, and only knew he had embarked when a postcard arrived that read, “Gone to get me knees brown, Dad,” which was about as close as any serving soldier would ever get to saying he was sailing for North Africa.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had no feelings about this news. His father had gone. He might be killed in battle. He might never be seen again. Or he could return home with whatever vicious flame burned in his brain fanned into a conflagration. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “When you say you’re going to kill yer Dad, I can’t help but be shocked. Yet when anyone else says it, even as a joke, you just disagree and change the subject,” Abner said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s my prerogative,” Wilderness replied.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yer what?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My . . . privilege. It’s mine and mine alone. I’m the one he’s beating . . . and . . . besides, do any of us mean it? It says what we feel not what we might do. And . . . Harry’s in combat. There’s a half a million Jerries out in the desert who really do want to kill him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like I say, son, I can’t keep up with you. You and yer great big brain. Maybe you should o’ done all them exams arter all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing to this. It was too late, and “too late” was not a phrase he wanted to utter.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§15")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Abner had no time for oxyacetylene cutters. Apart from the inevitable smack of modernity—anathema to a man clinging to the last elusive vestiges of the Edwardian era—it would have altered his entire cracksman’s modus operandi. It was a bulky kit and would have required him to have a van and that would have sacrificed one of his principal tenets—to be able to “have it away on yer toes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The biggest component of Abner’s kit was his Phillips Motor Hammer Impact electric-powered drill—a beast heavy enough that it was only brought out when he had cased a job and decided it was worth the effort. It could bore through steel over three-quarters of an inch thick, hammer into sheet iron, and required both of them to hold it steady. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were back in Hampstead, on a rooftop high above Downshire Hill, only yards from Hampstead Heath. It was, against Abner’s habitual practice, a job to be done in darkness—in the February of 1944 when the Luftwaffe had resumed bombing London, and provided him with cover, a blanket of night and noise to smother any sound he made.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At the south end of the heath was a station of the North London Railway Company, built to feed commuters into the City, into Broad Street, once, in the days when Victorian London was home to a million Mr. Pooters, the busiest railway station in the world. It was their getaway, a twelve-minute swaggard ride almost to their own doorstep—off the train, out the back way to vanish “on their toes” into the narrow streets of Shoreditch and to emerge home and free in Whitechapel. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("London was blacked out every night. The days when people had been more at risk of being run over than bombed had long passed, as an instinctive night-awareness took over. When the sirens whined Wilderness shinned up the soil stack at the back of the house, perched himself on the parapet and lowered a rope to Abner. Abner tied on the bag of tools and Wilderness hauled them to the roof. Abner followed, complaining that he was “too old for this lark.” But, “this lark” had been his choice. They would not be on a rooftop with the searchlights raking the sky above them if the old man were not a hundred per cent sure of what they were after.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Over the other side,” he said, pointing with his free hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The top floor of the house appeared to have been turned into some sort of studio. A low-ridged glass atrium spanned the house front to back. The only way across to the far side was to walk along the parapet—a perilous nine inches, single-brick wide.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do we need to be over there?” Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We do. Or else it’s cut a way in here and risk bringing the whole damn thing down with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness understood the risk. The atrium looked shaky, flaking white paint and green moss—in all probability rotten in places.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Still we’s’ll manage, eh son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner crossed first. Wilderness followed slowly, inclining his head and shoulders inward to offset the weight of the drill, which otherwise threatened to unbalance him in the direction of a four-storey drop.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Once across Wilderness slung the rope around a chimney, and his grandfather climbed down one floor and slid the catch on a sash window.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The safe was a Milner List 5. Tall and tough. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner surmised that it dated from circa 1900—knuckle hinges, three triple-stump fantail locks, and a sandwich door with a drill-resistant plate at its core.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The plate fell to Abner’s touch, to his touch and his Phillips Motor Hammer Impact drill.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Once or twice they stopped to listen to the dull thump of bombs falling. Wilderness wondered how close they were. It sounded as far off as Hackney, but the volume was rising and the bombs crossing London manors . . . Islington, Highbury, Holloway, closer. Abner pressed on. His shoulder against the back of the drill.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Once the all clear sounds Gawd knows who’ll hear the fuckin’ racket we’re makin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But they had the door open long before the raid was over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness packed up the drill. Abner stuffed his bag with white fivers and chuckled to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Easy money, son. Easy money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Back on the roof, Abner handed the bag of money to Wilderness and took the drill off him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let me. I’m younger than you, Grandad.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Younger don’t mean stronger. The day you can beat me in an arm wrestle . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness walked the narrow parapet between the glass atrium and the drop like a man on the high wire. All but dancing. He wore the two handles of Abner’s old canvas bag like shoulder straps. The money and the hand tools centred in his back for balance. He reached the other side and turned to Abner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was the moment before the moment when a voice in Wilderness’s head would have said “home and dry.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A voice that came from the roof of the neighbouring house said, “There they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And the voice in Wilderness’s head said “Who? Me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner was crouched down, just hoisting the drill bag onto his shoulder. He turned. A London bobby, pointy hat and all, had appeared on the rooftop and behind him was a bloke in evening dress clutching a 12-bore shotgun.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I told you I heard something. Thieves I say, thieves!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness froze as the barrel of the gun levelled on him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner stood up, the bag now dangling from his right shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Leg it son, he won’t shoot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness did not move. The copper was saying something about staying where they were and being under arrest. None of it seemed to translate into meaning. It might have been Chinese for all Wilderness knew. All he could see was the gun, and all he could hear was the pulse pounding in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner set off along the parapet at the same dancing pace Wilderness had used. Younger was not stronger. It was nimbler. It was more agile. Abner’s natural gait, limping slightly, coming down hard on the right foot was nowhere near as light or balanced as Wilderness’s—and the weight of the drill on his shoulder threw him off kilter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He was halfway across when the bag slipped to the crook of his ­elbow. Instinct overtook logic. Instead of letting the drill fall to earth he attempted to right it with a sudden jerk of his shoulder and the shift of weight swung the bag too far to the left, across his chest, his whole body following in a corkscrew twist with the slow inevitability of a ­pendulum—and tipped him through the glass roof.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His last word as he fell, roaring up through the sound of breaking glass, was “Scaaaaarper!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then the bang as his body hit the floor below, and the cascade of shattered glass and splintered timber as the atrium collapsed on top of him.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§16")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness found a pair of wire cutters under the wad of money. At Gospel Oak Station he snipped the lock off a bike and cycled back in the direction of Stepney. He got off and walked for a while close to Highbury Corner. Most of one side of the street was in ruins. Air raid wardens, firemen, and Heavy Rescue swarmed across the rubble. No one paid the slightest bit of notice to him. Nor did they when he abandoned the bike by the London Hospital, where ambulances swept in and out every few seconds like bees at the hive.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§17")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He lay awake, watching the night pale into day through the skylight. Around dawn it started to rain. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Abner was dead. He was certain Abner was dead. The old man would not have his identification card on him, but it would not take the police long to work out who he was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It took till breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He sat at the kitchen table—a steel Morrison shelter to which Abner had bolted a wooden top—with a cup of tea.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Merle was asleep. He’d told her nothing. She had come in long after he had got home, another night on the game, and he’d told her nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The copper at the door was not a local. He knew all of them by sight. This one was in civvies. A rain-spotted, belted macintosh and a trilby. The copper who stood behind him, buttoned to the chin, helmet clutched to his chest, was a manor face. One he knew from the streets without ever knowing his name.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is the home of Abner Riley?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They knew damn well it was. As surely as they knew he was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness strived for the appearance of innocence, to sound and look closer to thirteen than seventeen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Grandad ain’t up yet.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The detective was torn between the certainty of duty, to investigate a crime, and the civility of duty, to report a death, and it seemed to Wilderness that the ambiguities of this were beyond the man. He wanted to explain and he wanted to accuse. His cheek twitched and he could not quite hold the tough-guy pose of looking him in the eye. And when he stepped in uninvited, he removed his hat.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anyone else at home, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had not heard Merle stir.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s the matter?” Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your grandad’s met with a . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was searching for a euphemism or perhaps just a small lie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“An accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness reached for an equivalent fib.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean the air raid? You mean he’s dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The detective looked at the bloke in uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The bloke in uniform took the hint.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Fraid he is dead, but it wasn’t the raid. He died pulling a job.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At last they had got to the point. It could only be a matter of a minute or so before they asked him where he had been last night.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you mind telling me where you were round about ten o’clock last night, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("From behind him Wilderness heard Merle say, “He was home with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was propped in the doorway to her bedroom, a dressing gown pulled loosely round her, one hand holding it closed over her breasts, the other pressing a cigarette to her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mrs. Riley?” asked the detective.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The uniform shook his head at this. Merle drew on her cigarette and didn’t bother to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re alibiing the boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah . . . I’d only be doing that if a crime had been committed wouldn’t I? You said an accident. What accident?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There has been a crime. Abner Riley died . . . accidentally . . . in the act of committing a burglary.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t say? My Abner was a tom? Lord love a duck.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The coppers looked at one another again. They knew.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re saying the boy was with you all night?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Yep. Once a raid starts up. I just stay put. Ain’t been down a shelter since 1941. Who wants to die with strangers in a stinkin’ hole in the ground. Stay put, sit it out. That’s our way. Don’t even sit under the table no more. We had cup of char and a bit o’ toast an’ Bovril, listened to the bombers and went to bed. Tucked him in meself round about eleven, didn’t I, Johnnie?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness hated the last line. It was a lie too far, a snook too cocked, but then his squirming at this could easily be read as the embarrassment of a sixteen-year-old in the presence of adults. At least she hadn’t said they’d listened to the wireless, only to have them ask her to name what programmes they’d listened to.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now, if you haven’t got any more questions, I’d appreciate being left in peace. I just lost me bloke. This is . . .” and here she paused. “A house in mourning.” Emphatically, her voice rising a fraction, “A house in mourning . . . so . . . be a mensch and just fuck off will you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They left. Wilderness had no doubts they knew, no doubts that they’d go away only to come back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle lit up a second cigarette from the stub of the first, and poured herself a cup of tea. Silent tears at the corners of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A long exhale, a cloud of smoke and a first sip. The tears suspended in time and space, ready to roll.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why didn’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I didn’t want to say the word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What word?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dead. That word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And exactly how did Abner end up dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness told her. She tilted back her head while she listened, as though it were a matter of pride that a tear should not roll.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And where,” she said, still looking at the ceiling, “is the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On the roof.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now she looked at him, tears escaping her clutch to stream down her cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?” she said. “Out in the bleeding rain?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§18")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Merle took the money. Over two hundred pounds. For safekeeping, she told him. All Wilderness could hear was “keeping,” and keep it she did. She kept all of Abner’s loot, just as Abner had. Abner had bunged him a couple of quid every so often, but kept the bulk. It seemed to Wilderness that the old man must have built up quite a stash in his time—a successful thief, with only a fence to pay off. Rationing was a leveller, but it was clear they had lived well before the war. Well, but not high. A discreet level of consumption, attracting, whatever the rumours on the street, as little attention as possible. Abner had a decent suit, Merle some posh frocks—but the money was never flaunted. No “drinks for everybody” in the pub, no diamonds on her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All in all it seemed there must be a lot stashed away. The ill-gotten gains of all the jobs they’d pulled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness never found it. Now it was Merle who bunged him a couple of quid every so often—and she saw he never went short, peeling notes off a roll in her handbag—but Wilderness never found the stash.")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§19")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The day after Wilderness was called to a police lineup at the Leman Street nick. The bloke in evening dress who’d stood on the roof pointing a shotgun at him failed to pick him out.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Toff diffidence saved him. The sense of fair play that would not have restrained most men restrained this one. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One has to be sure, d’ye see? Couldn’t point the finger at a chap without being one hundred per cent sure. It wouldn’t be cricket,” he had said to the duty sergeant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He could point a gun but not the finger?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could not hear the sergeant’s muted reply, but it was bound to be along the lines of, “But he’s the old bloke’s grandson. Bound to be him. Stands to reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And the toff had replied, audibly, “No it doesn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And after that all the sergeant could do was turn him loose with, “Don’t think you got away with it, son. Yer card’s marked.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§20")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On May Day 1945 the news broke that Hitler was dead. For weeks now “It’ll be all over soon” had been a rolling cliché on the streets of London. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought, “I’m free. They’ll never call me up now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("He had watched his schoolmates vanish into the army over the last year and more—ever since D-Day. And ever since D-Day he had thought the odds on the army claiming him to be diminishing on a daily basis.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the spring new weapons had crashed down on London, the noisy, puttering doodlebug, the silent, devastating V2. Enough V2s and there’d be nothing left of England—but there weren’t enough, it was Hitler’s last roll of the dice, and when the Allied Forces overran the launch pads the raids stopped. By the end of April even the blackout restrictions had been lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The neighbours were cautious. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hard to believe, innit? I mean to say, the buggers could be back any minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle had had none of this. She had ripped down the blackouts and thrown open the windows, clouds of dust cascading around her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Enough, enough of darkness and dirt. Enough of bombs. Enough of pompous little twats in tin hats. Enough is enough!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It reminded Wilderness of scenes close to the end of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Great Expectations")]), _vm._v(". Ripping down the moth-eaten curtains that had shut out the light from Satis House for a generation.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Motes of dust danced in the late afternoon sunlight. Merle had danced with them, sweeping Wilderness along in her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s over, bleedin’ war is bleedin’ over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She hugged him, kissed him, told him again that it was over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They’d never get him now.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A week passed in high anticipation—the national nerves stretched to breaking. Woolworth’s, Bourne & Hollingsworth and Whiteleys all sold out of bunting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("May Day. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hitler was dead. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Surely it was over now?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Germans surrendered in chunks, a division here, a division there.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Surely it was over now?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Russians took Berlin. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Surely it was over now? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All they needed was the word.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And on May 7 the word came—the following day would be Victory in Europe Day. The Prime Minister would address the nation at 3:00. And at 3:01 the nation would erupt in a frenzy of celebration that would last until the beer ran out. And woe betide any landlord who tried to put up the towels for the night when it did.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§21")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Not here,” Merle said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I wanna be somewhere else for this. Not sat in the street with the neighbours, wearing a paper hat and drinking warm beer from a coronation mug.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where then? Buckingham Palace?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Not the palace, but up West, definitely up West.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Up West” was a concept as much as a place, and as a place it was a moveable feast—the most appropriate term imaginable for the night in question. It might begin just west of St. Paul’s, but who knew where it ended? Regent Street? Park Lane? Knightsbridge? Wilderness had in a sense never been up West—he’d passed through it on trams and buses—a sensation rather like pressing your nose to the glass panes in the window of the sweetshop—and he’d pulled a couple of jobs with Abner in Mayfair and Kensington. But been up West in the sense of walking its streets, eating in its caffs and drinking in its pubs and shopping in its shops . . . never. Harrods was just a word. Westminster Abbey a postcard. The Ritz a colonnaded facade glimpsed from the top of a number 19 bus.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll take you to the Ritz,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§22")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Piccadilly was a conga. A human snake that began at the circus and the boarded-up plinth on which Eros used to stand and slithered past Fortnum’s, Jacksons, the Royal Academy, the Berkeley, and the Ritz to fizzle out in Green Park.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There seemed to Wilderness to be as many in uniform as in civvies, prompting the question “who is actually at the front?” which in turn prompted the question “is Harry Holderness at the front?” but that he readily dismissed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Merle seemed content to watch. She slipped an arm through his, and they hugged the pavement rather than let the human tide sweep them up.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("She seemed happy, her head bobbing against his shoulder, and—­although he’d no real idea how old she was, perhaps half Abner’s age, say thirty-two or thirty-three—“girlishly” happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By half past eight the sun was setting over the palace and Green Park became ablaze with bonfires. Londoners tore up the shelters that had served them since the Blitz and fed them into the flames.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Men and women danced around the fires as though in some ancient Dionysiac—a hint, more than a hint of impending intimacy between strangers, encounters flashed in the night rather than forged. To fuck but never fuck again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Forces were out in force. A sailor, a couple of RAF blokes wearing observers’ part-wings. And the Army—a couple of Artillery gunners and a lance bombardier, who took off their battledresses, waved them around their heads, and let them float down onto the flames like giant autumn leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A benign policeman, a pointy-hatted London beat bobby, looked on without comment. A large well-dressed, matronly woman caught his eye with a wave of her brolly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Constable? Can this possibly be legal?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It is most certainly a crime to burn the king’s uniform, madam, but so long as they none of ’em get their wedding tackle out I shall be turning a blind eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle giggled at this, not meeting the woman’s gorgon gaze—and all but collapsed in hysterics when the gunners stripped to their socks, wedding tackle out, and threw every stitch of uniform into the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“War is over,” they yelled, echoing what Merle had said days ago, “Bleedin’ war is bleedin’ over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The blind eye turned no more. The gunners set off across the park in the direction of St. James’s at a bollock-bouncing trot, and the copper gave chase. The RAF observers stripped more slowly, fed their uniforms into the flames as though consigning the dead to the furnace—a gentle respect, a fond farewell to arms, at odds with the hysteria of the night. Then they turned and kissed. The matron stormed away trailing fury, complaining loudly about “the bloody queers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle buried her face in his chest, he could feel her laughter in his ribs. Then she wiped her eyes and said,")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“C’mon. It’s past nine. Let’s get to the Ritz before they sell out of champagne.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was hesitant and she sensed this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wossmatter?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are we ready for this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I been ready for the Ritz all my life. Puttin’ on the Ritz is what I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are we even dressed right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle was in a scarlet summer frock that looked like it cost a packet. Her best patent leather handbag, with its diamante cluster on the clasp. Wilderness was in what passed for best. A light sports jacket and cavalry twill trousers. Put a cravat around his neck and he just might pass for a countryman up to town for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She picked up the regulation black RAF tie dropped by one of the queers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Slip this on and you’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Supposing they won’t let us in?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“I’d like to see ’em try. Tonight of all nights I’d like to see ’em try.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As they left, heading north onto Piccadilly, the naval rating was stripping, even more slowly than the RAF queers, consigning history to the flames. Ashes to ashes, dust to dust.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§23")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The crush in the bar at the Ritz was scarcely less than in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle made him sit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It ain’t a pub. They come to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And when he came, he took one look at Merle and drew too keen a conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Excuse me, sir,” he said to Wilderness, sotto voce, his back to Merle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was almost impulsive to look over his shoulder, and see to whom the waiter was talking, but he knew it was him and he knew what the man was going to say if not how he might phrase it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your companion, sir. I understand it is a night for celebration, a waiving of the rules, but this is a respectable establishment—the most respectable in London. Certain things we cannot permit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not admitting he was a bookworm had saved Wilderness a kicking on many occasions as a boy. Equally effective was an ability to make his enemies laugh with mimicry. Few accents could elude his ear and tongue for long, and certainly not those of the English upper classes as personified by Ronald Colman or Robert Donat. Either would do—C. Aubrey Smith perhaps a trifle excessive.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, old man. Don’t quite catch your drift here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The waiter coughed once into the end of a loosely clenched fist, but by then Merle had stuck out her left hand and was waving her ring finger at him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was wearing a wedding ring, and Wilderness could only assume she had slipped it on in the last few moments and that she carried one just to be able to pull a stunt like this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Ere, take a gander mate. What do you think this is, a bleedin’ doughnut?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The man reddened. Wilderness thought it touch and go which way he jumped now.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My last leave,” he said. “Popped the question. The old girl said yes. Now how about drinks for the pair of us? The sooner we get them the sooner my good lady and I will be on our way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The blush deepened. He must have worked out Wilderness’s age to within a year or two and might be guessing at twenty-one or twenty-two rather than seventeen, and he might deem him unlikely to be either officer or gentleman, but he wasn’t going risk it. Wilderness knew he’d won this one. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. Make mine a Tom Collins,” Merle said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And for you, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Oh, the same,” Wilderness said, with no idea what a Tom Collins was.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m afraid the lemon will be out of a bottle sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ah, so it had lemon in it did it?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness smiled his assent, and the waiter vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Old hypocrite,” Merle said. “He never told me he worked here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean you know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wasn’t certain till he started staring and whispering, but I think I did him a quickie in St. James’s Park last February. Cold as a polar bear’s bollocks and bombs wangin’ down everywhere, and I pick up the only fare left on the razzle. Cheeky bugger. Of course I know him. Do you think he spotted me for a brass ’cos I look like one?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well I did wonder about the handbag.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I might just clock you with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A Tom Collins turned out to be mostly gin. The tipple that had ruined his mother. Gin and sugar. It was little short of disgusting, but he sipped at it for Merle’s sake, wishing she’d ordered champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was talking at him. “At” might be “to” as far as Merle was concerned but Wilderness could not hear her. Her words were simply bouncing off him. He could suddenly hear nothing. One of the loudest evenings of his life, the letting down of the national hair—or in many cases the national trousers—and it was like watching a silent film. Or more precisely, an effect in a talking film when they drop the sound and the observer sees only faces, and faces become grimaces magnified by the glass walls of the fish tank through which he appears to be watching.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He could think of it no other way. He was in an aquarium or in a zoo—not that he’d ever been to either—he was a scientist, they were specimens . . . ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Homo anglicus")]), _c('span', [_vm._v(", in all his limited variety—his native grey plumage enlivened only by the deep blues of the navy and the paler blues of the RAF and the spring colours of all the posh totty on his arm. Well-heeled Englishman and Englishwoman. So remote as to be another species.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Minutes passed, perhaps a quarter of an hour, Merle still talking, and the glass shattered. Hit his eardrums with the blast of a bomb. The mass braying of assembled toffs in their mating ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can we go now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _vm._v("’Course, enough is enough,” she replied. “Let me summon old winkledick and pay the sod.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Walking towards home, walking to the point where they’d both get fed up and hop on a bus, she leaned her head on his arm said, “Wasn’t a bad idea goin’ to the Ritz was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” he replied. “Not a bad idea at all to put on a bit of ritz. My first glimpse of the high life.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The high life? And what do you make of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno,” he said honestly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was repellent and tempting. And he did not care to discuss temptation with her.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§24")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("She took him to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Reading the hesitation in his eyes, she splayed her left hand in front of him, her own eyes peeping coquettishly over the fan, a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("strega")]), _vm._v(" at "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("un ballo in maschera")]), _vm._v(". The slender gold ring still upon her finger.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We got married on your last leave. Remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That was the masquerade. They weren’t real any more, they were characters in a masquerade of his own devising.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Afterwards. Passion far from spent. Looking up at the skylight. Merle stirring.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Merle,” he said. “Where’s the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wot money?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Our money. Mine and Grandad’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Safe. Don’t you worry. It’s safe . . .” She yawned and paused. “Safe as houses.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He said nothing to this, realising that she was not going to answer any more questions, and searched what she had said for a clue. But it was just a phrase—a common turn of phrase that offered nothing and concealed nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She slid one hand across his belly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re a nice shape, young Johnnie. A nice flat tum on yer. A bit more muscle on yer bones and I bet all the girls’ll fancy you. Let’s do it one more time. Afore I fall asleep. After all . . . we’re not going to make a habit of it are we . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was damn certain they weren’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So let’s do it one last time for . . . for old times’ sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness saw in the first dawn of peace humping his grandfather’s mistress, a common prostitute of the London streets, shooting the second (shared) orgasm of his life into her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had taken his virginity. His grandfather’s mistress. He still had no idea how old she was. She took his virginity—there was no one else on earth to whom he would rather have surrendered it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He never did find the money.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§25")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("When the celebrations of Victory in Europe had dwindled to a national hangover, Wilderness was convinced he was home free. Japan had not surrendered, but it could not be long, and it could hardly be worthwhile training up anyone new and shipping them East. The voyage alone took the best part of two months.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But—the day he turned eighteen at the beginning of August a letter arrived from the War Office ordering him to register for the Forces at the local Labour Exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle told him to do it and attract no trouble. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t want no more coppers pokin’ around here. They’ve had you marked ever since your grandad died.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He registered, and opted to join the RAF, for no better reason than that blue was preferable to brown, thinking he would, in all likelihood, never hear from them again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The following week he received instructions to report to the RAF Recruitment Centre at Euston, a twenty-minute ride away on the London Underground. It was not his “call-up.” It was some sort of exam.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle said, “Just do it, kid. Don’t ask for no more attention. Like the man said, yer card’s marked. Besides, nothin’ ter lose. Not after them big bombs on Japan. War’s all over bar the shouting. And you was always good at exams.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was good at exams. And all this one seemed to be was some sort of crude test of his intelligence. A matter of not banging a square peg in a round hole. A doddle. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then the shouting—August 15, 1945—Victory over Japan, and a piss-up in the streets to beat all piss-ups, and it was, as she had said, “all over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("About a month passed—Britain adjusted painfully, if at all, to life under Labour government, life in the nuclear age, and life at peace.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then Wilderness received his call-up papers. A travel warrant to get him from St. Pancras Station to RAF Cardington in Bedfordshire and a postal order for four shillings. Two days’ pay in advance.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle took the letter from him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Ere. You’re now Aircraftman 2nd Class Holderness, J. of the RAF Regiment.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh fuck indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a telling pause as she lit up a fag. Merle striving hard to look as though she was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You know I’ve always urged you to keep your nose clean? You know, ever since Abner . . . you know . . . Well this is different. I wouldn’t blame you if you did a runner. Really I wouldn’t. The bloody war’s over. They’re demobbing blokes already. For all we know yer dad’s on his way back right now. What can they possibly want with a skinny bugger like you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” said Wilderness. “They’ve got me. Nowhere to run to. They’ve got me by the balls. And I think it pays to know when they’ve got you by the balls.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What you gonna do? Join up, keep yer head down and yer nose clean and hope trouble just passes you by?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well I can try,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fat chance, kiddo. Fat chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The sole consolation in this was that if his father was on his way home, back home from God only knew where, perhaps to be on an RAF station somewhere, anywhere where Harry wasn’t, might be no bad thing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fat chance,” she said again, leaving the phrase echoing around in Wilderness’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§26")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("RAF Cardington seemed to take up about half of Bedfordshire. Wilderness was there for five days.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He had his hair cut to regulation RAF length (“Get yer ’air cut! You bunch of fuckin’ pansies!”)—length and regulation being about as close to an oxymoron as possible—was issued with a best and a working uniform, a “cheese-cutter” forage cap (“Stick it to yer ’ead with Brylcreem!”), shoes as well as boots (“This ain’t the bleedin’ army—we don’t live in fuckin’ boots.”) assigned a number (“Learn to recite it in yer sleep! You can forget yer own name, but never forget yer number!”), and told to stamp the number into his personal cutlery (“Knife, fork an’ spoon, nerks fer the use of. Get ’ammerin!”). The uniform could have fitted better, as with every pair of trousers Wilderness had owned since he was thirteen they were too short in the leg. (“You’re a big bugger ain’tya!”). And he ate five days’ worth of bangers and mash, rendered soggy by the limp, dripping grey cabbage piled onto the plate. RAF Cardington seemed to smell of cabbage constantly. Later in life, he had only to catch a whiff of boiling cabbage to see Cardington for a split second in the mind’s eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The low point was posting home all his civilian clothes. Nothing, not the brutal haircut, the mindless shouting or the appalling food brought home quite so sharply that they had “got” him. He stuck a note to Merle in the package. “Trying to keep me head down and me nose clean. Don’t bet on it. Jx”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("None of this seemed crucial. What was crucial was the careers hut.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Right. You gotta pick. What do you want to be?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had replied that he would like to be a pilot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah, clerk, cobbler, barber, mechanic, cook, driver an’ blah blah blah.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, really. I’d like to be a pilot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The flight sergeant had laughed at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No chance, son. Not for likes of you. Pick a trade. Wot was you in Civvy Street?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He could hardly say thief.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK, how about driver?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you drive?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We got a word for drivers wot can’t drive. It’s clerk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He left Cardington a clerk, with a recommendation that he train as a driver—if a vacancy arose. They had got him, and chained him to a desk.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§27")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Cardington dispersed its recruits on the sixth day. From Cornwall to Aberdeen, from Pembroke to Suffolk. Wilderness, along with half a dozen new recruits, was posted to RAF Ravenhoe in Essex for basic training. Until the peace Wellingtons had flown out of Ravenhoe to bomb Germany. Now they ferried men and equipment, and half the base was given over to training.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The school cliché had always been that the fat kid who could not tie shoelaces was always last in a race and never to be trusted in goal. Sandy Birch was not fat. He was a skinny redhead who looked less eighteen than fifteen. You would never trust him in goal, he could not tie his shoelaces, nor could he dress on time or shave to a sufficient standard to please the NCOs. He laid out his kit on his half-made bed in a fashion that could only be described as chaotic and graced his first parade with patches of bog paper sticking to his cheeks, crisping with brown stains as the blood dried.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As such he was poison to the RAF corporals charged with licking civilians into the shape of airmen. They ate him all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had spotted him as long ago as day two at Cardington, when he had managed to drop most of the kit he had been issued, his personal knife, fork and spoon clattering down with his enamelled tin mug.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Their first pre-breakfast, post-ablution parade at Ravenhoe: 7 a.m., all in working blues—a second-best uniform, designed to get dirty—and boots.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The bog paper was a red rag to a bull. Corporal Turpin passed Wilderness with a glance, stopped and stared at Birch’s face, then let his eyes roll down the length of the boy’s body, to his boots. Each boot had twenty-two lace holes. Birch had missed a good half dozen on each boot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus H. Christ. What are you, boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Birch rattled off his name and number.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, that’s who you are. I asked what you are? Now, what in God’s name are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Please, Corporal, don’t know Corporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then I’s’ll have to tell you. You Birch are a twat. What are you Birch?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A twat,” said Birch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, Birch. I must be a bit mutt an’ jeff this morning. I didn’t hear you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A twat.” Birch said more loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So far Turpin had not raised his voice, but Wilderness readily deduced it was a weapon held in reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“WHAT THE FUCK ARE YOU?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Birch went red, his cheeks blew out as though he might burst, then he yelled as loud as he could.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I AM A TWAT!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Turpin resumed a normal volume.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, no, no . . .. ‘I am a twat, Corporal.’”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I AM A TWAT, CORPORAL!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thank you Birch. You are indeed a twat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had said nothing. Further down the line, his newfound comrades were grinning and sniggering. Wilderness said nothing. But, any English school will teach you that silence is not the same thing as innocence. Turpin stepped back to him. It reminded him of those moments when a teacher could seize upon the merest expression and decide it was insolence. Wilderness had never been able to work out what insolence was. It defied definition and was so bound up in matters of rank and status as to require an entire chapter in any manual of etiquette. However blank the face, the offended party would profess to read a message in it—invariably it would be found insolent. And Wilderness had long ago concluded that only the insecure bastards hovering one rung above bottom ever bothered with insolence—it marked out the losers in life that they could be so readily offended by silence.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you. You lanky bastard. What’s your game?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness recited his name and number.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Could it be, Holderness, that you are a smart alec?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Answer me, son. Are you a smart alec?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes, Corporal. Smart as they come. Smarter than you by a plank and a half.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wasn’t wholly sure why he’d said this, but had time to reflect as he doubled up under a fist to the solar plexus.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“IF THERE’S ONE THING I HATE MORE THAN A FUCKING TWAT IT’S A FUCKING SMART ALEC! ONE MORE FUCKING CRACK, ONE MORE SNOTTY FUCKING LOOK OUT OF YOU SON AND I’LL HAVE YOU ON FUCKING JANKERS!”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§28")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Jankers was universal British forces slang for punishment, usually following a charge of insubordination. It did not require a court-martial. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jankers duly followed. Wilderness failed to salute a pilot officer, who sent for Flight Sergeant Mills, who shouted at him and rushed him in front of the flight lieutenant, no one of higher rank being available or interested. Wilderness scrubbed lavatories with a toothbrush for a weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not long afterwards, on morning parade, he laughed at something a chap in the row behind had muttered about Corporal Turpin’s mother. Turpin exploded into a practised routine of “Twat,” “Fucking twat,” and “Smart-alec wankers.” He sent for Flight Sergeant Downes, who sent for the flight lieutenant, who could not conceal his boredom with all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is this really necessary, Flight?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rank insubordination, sah!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you have to be quite so loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sah!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Call the man a fool and have done, Flight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, sah! King’s Regulations clearly state—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Flight Sergeant, do not start quoting me King’s Regulations. If you want to punish this man, punish him. I don’t know . . . have him whitewash the coke heap . . . polish the lino . . . something like that. But for Christ’s sake stop shouting.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness whitewashed coke, and when he had whitewashed it Downes and Mills had him hose it down and do it again. After three days he was whitewashing it by torchlight. Small incident followed on small incident. More bogs to scrub, more coke to whitewash. And the added pleasure of putting a shine upon linoleum floors that already shone. He spent a total of six nights in the glasshouse for minor misdemeanours. They had him marked as a troublemaker.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Along the way he learnt what he had to about marching, cleaning a Lee Enfield .303 (but not actually firing one), the boundless joys of blanco and stamping his feet. It wasn’t enjoyable, but it was tolerable. For some reason planes—surely the raison d’être of the RAF—had not yet come into it. Nor had clerking, nor had the prospect of driving.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What changed things for ever, and most certainly for better, was the cunt.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yet again they were on parade. Wilderness bored out of his brain, Flight Sergeant Downes shouting orders, Corporals Turpin and Bodell enforcing them, checking that thumbs aligned with the seams of trousers, that feet were splayed at the regulation RAF angle, that heels banged down with the requisite force.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They got as far as Birch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Today he was not bleeding, but his shirt protruded beneath his blouse and his bootlaces resembled a cat’s cradle made by a three-year-old.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Turpin kicked at his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are you Birch?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Birch knew the routine.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a fucking twat, Corporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, no, no, no . . . laddie. That was last week. You have slipped down the slippery slope of sloppiness since then. Birch, you are a cunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Birch said nothing, reddened in the face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are you, Birch?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, corp. I can’t say that. Not that word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Turpin screamed, “YOU ARE A CUNT. WHAT ARE YOU BIRCH?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Birch said nothing, turned his head towards Wilderness to avert his eyes from Turpin’s glare.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Turpin seized him by the chin, turned his head back and an inch from his face yelled, “SAY IT! YOU ARE A CUNT!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Birch wet himself, a hissing sound of escaping urine, a rapidly spreading wet patch discolouring his best blues, and a splash of orange piss bursting over his shoes and onto Turpin’s. Turpin all but jumped backwards. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus H. Christ. I do not fuckin’ believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As he raised his arm to hit Birch, Wilderness blocked it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hit him and I’ll deck you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was at least six inches taller than Turpin. Turpin looked up in disbelief, not trusting his own ears.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Come on, Sandy. Let’s get you cleaned up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He led Birch out of line and across the parade ground in the direction of their hut.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Bodell intercepted, positioning himself in front of Wilderness. Downes stood motionless a way off, swagger stick tucked under his arm. Turpin began to yell, so loudly Wilderness could not make out what he was saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Bodell was no bigger than Turpin. Five foot six of gutless obedience.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “Step aside, Corporal. This won’t take long and then we’ll both be back on parade.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Bodell seemed to have a verbal fit, “Wuuh worra wuuh worra wuuh.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness shoved him aside, the palm of his hand flat against his chest. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was then that Downes’s voice boomed out, “Arrest that man!”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§29")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("This bloke wasn’t RAF he was Army, a half-colonel in the Guards. As a boy Wilderness had collected the cards that came free inside packets of cigarettes—he’d had a full set of English Automobiles, most of British Butterflies and all but three of HM Forces Uniforms. According to his fag cards, this bloke was in the Coldstream Guards—the buttons on his tunic grouped in pairs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wondered why he was getting a bollocking from the army. Was the RAF not capable of slinging him back in the glasshouse one more time without calling in the troops?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A corporal he’d never met before had barked him in, all the hup-to, left-right, left-right bollocks, slamming down his feet and expecting Wilderness to do the same. Wilderness went through the motions, out of step, out of time and no doubt far too quietly for the barker.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The colonel was bent over papers. Looked up once to say, “Thank you Corporal. You can go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("More stomping. Turning on his heel as though powered by clockwork. But then that was their trouble with NCOs. They really were clockwork. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("More than a minute passed. The colonel looked up again, pushed his sheaf of papers away from him and pointed at the chair opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You might as well sit. I’m sure you’re less trouble sitting down.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It seemed to Wilderness like an invitation. He took it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t think I’m ever trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Really? You don’t say? Aircraftman Holderness, I’ve just read a dozen pages about you—all but three of them complaints. Complaints from Corporal Turpin, complaints from Corporal Bodell, complaints from Flight Sergeant Mills, complaints from Flight Sergeant Downes—all endorsed by Flight Lieutenant Cooper. Not trouble? Holderness, they think you’re a pain in the arse!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s ’cos they’re a bunch of fucking twats.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a momentary pause, the merest flinch on the colonel’s part.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A bunch of fucking twats, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("sir")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course. Sorry. A bunch of fucking twats, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("sir")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s get one thing clear. I’m not a fucking twat, and if you talk to me like a fucking twat I’ve enough authority to bung you back in the glasshouse and throw away the key.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good—now we understand one another, let’s backtrack and get to the introductions. I’m Lieutenant Colonel Burne-Jones. And I can save your bacon if you let me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones. A hyphenated Englishman. That went with the rank and the regiment and the pencil-line moustache. If he stood he’d be six two and ramrod straight . . . but then so would Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones held up the top three pages of the papers in his right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You remember this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s the test you sat in London last August. It’s known as an IQ test. Now, do you know what that stands for?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness remembered it now. Word games and pattern recognition. Matching up identical triangles. Juggling rhomboids and trapezoids. The square peg and the round hole. Only an idiot could fail it. He’d thought nothing of it at the time. Just call-up bollocks. It went with the ill-fitting uniform and the beetle-crusher shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Intelligence Quota?” he ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Close. Intelligence Quotient. It’s a way of measuring intelligence. Assigning a score to it. Would you be interested to know yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If I say no I go back to chokey?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then I’m all ears.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One hundred and sixty-nine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Big is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, it’s bigger than mine. In fact it’s bigger than most.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bigger than yours? Then maybe I should be the officer?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s right, Holderness, push your luck. I do hope you like bread and water.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Excuse me, sir. Cheek is a way of life where I come from. Almost a language in itself. It has its own rules and syntax. My point is it must mean something, it must change something or you wouldn’t be telling me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The shift from cockney lout to articulate individual gave Burne-Jones another little pause. An effect Wilderness relished. It was like swapping masks at the ball.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Quite. It does. It means I’m not going to let you go on square bashing. It would be a waste of everybody’s time. You’re moving to my operation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? The Guards?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Regiments are meaningless. You’ll be a trainee for a while, in fact for six months at least. If you pass you’ll be in an Intelligence unit, and for the time being that’s all you need to know about it. You’ll still be in the RAF for purposes of pay and uniform, but effectively not. You need never go on parade again, no one will put you through a crack of dawn kit inspection. You’ll answer to me. And I’ll tell you now, you make trouble, you fuck up . . . I’ll just send you back here for the bunch of twats to pick over your bones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No was not an option. Technically, in shoving Bodell aside Wilderness had struck an NCO. He’d spent the last four days in the glasshouse. He knew he was looking at six months in a military prison.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fine, sir. Where do you want me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cambridge. Queen’s College"), _c('span', [_vm._v(". ")]), _vm._v("You’ll be learning Russian and German.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§30")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Much to his surprise this transfer—which Wilderness saw as something between being booted out and being rescued—was regarded by the RAF as just another posting. He was paid up to date—an unprincely two pounds and six shillings—and he was allowed forty-eight hours embarkation leave.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He avoided Turpin and Bodell, since it seemed obvious that they would resent his dodging the glasshouse, would therefore have it in for him and be looking for one last way to take a poke—and whilst it was tempting to make up his bed by numbers, lay out his kit to a grid and then unzip and piss all over the lot, it was a temptation readily resisted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He spent a quiet, sad weekend back in Sidney Street—Merle poised wistfully in front of a cold cup of tea lamenting the downturn in trade since peace broke out—walked the streets of the old manor in search of faces he knew, concluded that everyone he’d ever known, every kid and every scallywag, was now in uniform and elsewhere, and boarded a Cambridge train at Liverpool Street Station two days later, not glad to be there, or anywhere, but feeling that he was nowhere, and hoping this sensation would not last.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Much more to his surprise Burne-Jones met him off the London train at Cambridge Station. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You thought I wouldn’t show up?” Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing of the kind. And don’t look a gift horse in the mouth. Or in this case a gift MG in the radiator.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had never thought much about cars. They had always been beyond his reach. He knew no one who owned a car. He’d never even been in a London taxi. He’d not yet learnt to drive. But if he did, when he did, this, a neat little open-topped 1938 MG two-seater, was what he’d like to own.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sling your kit bag in the back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Driving up Hills Road towards Parker’s Piece, Burne-Jones said, “You’re in digs a couple of streets from here. There’ll be no room in college, what with dozens of chaps returning to pick up the degrees they put on hold during the war. But you’ll be fine. Besides, you get a taste of living in hall and it could spoil you for life.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe I’m ready to be spoiled. Very few opportunities to get spoiled have come my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My point exactly. You’re vulnerable. Seducible by easy living. And if you get seduced . . . you’re no bloody good to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness handed over his kit bag to his new landlady—an aproned, tiny, floury, cockney woman called Mrs. Wissit, who looked not unlike his great-aunts and who did not look likely to seduce him—and dashed back to the car.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’ll go into college. I’ll introduce you to a few people I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You went to Cambridge yoursel"), _c('span', [_vm._v("f")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Magdalene. 1920 to 1923, and again in 1926 for my master’s. Hasn’t changed much. I’ll show you around. There’ll be about a dozen other chaps doing the crash course with you. And if you could try to remember ranks for the rest of the afternoon, mine included, I’m sure we’ll all get along pretty well. Just say sir from time to time, on the basis that everyone you meet today, whether in civvies or in uniform, will probably outrank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll do my best.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just try, Holderness. Just fucking try!”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§31")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Wilderness became aware of the phenomenon of town and gown, and equally aware that he was neither. He mixed with undergraduates without being one of them, and while he wasn’t exactly town, he never wore a gown, he wore his RAF uniform. He was one of twelve students of Russian and German assigned to a short-term course by His Majesty’s Forces. Two RAF, four Royal Navy, two of whom were the same age as Wilderness but not the same class, and were newly-commissioned sub-lieutenants—that is green whilst being blue—and six soldiers, two of whom were NCOs in their midtwenties, far from green, who had seen combat in the war and elected to stay on with Burne-Jones’s unit. They also elected to have nothing but contempt for the “kids,” officers or other ranks, who had not taken part in the war, and that was everyone else on the course. In between the active and the inactive, but receiving no less contempt was a fat artillery bombardier with a broad Birmingham accent, and a demeanour of contained misery, who had been called up in 1942 and had spent the entire war in England as a driver.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Even rationing doesn’t make me thin. I reckon they did me a favour. Too fat to be fit. Basic training was a total bloody nightmare. Jump this, jump that. I look like Porky Pig and they wanted me to be Road Runner. So I got trained as a driver. Jeeps, staff cars . . . driving officers and nobs. I drove Anthony Eden across London once during a V-1 raid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wondered if this was Bombardier Clark’s way of saying he had done his bit. He didn’t care if he had or not.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Could you teach me to drive?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“O’ course. But we haven’t got a car.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You leave that to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("However superior the NCOs felt, it was Clark and Wilderness who shone at languages. In weekly tests of what they had learnt, Wilderness came top and Clark invariably second, followed by the two navy sub lieutenants and everyone else an also-ran. It narked the NCOs, but not half as much as Wilderness’s inability to respect them, their rank or their experience.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On one of his occasional, unannounced spot checks—roaring up in his MG, a dozen belt-fed machine-gun questions rattled off—Burne-Jones found Wilderness bruised, scabby, and with an Elastoplast over one eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness would not tell him that the two infantry corporals had given him a kicking for his cheek, but Burne-Jones was no fool and readily deduced it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You want to report this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not. You think I can’t handle a pair of fucking twats?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Holderness, is everyone in a uniform a fucking twat to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Just the NCOs, and to prove it you can have a sir at the end of this sentence, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I hope I don’t come to regret you Holderness, I really do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m good at this, you won’t have any reason to regret it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of those non-committal toff words that Wilderness was adjusting to—it was less than meaning, more than punctuation.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not only good. I’m the best you got right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That I can’t deny. Top of the form. But is there a point to you telling me this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. The quid quo . . . quid . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quid pro quo. Nice try, Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I want something in return.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We don’t make deals.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It isn’t much. In fact it’ll cost you nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones could have walked away at any moment. He didn’t. His look said “try me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Birch,” said Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aircraftman Alexander Birch. The kid who pissed himself on parade.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah, yes I do indeed recall.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I want him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Meaning?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s still back in Essex doing his basic training, while I’m here leading the life of Riley. I want him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve no use for him, Holderness. You were the only one who met the IQ requirements.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not talking about that. What I mean is I want him out of the RAF. Away from those tosspots who’ll drive him to suicide before his ten weeks are up. Get him discharged. Medically unfit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But he was passed fit or he wouldn’t be in the bloody RAF.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then un-pass him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s got two years to serve, just like everyone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s not that easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never said it was. But if it were impossible you’d have said impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two years, Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fine. If the king can’t spare ’em, I’ll serve his two bleedin’ years, You can sign me up till 1949.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re not joking?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Just get him out and back in civvies before those fuckers kill him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Was he charged after the piss incident?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. They blamed me for everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jankers?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All they could pile on I’d imagine, but no formal charges.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Alright, you have a deal. And you tell no one. Mr. Birch will be back in Civvy Street by the end of the week.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thank you sir. You are a gentleman . . . and I am a scholar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The grin was too much for Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t push it, Holderness. And don’t let altruism ruin you. Or you’ll be no bloody use to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones got back in his MG. Wilderness went in search of a dictionary and looked up “altruism.” It was not something he thought would trouble him much.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§32")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was tempting to be a schoolboy and slip laxative into the cocoa of the two infantry corporals or to let down the tyres of their ubiquitous Cambridge bikes, but it went against the grain of everything he had learnt from his grandfather, chiefly that vengeance could and should be tempered with profit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was easy enough to find out where they boarded, and almost as easy to slip in when no one was home and rob them of everything worth stealing. Two burglaries in a single wet afternoon while both corporals were stuck in remedial German grammar would point the finger squarely at him, so he chose the digs of the bigger, nastier of the two and netted seven pounds seven and sixpence in cash, a pair of gold cuff links, a silver cigarette case and several back issues of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Men Only")]), _vm._v(". It felt odd, like practising an instrument after months of neglect—a strange tingling in the fingertips as though they itched not for the easy pickings of petty theft, but for a safe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On his next trip to London he sold the gold and silver to Abner’s fence and on his return took Clark out for an off-the-ration meal at one of the city’s better restaurants. Much to the bafflement of the waiters they conducted their entire conversation in two languages. Clark would speak in German, and Wilderness was obliged to respond to whatever he said in Russian. And vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Мне кажется, что если мы не были в форме, они уже позвонили бы Полиции")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v(".")]), _vm._v("” Wilderness said. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Verdammt richtig.")]), _vm._v("” Clark replied.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness switched to English over the coffee, not yet feeling he could string out every vital thought at its proper speed in any foreign language.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve never eaten in a restaurant before.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can tell,” said Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not counting chippies of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I have. When I was a War Office driver, the back pay used to pile up by dribs and drabs and about once a month a few of us would go up West and have a bit of a blowout. It’s what got me interested in languages, reading menus in French.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Filet mignon")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Steak, posh steak.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Et pommes dauphinoises")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You got me there, Eddie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Spuds in milk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sounds awful.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Y’know. One day, I’m going to go into one of those posh restaurants and eat my way through the menu.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Literally?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah . . . but have anything, absolutely anything I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Clark paused, drew breath.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ve never really lived have you, Joe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m eighteen and a half, Eddie. How much living do you want me to have done?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m only twenty-three meself. What I mean is England isn’t one world, it’s several. Let’s not kid ourselves that because we’re on first-name terms with a couple of navy sub-lieutenants and the colonel’s not above using our first names when it suits him, that us and them live in the same world. We don’t. Going up West was a wartime treat. It would have been unpatriotic for any restaurant to have been snotty with us, but the war’s over. English snottiness will be back in spades. And we’ll be down the chippie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I say, waiter, cod and chips twice with an extra helping of mushy peas and a saveloy. Pip pip!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Clark giggled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How do you do that? You sound just like Burne-Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ain’t difficult Eddie, and if all it takes to pass for a toff is sounding like one and looking like one . . . well . . . their world is ours for the taking isn’t it? A bit of ventriloquism and a decent tailor and it’s ours.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not sure I want it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I do. I want the bleedin’ lot. I wants what’s mine, and if some other tosser’s got it I want what’s his too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For a chit of a kid, you certainly scare me sometimes, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§33")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness had no idea why or how a serving officer might come to pawn his uniform, but at the back of a dusty, cobwebbed window in a pawn shop in the Mile End Road there hung the jacket and trousers of what his fag cards (buttons grouped in fives, ludicrously embossed with leeks) told him was a second lieutenant in the Welsh Guards.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, I remember him. Three sheets to the fuckin’ wind ’e was. One day in, I reckon it was January 1943. Said he’d come on leave without evening dress and could he swap his uniform for a full DJ and dickie until Monday morning. Well, I got five bob off him up front, ’cos if he never come back I was stuck with the bleedin’ thing wasn’t I? And he never did. Not seen him again from that day to this. Either he was so pissed he forgot where the shop was, and if he weren’t pissed and lost, what was he doin’ in the bleedin’ Mile End Road in the first place? . . . or he copped it. Either way I got stuck with his uniform.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two quid,” said Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Three,” said the pawnbroker. “This ain’t tat. This is the proper clobber. Gieves and Hawkes. Savile Row tailors they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two pound ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Done, but yer robbin’ me blind, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Looking in Merle’s full-length mirror on the front of her wardrobe he thought, “Not bad. Bit shorter than me, a bit fuller.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle said, “Nobody looks at your feet. The length don’t matter. ­Tighten your belt and the tum’ll be OK. What people look at is your face. If you’re going to pull off the stunt I think you’re going to then what you need is a proper haircut—and I don’t mean the ninepenny barber down the road. I mean a proper job. Half a dollar up West.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("In an alley off Jermyn Street, he strangled his vowels, got a haircut for half a crown—a ludicrous sum of money, but the trick, he knew, was to suppress all sense of the ludicrous—and took himself for tea at the Café Royal.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Café Royal was nothing more to him than a name. He’d never been there. He had no idea if royalty might be there. One of his childhood heroes was forever eating there, but A. J. Raffles was fictional. He’d no idea what would be on the menu, but assumed that at four o’clock they would probably be serving tea and cake. All he had to do was catch his dropped aitches before they hit the carpet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a caff. Just a caff. A caff glorified by waiters dressed like penguins, by a lick of paint and a clean cloth on every table, but a caff. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was shown to a table with a degree of obsequiousness unknown in the Mile End Road—and over Assam and Battenberg pretended to read the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Daily Express")]), _vm._v(" while looking at and listening to everything around him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It reminded him of going out on jobs with Abner. He was peeking into other rooms and other lives. It was the same feeling he got creeping around in some rich woman’s bedroom. Every sight, every scent was fascinating. The real difference was not in his visibility—he was surely almost as invisible at four in the afternoon under electric chandeliers as he had been in the crepuscular light by which Abner worked. The real difference was he had not snuck in through a window or shinned down a soil stack, he had walked in through the revolving door. It wasn’t his world, it might never be his world, but it was just a game, a game of manners and illusions and deceptions, and at that a game he could play. Raffles got away with everything. He could be as fake as Raffles, and get away with everything. ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§34")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Eddie Clark did not agree.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You stupid bugger. Masquerading as an officer. It’s a court-martial offence!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Supposing you’d been rumbled?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I wasn’t. I remembered to tip the waiter. I got a cab to King’s Cross. Tipped the cabbie. Once I was on the train I nipped in the bog and changed back into my RAF togs. Nobody rumbled me. In fact I’ve found only one thing not to like about being a toff.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And what might that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All this tipping lark. Never had to do that before. But then I’ve never had tea at the Café Royal or ridden in a cab before.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And your point is?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My point? My point . . . my point is it’s our world Eddie, not theirs.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§35")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The first car they stole was a 1937 Crossley 26/90. A plain four-door model with no exotic, athletic ornament on the radiator cap—as though Crossley Motors had anticipated the austerity to come.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We don’t want to attract too much attention, now do we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe—I don’t want to attract any attention. I’m not past a bit of coupon fiddling, but I’ve never nicked anything in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We aren’t stealing it, Eddie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How do you reckon that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Cos if there’s no one about when we’ve finished, I’ll put it back where we found it. And if you have any of those hooky petrol coupons about your person we’ll even put a gallon in the tank for him. Now I’m going to head out in the direction of Trumpington, you just tell me when I do something wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie told him not to crunch the gears, to ease his foot off the clutch not just let go of it, to make more use of the mirrors.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re not half bad for a beginner,” he said. “Get some miles in and you’ll pass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The coast being clear, Wilderness parked the car back where he had found it. As they walked away, he taught Eddie a thing or two.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never look over your shoulder. It’s a dead giveaway.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whatever you say. But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah? What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are we going to go on nicking cars?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t see why not. Nobody loses. Bloke who owns the Crossley made half a gallon of petrol and still has all his coupons.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then, next time, would you nick something a bit smaller.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two days later, they had arranged to meet by Jesus Green. Clark stood watching as Wilderness roared up in a 1938 MG.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This small enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . but . . . that’s Burne-Jones’s car.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All the way to Newmarket, Eddie said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the way back he said, “You’re still not using your mirrors and you stay in third too long.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he said, “Do you do things like this just because you can?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not quite with you there, Eddie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I mean—what are you trying to prove? You could have nicked any car. You didn’t have to nick Burne-Jones’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He insisted on getting out at Parker’s Piece, well short of the city centre, well short of Queens.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Y’know Joe . . . I think I’ll get shot if I stick with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§36")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("About a week later, Burne-Jones called Wilderness to a meeting in rooms at Queens.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re doing very well. In fact too well.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How do make that out?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You’re ahead of the class. I am told that the pace at which you learn is forcing the tutors to speed up and that isn’t working out for the rest of them. Hence I’ve arranged more private tuition for you. Native Russian speaker. Probably the best tutor in the business. Think of it as your finishing school. It’ll mean you going up to London twice a week, but I doubt that’ll be a hardship for you. Tuesdays and Fridays from now on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones fished around in his pockets, found a battered, dog-eared calling card and handed it to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at it.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Countess Rada Lyubova")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("99 Douro Mansions")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Cornwall Gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("London SW7")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-03"
  }, [_c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Tel : Knightsbridge 349")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not your neck o’ the woods I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I might have seen it from the top of a bus. Where is it exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sort of between the Albert Hall and Earl’s Court.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ah—he knew now. He and Abner had pulled a couple of jobs in Earl’s Court.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This Friday? Like tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, Holderness, tomorrow. Just gives you time to fit in another driving lesson.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stared at him and said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones threw him the car keys. Wilderness almost dropped them, clutching them to his blouse with one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’d prefer it if you didn’t hot wire my car, and if you could see your way clear to making it two gallons of petrol this time I’d be most appreciative.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the piece of paper again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Countess? What do I call her?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“You’ll think of something. Either that or she’ll tell you. But it’s what you tell her that matters. She is a Russian. Don’t ever forget it. And I’ve never been quite sure whose side she bats for. So you tell her nothing you don’t have to. Not the names of your fellow students. Nothing. Not the size of your feet. Nothing. Do you understand me, Holderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§37")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Cornwall Gardens was like an island shrouded in mist. If you didn’t seek it out you’d never stumble on it, tucked away as it was between Victorian extravaganzas—the Albert Hall, the museums—and Victorian ­practicalities—the curve of the Circle line as it cut its way from Kensington High Street to Gloucester Road. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He could scarcely believe anywhere in central London could be so quiet, so utterly devoid of traffic, only a hundred yards from the Cromwell Road.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Douro Mansions was a large and rather dirty redbrick building sitting next to the railway cutting. A hydraulic lift hoisted him up to the ninth floor, with a smooth motion, silent but for the gentle hiss of water under pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When he rang the bell a small face peered around the door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah you must be Alec’s boy. Aircraftman Wilderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A small woman, with masses of thick, black curls—the high cheekbones and fine lines of a fading beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Er . . . that’s Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite so, quite so dear boy. Wilderness. I haff been expecting you. Come in, come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She left him standing in the open doorway, and, leaning on a walking stick, bustled away to the end of a dim corridor. As he followed he could just make out the dozens of framed photographs that lined the walls—peeling strips of passe-partout, cracked glass, and clinging cobwebs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She flicked on the overhead light. He could see her clearly now. No more than five foot two, slim, lithe even, but leaning heavily on the duck-head handle of her walking stick. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She met his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, I am not totally increpid, young man. I simply twisted my ankle on the threshold at Derry & Toms department store the day before yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Increpid? Why not?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps I can sue them? Are you familiar with the law?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Only in so far as I break it now and then.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She smiled at this. For a moment he thought she might laugh, but it was a bubble that never quite broke the meniscus. He could only guess at her age. She could be anywhere between forty and sixty. He was careless about middle age. Ignorant of middle age. Merle was the oldest person he knew. The countess was not of his era and he had no idea which hers had been. Had she been a girl at the turn of the century? On the eve of the Great War? A Russian beauty to drive the young men wild?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Husbands,” she said, seemingly apropos of nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he realised, the photographs. They couldn’t all be her husbands. No one could marry that often.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She tapped lightly with her free hand on the one nearest Wilderness’s chest.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My first. Leonid Andreyevich Lyubov. Ten thousand acres and a castle in Estonia. Shot himself in 1915. Couldn’t wait for a revolution any longer. Silly bugger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her hand moved like a knight advancing on a chess board, across and down.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My second. Piotr Ilyich Zakrevsky. Composer of romantic symphonies that were thirty years out of date before the ink was dry on the stave. Taken in the flu pandemic at the end of the Great War.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pawn takes pawn.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fyodor Ivanovich Ranevsky. A colonel in the Red Army. Loyal to Trotsky. I left him after six weeks. I never knew what fate befell him after 1924. I asked, of course I asked. Letter after letter. Stalin even replied to one. I had him declared legally dead in 1932, so I could marry my fourth . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Straight up almost to the picture rail—rook to bishop 4, her arm stretching out.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Graf Klaus von Rittenberg. Another ten thousand acres, another castle, but of course he’d abandoned both in East Prussia years before I met him. Died on me. Just before the last war started. Just as well. A German in London. You English would haff locked him up I daresay—Klaus would haff hated being locked up. I didn’t haff the heart for any more husbanding after that. There was the odd candidate, but as you can see I am grown old.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So, she was a German countess. He’d never met a countess before, of any nationality.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She led him into her parlour—a room lined with books, books in shelves, books stacked on tables, books in piles on the floor, and dust everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She pointed to a large, empty birdcage.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I also haff no heart for parrots any more. The one before was an artist, could recite almost whole sentences. ‘Half a league, Half a league . . .’ but then he’d stop. This last was a lazy bugger . . . he’d copy the creaking door or a fart, but he wouldn’t say a damn word. So tiresome. Really I was quite glad when he fell off his perch. Now, Alec tells me you are learning Russian?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And German.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Very well, from now until you leave we shall talk in one or the other but not in English. That is the rule. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Verstehen Sie?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§38")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Naturally averse to rules of any kind, much to his own surprise, he found Rada’s rules acceptable and easy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He had no idea how to address a countess.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Call me Rada.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He longed to be out of uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wait till the suit you own is better than the uniform the king supplied for free. We both work for him, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On his second visit, the following Tuesday, he found her on the floor, the duck-head walking stick discarded, clipping articles from newspapers with pinking shears. Not the ideal tool, but clearly what she had to hand. They left the clippings with serrated edges. Part news, part history, part dress pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are you doing?” he had asked, as the rules demanded, in German. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("“Was machen Sie?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Making history,” she replied. “In so far as the keeping of the record is the making. Others act. I record. I comment. I rage. I kick against the pricks.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, I don’t follow.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She prised herself off the floor. Surprisingly supple now the ankle had healed. She led him to the longest wall, the one without a window. A room-wide rack of books and folders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How old did you say you were?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I didn’t, but I’m almost nineteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. A National Service"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("man")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite so, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("un ragazzo")]), _vm._v(". And you know nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know things you don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Such as?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Such as how to open the wall safe you have hidden behind that awful oil painting of some old bloke.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her head turned to the portrait. He thought she might take offence, but she was smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My great-uncle Nikolai. How can you tell there is a safe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You hinged the picture at the right hand side. It hangs very differently from the way it would if it were on a wire and a central hook. I spotted it at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Ah. No matter. You see . . . my files. I have clipped the papers since I first arrived here nearly twenty-five years ago. They hold . . . they hold whatever takes my fancy. And that is the wrong word. Most certainly the wrong word. But they are things of which, I say again, you know nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Am I to blame?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ragazzo")]), _vm._v(". But . . . but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She pulled at one of the thin cardboard folders, and half a dozen tumbled to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("‘Appeasement.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("‘The Rhineland.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("‘Armageddon.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("‘Hitler.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Take them, take any, take them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought I was here to learn Russian.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are here to learn. Does it really matter what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then trust me. You are a natural at Russian. And German too for that matter. You don’t need me to teach you languages. A quick polish here, a bit of dusting there. A tweak or two at your accent. You will be of much more use to Alec if you know the world as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Alec?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Colonel Burne-Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§39")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-13"
  }, [_c('span', [_vm._v("Later. In bed, at Mrs. Wissit’s boardinghouse, he read the file named “Armageddon.” It was everything Rada had ever found on the atomic bomb. Indeed, she had been prescient. Long before the bomb had been much more than a fantasy she had clipped the papers in three or four languages—­anything she could find on the meetings of obscure physicists at conferences across Europe at which they discussed the atom and its fission at a purely theoretical level. He made a start on French (“Make what use of that you will, Alec”) and learnt the names of Niels Bohr, Otto Hahn, Lise Meitner, and Werner Heisenberg. It settled in a sedimentary layer of the mind, compressing slowly into meaning. None of it quite made sense, and none of it would ever quite be wasted. And suddenly it all jerked to the moment, as though kicked into life, as the clippings came almost up to the present and recorded the bombs that had fallen on Japan . . . and the names were names like Robert Oppenheimer, Edward Teller, and Karel Szabo.")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§40")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("His supposed practice in German and Russian now became a test of how well he could hold his own on current affairs, history, and the arts, in several languages. They would often begin with something close to absurd—she would have him translate an episode of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tintin")]), _vm._v(", a page from "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Dead Souls,")]), _vm._v(" or the entire menu she’d saved from Quaglino’s one night in 1936 . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("potages")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("poissons")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("légumes")]), _vm._v(" . . . there were more ways fish could be cooked than he’d ever imagined in a Mile End chippie . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Dieppoise")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("czarine")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("meunière")]), _vm._v(". But that was the point—things he had never imagined. And then they’d dissect the century.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As the days grew longer he stayed later at Cornwall Gardens, often rushing to the Piccadilly Line to arrive at King’s Cross or Liverpool Street in time for the last train of the night. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She would talk to him about anything and everything. The people in Petrograd. The weather in Warsaw. The food in Florence . . . the beer in Milwaukee.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had danced with Kaiser Bill in 1912 . . . “more charm than you might imagine.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had dodged anarchists in Moscow in 1918 . . . “monsters who killed for pleasure.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had fled the Bolshevik Cheka . . . “rough justice that became an institution.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had turned back at the British lines near Archangel . . . “such folly.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had crossed Siberia with the remnants of the Czech Legion . . . “not many ever saw home again.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had found herself caught between the Japanese, the Americans, and even the Italians at Vladivostok in 1920 . . . “poor buggers stranded in a land without tomatoes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How an American infantry major had taken her back to San Francisco with him . . . “I might have married him but for the uncertain fate of my third husband.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had landed in England, far from penniless, in 1923 . . . “but money isn’t everything.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had been wooed by H. G. Wells in 1925 . . . “he loves to talk, usually about himself.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had plunged into London society . . . “such a fuss.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had danced with the Prince of"), _c('span'), _vm._v("Wales . . . “such a bore.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How she had slapped von Ribbentropp’s face at a reception in 1937 . . . “such a pig.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stayed later.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On one occasion he slept on the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let us not make a habit of this. I see no reason to let anyone of your age catch me in my dressing gown.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had been his bad luck, the next morning, to meet Burne-Jones leaving King’s Cross as he was entering.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones had said, “Anything I should know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Wilderness had replied, “How do I know what you think you need to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§41")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Late in June, after an evening discussing the crisis in Greece, the demise of the League of Nations, and a recipe for ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Oeufs Balzac")]), _c('span', [_vm._v(" (truffle and ox tongue), she had led him out onto the tiny, west-facing terrace. Just big enough for a small table, a couple of chairs and a row of dead plants in terracotta pots. They had watched the sun set over Kensington, making a chiaroscuro of the plain backs behind the ornately fronted Art Deco department stores on the High Street, Pontings, Barker’s, Derry & Toms—a reddening sky across all the boroughs beyond that he never quite knew the names of and had never visited—and they had sipped champagne and nibbled on warm toast and chilled caviar. The champagne was off the ration, the caviar probably counted as fish on the coupon—no more or less than cod or kippers—God only knew where she got hold of ice—and the bread wasn’t rationed either, though there were rumours that it might be soon. He liked neither fish nor fizz. It was just another recipe, another part of the glossary. No more than a practical test. No more or less than ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tintin")]), _c('span', [_vm._v(" or another egg recipe. As with so many toff things he faked the pleasure and wondered at the cost. Chips and a saveloy, pip pip!")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I could watch sunset all day,” she said. “I haff seen sunsets over the Atlas Mountains in North Africa, I haff seen sunsets over the myriad lakes of Finland, and through the giant redwoods of California.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I never much bothered, meself. Sunset over the East India Dock Road doesn’t have the same ring to it. Besides you can’t watch them all day. There’s only one a day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On this planet. Who knows about other planets? Perhaps there really is a planet somewhere out there on which one can watch the sun set forty-four times.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Forty-four? How do you reckon that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh . . . one would haff to keep moving the chair of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He giggled, snorted champagne, felt the rush of bubbles down his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And for all that, for all those places . . . a sunset still reminds me of home. And there is no earthly reason why it should.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you miss Russia?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you wish you could go back?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now you’re just being stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t miss Stepney.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . not yet anyway . . . but you will. Meanwhile . . . what is the place of birth but a jumping-off point?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You are a boy . . . a better-educated boy than when we met, of that I shall flatter myself . . . but a boy. You will miss nothing for a long time to come . . . but one day you will be so far from Stepney . . . physically, morally perhaps, that you will look back at it and wonder how you ever got from there to wherever you are in . . . I pluck a date from the air . . . 1963 . . . an impossible figure . . . only H.G. or Verne could ever conceive of such a time . . . men on the moon . . . a war of the worlds . . . and you will look back . . . believe me you will . . . the physical distance will mean nothing, the moral distance may, but the emotional distance and the passing of time will rip through you like hawk and handsaw.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She downed half a glass o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Veuve Clicquot. A silence he would not fill. No glib remark about the East India Dock Road would do.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But,” she resumed, “if you weren’t looking at the sunset or gazing at the stars, what were you doing, Wilderness, looking at the gutter?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had forcefully changed tack on him, swung the subject away from herself, away from the tears that had formed in the corners of her eyes but would not roll.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not especially,” he said, looking down into the bubbles of his champagne, then lifting his eyes past her and staring westward. “Standing in it some of the time, for sure. But mostly I looked at the streets, the people in the streets, and when I wasn’t looking at the streets I had me nose in a book. I was . . . I was . . . a . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at her now. The tears had vanished. They might never have been there at all.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A word child?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. That’ll do. That’s exactly what I was. A word child. It’s what I am. A child of language . . . a word child.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course you are. That is why Burne-Jones chose you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is it? Chose me for what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Rada had a way of not answering any question she didn’t want to answer. The dark eyes might smile at him, but the lips would move only to change the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He tells me you have signed on for another two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, well. He won’t hold me to that. He’ll have had enough of me after two years’ National Service.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But she was shaking her head.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh no, oh no no no.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She made him wait as she downed another half-glass o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Veuve Clicquot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He has you. He means to keep you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bugger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You might have realised that the moment he sent you to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("A little after eleven she bundled him towards the door, shoved another couple of folders under his arm—“FDR—The Tennessee Valley Authority,” “The Death of Leon Trotsky."), _c('span', [_vm._v("” ")]), _vm._v("The short excursion to watch the sunset had made him duck through the rarely opened French window, and he had cobwebs in his hair. She stood on tiptoe, brushed them away and as her fingers ran across his cheek she, who had seemed always to avoid touching, had kissed him on the cheek. The only time she ever did so.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rada, what did he choose me for?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Спокойной ночи")]), _vm._v(" (Good night) Wilderness. It is time for candlewick and cold cream.” ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§42")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("One day, later in that same summer of 1946, a letter arrived at his digs by the second post of the day. It was from his father, contained no return address, and was easily the longest communication of any kind that he had ever received from the man—and the first in four years. Wilderness knew where the regiment had been. He’d been able to follow the course of the war and the regiment’s part in it in the newspapers. His father had fought under General Montgomery and helped defeat Rommel, had landed in Sicily, fought up the spine of Italy, through the South Tyrol and into Austria, where he had met up with the Russians or the Americans or both. And only the absence of any letter from the War Office informing him of his father’s death gave him reason to think the old man had survived all this. But he had, and here was the final proof scrawled in pencil on lined paper.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('span', [_vm._v("Son, I’m due for me demob. Back in Blighty. If you can get away meet me at noon on Saturday. You remember that last holiday me and your Mum took you on before the war? It was 1937 or maybe 1938, we went to stay with your Great-Uncle Ted in Felixstowe, and one day we caught a ferry over the river and walked out along this shingle beach all the way to that martello tower they got out there. I reckon it was called Bawtsey or Battsey or something like. Anyway meet me there. Dad.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was Bawdsey beach, and it had been 1936. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Come Saturday, Wilderness caught an early train from Cambridge to Ipswich. In Ipswich he changed for a train to Woodbridge and in Woodbridge he stole a bicycle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The ride was six or seven miles, and he arrived at the beach pretty well on the dot of noon. Riding a bicycle on shingle is impossible, so he propped it against a groyne and set off on foot for the tower and what he perceived to be a human speck at the water’s edge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Closer, the speck was clearly his father. Closer still, it was his father stark naked, staring out to sea, his khaki uniform a neat, orderly, barrack-room stack at his feet, even down to the crowning effect of the tin hat and the black boots splayed at forty-five degrees. Closer still and Wilderness could see that all his father was wearing were his army dog tags—two small pressed discs, each about the size of a florin, on a green string around his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Well,” Harry said. “Here’s a how de do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was the sort of thing he would have said to his son ten or twelve years ago—a nonsense phrase for a small boy who strived for literal meanings to puzzle over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at his father. He could not recall that he had ever seen him naked, and certainly the man had no sense that he was. The coast of the North Sea is never warm, and for all the beauty of its beaches it is a hardy soul that strips off there on any day. Harry’s skin rose up in an alpine terrain of goose pimples, and the muscles in his chest twitched involuntarily. His genitals had contracted to an olive perched atop a walnut. But it was the scars that drew the eye. A brown, bronzed body, taut with muscle, and punctuated by scars.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Across his left arm and left thigh ran raised, paler welts where bullets had skimmed his flesh. Wilderness could imagine him being bandaged up in a field hospital and stood down for a week. On his right thigh was a moon crater where shrapnel had been dug out. Where had that happened? How long had he been hospitalised with a wound as nasty as that? What was a man his age—still under forty by Wilderness’s reckoning, but an “uncle” in infantry terms—doing in the front line?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” he replied. “A bit of a how de do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m glad you could make it son. We haven’t a lot of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Haven’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harry nodded, a tilt of the head seaward.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Doesn’t do to hang about. I mean to say, once your mind’s made up it’s made up, innit?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suppose not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And there’s not a lot to be said.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He paused. It seemed to Wilderness that he was waiting on him, and looking at him without quite seeing him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But if I don’t say ’em now . . . well. I know it’s been tough for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Indeed it had. Abner’s conviction that Harry had been “a nutter since Dunkirk” was a portion of the truth. Harry had always been a nutter who expressed his emotions with his fists. Dunkirk had simply made him a worse nutter. Shell shock, that old phrase from the last war, did not begin to explain Harry Holderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And,” he went on. “What’s the bleedin’ point of sayin’ sorry. What’s done is done. So I thought, I should just say goodbye, wish you all the best and hope you make a better job of this life thing than I could.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thanks,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . I’ll be off now. It’s good to see yer, and you look a treat in that uniform. RAF, who would have thought it, eh? You’re a big lad, you just ain’t filled out yet. But you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was not a copy of his father. As tall, he’d never be as broad. Nor did he have his father’s wispy red hair or his dazzling, bright blue, crazy eyes. The eyes that now looked into his.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was holding out his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shake, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness shook his hand. A more formal parting than he ever would have imagined, and watched as Harry walked out into the North Sea. It evoked the old classroom puzzle. How do you know the earth is round? Because of the way a ship vanishes over the horizon. Wilderness watched Harry until he vanished. And then he stood and stared a while longer in no anticipation of his reappearance—just to be sure that he had finally gone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he turned to the pile his father had left on the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The boots had no name in them and were two sizes too big. They could be left for some lucky beachcomber.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("In the pockets of the blouse he found a packet of Craven “A” cigarettes, with nine still in it, his father’s ration book, ID card, and more than fifty pounds in notes. He had, clearly, picked up his back pay and demob gratuity before setting off for Bawdsey—fourteen shillings for every month served was a pittance, but over five years and more it slowly mounted up. In the trouser pockets, twelve shillings and eightpence in change. The last item was a brown paper parcel. He tore it open and found a crushed trilby hat and a shapeless demob suit, pale grey with a thin blue stripe and in the inside pocket of the suit, the War Office documents issued by the demobilisation centre in Wembley formally discharging his father from the Army. Neither the blouse nor the jacket had a name in it. But on the front of the blouse was a row of ribbons, and it seemed to Wilderness that they could be read as a language, that there was a hidden syntax to the strip of reds and blues and greens, whereby an informed person could read the history of Harry Holderness’s war and hence, sooner or later, know that these colours had belonged to Harry Holderness. A man’s war in a colour palette. A neat and simple semaphore. The strip came away in his hand with a gentle tug, and he tucked it into his trouser pocket. The rest he left. Walked back to the bicycle with the brown paper parcel under his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness put the bike back where he had found it and boarded the next train for Liverpool Street, London. From there a short hop on the Metropolitan Line (Hammersmith and City branch) took him to Whitechapel Underground, a matter of yards from the house in Sidney Street in which Merle still lived. But he passed the end of Sidney Street, walked on past the Blind Beggar and the Gaumont cinema to a grimy shop-front on the other side of the Mile End road—“Abel Jakobson Tailor, formerly Minsky & Jakobson est. 1904.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With any luck the irascible Mr. Jakobson would be at home on a Saturday afternoon, or down the Catford dog track, and the premises manned by his diligent, civilised partner, Mr. Hummel—or as Wilderness had known him since he was a boy, Vienna Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah, Johnnie Holderness, looking every inch the hero in his RAF uniform.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hello, Mr. Hummel. I was hoping you’d be here. I got a bit of a job for you. I mean, a paying job.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No problem. I long ago gave up any notion of a Sabbath. Indeed, I have been wondering for a while now which of you street urchins would be the first to knock at our door in search of their first bespoke suit. I am glad it is you, Johnnie. It is a significant "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("rite de passage")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s not quite what I meant, Mr. Hummel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness unwrapped the demob suit. Laid it out on the cutting table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Could you tailor this to fit me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hummel turned the suit over in hands, rubbed the fabric between finger and thumb, turned down his mouth at the corners.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is it worth the effort?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. I never owned a suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s no reason to look like a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("shlump")]), _vm._v(". How much money you got?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Enough I reckon.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Spoken like a cockney miser. Follow me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hummel led him over to a hanging rail. Took off the cover and pulled out a single-breasted suit in a plain, dark blue.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This I made for Captain Gibson of the Sherwood Foresters. In the May of ’44. It has hung here in its wrapper these last two years. The poor captain was killed in Normandy before he could collect. Naturally, I wrote to his widow. The suit after all was paid for. But I never received a reply. Captain Gibson was your size. I’d be a poor excuse for a tailor if I could not see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What even without measuring me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t need a tape measure, Johnnie. Just try the suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Wilderness admired himself in the mirror, his mind juggling clichés . . . a second skin . . . like a glove . . . and comparisons . . . like Cary Grant, like Fred Astaire. The late captain and he had been cast in the same mould.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How much?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing. As I said, the suit is paid for.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . but it’s a much better suit than the one I brought in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Such understatement, Johnnie. It is an infinitely better suit than your demob sack. If I ever talk Billy into opening up in the West End this suit would cost . . . forty-five guineas. That’s what Kilgour and French or Henry Poole would charge in Savile Row this very day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fuck me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Genau")]), _vm._v(".” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mr. Hummel, if you are, as I think you are, offering to give me this suit, why did you ask how much money I had?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why? Because for two pounds ten shillings I will recut your RAF uniform so that it fits you as well as this suit. You will be the best dressed basher on the square.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t do square bashin’ Mr. H. I’m an egghead these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness left his uniform, strolled into Sidney Street wearing his Gibson suit, looking, as Merle told him, like a million dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Lunchtime Monday, he put on his tailored RAF uniform, felt like two million dollars, paid Hummel, and caught the next train back to Cambridge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He had not told Merle or Hummel about Harry. It would be more than a year before he would tell anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§43")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was about three months later. Towards the end of October. He let himself into the flat in Cornwall Gardens and called out Rada’s name. It was his intention, his desire, to surprise her. Wearing his Gibson suit rather than his uniform for the first time. The suit the king had not bought.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She did not answer. No “Chust a minute, dollink.” No “Put the kettle on, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ragazzo")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was sitting upright in her armchair, her chin resting on her chest, a book open on her knees, a folded page of unlined paper wedged into the spine. He read her last words, surprised to find they were addressed to him.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Wilderness, chéri —“Quand tu regarderas le ciel, la nuit, puisque j’habiterai dans l’une d’elles, puisque je rirai dans l’une d’elles, alors ce sera pour toi comme si riaient toutes les étoiles.” . . . au revoir, Rada.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He picked up the book to look at the title. What had she chosen to read in the moment of her death? A fairy tale, of sorts: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Le petit prince")]), _vm._v(" by Antoine de Saint-Exupéry. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He lifted her chin. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was not yet in rigor, and he smelt the scent of almonds on her lips. He did not know how he knew this meant that Rada had taken cyanide, and could only ascribe it to Hollywood films seen on matinees at the Troxy cinema—but he knew she was dead. He did not know where she might obtain cyanide—but he knew she was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He could see the grey roots to her hair. If he had noticed them before, he had blotted them from sight and from memory. Rada had not been old until now. Rada had been ageless until now. If she’d worn a wig . . . he would have noticed . . . Merle’s atrocious collection of wigs for her nights on the game had made him aware of wigs . . . but now he saw that dead Rada was old Rada. The years had not slipped away, they had accumulated, the twentieth century had fallen on her in a single coup. The Great War, the Russian revolutions, the death and disease that had followed in the wake, the starvation years of the twenties and thirties, the coming of the Nazis . . . death camps, gulags, total war . . . a continent of refugees . . . ragged, battered humanity on the move . . . everything that had wiped out her generation . . . for whom to grow old was a rarity. The survivors were few. Her false teeth had slipped in her jaw. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was not yet in rigor. He slipped the teeth back into place.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the wall safe. It was shut. He looked at the rings on her fingers, at the tangle of necklaces trailing out of a drawer in her rolltop desk. He smelt a faint scent of burning. Looked in the fireplace. A cascading pile of fine, feathery ash, as though she had burnt letters or papers. There’d been no crime here but the obvious one. And all his instincts told him not to get involved.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took out his handkerchief—a linen one, one of half a dozen she had given him on his birthday only a couple of months ago—and wiped everything he thought he had touched. He picked up the book, stuck it in his pocket, closed the door behind him, wiped the doorknob and went back to his digs in Cambridge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He told no one. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Lying on the bed, he read "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Le petit prince")]), _vm._v(" at a single sitting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He learnt of the forty-four sunsets, and . . .")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Quand tu regarderas le ciel, la nuit, puisque j’habiterai dans l’une d’elles, puisque je rirai dans l’une d’elles, alors ce sera pour toi comme si riaient toutes les étoiles"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He put the book on the shelf with the folders she had given him in ones and twos and half dozens. He had forty-eight. His private university. He would never part with any of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He told no one. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not Eddie. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie had been posted in August.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not Burne-Jones. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones told him. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next morning Mrs. Wissit called him to the hall, where the telephone sat in exile from the warmth of the kitchen, as though it might emit rays and curdle the milk or rot the brain.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Were you due for a session with Rada yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. But, I was coughing fit to bust, so I put it off. I’ll be going up later today instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You told her this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. She hated the phone. Always said if I couldn’t make it just to show up the next day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He hoped that sounded believable.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe—she died yesterday. Looks like suicide, but you never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then I won’t be going.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Come up to town. I’m there now. In her apartment. I need you to do something for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§44")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("There was a London bobby on the door of the block and another at the door of the flat. Both just said “Mr. Holderness?” and waved him in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The body had been removed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Someone had raked through the ashes in the fireplace.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Burne-Jones was sifting through the papers that remained on Rada’s desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good of you to come,” he said. As if Wilderness had any choice.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The painting in front of the wall safe that had so scarcely disguised it was open. The safe wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you open that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the safe. Then he looked at Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tell me. Is there anything you don’t know about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you do it or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Of course he could do it. It was rather small wall-mounted Cyrus Price, operating on a combination. Half the defence was in its concealment. The door and the tumblers would be simple.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes I can do it. Give me five minutes of silence and I’ll have it open.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good, because —”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I mean, silence. You have to shut up, and you have to stop rustling papers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Alright.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones sat down. Folded his arms. A child under sufferance. Instantly bored, he then picked up a book off the nearest pile and began to leaf through it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness took a tumbler from the kitchen and pressed it to the safe door with his ear. It took him less than five minutes. As he swung the door open Burne-Jones got up. Snapped the book shut, as though pointedly breaking the silence, and stuffed it in his jacket pocket—just as Wilderness had done only yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A souvenir of Rada. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Le rouge et le noir")]), _vm._v(" by Stendhal. Read it when I was about twenty-five. If I’d read it at sixteen I rather think my life would have been utterly different. Now, is there anything in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness passed him a fat sheaf of papers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No jewellery or anything like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“That was all in her desk. She didn’t seem to care much about it. But.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . you’re not interested in jewellery in the first place . . . and there’s a false panel at the back. Easy trick on the manufacturer’s part. You get the door open, make off with what you find and don’t think there might be a second compartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness took out his penknife and prised off the back panel.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Letters.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Letters?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“See for yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness handed over a bundle bound up in black twine. Burne-Jones turned it over in his hands. Riffled the letters like cards and stopped about halfway through.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Good Lord. Just look at these. Half a dozen of them. The edges of the envelopes, sewn up in cotton like the hem of a dress, and then sealing wax . . . talk about belt and braces. Never seen anything like it. Someone didn’t want these read by anyone but the person they’re addressed to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He threw them all back to Wilderness, sat down again, bent over the first pile of papers. Flicking rapidly through them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you looking for anything in particular?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve no idea what I’m looking for. She left no note . . . so . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness sat down and looked at his much smaller share of the loot. They were all letters, complete with envelopes, stamps and postmarks and all from well before the war. Some more than thirty years old. The foreign stamps were those he had collected as a boy . . . Germany: Weimar stamps in millions of marks, Nazi stamps with Hitler’s face in shitty brown . . . Russia: Tsarist stamps with the imperial eagle, Soviet stamps crudely overprinted to cope with inflation . . . France: stamps with revolutionary maidens in flowing dresses looking as though they had stepped straight from the barricades in a Delacroix painting. It was how he had learnt geography . . . and it was now how he learnt history, as Rada had lived it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He opened one, delicately sliding his fingers between the slit threads and the paper, watching a brittle flake of red sealing wax break off and fall to the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Sorrento. November 22, 1924.”"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("The paper dull, the ink faded, the Cyrillic handwriting precise as its era and devoid of modern scrawl—‘"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Дорогой Радочкe")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He opened a second. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tripoli. January 10, 1936.” Another precise hand, a geometric regularity, almost a typeface in itself—“Rada, chérie, j’ai tant de choses à te dire . . . le sable, les étoiles . . .” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything?” Burne-Jones said, still not looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything that might explain her death or might tell me one way or the other who Rada really worked for. I said I was never certain. I’d be delighted to find out it was us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“So, what am I looking for? An uncashed cheque from Joe Stalin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cut the flippancy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” said Wilderness. “Nothing like that. They’re love letters.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had saved the love letters and she had burned what? If Burne-Jones would not utter this, nor would he.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“What? Hidden at the back? Love letters? Love letters from whom?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones seemed genuinely surprised, almost incredulous, as though an unimagined side of her nature was unfolding before him. Wilderness was not surprised. The facts were new, not the feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well,” he said. “This one’s from Maxim Gorky . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . makes sense, I suppose. She knew Stalin, she knew Stravinsky. She’d know Gorky as well, wouldn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And this is from Antoine de Saint-Exupéry.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who’s he?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Another writer.” Wilderness said, feeling for the first time that he knew something Burne-Jones didn’t. “They were both writers.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§45")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The British Zone, ")]), _vm._v("Germany: Spring 1945")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("When the Führer announced the formation of the Volkssturm in October 1944, Max Burkhardt said, “That’s it. He’s calling up old men and boys. We’re fucked now.” He might have added “cripples too” as he, born with a club foot and hence lame for life, found himself pressed into service in the Volkssturm at the beginning of November.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Shortly before Christmas, convinced that Germany would lose the war and that Berlin would fall to the Russians, who had already entered Slovakia and were at the gates of Warsaw, if Warsaw had any gates left after the SS had finished with it, Max’s wife, Marie Burkhardt, sent their fifteen-year-old daughter Hélène west to live with Great-Uncle Klaus, the elder brother of her late mother, in a village a few miles north of Celle, a mile or so off the road to Bergen, in Lower Saxony.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_vm._v("21 Pfefferstraße,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("Charlottenburg,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("17 XII 1944")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02-indent"
  }, [_vm._v("… She is a bright child, she loves to learn—but an innocent, so trusting I fear that her life will be one in which others take advantage of her. But she is brave. She has stamped her little foot and stood up for what she thinks is right, however wrong she might be, since she first learnt to talk. Take good care of her Klaus and she will be all the reward you could ever ask for. ")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-15"
  }, [_vm._v("Your loving niece,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-15"
  }, [_vm._v("Marie")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-13"
  }, [_vm._v("ps Beware of her “po” face. It’s her biggest, perhaps her only failing. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell Burkhardt had spent the war in Berlin. Berlin was all she knew. She had no wish to leave. When the city Hitler had told his people would never be bombed was bombed late in 1940, the Nazis responded with typical efficiency with the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kinderlandverschickung")]), _vm._v("—a scheme more aptly and more curtly named “evacuation” by the British. Berlin’s children would, effectively, be deported to rural homes and specially built camps. Nell was eleven. She had no wish to leave, and her parents—Marie, a former university tutor and Maximilian, a civil engineer for the City of Berlin—easily evaded the rules by telling the medical examiner that Nell wet the bed each night. They might just as well have said she had bubonic plague or was Jewish. Her name was off the list. She would live or die in her own wet bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By 1944 everything had changed. The RAF had sent bombers over in wave upon wave of hundreds of aircraft, and while the death toll was low, and Berlin had not burned like a Roman candle or, more aptly, like Hamburg, the damage to the city had been vast. Besides, the RAF and the USAF were as nothing—the tide of the war in the East had turned at Stalingrad and only a fool would think the Slavic horde would not be the first to march down Unter den Linden. So when her mother put her on a train to Celle, Nell complied. A small fawn knapsack with red leather straps contained almost all she would ever keep from her childhood.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Great-Uncle Klaus met her at the station with a pony and trap. She had seen him only once before, sometime in the midthirties, and while she had changed to the point where it might have made sense to wear a label, he had not—conspicuous by the fulsomeness of his moustache, the look of a man a generation or more out of date. Modernity an age he would never come to know.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had no real idea how old Klaus was, and guessed at seventy. He had fought in the last war, and according to her mother had been middle-aged even then. He had come back from the Western Front, from the Second Battle of the Marne, a disappointed though hardly broken man, adorned with "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Eiserne Kreuze ")]), _vm._v("first and second class, had raised pigs in the gentlemanly manner and done his best to ignore politics, and with it history. The weather forecast mattered more to him than any speech Adolf Hitler could ever make.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Great-Uncle Klaus, being childless, had no vocabulary with which to talk to a fifteen-year-old. He sidestepped the obligation to send her to school, declined to enrol her in the local ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("BdM")]), _c('span', [_vm._v(", and offered her free access to his library—and whilst in most houses this might mean a shelf of forty or fifty books, in his it meant a room dedicated to reading, containing ten thousand books, in which Nell could continue her education on her own—ten thousand books which, she rapidly concluded, Klaus had inherited and never opened, so honed were his interests. She blew off the dust, and took a paper knife to uncut pages.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Klaus had taught himself to cook after all his household staff were directed into war work in 1941, and once the evening meal was served would engage her in conversation about the only things that seemed to interest him—Shakespeare, Beethoven, Mahler, and pigs. She knew next to nothing about the last three of these and was happy to learn. When the meal was over, often as not, the old man would wind up the gramophone and play records . . . Bruno Walter conducting Mahler’s Ninth, Artur Schna­bel playing Beethoven piano sonatas. And afterwards, a finger pressed to his lips and a gentle “ssshhh,” he would tune the radio set in to the BBC.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell passed the most austere Christmas of her life, and had no complaints. Letters arrived from her mother, but no presents—")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("“There is nothing left to buy in Berlin except Berlin itself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And in January she turned sixteen and passed the most austere birthday of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When the thaw came, late in March, a vast plume of smoke appeared in the sky a few miles to the north, black, turning grey, and a sickly-sweet smell of cooking fat hung over the house.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What is it?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Klaus stood on the threshold, his eyes fixed on the plume of smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The camp,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Camp? What camp?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He turned and went inside. Nell followed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A soundless, invisible stamping of the little foot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What camp? A "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kinder")]), _vm._v(" camp? A prisoner of war camp?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He sat at the dinner table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You have not heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Heard what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I have not told you. Remiss of me perhaps, but I had rather you had not known, and now it seems you must. A concentration camp. A camp into which the Nazis throw people in order to forget about them—the biggest oubliette in the world—a concentration camp that exceeds even the Nazi imagination. And, if what I am told in the town is true, they have been shipping in prisoners from the east, from other camps, for months now . . . Poles, Russians, Jugoslavians . . . Dutch, French, and Belgians that have shuttled back and forth across the Reich. Just so the Russians capture empty camps and free no one—and this one, Bergen-Belsen, overflows until it bursts.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the burning and the smell?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“I fear they are burning the dead. Of whom there may well be thousands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That night, as ever, they listened to the BBC and she learnt that the Russians were only a few kilometres from Berlin and that the distant booming that had peppered the sky for days now was the advance of the British.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was about three weeks later; she stepped out into the sparse sunshine of an April morning. Crisp, scentless air. There had been no more bonfires of the dead. She had asked questions in the town—no one but Klaus seemed to know anything about the camp—indeed the grocer had turned her out of his shop for daring to ask and upsetting his customers, and the burgomeister, another veteran of the last English war and an old friend of Klaus, had told her it was “nothing you should worry about.” It seemed to her that the only words missing from his evasion had been “pretty little head.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Klaus had shot his dog in 1943. The dog was old, and he would have hated to see her starve to death. Since then the kennel had stood empty, halfway down the track between the road and the house—its felt roof peeling back and its timbers rotting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As she approached a hand stuck out of the arch and a guttural voice said, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She hesitated; the voice spoke again, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She knelt down. The hand extended from a ragged cotton sleeve of dirty white with blue stripes. Where the roofing felt had parted a thin shaft of sunlight cut across the face of a gaunt unshaven man, hunched up with his knees against his chest. She could name every bone in the hand that held itself out to her, phalanx, carpal, metacarpal—it was less a limb than an anatomical drawing. Bone merely sheathed in skin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She ran to the house. Klaus did not smoke cigarettes. She found a pipe and tobacco and matches.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A second arrangement of bones emerged to grasp the pipe, the first tamped in tobacco and struck the match, then both withdrew into the kennel and a cloud passed across the face of the sun, the stripe of light vanished, and only a wisp of fragrant smoke drifting out showed where the man was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Later she and Klaus split their rations three ways and she put a portion of their evening meal out on a plate, just as she would in giving leftovers to a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He must have escaped,” Klaus said simply.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next morning she approached with bread and apple jam and ersatz coffee made from roasted acorns. Last night’s plate was empty, but next to it a pile of vomit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A British jeep roared by.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The jeep pulled up sharply and reversed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two men got out. A corporal-driver who stood by the car and a captain who approached her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The captain had the initials R.A.M.C. on a band sewn onto each shoulder, atop a large and curious serpent symbol. He looked at the hand, he looked at the house, he looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you live here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Accurate, if oddly accented German.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“With my uncle. An old man.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knelt down, peered into the dog kennel.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How long has he been here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Since this time yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“He must have escaped. The Wehrmacht have gone. There’s just a few SS left now. He must have just slipped out. I’ll have to take him back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Wehrmacht have gone. You just said so. They have surrendered. There is no need to take him back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh no, my dear. Not a surrender, just a truce. We took the camp without a shot fired, that was the deal. He has escaped from us not them. I can’t let him go or let any of the prisoners go. Typhus, you see. It could spread like a forest fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knelt down again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Come on, old chap, we’ll soon have you fixed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What came back was gibberish to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell said, “I think the only German he knows is how to ask for tobacco. He answered you in Polish.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And at least let me get him some.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("She dashed into the house, came back with a fat pinch of Klaus’s tobacco. Both hands appeared, the tamping down and the lighting up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You speak Polish?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . see if you can’t coax him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Before she could say a word a big British Army truck came up the road from Celle and stopped by the jeep. A short fat Army major climbed down from the cab. The captain saluted, after a fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s going on here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The captain explained and when he had finished the major turned and bellowed at the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jones! McKay! Crawley! On the double!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Three enlisted men came running.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Get this bugger on the truck. Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he turned to Nell.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“You too, and anyone else who lives here. Crawley, round ’em up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The first two men lifted the roof off the dog kennel, then they lifted out the skeletal man clamped on the end of Klaus’s pipe. He made no move to cooperate, said nothing, and blew smoke. It seemed to Nell he was weightless and if the soldiers let go he might drift off into air as lightly as his puffs of smoke. The third soldier emerged from the house, gently propelling Klaus along with the flat of his hand against his back.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He slung his rifle, slipped his free hand around Nell’s upper arm and escorted them both to the back of the truck. The skeletal man sat on the edge by the tailgate, still hunched up, bony chin resting on bony knees, drawing on the now lifeless pipe. Klaus reached into his pocket and handed him more matches. The crab hands flicked one into life.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As the tailgate swung up another truck drew up next to them. While the drivers talked, across the gap, Nell saw the burgomeister, wedged in between the grocer and the man who ran the pharmacy. He turned away from her gaze. She looked around. The two trucks held perhaps forty or fifty locals—sullen, resentful, or merely perplexed—and the skeletal man, who was none of these. She could see him clearly for the first time now, skin the colour of parchment, stretched across the cheekbones as tight as timpani, and as the truck jerked into life she fell down next to him and found herself looking into eyes that did not look back.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§46")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The small convoy of two trucks and a jeep arrived at the gates of Bergen-Belsen in a matter of minutes. The jeep led, and the truck carrying the burgomeister, the pharmacist, the grocer and, it seemed, every other district notable, overtook them as the first truck stopped to unload the prisoner. Two Tommies lifted him down, his teeth still clenched around the pipe, his limbs still tucked into his chest and sides as though minimising his place in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When they set him down Nell thought he might unwind like a watch spring, but he stayed hunched, sucking on the last of Great-Uncle Klaus’s tobacco.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She jumped down, the Tommies seemed not to notice her as they banged the tailgate shut and drove on another hundred metres.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell looked around her, lifted her eyes from this lone, troubling individual to the scene in which she had landed. She was washed ashore, driftwood bobbing at the edge of an unknown world, flotsam in a lagoon of barbed wire, marooned upon the dark side of the moon. He was not a lone individual, he was one of thousands. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Everywhere she looked living skeletons squatted, naked and half naked, everywhere she looked vacant eyes looked at nothing, everywhere she looked men, women, and children lay prone as sleeping dogs or hunkered down to shit where they were. And beyond them the dead, body piled upon body as they had been tossed out and tossed aside—rat-gnawed limbs, bird-pecked eyes and the concave stomachs of the starved.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She followed the trail in the dust left by the trucks, past wooden huts onto a flat parade ground. It resembled a grotesque jamboree. The British had provided tents, and the prisoners had lit campfires—fires by the dozen, fires by the hundred. A thousand billycans of boiling water. She picked her way across in a haze of smoke and steam. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("She peered into one of the huts. The smell hit her like a blow to the gut—death and shit and decay. The full blast of the corruption that wafted and faded all the way to Celle when the wind was southerly. An abattoir could not smell as bad as this. It was as though she had plucked the lid off the dustbin and come across a nest of maggots in stinking meat—but the meat was human flesh and the living and the dead lay side by side.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The old men were just in front of her, poked and prodded forward by the British. A shuffling line of the stout and the respectable, all dressed for the occasion. Old men in winter woollen overcoats, clutching their felt hats to their chests as though they might be entering a church, old men herded along like sheep. But sheep were never so silent.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She picked her way between them until she found Klaus. As she touched him on the arm to let him know she was there, a diesel engine started up with a roar and Klaus turned and pressed her head to his chest blocking her view.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But she squirmed free. Ducked underneath his restraining arm. Found herself on the edge of a pit some two metres deep and twenty long, in which the dead were strewn in their hundreds. And on the far side a British sergeant, a scarf across his nose and mouth, drove a bulldozer forward to topple more bodies in, a Gordian knot of arms and legs cascading down to add another layer. Humanity shovelled up and tipped like garbage. Dogs did not die this way.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Behind her the pharmacist was crying, the grocer was throwing up, and Klaus’s hand rested upon her shoulders, his fingers digging hard into her collarbone, less restraining her than himself.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Tommies made them watch as the bulldozer did its work, the pit was filled with corpses and the first scoop of soil tipped back on top of them. A grave for the great unknown. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then a whistle blew and the engine stopped. A rumble that dwindled to nothing and left a piercing silence. A bucket of earth poised in mid-air ready to fall. The British major stood on the far side, across a gulf as wide as evolution itself, and began yelling something at them all in mechanical German, reading it off a sheet of paper, something formal, a headmaster’s reprimand, almost a lecture—but she neither saw nor heard.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Suddenly it was over. Whatever purpose had brought them there was fulfilled and half a dozen Tommies came along, badgering them in English and reinforcing their words with nudges from rifle butts and the one German phrase they all appeared to know.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schnell. Schnell. Macht schnell.")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Again they missed her. Either they hadn’t seen her or they didn’t associate her with the old men, or any child was taken to be an inmate. It seemed to her that she must wear some cloak of invisibility like a creature in a Brothers Grimm tale. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She stared into the pit. As though she might will the dead to move and show they were not dead. As though a hand might yet rise up for rescue. Some instinct made her want to count them, but it was absurd—a tangled skein of limbs, slack, nacreous skin and featureless faces, a merging of individual bodies into a composite dead flesh. Extreme emaciation produced effects she had never had cause to imagine. Human beings reduced to sticks—the difference between thighs and calves eliminated as legs, and arms, shrank to the straight lines of geometry, the human curve disappearing, punctuated only by the bulbous knots of knees and elbows, and the gaping anus—the fixed shutter, the dark lens, as though it had opened only to expel life and admit death. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("An April breeze had caught the ubiquitous dust, whipping it up into eddies, settling it on the dead like frosting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A line from school English lessons—all those weeks spent translating the metaphysical poets—rolled around in her mind: “The grave’s a fine and private place . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A hand on her arm. Slowly she turned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was the English captain who had first approached her an hour, a year, a lifetime ago. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look . . . I’m sorry. I didn’t know Major Thomas was going to do that. The old men, well . . . perhaps they had to see this, but I would not have exposed you to this for the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think perhaps you are. What are you? Fifteen?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eighteen,” she lied. “And I could be of use to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How so? Do you have medical training? I have fifty thousand patients. I could use all the nurses I can get.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I have no training of any kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then I don’t see what use you’d be—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Please!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She didn’t stamp her foot. She waited until she saw compliance in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re English… and you speak German? Perhaps some French?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No . . . I speak next to no French.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“These people . . . these people that the Ger…. that "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("we")]), _vm._v(" have put here . . . they are French, Poles, Russians, Jugoslavians . . . I speak more of their languages than you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Russian? You speak Russian?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Better than my Polish. And my French and English are fluent. I can help you do what you are going to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And what is it you think we are going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Put them back together again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Whatever it was he was going to say she had stopped him in his tracks, the words half formed on his lips froze into silence. He turned away from the pit, took a couple of steps, turned back with the bodies beyond his line of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Put them back together again? Jesus Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Believe me. I can help.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sure you can. Russian? Polish? No one on my staff speaks either.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s what I am. A child of language . . . a word child.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked off into the middle distance, to a group of the motionless living, squatting on the ground as her skeletal man had squatted in the dog kennel. Then he looked back at her. She could almost hear the sigh he would not let out.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Alright, word child. Report to the main gate. Eight o’clock tomorrow. Ask for me. Nicolas Dekker of the Royal Army Medical Corps—and I’m not English, I’m Dutch.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On her way back to the main gate she came across her skeletal man, squatting exactly where the Tommies had set him down when they lifted him from the truck, dust settling upon him, on the living as on the dead. She doubted he had moved a millimetre. His pipe had gone out. Without the pipe would she have known him? He was all but indistinguishable from every other skeletal man. The identities of the living had blurred, the flesh of the dead had merged. He heard her approach, but did not look up. The hand simply extended in her direction, his gaze elsewhere, infinity, oblivion, locked on to some inner vision, and all he said was, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§47")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("When she got home the front door was wide open and the house silent. The British had taken every mattress in the house and most of the bedding.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Klaus was in the garden, digging. It was almost time to plant potatoes. He was out there most of the day and returned only an hour before dusk. He prepared a meal of mashed turnips and bacon, said nothing at all in the cooking of it and next to nothing in the eating.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Afterwards, there was no music, no BBC.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had a thousand questions that came down to one question, and she did not ask it because she knew he would not answer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir, was sind wir?")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Who are we? What are we?")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§48")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Dekker asked her to roll up her sleeve.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re losing hundreds to malnutrition every day. They can’t keep down what we give them. If we don’t get it right, thousands will die. After that the biggest threat is typhus. You won’t starve to death. You’re skinny but you’re healthy. But typhus will take the strong as well as the weak. And we have typhus rampant—you’ve surely smelt it, that stench of boiling peas. Like winter in an Amsterdam café. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Erwtensoep")]), _vm._v(" and pumpernickel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She watched the needle sink into her upper arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("To speak might stop her crying.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We were rationed too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My family. Mother, Father, me. Berlin was rationed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t talk to me about rationing. Rationing isn’t hunger. And whilst you may not have known it the Wehrmacht stripped Poland and the Ukraine to feed Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He dropped the needle into a steel kidney dish and stuck Elastoplast on her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m putting you in with the German nurses. They’re awkward buggers, but they’re fitter and, dammit, they’re saner than the inmate nurses we’ve found. But they speak nothing but German and their attitude has got to change. Interpret for them. Get between their denial and the patient’s fear.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Denial?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They don’t believe their own eyes. They don’t believe what Germany has done. Any more than those old men yesterday. They probably thought rationing was starvation too. And the patients trust no one speaking German. Why would they?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§49")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The German nurses were crisp, confident, and contemptuous. They had arrived from another world, one that was clean and starched. They could not have scared Nell more if they had carried guns. Clearly, they felt she was superfluous. They’d get through to the inmates without her help. Dekker told them they wouldn’t, shouted down the protests of “she’s just a child” and “it’s unprofessional.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know what unprofessional means? It means you don’t like what I’m asking you to do. You know what this uniform and these three pips mean? It means you bloody well do it anyway!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of the first tasks was to try to inject a ward of Polish women against typhus.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Most of them were just a day away from the filth of the huts they had been found in—hours before they had been hosed down and scrubbed in the makeshift showers, those with lice had been shaved, and, as far as was possible, they had been clothed, although in most cases this amounted to no more than a clean blanket to drape around their shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The sight of German nurses in Wehrmacht uniforms widened Polish eyes. The women seemed to flatten themselves against the wall, as though they would pass through it like wraiths.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell explained what was happening to the first woman they approached, but at the sight of a hypodermic needle her reaction was to scuttle into a corner, to make herself as small as possible and to pull her blanket over her head.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell caught a muttered "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Strau")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ß")]), _vm._v(" (ostrich) from one of the nurses. And the nurse, flourishing the hypodermic like Lady Macbeth’s dagger, moved on to the next bed and told the next patient, in uncompromising German, that she hoped she would be "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("vernünftig")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sensible. Not a word Nell had found much use for since the day she found her "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tabak")]), _vm._v(" man in the dog kennel. She translated all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This woman was no ostrich. She knocked both hypodermic and kidney dish flying and leapt from her bed to the next and from the next to the next, and in a dozen leaps to the far corner, pursued by all the nurses.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All the other women in the room fled screaming, flocking like birds, as far away from the nurses as they could get.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell shoved her way to the front, trying to get between the Germans and their reluctant patient.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Please, leave this to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ridiculous. Chit of a girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They paused, all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell turned to the woman defending her corner. Knelt down.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Trust me. It’s harmless. It’s for your own good.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She seized Nell’s head between her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t let them touch me. The SS. Auschwitz. They injected benzene to make us burn better.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell prised herself free, the woman’s fingers like twigs in her hands, and faced up to the nearest nurse clutching a hypodermic.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We can’t do this. They won’t have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We are the nurses, you are just an interpreter, stand aside.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They won’t let you do it. In Auschwitz . . . in Auschwitz they were injected with benzene so that their bodies would burn better.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That is nonsense!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It may be nonsense but it’s what she’s saying. We don’t know what they’ve been through. But it all comes down to the same thing. They are terrified of needles and they’re terrified of you!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell saw the nurse flinch and crouch and turned to see what she had seen. A tin plate, thrown like a discus, sliced through the air and into Nell’s cheek. She felt the warm blood washing down her face, clapped a hand to the cut and fled.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§50")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was a deep cut, but Dekker was reluctant to stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You’ll be scarred for life, I’m afraid, but it will be a neater scar without stitches. With any luck I can tape you tight enough for it to heal properly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When he’d finished he held up a scratched, stainless steel mirror for her to look in. She looked like an Apache in war paint—a broad white stripe that started on the side of her nose and travelled left to end just under the corner of her eye. Scarred for life. Such a telling phrase.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My war wound,” she said. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . your visible war wound. You did the right thing, you know, running when you did. They ripped the clothes off their backs.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You were just the first casualty. The Polish women damn near stripped those nurses naked. But there is a plus side. Perhaps they’ll listen now. Perhaps they’ll start realising their patients are human.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Will they carry on with injections?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They have to or we’ll have an epidemic on our hands. All depends on their attitude, how they go about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What about what the Polish woman told me, about Auschwitz and benzene?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Might be true. Might not. There’s one bugger we have locked up right here, rumoured to have injected his victims with creosote. Who knows what went on at Auschwitz? Who knows what they were injected with? God knows, it would hardly make a difference. Human flesh burns pretty well.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Auschwitz. What is Auschwitz?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§51")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Approaching the main gate she found her "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tabak")]), _vm._v(" man. He had moved she was almost sure, but he had resumed the same position—and he’d found another source of tobacco and was puffing on Klaus’s pipe. He was, the last two days had taught her, one of the “healthy” ones. She doubted he weighed much more than fifty kilos, but that was health by Belsen standards.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She crouched down, copied the posture, tried to look beneath the tilted brow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Pami")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ę")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("tasz mnie. To ja, dziewczyna z tytoniem")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("You remember me. I’m tobacco girl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The head lifted. The light not yet on behind the eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nazywam si")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ę")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" Nell. Nell Burkhardt. Jestem Berliner. Jak masz na imi")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ę")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("My name is Nell. Nell Burkhardt. I’m a Berliner. What is your name?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The merest flicker. For the first time he seemed to know what was beyond the reach of his hand, to what he reached out, to be able to see the person he had heard and never looked at.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tabak?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tabak")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now he looked directly at her for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jestem")]), _vm._v(" . . . Kraków,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then his head tilted, he drew on the pipe and said no more.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She waited, hoping that her silent determination might draw more from him. Minutes passed, the pipe smoked out, the head lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jestem . . . byłam . . . nikim . . . mniej ni")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ż")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" nikim . . . jestem . . . niczym")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I am . . . I was . . . nobody . . . less than nobody . . . I am . . . nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nikt nie jest niczym. Nawet pies ma imi")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ę")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No one is nothing. Even a dog has a name.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jestem mniej ni")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ż")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" niczym . . . mniej ni")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ż")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" psem")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I am less than nobody . . . less than a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§52")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("In the morning she asked Klaus for more tobacco. As she passed the main gate, the same hunched figure, the same hand extended, the same head bowed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Dziewczyna z Berlina. Gib mir Tabak")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She found Dekker.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He said, “I can’t put you back in with the German nurses. I really don’t want to take that risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She said, “I have found something better to do. You’re treating people whose names you don’t even know. Give me access to the records, the papers, the card indexes, whatever system the SS had. Let us give them back their names.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The buggers burnt the lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So the only way we have of finding out anything at all about anyone is to ask them?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you’re going to be the one to ask, is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you let me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dekker did what he always did, looked away, took his eyes off her, took in some object in the middle distance and made up his mind without the persuasive glare of her gaze. He picked up an RAMC battledress. Tossed it across the desk to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’ll be as well if they don’t think of you as German. Put this on. It’s the smallest I could find. You may look daft wearing it with a skirt but no dafter than any other ragamuffin in the camp. And it may just protect you from another attack. See the stores NCO, Staff Sergeant Cox, ask for pen, paper, cards, whatever you need or more precisely whatever he can spare. When we can we’ll set you up with a desk somewhere. But you can’t do this on your own. We really could use some sort of record, but it’ll only stand a chance if we have nurses and the med students involved. That will take a while. A few days at least. We’re moving people out haphazardly. I’d prefer to take the sickest first, but it just isn’t possible. It’s selective, and a selection will be about as welcome as an injection. Meanwhile what we have is a mixture. The walking “healthy”—that is anyone who can stand unaided—and the chronic. Start with a “healthy.” Someone who’s fit enough to talk. See what it yields. See what you can do for him or her. For all we know you may be the first person to ask anything of them in months. Even if we don’t get answers, your asking may be worthwhile. Implant the idea that they matter to someone. And if they do answer, get what you can, in particular get medical history. Operations, permanent conditions, immunisation. I’ll give you a checklist to tick off. I suggest two of everything. One card for us, one for them. Give them the second card and hope they don’t lose it. For a while, possibly for months, it may be the only identity card they have.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stopped as suddenly as he had begun. Drawing breath. Hitting the buffers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s quite a speech,” Nell said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dekker was smiling now. “I was improvising. It’s quite an idea. It may not work, but it’s quite an idea. And I have to ask you . . . why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was her turn to pause. She knew what she wished to tell him, but it had to be precise.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Having been nothing, they wish to be someone,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” Dekker replied, “I suppose they would.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“These are people who have families . . . brothers . . . sisters . . . children . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell—the tense of what you say may be your biggest mistake. These are people who "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("had")]), _vm._v(" families, who "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("had")]), _vm._v(" brothers, sisters, parents, children. These are the survivors. The rest are probably dead. Germany is an open grave. The dead we are burying here are the tip of an iceberg. People are dying every day, and many more will die. This is not peace, this is merely the absence of war. And if you can help these people resurrect their identities you will also be invoking a roll call of the dead. Are you sure you want to do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” she said. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Dekker thought that perhaps he was looking at the most determined, the most po-faced child he had ever met.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then perhaps in the end you may find all you can do is listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§53")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Of course, it did not work.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("She began with her pipe-smoking acquaintance. The next time she saw him, he had moved fifty feet, was sitting in the sun and had traded his camp stripes for a brown woollen jacket that fitted loosely and grey flannel trousers that bagged around his bottom and thighs. He still squatted, but instead of dirty bare feet he balanced in a pair of shining brogues, confiscated from some bourgeois citizen of fastidious cleanliness. The dust of Belsen had not even had a chance to settle on them.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She squatted opposite him, a leaky fountain pen and a small stack of index cards in her hand. In the absence of a camera, she would sketch. She would put in a name, a date of birth, a place of birth, an occupation and a simple sketch. If possible she would add medical history. If further possible a date and place of arrest.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He raised his head. His pipe was lit. He did not ask for tobacco.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Dziewczyna z Berlina")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The girl from Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tak to ja. Czy mogłabym Cie prosi")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ć")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" o Twoje imi")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ę")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("?")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Me again. Could I ask you your name?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Co tu robisz w tym brudzie?")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What are you doing down here in the dirt?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Có")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ż")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" . . . Co robisz w tym brudzie?")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Well . . . what are you doing down here in the dirt?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jestem psem . . . jestem gorzej ni")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v("ż")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" psem . . . jestem niczym . . . jestem numerem.")]), _c('span', [_vm._v("” ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I am dog . . . I am less than dog . . . I am nothing . . . I am number.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He rolled up the left sleeve of his woollen jacket to reveal the number tattooed into his forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jestem Auschwitz")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I am Auschwitz.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§54")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("In the morning she passed him again. He was standing now. She’d never seen him stand before. He was over six feet tall. He was looking out through the wire.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She didn’t wait for him to speak, and held out the tobacco before he could ask for it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The eyes that had looked at nothing could see her clearly now. He took the tobacco, looked at it in the palm of his hand, looked down at her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nowak,” he said simply. “My name is Aurelius Nowak. I should have told you that when you asked me. I am sorry. It was rude of me. Hunger is madness. You must forgive me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She took out her pack of cards.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had two for him, all they showed was an inky sketch and the word “Krakau.” She wrote in his name.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Did you think I had forgotten my own name?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought it was possible . . . hunger is madness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can forget nothing. I wish I could.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything would help. The SS burnt everything. We have no records. Nothing. Can you tell me your date of birth?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can but I won’t. It’s just another number. I am . . . through with numbers. I have been a number too long."), _c('span', {
    staticClass: "char-style-override-17"
  }), _vm._v("Sit with me a while. Play the prisoner with me in the dirt again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("While they squatted Nowak lit up his pipe and in scarcely more than fragments gave her the bare facts of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was professor of music in Kraków. They shot most of my colleagues in 1939. Perhaps I was not enough the intellectual to merit a bullet. I was merely expelled and found work in a bakery. They came for me only in the March of last year. My entire family was sent to Auschwitz. My son died on the train. I never saw my wife again after we arrived. In January this year, at least I think it was January, they marched us out of Auschwitz fifty kilometres to a railway yard and put me back on a train. This is where the train stopped. I fell from it alive. Many did not. The rest you know. I was, I have been, as you found me that day in the dog kennel . . . mad with hunger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She tried to reduce his narrative to keywords, found herself crossing out and rephrasing. Ink leaking onto her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Can I ask you about your medical history? Diseases and the like?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . the British doctors. Everything in its place. Yes. And I shall answer. I had not a day’s illness in my life until last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And . . . then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I caught an incurable disease.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s it called?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§55")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Of course, it did not work.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As more and more inmates moved from the squalor of the camp to the relative order of the nearby Panzer Barracks, the British organised hospital wards. Nell followed, and as the British Red Cross nurses treated the results of prolonged malnutrition, she gently probed, filling in her cards, sketching faces, trying, as Nowak had told her, not to make it all sound like statistics. Statistics were no more than a hypodermic in the hands of a German nurse, and that no less than a Luger in the hands of a Wehrmacht soldier. Fear was everything. Once overcome, there was listlessness, aggression, and lethargy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On one day, she estimated, she had made out over one hundred and fifty cards. She gave each individual a card and handed the duplicate set to Dekker. The next morning she found dozens of them, blowing with the dust or strewn across the ward floor. It was predictable. So many of the women on the wards had looked blankly at her as she had pressed the half-filled cards into their hands. She doubted that any had really forgotten their name, but a good number had seemed incapable of uttering it. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Futility,” Dekker said, “is the name of the game.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Meaning?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Meaning you have to risk it; nothing ventured nothing gained. And when it all goes "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fuß über Kopf")]), _vm._v(" you accept it as futile and start again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She gathered up the cards. Sat in the nurses’ lavatory, tearful, trying to interpret Dekker’s homily on futility. It would have been hubristic ever to think that she could give anyone back their identity, and she had only ever thought that for a second. The best she could do was help someone, anyone, resurrect their own identity. Nowak, in his unsubtle way, had pointed out the gulf between identity and an identity card, but what other method was available to her? Was Dekker’s “perhaps all you can do is listen” all there was to be done?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two Red Cross nurses came in to scrub up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah,” said one. “The little ink girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("And she saw herself as some transparent, useless flake of a child in a Hans Andersen tale. No longer invisible, but futile. The Little Ink Girl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then the other one said, “Cheer yourself up, ducks. I always find a bit of makeup does me the world of good. That and a nice cup of char.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And she pressed something small, hard, and metallic into her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell unfolded her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a tube of lipstick.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had never worn lipstick.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She pulled off the little golden cylinder. It was searing red, and the imprint of the nurse’s lower lip was sculpted in. A twist grip on the base propelled the lipstick upwards. It was a toy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She looked at the bundle of cards, sifted through them. Her sketches now looked to her to be all alike—the same hollow cheeks and new moon eyes, the same shining skull.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She clutched them in hand, pen, cards, and lipstick and returned to the ward. Most of the women were milling around in a susurrus of slow Polish talk, the effort of animation all but beyond them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Alone on her bed sat a Belgian woman she knew only as Bruges—knees tucked up to her flattened chest, Nowak-style, Belsen-style, hands around her ankles, head down. Her card was on the top.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell sat on the edge of her bed and held it out to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She looked up and offered no reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell set the rest of the cards on the bed—the pen rolled off the pile, she reached out for it. The lipstick rolled off the pile and another hand grabbed it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What to Nell had been a toy was a magic wand to Bruges. She took the twist grip between finger and thumb and turned it as slowly as was possible, the fierce red tip peeping out like the tongue of a cat. And when she looked up she was smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell looked around, almost desperate for a mirror. She tipped a few shreds of gauze out of a kidney dish and held the flat base up to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Bruges tipped her head from side to side, coping with the distortion, looked once at Nell and then put the lipstick to her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It occurred to Nell that there were few mirrors in the barracks and none in the camp—it could be the first time Bruges had looked at herself in an age. But Bruges was focussed, if she was shocked by her thin face and sparse hair, she did not show it. She applied the lipstick with artistry, arching her top lip, stretching her lower, pursing them together in a scarlet pucker, almost blowing a kiss to herself in the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She smiled at Nell, as Nell lowered the dish, and held the lipstick out to her. Nell did not take it—around her, all around her, gathered like silent shadows, every woman in the ward.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§56")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Later the same day, the afternoon brightening into April sunshine, Nell sat at a makeshift desk outside Dekker’s office filing her cards alphabetically.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sabine Michel,” Bruges had said at last. “I am twenty-six years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had sat on the edge of the bed and listened, and then she had sat on the edge of every bed in the ward and listened as every pair of red lips told a tale. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had just filed Katya "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Ż")]), _vm._v("ebrowska when the quartermaster, Staff Sergeant Cox, appeared with a cardboard box under his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I hear you can use these,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She looked at the stencilled label on the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Field Dressings x 40. RAMC type 101/7. Dec. 1944”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thank you Mr. Cox, but I think not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not so fast, Inky Fingers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He flipped the lid off. There were no field dressings, the box was full of lipstick, hundreds of tubes of lipstick, all marked “Max Factor,” and “Made in the USA”—rose red, poppy red, flame red . . . every red that Max could factor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My God! Where did you get this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t think I ordered them do you? Nah. Cock-up back at HQ. I was getting ready to send ’em back before some light-fingered bugger got his hands on ’em and sold the lot on the black market, but then I heard about you and yer tube of lipstick.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The whole bleedin’ camp heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell sat on the edge of a bed, any bed, and listened to red lips talk. She would go on listening for over three months.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§57")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Of course it did not work. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dekker had been right about futility, right about the pursuit of futility, but as soon as resources permitted he assigned Red Cross nurses to record keeping. And some of those who would not or could not talk to nurses would talk to Nell, and Nell would listen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She would go on listening for over three months. She would go on listening for eternity.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§58")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Weeks passed. The Allies, in the form of the Supreme Headquarters Allied Expeditionary Force—a phrase that put Nell more in mind of an Antarctic trek than a total war—recognised the nature of the problem and found a bureaucratic solution. By the thousand printed, tick-in-the-box, Displaced Person cards arrived. Twenty questions poised upon a precipice. The card asked all the questions Nell had been asking and several she might not. It invited the contempt Dekker had so accurately predicted, and Nowak so acutely embodied with his “just another number.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So often the answers were all too predictable.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do have a husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Auschwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you have children?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Auschwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What was your last address?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Auschwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What is your religion?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I left that in Auschwitz too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And sometimes not.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are a Displaced Person.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No I’m not. I know exactly where I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What she had learnt fed into the system. And the cards fell in the dust, fluttered in the wind, blew out across the heath into a symbolic, anonymous confetti of freedom much as her first efforts had done. She had not learnt not to care, she had learnt not to mind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dekker could not resist a joke. Which was more prevalent the Displaced Person or the Displaced Card?")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§59")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On May 20 no one died. The first day without a death, but by then they had buried over twelve thousand, and would bury more.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the twenty-first the original Belsen camp was evacuated. The survivors were housed in the former Panzer Barracks, now renamed a Displaced Persons Camp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The British burned Belsen to the ground and threw a party.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell went home to Klaus, as she did every night.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§60")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On a light evening in the middle of August she came home to find the house silent again. A common occurrence. It seemed to her that Klaus had vanished into silence. Into silence and vegetables. As the days had lengthened he spent more and more time in the garden—planting out his cabbages, earthing up his potatoes. His evenings were spent behind his pipe and the gentle smoke screen he blew. If the radio or the gramophone went on it was because Nell put them on. Things that had interested him before, few though they were, seemed to have dropped away, petals, leaves and all, leaving the husk of the man. The British, who had rounded up and pressed into service—fetching, carrying, cleaning . . . burying—hundreds of the younger able-bodied, had left old Klaus alone. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("It had been April, almost the end of April, when she had tuned in to the BBC and they had learnt of the death of Hitler. An occasion that might have been cause for rejoicing in a house such as theirs received only a muttered, “Well, that’s that then” and a rhetorical “How many millions have died for him?” The news of Admiral Dönitz’s unconditional surrender, ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Stunde Null")]), _c('span', [_vm._v(", a matter of days later, drew forth a sigh of utter world-weariness and an equally rhetorical, “Was it all for nothing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The house was silent, the doors open front and back to let the breeze pass through.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She called out his name, and when there was no answer walked through the dining room towards the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the dining table an envelope was propped against a bottle of Cognac and an empty glass.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01 para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("To my niece,")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Christina Hélène von Raeder Burkhardt ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was closed and sealed with red wax, and the imprint of his signet ring, an interwoven "), _c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("KvR")]), _vm._v(". The ring itself he had dropped into the empty glass.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The message was simple.")]), _vm._v(" "), _c('p', {
    staticClass: "letter para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("We all knew. Forgive me. KvR.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She knew he was dead. It was a simple matter to find the body.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Out in the garden he had dug one more trench and lain down in it. She had no idea how he had killed himself, but knew he had. A rational strand in her mind told her that he had spared her the task of cutting him down from a roof beam or mopping up the blood from a shot to the head. He had left her but one task, to bury him. He had left his garden spade in a mound of earth and he had pinned his two iron crosses onto the left breast of his jacket. He lay ramrod straight, his eyes closed and his arms folded like a Teutonic knight carved on a tombstone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was still looking at Klaus when she became aware of someone looking at her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nowak was standing on the other side of the grave. She had not seen him in days, perhaps weeks. She heard he had volunteered as a porter and stayed on after many of the able-bodied had chosen to leave. He had put on weight, his hair had grown back. She could see now that he was a young man, probably well under forty, whereas before he had been both aged and ageless. He was clean, if dusty, and he was carrying a fawn knapsack much like her own.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I came to find you. The door was open. I wasn’t sure if you still lived here. I came to find you. I came to say goodbye. I am leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She said nothing. He picked up the spade and said, “It’s the least I can do. A thank-you for all the tobacco he gave me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She watched as Nowak buried her uncle, thinking that the old man had outlived his time and that perhaps it was a rare gift to know when to die, and thinking that three months ago Nowak had scarcely had the strength to lift a pipe let alone a spade.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At last she said, “Leaving? Where will you go?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Dutch have already gone back to Holland and the Belgians to Belgium. The Jews are lobbying to go to Palestine. The Czechs are on their way to Czechoslovakia. Few of the Poles want to go to Poland. You couldn’t pay me to go back to Poland. So . . . I think perhaps I shall go to England. This displaced person is displacing himself once more.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll walk if I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And papers. Do you have papers?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nowak smoothed out the mound that covered Klaus and stuck the spade back into the earth. From his inside pocket he took a folded card and handed it to her. It was dog-eared and grubby now, but it was the same card she had given him as they sat in the dust together at the gates of Belsen. The inky sketch she had done of him now dated as he had gained both flesh and hair. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That won’t get you very far.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On the contrary my dear, it will get me into heaven. And you, what now for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a Berliner,” she said. “I belong in Berlin. I should be in Berlin. I have . . . perhaps had . . . family in Berlin. A mother and a father.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And when did you last hear from them?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In January.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two portentously vacant words, and they both knew the possibilities inherent.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And how w"), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_vm._v("ill you get there?”")])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('p', {
    staticClass: "BT"
  }, [_vm._v("She looked at Nowak, remembered how she had arrived with her little fawn knapsack with the red leather straps, and all that mattered to her stuffed inside.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, I’ll walk if I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§61")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Dekker was sceptical.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s over two hundred kilometres.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I should say closer to three hundred.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the green border . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The line between us and the Russians. It’s hardly fifty kilometres from here. We drew back, gave them a chunk of Mecklenburg and some of Hanover. All agreed beforehand apparently. Wherever we stopped, wherever the Nazis surrendered we’d revert to the line agreed at some conference or other.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And do they patrol this line?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It would be very unlike them not to.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had placed her RAMC battledress on the desk between them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dekker removed the “I” (interpreter) armband and handed the jacket back to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Keep it. I doubt it would fit anyone else, and, who knows, it might ward off a few bullets.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was pleased. A gift. Something to make her think of Dekker in the days to come when she would know nothing of him. It did not suit the summer weather, but that was by the by.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am sorry,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“About what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That I was not of more help. I think perhaps I blundered in . . . the medical records . . . just little scraps of card.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Au contraire. My nurses think you broke the ice. Do you have any idea how many people traced their families as a result of the conversations you had, the notes you took—those little scraps of card?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She hadn’t, so he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One hundred and fifty-eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Out of . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Forty thousand, give or take a few.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s . . . that’s pathetic.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Nell. It’s marvellous. One hundred and fifty-eight people too frightened to talk to anyone else. One hundred and fifty-eight people who thought they were alone in the world now know they’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She wondered. Was she alone in the world? Was she a “Displaced Person”? Had her parents lived or died in Berlin?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was as if he had read her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you really have to go to Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. I’m a Berliner. It’s still home. What’s left of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Dekker walked with her as far as the gate, and she had taken but half a dozen steps eastward when he called after her, “How old are you really?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She turned, looked at Dekker for the last time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Eighteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “And that’s a lie isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell said, “The only one I’ve ever told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But it was a lie she stuck to ever after.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§62")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("She packed what she could but left most things.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Food would be a problem. She had money to buy food, but would there be food to buy?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was summer, almost anything would rot before she could eat it, so she filled her knapsack with hardtack . . . with apples and nuts, with potatoes and carrots from the garden—with sweaty cheese and black bread from the larder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Leaving, she thought what she might do with the key, and then she knew. She left it in the lock, for anyone to turn. It wasn’t her house, it had never been hers. Let anyone who wanted have it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("It was warm, too warm for the RAMC battledress Dekker had given her, but she was determined to wear it—a badge of honour. She wore it open and loose, its belt tag dangling over her billowing green skirt, the sleeves rolled up to her elbows—and the strange insignia at the shoulder . . . a serpent coiled around a staff, peeping out between the straps of her woollen-sheathed British Army water flask. She had meant to ask Dekker what the insignia meant but had never remembered.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Celle was full of people. It seemed as though the whole of Germany was pouring into one town.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Celle was full of soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A sergeant wearing the armband and fiercely raked cap of a military policeman stopped her in the street. Gave her the once over, his eyes ranging down from the grips in her hair to the brittle leather walking boots on her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now, where do you think you’re off to dressed up like a dog’s dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was not a phrase that translated readily but she got his drift.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin,” she said, and the man grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ll be lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a Berliner. Berlin is my home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Papers,” he said as abruptly as any German cop.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hers were out of date. A wartime identity card and a ration book she had not used in weeks, not since the army had fed her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But Dekker had taken the precaution of writing a letter for her in both English and German. It requested her safe passage. Wherever.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The sergeant read it, said, “I know Captain Dekker. I’m sure he means well . . . but you need a pass to cross zones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I have no pass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . you won’t need it till you meet a Russian. If you was my girl I’d be telling you to turn back right now . . . most o’ your lot are coming in the opposite direction. Look around you. We got Pomeranians, we got Sudetens, we got Silesians. We got half of East Prussia. Nobody wants to be in Berlin. Anyone who can outrun the Russkis is doing it. So many been through here these last few weeks, I reckon Berlin must be just about empty by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a Berliner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So you say. Well . . . I’m not gonna be the one to stop you. But if I were you I’d travel very carefully. The countryside between here and the green border is full of DPs—Displaced Persons. Refugees, foreign workers, POWs . . . the lot. None of ’em partial to Germans. And then there’s renegades, werewolves and what have you. And if there’s one thing I know about a British battledress, it’s that it don’t stop no bullets.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§63")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Cambridge")]), _vm._v(": November 1946")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Mrs. Wissit slapped a bowl of Irish stew in front of him and said, “The colonel phoned for you. But you was out. I told him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the unappetising mess—chunks of fatty mutton in transparent gruel—not waving but drowning.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Important, was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _vm._v("’Course. He don’t pick up the blower for nothin’ now does he?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I wrote it down, din I?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She fumbled in the pocket of her pinny, turfed out a handkerchief, a couple of hairgrips, a pair of scissors, and a note she had folded over so many times it was hardly bigger than a postage stamp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It says . . . Pack yer kit, clear out and report to me at . . . ’ang on can’t read me own wotsit . . . somethin’ somethin’ Commission in Knightsbridge tamorra mornin’ 8 a.m. sharp.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is that all?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Said thanks to me, and told me he’d be sending some other bloke to take your place.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So, I’m off and you’re all paid up?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, been grand ain’t it.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§64")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He spent the night back in Sidney Street. The only sign of Merle was the snaking tendril of her scent. He heard her come in around two in the morning and thought better of a mid-nighttime encounter. When he got up at six a note on the kitchen table read simply, “Wotcher, Johnnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At the Control Commission for Germany HQ in Knightsbridge the staff sergeant on desk duty handed him another note, and Wilderness wondered if it might be the start of an album like stamps or autographs or fag cards.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Report RAF Wyton. 10 a.m. tomorrow morning. Travel light. Mind your manners. Try saluting once in a while. ABJ.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s not actually here, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Colonel Burne-Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t be daft, son. I can’t answer questions like that. We’re meant to be a secret service. How secret would we be if I answered everything some Tom, Dick, or Harry asks me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are the whereabouts of RAF Wyton a secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah. It’s just outside Cambridge, everybody knows that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve just come from bloody Cambridge!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So you’ll have no difficulty finding it then.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§65")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The pattern repeated itself. Wilderness went to bed, Merle came in hours later. The only difference was that she left no note for him to read as he set off for King’s Cross at seven in the morning. He left one for her.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Looks like I been posted. See when I see you. J x")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But he didn’t. He never saw Merle again.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§66")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Crossing Wyton field, kit bag perched on his left shoulder, it occurred to him that he was about to come face-to-face with a wartime legend. His first look at an Avro Lancaster heavy bomber.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was no sign of Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He dropped his kit by the crew hatch and circled the aircraft, awed by its size. It had seen better days. In the eighteen months or so since it last dropped a bomb this Lancaster had been stripped of its machine guns and had not seen a lick of paint. The gun turrets looked like the glassy eyes of some giant dead fish—the gunmetal grey of aluminium showed in streaks beneath the peeling black paint.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As Wilderness came full circle a man dropped feetfirst out of the hatch to the grass. A tatty-haired bloke wearing the Saturn rings of a squadron leader on his sleeve.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness saluted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Knock it off, old man. This is my last op. Tomorrow when this crate touches down back here I’ll be in Civvy Street. And not a day too soon. Be fucked if I spent my last day returning salutes to erks like a bloody jack-in-the-box.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stuck out his hand for Wilderness to take.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Miller,” he said. “Dusty Miller. You must be the kid Alec was telling me about.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, that’s me. Joe Holderness. Is the colonel . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness hesitated. Was one “on board” or “inside” a plane? Was a plane more like a ship or a lorry?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Instead he pointed . . . “Up there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Alec flew on ahead. He gave me these for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He handed Wilderness a small buff envelope and a square of pale blue serge with a propeller motif on it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness must have looked more puzzled than he felt.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Miller said, “It’s your promotion old man. You’re a leading aircraftman now. An extra five bob a week in your pay packet. Don’t forget to sew it on.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He grabbed hold of the fuselage above his head and in a neat, practised movement swung himself back into the plane.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness opened the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Meet me in the main bar. Victory Club. 7:30 tonight. ABJ.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Victory Club? What Victory Club?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Lancaster’s engines turned over, catching Wilderness in a blast of cold air that whipped his cheese-cutter cap away into oblivion.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A head popped out of the hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Skipper says get on board or get left behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness tossed up his kit bag and grabbed two willing hands just as the plane began to move.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Upsadaisy!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He fell into the plane, heard the hatch slam shut behind him and found himself sitting next to a flight sergeant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you a rabbi?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not the greeting Wilderness had expected, but the man probably had his reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No? Is it essential?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nope, but last week we flew out three rabbis and a Catholic priest and I had to mind me p’s and q’s all the bleedin’ way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean you don’t bloody know? Hamburg! You’re on the milk run, mate.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had some grasp of RAF slang. “Prang,” “crate,” and so forth. Doubtless if he had stayed in basic training he’d be fluent. “Milk run” meant easy, didn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Piece of cake?” he ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The flight sergeant grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh that too, but I meant we’re flying out condensed milk. You’re sitting on five thousand cans of the stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked down at the box he had perched himself upon, at the crude stencilling: “Milk. Con. Units 200. WD.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And then you got yer flour. Two thousand pounds of grey British flour.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Flour? But we’ve got bread rationing!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“That’s ’cos we ship bleedin’ flour to bleedin’ Germany innit. Then there’s yer canned cheese. Don’t matter whether it says cheddar or double Gloucester on the outside it all comes out lookin’ like yeller rubber. And fags and matches and fag lighters and footballs and razor blades . . . two crates o’ Bibles . . . two complete Shakespeares . . . and then there’s blankets . . . and ex-army greatcoats and half a dozen sheepskin flying jackets. Speakin’ o’ which, best help yerself. No one’ll miss it. Certainly not the RAF. It’ll be bollock freezin’ once we get airborne. We’ll fly within sight of land, no goin’ up to thirty thousand feet, but cold all the same. And when we get there, Hamburg’s on the same latitude as Liverpool. But if you ask me it’s more like Aberfuckindeen. Cold as a witch’s tit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The crew was as stripped as the plane. No guns, ergo no gunners. No navigator, just a pilot and a wireless operator.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness sat in the former navigator’s seat as the Lancaster took off. An interesting surge, he thought. Not as traumatic as his imagination might have led him to believe, but a definite sensation in the lungs and stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As the plane levelled off the flight sergeant said, “Front turret’s empty. Lie down. Get some kip if yer like. It’ll be more than two hours to Hamburg and nothin’ to see till we cross the Dutch coast. Even then Holland’s like my mum’s Yorkshire puddin’, flat as a pancake.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness lay down in the front turret in his RAF flying jacket feeling fraudulent, wondering who had lain here in the war aiming his machine guns at German fighters. Wondering to no particular point about the war that he had gratefully missed. He nodded off, the North Sea had little to captivate. He woke up somewhere over the Frisian Islands, a pleasing chain arcing out across the northern end of the Zuyder Zee.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("About ten minutes out of Hamburg the pilot sent for him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Take the flight engineer’s seat. I’ll give you the Hamburg tour. You’ll get a better handle on the place if you see it from above. Dunno what you’ve heard about the raids we made on Hamburg, but exaggeration is close to impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m a cockney,” Wilderness said. “I was in the East End right through the Blitz. I’ve seen enough ruins to last a lifetime.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not like this you haven’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And he hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Miller put the Lancaster into a slow curve and took the city at less than a thousand feet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("London, the East in particular, was dotted with ruined houses. Occasionally a whole terrace might have vanished. One side of the street reduced to rubble, the other still standing, albeit with every window blown in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hamburg looked as though it had been hollowed out with a spoon, like sinking a spoon into ice cream and just scooping out the middle till the sides were scraped clean. Every house was wrecked, every street was wrecked. The flesh had been seared off. All that remained were the bones, the teetering, improbably slender facades of houses and blocks of flats, gutted from attic to cellar, looking as though the first stiff breeze would fold them in like a tower built from playing cards. Nobody lived here. Surely nobody could live here?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Did you do this?” Wilderness asked, wondering if Miller might take offence.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, no I didn’t. But if you’re ever in what’s left of Cologne . . . well . . . I did three runs over Cologne. And I think the only thing that can be said for Cologne now is that it got off marginally lighter than Hamburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The arc Miller had steered took the plane across what appeared to be endless acres of brand new Nissen huts—an instant town, drawn to a line and a grid. It looked grim and heartless—a town, a real town, a town that had “growed,” however ugly, could not look as forbidding as this. They’d sprung up like mushrooms, like the prefabricated houses back home. Bulldoze the ruins of London and build a home in a day. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were approaching the edge of Fuhlsbüttel, the base taken over by the RAF. They all but skimmed the roofs of what looked to Wilderness to be a shantytown that fringed the airfield—a mishmash of makeshift shacks and tents. Just when he was thinking there could be nothing worse than a sea of Nissen huts.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nobody could live here you said a minute or two back?” said Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought he had only thought this and was surprised to find he had uttered it out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite right, old son. This is where they live. I reckon about a million Hamburgers fled what we did to them, and this is what’s come back. Not many, but it seems like an awful lot sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why here? Why right next to a British base?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Because this is where the easy pickings are. Hamburg is rotten, like an overripe fruit. Ready to burst. I shan’t be half glad to see the back of it. Civvy Street here I come.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness didn’t understand the image, or the idea, but asked Miller what he had done in Civvy Street.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “I was a trader.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stocks and shares?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. Not going back to that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was a trader too. Off a barrow in the Whitechapel Road.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Miller hooted with laughter at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hang on to your seat son, we’re going down.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§67")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("An RAF corporal met him by the guardhouse at the Fuhlsbüttel perimeter. He drove a staff car, a commandeered French Citroën given a cursory lick of RAF blue paint, doubtless executed with half a working brain by some poor sod on jankers, and seemed none too pleased to see Wilderness. He stood to attention, scanned him fruitlessly for any sign of rank, and none being visible beneath the sheepskin jacket, looked appalled when Wilderness held up his corner of blue serge with the propeller on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The corporal scowled. Shoulders slackened, elbows and knees abandoned symmetry, the spit and polish on his shoes faded into history. All pretence of deference vanished in an instant. He thrust a small brown envelope at Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was getting used to this.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("You’re billeted at the Atlantic Hotel. Meet me. Breakfast 8 a.m. tomorrow. Sleep well. ABJ.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He might travel to the ends of the earth, to Samarkand or Boggley Wollah only to find Burne-Jones had departed minutes before and left him a small brown envelope and instructions to guide the course of the rest of his life, in Richard Burton’s words—“Pay, pack, and follow.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness made the by now stock response.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So the colonel’s not here then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The fuck should I know. All I know is I got dragged off a winning hand at Tuesday night poker and ordered back to the base double quick to pick up a VIP. And what do I find. I find you. An erk. So that’s what I am now . . . a chauffeur for erks without so much as a bit of scrambled egg to their caps. You ain’t even got a cap. What’s so fuckin’ special about you you get a staff car all the fuckin’ way in to fuckin’ ’Amburg?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve no idea,” Wilderness replied. “But I’ll carry my own bag if you like, Corporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fuck you, kid. Get in the car and keep yer gob shut.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They got to the Atlantic Hotel in the last of daylight. A blanket of grey falling upon the ash and rubble, not a hint of colour, the temperature plummeting towards freezing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The gift of an RAF sheepskin flying jacket notwithstanding, Wilderness wondered if he might regret the decision to make room in his kit bag for his Welsh Guards outfit by ditching his winter woollies. The only words the corporal spoke to Wilderness as they crossed the Hamburg suburbs were, “Three kings, I had. Three kings and a fortnight’s pay riding on ’em.”")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§68")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("That the Atlantic Hotel had survived at all was a miracle. It towered over the Alster Lake, with all the hallmarks of a prime target. Its luminous white facade now dulled to a dirty grey, but all that needed was paint. It was battered, pockmarked but far from decrepit. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Another churlish corporal checked his papers at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is supposed to be officers only.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing to this. Let the twat think he was Bomber Harris in disguise if he felt like it. Whatever string Burne-Jones had pulled to get him in here mattered more than the two stripes on this bugger’s arm. He took back his papers, hoisted his kit bag with a silent “fuck you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was as grand as the Ritz—and the night of his cocktail in the Ritz with Merle had been the last, the only time he’d ever set foot in a hotel like this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was on the top floor, almost under the eaves, but the bed was as wide as the Thames and the bathroom not much smaller than Wembley Stadium. He slept the sleep of the just with ne’er a dream nor waking thought of corporals.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At breakfast he was shown with chilling disdain to the table at which Burne-Jones was already seated.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Glad you could make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of Burne-Jones’s pointless pleasantries. The pretence he occasionally indulged in that rank was of no import. Of no import in a room full of brass. Wilderness sat down quickly, feeling that heads would start to turn soon if he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tell me,” he said. “Am I the only erk billeted in this place?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite possibly. The others are all out at Fuhlsbüttel. But I need you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where you can keep an eye on me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones ignored this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bacon, eggs, and coffee OK? Or are you still a cockney sweet tea man?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You and your little digs, eh? No, I’m a reborn sophisticate. Coffee will be fine. Black, no sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones smiled, tucked into his breakfast, and between mouthfuls muttered, “How quickly they grow up.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§69")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Out in the street it was, as everyone had predicted to him, bollock freezing. He zipped up his flying jacket, and the look on Burne-Jones’s face told him he had thought better of asking if it was nicked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s take a walk. I need to show you Hamburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I got the aerial tour last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I need you to see it at ground level. In fact I need you to see Germans.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They stepped around a child collecting fag ends in a tin mug.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The kid looked up, a bright smile on hollow cheeks, a dead light in his blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s your first,” Burne-Jones said. “They call them "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kippensammler")]), _vm._v(". Literally fag collector.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Choc, Tommy? Fags, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had half a Mars bar in the pocket of his blouse. He’d eaten the rest on the flight. He held it out to the kid and the kid snatched it out of his hand and ran.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stared after him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You weren’t expecting gratitude, surely?” said Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” said Wilderness. “I wasn’t. I was thinking there goes the master race. Blond hair, blue eyes, begging for half a bloody Mars bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jolly good. You’re getting the idea nicely. This will all be about Germans, and that’s an awfully good place to start.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He led off into the ruined centre of Hamburg, across St. Georg in the direction of Borgfelde and Hammerbrook—districts that had been razed by the firestorm of 1943.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The child, you see, collects fag ends. These he sells to some lucky bugger in possession of a rolling machine who can reassemble the bits our chaps throw away into the semblance of a whole, if not wholesome, fag. A good fag retails at seven or eight marks, but even a roll-up using bog paper will fetch three or four. It’s the new currency. Money doesn’t count in Germany any more.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like my stamp collection.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh? What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I used to collect stamps when I was a nipper. I had all those pre-Hitler stamps from the Weimar days—had a whole page of perforated "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("200 Millionen Mark")]), _vm._v(" stamps. Wasn’t worth the sheet of bog paper you say these blokes roll their fags in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Burne-Jones wasn’t paying much attention to their surroundings, concentrating on his argument, but it was clear from everything he’d said that he expected Wilderness to, that he expected him to combine what he heard from Burne-Jones with what he saw in the streets. Of course, it wasn’t London, as Miller had said, so much worse. But in common, it seemed to Wilderness, was the extraordinary survival power of church spires. In streets that were but dust and rubble, every so often a church spire would loom up in desolate isolation. Just like St. George’s-in-the-East back in Stepney or St. Anne’s at the bottom end o")]), _c('span', [_vm._v("f")]), _c('span'), _c('span', [_vm._v("Wardour Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s go back a little further. 1919.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The revolution?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Quite, because you won’t understand the Germans if you don’t understand that. They don’t call it the revolution, of course—it wasn’t after all—they call it the “stab-in-the-back”—Hitler’s early speeches are littered with the phrase. It’s what that begat that mattered. The Nazis weren’t the only group to spring up, to cohere in the wake of 1919—if anything they were rather slow off the mark—but there were dozens of other groups, right and left. Spartacists, Steel Helmets, Reichsbanner . . . Freikorps. If you were young and angry in the 1920s you could join a movement. Some of them petered out before the republic fell, some joined the Nazis and so on. I’d say there was a time between the wars when, if you joined, you almost joined a state within a state. The paramilitaries made the Oddfellows or the Freemasons look like a Thursday evening Ping-Pong club in Scunthorpe. If you wanted they provided everything . . . more like life insurance than politics . . . if you wanted you could be married and buried by the movement you joined. It was . . . total. You could live in it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you have to ask yourself what it was in the German character that all this appealed to. Good-natured and malicious, Goethe called them. Or was it Nietzsche? No matter . . . it was something in the German soul, in the dungeons and corridors of the German soul. It wasn’t just Nazism. It could have been any faction. The Nazis just came out on top.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not sure I believe in national character. It’s like saying all Irish are piss-artists or all Frenchmen are terrific in bed but we aren’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good point. But everything in its temporal context. Think what these people had been through at the end of the last war. Military defeat. The collapse of the state—something we’ve never experienced. And add to it what they’ve gone through since 1933. A fragile democracy snuffed out in a palace coup. Then twelve years of the Thousand-Year Reich. It’s tempting to be too intellectual about this. To say that there is deracination of the mind if you like. But these people are made by their culture and twice made by the collapse of their culture.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are you trying to tell me? That Germans aren’t like us?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Exactly that. Not all Germans and not all Germans forever, but the Germans of now. The post-1945 German isn’t like you or me, and I don’t want you to think he is. That would be a great mistake. Germany and the Germans . . . right now . . . they’re a moral vacuum. And you’re going to be working with them. Millions of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stopped in his tracks. It suited Burne-Jones that they should stop. Another of his illustrations. A chain gang of women—women of all ages from teenage girls to grandmothers—wrapped in rags against the cold, they were passing bricks from person to person. The first one picked a brick out of the rubble, the last, seven or eight pairs of hands later, stacked it on a pallet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrauen")]), _vm._v(",” Burne-Jones said too simply. “Rubble women. They’ve been picking over the bones of Germany’s cities practically since the day the Führer put a bullet through his brain. They get extra rations, and bit by bit we get the streets cleared. And one day Hamburg will get rebuilt. Wasn’t much to look at in the first place, so who knows . . . perhaps they’ll build a better Hamburg. Meanwhile you get an object lesson in the German character.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Obedience?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Determination.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wondered if Burne-Jones had chosen the turnaround point at which they headed back in the centre or whether it was due to time and chance.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("They had ground to a halt—Burne-Jones had stopped talking, they had both stopped walking—in front of a blitzed terrace. It would not, with a slight shift of style, have looked out of place in London, in Stepney or in Deptford. The whole terrace was roofless and windowless, but as they reached the middle, any assumption that these houses were deserted was swept away. A door creaked open, miraculously still attached to its hinges, and a housewife swept dust and dirt out into the street. And when she had done that she reached behind her for a bucket, got to her knees and began to scrub the step. He’d seen this a thousand times in childhood. Houses that were damp, with flaking plaster and cracked windows, with buddleias sprouting from fractures in the brickwork, with leaking gutters, with . . . with scrubbed, whitened thresholds, the face presented to the world that boldly declared “this is not a slum, this is my home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§70")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("They’d crossed the Lombard Bridge between the two Alster Lakes, into Neustadt. Burne-Jones had talked all the way. His potted history of life and death amidst the ruins. Wilderness had listened. In between the spacious paragraphs of Burne-Jones’s narrative he was listening out for the sound of the city. London did not sound like Cambridge, Cambridge did not sound like London, although removed from both he could not have articulated the difference. Hamburg sounded like neither. Hamburg rattled. No, not precise enough. Hamburg clinked. Clinked to the sound of brick hitting brick, stone falling on stone, as the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrauen")]), _vm._v(" sifted the city. It was the ever-present sound, softer than bells, louder than trickling water. In a couple of hours Wilderness had come to regard it as a musical abstraction. Burne-Jones seemed not to hear it at all, but then Burne-Jones seemed not to see the writing on the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After seeing it half a dozen times, Wilderness pointedly stopped by one painted inscription.")]), _vm._v(" "), _c('p', {
    staticClass: "letter para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Nell. I’m alive! Where are you? Joe.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There’d been dozens, perhaps hundreds, adorning every wall they’d passed. A public noticeboard for the missing and the dead. The "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Times ")]), _vm._v("personal column for the homeless and desperate. There’d been plenty appealing to Nell—whoever she was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are paying attention, aren’t you Joe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course. I can repeat your last sentence if you wish. But don’t you wonder who Nell is?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones stared at the message. Double-Dutch not German as far as he was concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now you come to mention it, no. I don’t. Now . . . what was I saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You were telling me about Germany being in denial. Not a phrase I’d heard before. But while we’re here. Eighty-eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The number 88. I see that more often than I see ‘Where’s Nell’ or ‘Find me Hilde."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh. That’s old. They were painting that on the walls about nine months ago. Once they realised that liberation didn’t mean instant transformation into a land of milk and honey and that they might just have to clean up the mess themselves, they started wishing they had Adolf back. Eight is H, the eighth letter of the alphabet. Ergo . . . HH is Heil Hitler. But as I said, they’ve passed that. They now want to pretend he never existed. If you were to believe every German who claimed to have been part of the July 20 conspiracy, then you’d marvel the Reich made it to the twenty-first—the conspirators seem to have had more regiments than Joe Stalin, more divisions than the Pope.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They’d reached the Dammtor Bahnhof as big as any in London and suffering from the same glass and iron Paxton pretensions to being a cathedral. The war, the British, had somehow left it intact. Like the Atlantic, frayed and ragged, but intact.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Opposite was a clean, unmarked, vast, eight-storey building. Not a scratch on it. A sign curving around the front read, “Victory Club NAAFI—Other Ranks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know what you’re thinking,” said Burne-Jones. “It didn’t survive the raids. It wasn’t there. We built this from scratch last year. Ballroom, gym, shop . . . you name it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stared. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ballroom? A bloody ballroom?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The building all but shone. In a city where people shuffled around in rags, half-starved, picking over the contents of dustbins—a city in which that which was not grey with ash was yellow with vitamin deficiency—where people lived in holes in the ground . . . we had built this?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He said as much to Burne-Jones, and Burne-Jones replied, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Siegerrecht")]), _vm._v(". To the victor the spoils.” ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§71")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("In the middle of the day, the club was largely empty. They took deep bucket chairs and a low table in a bar that would not have looked out of place on the Queen Mary. In fact, everything about the Victory Club reminded Wilderness of an ocean liner. He’d never seen one, inside or out, but just the same . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Never one to rush anything, Burne-Jones continued his lecture while they were served coffee, but with the first sip said, “How many Germans were Nazis, would you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All of them,” said Wilderness knowing that Burne-Jones was inviting the obviously wrong answer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We reckon about twelve million.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why so sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Because party records survived the war intact. They were at a paper mill in Munich waiting to be pulped when the Americans arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s . . . incredible.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nonetheless it happened. So now almost every German has had to fill in one of these.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones slid a thin sheaf of papers across the table to him, four pages bound by red string with shiny metal tags through punched holes at the top left-hand corner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness leafed through it. Four pages, two columns, questions in two languages.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We call it the Personnel Questionnaire. The Germans just call it "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v("—‘Questions.’ One hundred and thirty-one in all, and how they answer determines what category they get bunged into and whether they get one of these.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Another sheet of paper slid across the table. Small and yellowing, the sort of thing you’d fold up in your wallet next to your identity card, a smudged blue number stamped into one corner, an unreadable signature in another.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is an "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Entlastungsschein")]), _vm._v(". They call it a ‘"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What, like the washing powder?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Exactly. It washes whiter than white. It’s official exoneration. You have one of these and you can prove to any employer, any copper, or any nosy parker that you’re not considered an enemy or a threat. I’d go so far as to say it’s the most valuable document in Germany . . . until we find Adolf’s will or Eva’s love letters.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness flicked through the questions.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Were you a member of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Korps der Politischen Leiter")]), _vm._v("? Were you a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jugendwalter")]), _vm._v("? What the fuck is a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jugendwalter")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hitler youth leader. In all likelihood a teenager good at ordering smaller teenagers around.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All sources of income since 1933? . . . and they answer this lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Indeed they do. They all want their "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(". As you might expect there’s a fair trade in fake "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(", but that’s not our problem. Our problem lies with the ones we’ve been asked to re-examine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At last, the rat Wilderness had been sniffing since breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s why you got me here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How many?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “One million three hundred thousand, give or take.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You couldn’t just send me back to square-bashing and jankers?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Very funny, Holderness. Stop sneering and let me put you in the not-so-pretty picture. In the first few weeks after the war, things got a bit gung ho. The French wanted vengeance. There were a few, shall I say, ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("incidents")]), _c('span', [_vm._v(" that won’t ever make the papers. The Americans, strangely, also seemed to hate the Germans more than we ever did. The result was chaotic . . . and answers to this form, matched against party records, led to a hell of a lot of minor Nazis—")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Muss-Nazis")]), _c('span', [_vm._v("—being dismissed from public life, kicked out of their jobs, denied their ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein. ")]), _c('span', [_vm._v("Madness. After all we knew full well that some jobs under the Reich couldn’t be held down without joining the damn party and every boy and every girl in Germany were, theoretically, enrolled in the various branches of Hitler Youth with neither consent nor responsibility. Interpreted too rigorously the ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _c('span', [_vm._v(" became a rubber stamp for the joke you cracked a few minutes ago. Everyone, absolutely everyone, was a Nazi. I say again, chaos. To give you just one example: eighty per cent of all schoolteachers in the American Zone got the sack. Extrapolate that to public life as a whole and you can guess what happened, the civic structure just caved in. Nothing got organised because there was no one there to organise it. Germans were starving, most lived off rations not much better than a prisoner got in Belsen. Now, odds are, Germany was going to starve anyway. But it’s undeniable that the mess we created made it worse. So what happened next? Uncle Sam puts the machine into reverse. Revises its classification system and starts actively hiring ex-Nazis. But, there’s more to it than that . . . for years, perhaps since the first doodlebug landed on London, they . . . I think I mean we . . . the Allies . . . have wanted to get our hands on the blokes who designed V-1s and V-2s. Mostly this was done in the American Zone at Peenemünde, Nordhausen, and Dora. And no one really gave a toss whether these blokes were Nazis or not. Personally, I think that’s a mistake. If they weren’t party members, they still had a lot to answer for. Dora was a concentration camp manned by slave labour, they worked people to death. But it was pretty obvious no one was going to ask Werner von Braun about dead slaves. We collared our share. Shipped a dozen boffins back to Cambridge. The Russians indulged in an unholy scramble that included kidnapping people off the streets . . . but above all the Americans wanted their rocket boys. They have most now, but not all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Burne-Jones looked around for something, reached for a roneoed, smudgy menu off the next table—egg and chips, saveloy and chips, peas and chips, chips with everything—and turned it over. A rough map of Europe sprang from the tip of his pencil. A shapeless blob for Ireland, a blob with proboscises for England, a square for Spain, a boot for Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We know that a lot of Nazis have escaped Germany in the last eighteen months.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He scribbled arrows down through Italy, across the South of France and into Spain and Portugal. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There are fairly obvious escape routes. Most, we reckon went south. Most ended up in Lisbon, a city where nobody asks too many questions, and from there to Brazil or Argentina. A five-bob postal order and a Mars bar to the man who spots Martin Bormann or Adolf Eichmann. But, supposing some clever bastard went north?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A long, thick black arrow was scribbled in, like an imaginary, unswerving autobahn from Stuttgart to Hamburg. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You could lose yourself in the British Zone, but getting a ship out to anywhere would not be easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So you think some of these boffins are hiding out in Hamburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. But the Americans are insistent that we look.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How many?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who? Who are we looking for?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t know that either.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So we’re searching for people who might not exist, might not be here, and we don’t know what they look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That about sums it up. But if they’re here . . .” He picked up the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(". “They’ve filled in one of these, and they’ve lied. That’s where you come in. Read them through, look for the loopholes that tell you they’re lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One million three hundred thousand!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not. Just Hamburg, and just the ones we’re sceptical about. A few hundred at most.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness scanned the pages again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who interviews these people in the first place?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Straight to the heart as usual . . . yeeees, that’s our problem really. Fluent German speakers, of course . . . many of them former refugees themselves . . . but few of them regular soldiers . . . in fact I’ve not yet met one who saw combat. They tend to be older men, men who were in Civvy Street much of the war.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“And they can be next to useless. On the one hand all the pent-up hatred of chocolate soldiers, Blimps who watched the war from an insurance office in Guildford, on the other Mr. Chips, soft old prep-school Latin masters who think a smack on the wrist and forgive and forget will fix anything and anyone. Even a Nazi. Not a lot in between in my experience. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re re-interviewing. You’ll be working with a Pioneer Corps chap, Captain Yateman.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The rat loomed larger.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Twat, is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t spare the qualifiers, Holderness. He’s a fucking twat, to use your habitual phrase.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “If he’s so sodding useless, why don’t you replace him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Because I didn’t appoint him. I don’t get to appoint the denazification team. I get to appoint the intelligence officer attached to the denazification team. In this case, you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Me? Leading Aircraftman Holderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then why not make me an officer? How easy is it going to be if I have to contradict an army captain with nothing but an LAC’s rank to stand on?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’d hate it. You’d absolutely hate being an officer. You’ve risen to LAC. Accept that promotion and be content for the time being.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hate it? Give me a half a bloody chance. I’d have been LAC nine months ago if I hadn’t gone to Cambridge.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you hadn’t gone to Cambridge you’d be in a military prison. Where were you when I found you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing and stared at him. Anger was a waste of time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where were you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In the glasshouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite. In the glasshouse on a charge sheet as long as your arm. Be grateful for small mercies, Joe. Being an LAC is a small mercy. Not being in prison is a big, fat, Technicolor mercy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said softly, “Sergeant would be good, even corporal, much as I hate corporals.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you’d hate them even more if you were one. Think how happy you’d be in the NCO’s mess surrounded by them. Stick with this, Joe. We’ll talk about promotion in a month or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness did not believe this. They might never discuss his promotion again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. Let’s get back to the real question. I"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Yateman fucks up how do I overrule him with no pips and no scrambled egg?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Trust me. You’ll have that authority. You can investigate anyone you think fit, whatever the good captain says. He might rant, he might have steam coming out of his ears and arsehole . . . you just refer him to me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§72")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("This called for a little privacy. Back at the Atlantic. Up in Burne-Jones’s suite. They awaited a man Burne-Jones referred to as the armourer, whom he greeted as Major Weatherill. About Burne-Jones’s age, and in the same Guards regiment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Standard procedure. You’re part of the occupying force. You have to carry a gun. King’s regs and all that. You’re lucky. I can give you a pistol. There are plenty of chaps nipping out for a swift stein of lager lugging Bren guns with them. Now, would you kindly remove your blouse, LAC Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness obeyed silently. Somewhat awed by the man’s apparent indifference to his lack of rank. He did not give orders; he made requests. It was like being at the tailor’s. A gentleman was a gentleman—a bloke whose cheques didn’t bounce.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness held up his arms as Weatherill fitted a shoulder holster under his left armpit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Comfortable?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When did officers ever care about your comfort?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good. Try this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Weatherill upended his satchel and took out three automatic pistols.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Colt .45.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was big and felt like a log inside the holster.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It won’t be easy to get at under my blouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The point is to have it,” said Burne-Jones. “Not to get at it. Or did you see yourself having to outdraw Wyatt Earp? You can have a button-flap waist holster if you insist but you’ll look like a military policeman.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hmm . . .” said Weatherill, ignoring Burne-Jones. “Perhaps not the Colt.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could almost hear him saying “perhaps something in dark blue.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He handed the Colt back, wondering at what point he should speak up, and thinking now might not be the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Try this. Beretta .22.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was like a toy, vanishing down the mousehole of his holster, all but weightless.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Not that either. Never really cared for the .22. More of a lady’s gun, alright in a handbag but . . . but . . . we still have the Sauer 38H. Point 32, takes standard 7.65mm ammunition, and God knows Germany is awash with that. We confiscated about twenty-five thousand of these off Jerry. Does the job. And the German coppers seem to like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness slipped it into the holster, decided he liked the feel of it, hefted the weight of it in his hand. Took a look at it. Small, smaller than his own hand, only about six inches long, black with an elaborate S stamped into the grip.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course some of them have red swastikas inset. We tend not to give those out. Some chaps would simply sell them to souvenir hunters after all. Now, you happy with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perfectly, sir. There is just one thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeees?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve never fired a gun in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones looked up from the newspaper he’d been reading.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? What? It’s part of basic training.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where was I when you found me? I hadn’t got as far as weapons training when they bunged me in the glasshouse for the last time. The most I’ve done is swing a broom handle around and attempt to slope arms with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bugger,” said Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bugger indeed,” said Weatherill. “It might be best if you didn’t try and shoot anyone. At least not just yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§73")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("After a month Wilderness had come to look forward to his meetings with Major Weatherill.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He spent his days in a clumsily refurbished office, seized from the Hamburg Port Authority, overlooking Planten un Blomen Park. They consisted of repetitive sessions with Captain Yateman.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The first session had not gone well.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Intelligence Officer? You’re an enlisted man!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The English language is prone to creating confusions, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones had been emphatic about the “sirs.” And when talking to a short, stout, ruddy man who had spent most of the war behind a desk at the Hatfield branch of the Herts and Cambridge Allied Assurance Society, it was as well to P the ps and Q the qs. Yateman puffed up like a bantam cock, and stood on enough dignity to provide a solid footing for the Empire State Building. He sat behind a desk here too—complete with in-tray and out-tray, although there was never anything in either as Wilderness held the files, and Wilderness concluded that the captain could not bear to be parted from them, the symbols of his authority . . . his crook and mitre . . . his helmet and truncheon . . . his inkwell and quill. He’d probably brought them with him from England.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They interviewed Germans together. Tedious beyond belief, and on Burne-Jones’s advice Wilderness intervened only when necessary and as yet necessity had not arisen.")]), _vm._v(" "), _c('p', {
    staticClass: "letter para-style-override-16"
  }, [_vm._v("Alle Ihre Dienstverhältnisse seit 1. Januar 1930 bis zum"), _c('br'), _vm._v("heutigen Tage sind anzugeben.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And once they had reached that at the top of page three, Wilderness would be listening for what seemed like hours to every job the bloke had ever had and every pfennig he’d ever pocketed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Some of them were lying, perhaps more out of fear of the tax man than the English man, but it struck Wilderness as trivial. Anyone who lied about their party membership was caught as easily as swatting a fly. They checked against party records. And most who tried that lie had been caught at the first examination not the second.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yateman’s failing, Wilderness concluded, was that he favoured the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Muss-Nazi")]), _vm._v(" for no better reason than that they tended to be of the same class—searching for a word that bridged the two languages, he coined “burger.” Roger Yateman was a “burger.” The sort of man who was a Rotarian and a pillar of the Chamber of Commerce, who gave generously to selected charities and who despised the poor as feckless and lazy, and who despised the rich as feckless and lazy. The sort of man who had no politics, so he joined the Conservative Party—the sort of man who had no faith, so he joined the Church of England. A “burger.” Most of the selfish, prim, morally vacuous sods arraigned before them were “burgers.” Solid citizens of a bourgeois world that had dissolved around them. Men with no real conviction but enough savvy to have bent to the political wind, and not to have much troubled their consciences these last thirteen years. They too might have been insurance office managers in Hertfordshire. Wilderness agreed with Burne-Jones—the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Muss-Nazis")]), _vm._v(" probably no longer mattered. Yateman no longer mattered, except in his capacity to fuck up. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("von")]), _vm._v(" or a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("zu")]), _vm._v(" affixed to a German surname could drive the man apoplectic. Nazi or anti-Nazi, they seemed to bring out in him a scarcely veiled counter-snobbery.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Again Wilderness did not intervene, any more than he did with the burgers, confining himself to “this way, follow me,” “thank you,” and “good luck.” Whether he intervened or not would depend on what he did with his nights—reading through pile upon pile of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" looking for Burne-Jones’s rocket scientists. And thus far not finding them. The rest, the underwhelming majority of the culpable, the innocent, and indifferent were of no concern. “In denial,” Burne-Jones had said. Germany was a land of ostriches. And heads buried in the sand could bleedin’ well stay in the sand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But . . . two mornings a week he and Weatherill drove out to the far east of Hamburg, past fragile suburbs, to abandoned farms, and an empty silage pit lined with sandbags. There he learnt how to shoot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know, LAC Holderness . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was never just Holderness or Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We have an advantage. Missing out on basic training leaves you nothing to "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("un")]), _vm._v("learn. No comparison between a close-quarters weapon like this and a rifle. You were quite right in your summary. Knowing how to swing a Lee Enfield .303 around on the parade ground with occasional cracks at a paper target isn’t knowing how to shoot. After all the bloke with the Lee Enfield isn’t there to shoot. He’s there to die.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you know how many bullets from a Lee Enfield it took to kill a Jerry in the First War? I’ll tell you. A quarter of a million. And all but one would miss the bugger. That’s how useful the rifle and the bloke holding it are in the twentieth century. What mattered was that he died doing it. I’m not here to teach you to die, LAC Holderness. I’m sure you’ll manage that very well without me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then what are you here to teach me, Mr. Weatherill?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m here to teach you to kill.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness did a silent double take at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . such innocence. Tell me LAC Holderness, what kind of an organisation did you think you’d joined?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness never answered this for fear Wetherill would put him right. He had few illusions, but he much preferred to hang on to them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By week three, Major Weatherill was complimenting him on his accuracy. It brought a silent, he hoped, invisible pride to Wilderness’s mind. The first thing he’d been really good at since Abner taught him to crack a safe. Russian and German were good things in their way, and his education at Rada’s hands was worth three years in any university . . . but this . . . a Sauer 38H in his fist . . . six inners and two bulls . . . this was . . . physical.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§74")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("The Atlantic Hotel was a refined version of hell. Wilderness did not fit in anywhere. There was no specific area for “other ranks,” but all the same the white-coated German waiters, all under the supervision of class-and-rank-conscious English batmen, always managed to sequester him several tables apart from any officer by what amounted to a cordon sanitaire. This pattern only altered if Burne-Jones was in town. The officers of the Control Commission ignored him—which had one advantage. He did not have to salute at five-second intervals every time he passed one.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Most evenings he pored over the files Burne-Jones had dumped on him, and he had worked out that the reason—perhaps one of the reasons—he had been billeted here, the fish out of water, was that Burne-Jones wanted none of his files going astray. On the nights he took for himself he usually drifted over to the Victory Club—past the by-now familiar cries of “Fag, Tommy?”, “Chocs, Tommy?”, “Jig-jig, Tommy?”—at least the Victory had “other ranks” in letters a foot high over the door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One night, in the first week in December, he was in one of the bars at the Victory Club, drinking alone as he had made no friends among the NCOs either, and had turned down an offer to have his cock sucked for a packet of ten Player’s Navy Cut. His “war” was at the opposite of most. He was zenith or nadir—it didn’t matter which—starting his task as others were finishing theirs. Much of what they did and said was reminiscence, and he had no memories to trade. Every other night, perhaps even every night, the Victory Club played host to someone’s demob party. The joy soon went out of them, and if a dozen blokes came in hell-bent on getting rat-arsed, burning their pay books in the ashtrays, showing each other their backsides and staging water battles with stirrup pumps and fire buckets, he’d usually drink up, go back to the Atlantic and his pile of paperwork. But it was frustrating. Hamburg was a city that lived by crime. The black market was the only market and it seemed to be ubiquitous and elusive at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On this occasion, a hand clapped onto his shoulder and a voice asked, “What’ll you have, mate?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was the flight sergeant from the Lancaster that had flown him out. The hand moved into mid-air ready for Wilderness to shake.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“John Blackwall. Call me Johnnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe Holderness. Call me Joe. I thought your time was up?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Nah, I got six months left. Skipper’s time was up. After we dropped you off he nicked anything that wasn’t nailed down, flew the old girl up to a little harbour near Kiel, put her down on the sands—hairiest landing of my life—and winched a yacht, sails and all, into the bomb bay.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Don’t the coppers and customs look out for that sort of thing back home? How do you sneak a yacht past the military police for Christ’s sake?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“We didn’t. We dropped it into the Solent like it was one of Barnes Wallis’s bouncing bombs. We tried it with a Merc last summer. Skipper made whopping great water skis for each wheel. Looked like the daftest flying boat in history. Sank like a stone, just of")]), _c('span', [_vm._v("f")]), _c('span'), _c('span', [_vm._v("Ventnor. Then in September we dumped five hundred pounds of NAAFI coffee beans wrapped in tarpaulin. Floated long enough for his pals to get it ashore. We got it right this time too. The yacht’s moored at Milford-on-Sea, just opposite the Isle of")]), _c('span'), _c('span', [_vm._v("Wight, now. Expects me to crew for him next summer. I should cocoa.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was ambitious. Impressive. A thief with nerve and imagination. Wilderness was looking for a good nick, but this was a nick far beyond him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So what’s the crack, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Crack?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There must be something happening in Hamburg. Everybody nicks everything. Everybody has something to sell. Everybody lives by the black market.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“True, fags are better than pfennigs and a bag o’ coffee’s worth a quick fuck in an air raid shelter. And enough bags o’ coffee’ll buy you a Leica. You’re getting nothin’, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not a sausage. Sorry . . . I mean not a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wurst.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I reckon I can tell you why. You based here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not exactly. I’m with the nobs at the Atlantic.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Blackwall sucked in breath sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Struth. Need someone to black their boots do they? Or is it regimental arse-wiping?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Security reasons, or so I’m told.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“O’course. The skipper said you was one o’ the colonel’s bright boys. But . . . it’s the Atlantic that’s stuffing you mate. All the action’s out at the base. ’Cos that’s where all the pickings are. There’s fuck all here. You can’t nick from the NAAFI, can you? I mean, look at those women they have behind the counter. They catch you light-fingered they’ll crush you to death with one hand. They get you between their tits and you’ll never see daylight again. Nah, you got to be out at Fuhlsbüttel. A quick visit to stores, a bit of a bung to the quartermaster and bob’s yer uncle. I always say, any posting, any town . . . you need to find the easy pickings.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All I can do is flog off my own fags and chocs ration.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never get rich that way. So, you haven’t dealt much with reichsmarks?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hardly at all. All I see is Little England on the Baltic. Sterling rules. I take some reichsmarks if I sell me fag allowance. But mostly I give fags away. There are so many just begging for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You give ’em away?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Chicken feed,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Clearly, Blackwall did not agree. He unrolled a 5RM note onto the tabletop.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Take a look. You see the little plus after the number? That means the Yanks printed it. If there’s a minus, the Russkis. Try not to take minuses. Stupid bloody Yanks gave the Russians the plates, they print money the way we print ‘Property of HM Forces’ on bog paper. It could all end up worthless. Before the war, there was a tale that people in Berlin papered rooms with reichsmarks because it was cheaper than buying wallpaper. One day all this could be so much cheaper than bog paper we’ll be wiping our arses on it. Here endeth the lesson.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two pints of Flensburger arrived almost by osmosis. Blackwall gulped an inch off his and said, “Easy pickings, kiddo, easy pickings.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a slogan to live by, the sort of thing Abner might have told him.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§75")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("At last.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Peter Camenzind caught his attention. His "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" was not one that had been singled out arbitrarily. He’d applied for a job with the state, the state being the Allied Control Commission for Germany, and that made a second look mandatory.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Thirty-four years old, a former teacher from Berlin. His "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" was bland. He’d never been in anything, not the Nazi Party, not a trades union, he’d never done any kind of military service, and he’d never been abroad. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Before talking to Yateman, Wilderness put a phone call through to Berlin. The school Camenzind claimed to have taught in was rubble—the whole street was rubble. As was the Ministry of Education, in which any record of his scrupulously accounted employment might have been kept. All very plausible, all rather neat, and making further checks impossible.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was not a day when Burne-Jones was in Hamburg. At the start of the day’s work Wilderness set Camenzind’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" in front of Captain Yateman.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Surprisingly Yateman remembered him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So he’s found a position. Jolly good luck to him. Should be a rubber stamp affair. In and out in two minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Position” not “job” was enough to show the extent to which the burger Yateman identified with the burger Camenzind. Certain people had careers, certain people had professions, certain people had positions, the rest had jobs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” said Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, LAC Holderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Since you do remember him, sir. Why did you not query his lack of military service? He was born in 1912. He’d have been called up for the invasion of Russia in 1941, if not before. If he was lame or ill, he’d have been in the Home Guard. At the very least, sick or fit, short of being in a wheelchair, if he could put one foot in front of the other, if he was anywhere near Berlin last year he’d have been in the Volkssturm, with the old men and the schoolboys. And he taught in a grammar school. Yet he lists no party or union membership.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Yateman was polishing his spectacles, avoiding eye contact with Wilderness.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps he wasn’t in either?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The National Socialist Teachers’ League was pretty well compulsory, and the pressure to join the party itself would have been nigh irresistible. Like joining the Freemasons if you want to get on back home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The wire loops of his spectacles hooked back around his ears with a dip of his head. And when at last he looked at Wilderness, the thin English lips were set like the slit in a pillar box, the little red moustache twitched independently in suppressed anger. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“An odious comparison, Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you say so, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All the same, they sent for Camenzind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a joke doing the rounds that had eventually reached Wilderness via Johnnie Blackwall one night at the bar in the Victory Club.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A bloke sweeping the street pauses for a breather to find another bloke looking at him from a street corner. The cleaner turns to the other bloke and says, kind of haughty like, “I was a senior clerk at City Hall before all this denazification nonsense—now I’m sweeping the fucking streets.” And the second bloke says, “Before all this denazification nonsense "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("I")]), _vm._v(" was sweeping the fucking streets.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And little fleas have lesser fleas and so ad infinitum. It was a world of fleas. They were meant to be finding little Hitlers not little fleas.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Peter Camenzind was a flea—a flea in so far as he looked no different from any one of a hundred other men who had sat in front of Wilderness and Yateman. His jacket was ragged at the elbows and cuffs, his shoes resembled burst sausages, he had no topcoat, he looked as though he shaved with a rusty can lid, and he stank. He had applied to resume his former profession of teacher of mathematics to children of secondary-school age. He expressed no resentment at having his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" flourished in front of him, merely a hint of boredom and a passivity that passed for cooperation in the flea world. Wilderness had rapidly concluded that this was the chief characteristic of the “new” Germany—passivity, a mental exhaustion, a level of sloth that would not whip up enough adrenaline to get out of the way of a rolling tank. Less death wish than lethargy. An indifference born in defeat.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But the scarecrow appearance did nothing to disguise the man. He spoke with a patrician Prussian accent, and nothing about facing a British army captain and his insignificant assistant dented his calm or his manners. He held himself well—the sort of boy who’d been beaten if he slouched, shouted at if he put his hands in his pockets. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His hands weren’t in his pockets, they rested on his crossed legs, on the all but transparent fabric of his threadbare trousers, nails bitten down to blood, fingers stained to a deep ochre with nicotine.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would either of you gentlemen have a cigarette to spare?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§76")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He passed muster. Smoked his way through half o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Wilderness’s fags and told plausible lies. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Why had he not served with the armed forces? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Asthma. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Why had he not been called to the Volkssturm?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By 1944 he had been in Hamburg, but was registered in Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Why was he in Hamburg?")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Berlin’s schools were bombed out, its children evacuated. A friend had offered him a job in Hamburg. The friend died, and the job with him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" . . . “And since the war was lost—only an idiot or a fanatic would think it was not lost by the autumn of forty-four—was I to go home and await slaughter or capture by the Russians . . . or stay here and wait for the British?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How had he lived?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“By my meagre savings and by the kindness of strangers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He waved a lit cigarette in the air, smiling at Wilderness, a trail of smoke like a passing dragonfly in the air between them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Lately it has hardly been an issue. Money becomes irrelevant when there’s nothing to buy.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§77")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Out in the corridor, Wilderness said, “He’s too cocky by half.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t believe him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“With all due respect, sir, the man is blatantly lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know LAC Holderness, I doubt you know the meaning of the word ‘respect."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then just keep him here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bugger respect. Just keep him here. Detain him, arrest him, play fuckin’ tiddlywinks with him. I don’t care. Just keep him out of my way while I turn over his gaff.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§78")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Camenzind lived in a converted air raid shelter. Conversion consisted of installing electricity (one bare bulb to a room), beds (straw-filled palliasses on rickety wooden frames), the odd scrap of furniture (a hat stand that could not have seemed more out of place than an antimacassar or an aspidistra table) and a gas ring that strove, in company with the kettle, to become a kitchen. The only running water was from a standpipe in the street. All but the top three feet of it was below ground level and it had no windows. It had ten rooms and was home to thirty-six men, half of whom were in residence when Wilderness called with an escort of military police and turfed them out into the winter cold where they shivered with only the merest of muttered complaints. A one-eyed man—a black patch over his left eye and a ragged red scar across the cheek beneath—wearing the remains of a haphazardly dyed Wehrmacht uniform—grey with black blotches, one breast pocket hanging loose like a waving handkerchief, the trousers baggy around his now-skinny frame—showed him where Camenzind slept, in a damp, dirty concrete room he shared with three other men.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are here to search the room?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What is there to search?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He walked away and left Wilderness to it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The man had a point. What Camenzind owned, and this seemed to apply to his roommates too, he was probably wearing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A small cardboard suitcase beneath the bed yielded clean if tatty underwear and three pairs of socks in need of the darning needle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Next to the bed was an upended crate that had once held oranges. Camenzind was using it as a bookcase. A couple of novels by German authors Wilderness had never come across, a volume of Schiller’s poetry, a maths textbook full of quadratic equations and a slim, paperbound physics treatise. He shook each book in turn, hoping for something concealed, or simply something being used as a bookmark.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Strips of torn newspaper fell from the Schiller and were nothing more than bookmarks a couple of inches across and ripped from the page regardless of the meaning of what was on them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("From the physics treatise fell the one piece that had been clipped with scissors. A photograph captioned in a language he did not recognise. But he recognised the photograph. It had been in one of Rada’s files—the one curtly, aptly labelled “Armageddon.” Her copy had been cut from the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New York Times")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the title page of the treatise, and all the fragmentary unease he had felt from the moment he had first read Camenzind’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" cohered, crystallised.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01 para-style-override-1"
  }, [_vm._v("Über den Nachweis und das Verhalten der bei der Bestrahlung des Urans mittels Neutronen entstehenden Erdalkalimetalle")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-1"
  }, [_vm._v("von ")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-1"
  }, [_vm._v("Dr. Peter-Jürgen von Hesse")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-1"
  }, [_vm._v("Max Planck Institut")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-1"
  }, [_vm._v("Berlin Dahlem")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-1"
  }, [_vm._v("1939")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Rada had sent him away with books as well as files—all part of the education she wanted him to have, and he was pretty certain Burne-Jones was insistent he had. Some he read with pleasure, some from duty, and some he abandoned as boring.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Peter Camenzind")]), _vm._v(" by the Swiss writer Hermann Hesse had been one of the latter—he’d given up in less than fifty pages. A turn of the century bildungsroman. Something about an angst-ridden Swiss teenager with a bit of a thing about St. Francis of Assisi.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But . . . if you were looking for a change of name . . . it was wise to hang on to your Christian name—as you’d never answer to another—and from Hesse to one of the other Hesse’s literary figures? Well it saved stretching the mind too far. And what were the odds anyone had ever read the book?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So, he wasn’t Peter Camenzind, he was Peter-Jürgen von Hesse of the Max Planck Institute in the Berlin suburb of Dahlem. A place with quite a reputation. Einstein had been its first director in 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The language on the captioned photo he concluded was probably Danish, as it depicted a gathering of Europe’s finest physicists in Copenhagen in 1937. Niels Bohr was in the middle, so readily recognisable. Lisa Meitner, not quite so recognisable, was on his right, a young woman he could not identify on his left, and standing, just behind her left shoulder, was the man posing as Peter Camenzind.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§79")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Another “Where are you Nell?” was in the process of creation on the outside of the shelter. The one-eyed former soldier, brush in hand, was signing his name—Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness asked, “Why do you do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“In hope. And if hope proves false, proves worthless, then it is an elegy. You take everything away from us, would you take away our elegies too?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then leave me with hope. Hope that one day . . . Joe and Nell will find each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness held out the packet of cigarettes that he’d opened for Camenzind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You smoke?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course, who doesn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As a matter of fact, I don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Johannes—Joe the painter—laughed as he lit up, laughed out the flame on his match.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“God that’s funny . . . the only currency left is tobacco, and it doesn’t even matter to you. You English amaze me sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Keep the packet,” Wilderness replied. “It may well be the last I ever give away.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§80")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He waited for Burne-Jones at breakfast the following day. Burne-Jones was late. He read a three-day-old copy of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Manchester Guardian")]), _vm._v(" almost cover to cover.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones dashed in looking frazzled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, old man. Didn’t get in till after two. The RAF aren’t as reliable as the Great Western Railway I’m afraid. All getting a bit Heath Robinson these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked around for a waiter. Gestured at the one he found and then turned to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have you eaten?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah. I was waiting for you. The service is better if you’re on the other side of the table flashing yer crown and pip. I’ve had three coffees though. I’m swimming in caffeine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And bursting to tell me something.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That obvious, eh.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rather.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness placed the Danish photograph in front of him and pointed to Camenzind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Swedish?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Danish. A physicists’ conference in 1937. I have this bloke in a cell right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good lord. Who is he? One of the rocket boys?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. You got luckier than that. He calls himself Peter Camenzind, but he’s really Peter-Jürgen von Hesse. He wrote this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness slipped Camenzind’s treatise across the table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bloody hell. What does it mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your German’s better than mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, I mean, what does it mean "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("mean")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s about what happens when you fire neutrons at uranium. It’s one of the immediate precursors to the theory of a chain reaction.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean atoms and stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I mean atoms, stuff, chain reactions, and bombs big enough to take out Hiroshima.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah,” said Burne-Jones. “The penny has finally dropped.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s not one of your rocket boys. He’s a bigger fish by far. If, and you’ll know better than me, Germany was trying to build atomic bombs this would be the bloke who made them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones said nothing while scrambled eggs, crisp bacon, and white toast were set in front of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It bought him thinking time and Wilderness could readily see that he was wondering how much to tell him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We . . . that is the governments of both Britain and America . . . were always concerned that Germany might be building a bomb. Most of the boffins with the know-how were German after all, and while most them worked for us . . .” He tapped the treatise with his finger. “There were a fair few who stayed on. No real way during the war of knowing quite what they were up to, so we took out their heavy water plant in Norway just in case. In ’44 the Americans set up a special unit in London with one purpose, to travel with the Allied troops as they crossed France and Germany and find out just how far the Germans had got. Led by a chap named Boris Pash. Met him a couple of times. Tough cookie, as our cousins would say. First American into Paris. In fact, his unit tended to be the first anywhere. They didn’t follow, they led. In April last year they took a small town way down south, Haigerloch, not far from Stuttgart, and only about fifty miles from Lake Constance. They captured a wagonload of boffins and Germany’s nuclear thingie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thingie?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cycle something. Science was never my strong point. I was more a Latin and Greek man.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cyclotron.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you say so, although quite how you know this sort of thing baffles me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They don’t have public libraries in your neck of the woods? I used to sit in Whitechapel Library and read "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nature")]), _vm._v(" while my mates kicked a tin can around the streets.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite an education.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. That and Cambridge and Rada.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good old Rada. Where would we be without her? Now, have you talked to this chap.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes, he’s chatty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not too chatty I hope. Yateman doesn’t have your clearance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I wasn’t aware I had my clearance, but there’s nothing to worry about. The good captain lost interest once Herr Doktor von Hesse revealed his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("von")]), _vm._v(". Brought out the Pooter in Yateman. He hates toffs more than he hates me. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I asked von Hesse why he was in hiding. He said he didn’t really know, but was perfectly happy to be in jail instead. He can smoke for Germany, so I kept plying him with fags and let him rattle on. I think, based on what you just told me, that he’s telling the truth. He was at Haigerloch. He maintains they were nowhere near building a successful bomb. And he lit out only a day or two ahead of your American pal getting there, headed north—on the assumption he’d be looked for heading south for Switzerland—and managed to lose himself in Hamburg. I think he knew he’d get caught one day, and decided we were preferable to the Americans. Once I’d asked him the first question the mask seemed to drop quite readily. As though I’d lifted a burden from him. He seemed to want to cross-examine himself. A lot of it was waffle. I got most of his life story, but in the end what it came down to was guilt by any other name. By that I mean he never used the word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Guilt about what? The war? The Jews?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Guilt about staying on. What he fears is not arrest or imprisonment; after all, he’s had three of the squarest meals of his last year in the twenty-four hours since I picked him up, all the fags I could have sold on the black market and me last bar of Cadbury’s Bourneville—for which you owe me by the by—and the only charge he faces is lying on his damn "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(". A smack on the wrist, a fine he can’t pay? And he’ll probably get to keep his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(". What he fears is the judgement of fellow scientists. Einstein got out, Lise Meitner got out, Leo Szilard got out . . . he stayed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not a Nazi?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not anything, and I think that’s what bothers him. He doesn’t know who he is any more. He teased that out into a whole thesis last night . . . what is Germany, who are the Germans? ‘"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir, was sind wir?")]), _vm._v("’ He said, and this is illustrative of the way he thinks, he said, ‘How can I listen to Schubert lieder, how can I write a love letter, how can I describe the splitting of an atom in the same language that told a million lies in propaganda, created euphemisms such as "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Die Endlösung")]), _vm._v(" to disguise mass murder, and ordered children into gas chambers. It would be an obscenity."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Obscenity?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s what he said, and he said it in English.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who are the Germans?” Burne-Jones echoed. “Who are the Germans? I rather think we’ll all be asking that for many years to come. We now have the German question . . . perhaps it’ll replace the Jewish question? Although I was never wholly certain what that was.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The German question?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Wilderness thought of the one-eyed soldier in his hand-dyed Wehrmacht motley asking his own German question for years to come, perhaps asking for ever")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Nell. I’m alive! Where are you? Joe.")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§81")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Lower Saxony")]), _vm._v(": August 1945")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Nell stuck to unpaved roads. To limestone tracks that snaked across heathland, wound their way in and out of woodland copses, past farmhouses and barns.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the third day, making slower progress than she had imagined, close to dusk, she could see in the infinite distance what appeared to be an encampment at the side of the road. It was the way she had imagined pilgrimages would end. Approaching the city, it seems to recede, to be always visible and always out of reach, its plume of smoke curling skyward merely to tantalise.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a caravan—much in the gypsy style.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had been off the road a while, grass and bindweed in the wheels, the shafts tied up, pointing to heaven and the cart horse put out to graze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By the side of the track a child of indeterminate gender was stirring an indeterminate stew over an open fire, with a Wehrmacht helmet serving as the cauldron.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The child’s trousers—baggy like pantaloons—puzzled Nell. Who would dress a child in bright red out of choice? But who had a choice? Then she saw the black arm of a hakenkreuz peeping out at the seam. And the faint rattle she had been hearing for the last minute began to make sense. A sewing machine. Someone, someone close and out of sight, was sitting at a treadle sewing machine turning Nazi flags into children’s clothes. The 1945 revision of “swords into ploughshares.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The child had noticed her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mutti!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell followed as the child ran around the end of the caravan. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("An old woman was indeed paddling away at a sewing machine, her hair tucked up in a headscarf made from the same material, her hands feeding more of the red and the black under the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hullo dearie. Come far have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“From Celle.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know where that is. Are you hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, I suppose I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . there’s enough for three. There is only me and Gretchen now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She pulled the redefined flag from the sewing machine, snipped the trailing threads and held it up—another pair of baggy pantaloons. The Third Reich rendered into the costume of a circus clown.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then she eased herself up with her walking stick.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Won’t be long. Come and meet the kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Behind the caravan, the horse grazed on the sparse grass of heathland—half a dozen rabbits nibbled in a wire run—cabbages and carrots struggled in the sandy soil—and three wooden crosses stuck in the ground marked the lives of Mutti’s children.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My daughter Kattrin, my son Eilif.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They died here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. They neither of them died here. They died in the wars. They died on the road. And we’ve been on the road since the day the Russians entered East Prussia. The graves are markers—tokens if you like. In a world where everything is ersatz, they are ersatz graves for the children I never got to bury.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why . . . why here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Here? Because this is where the horse stopped. He would go no further. Folk there are who would have stuck old Pickles like a pig and feasted on horse meat, but he had been too loyal for me ever to do that. Hauled us all the way from Gumbinnen, where I bought him. Before that we pulled the wagon ourselves. He has been too good a horse to end up in the pot. A thousand kilometres and more between the shafts. Allenstein, Graudenz, Bromberg, Landsberg, Berlin. No, dearie. It’s rabbit stew for us. Come, fill up the hole in your belly before you fill one under the ground.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They ate from tin plates. Nell was pleased. She had not been at all sure she could have eaten from a Wehrmacht helmet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Going far, dearie?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . I was there in . . . March I think it was. Far enough ahead not to hear the Soviet tanks grumbling at my arse.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I have not seen Berlin since December. But it is home. I am a Berliner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are a Berliner. I am a Gumbinner. And I will never see my home again. Forget Berlin, dearie. Berlin is gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In all the warnings she had received—Dekker, the British policeman in Celle—it had not occurred to Nell that Berlin might be “gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin cannot be gone,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Once Berlin was not. Then Berlin was. Now Berlin is not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I must get to Berlin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, dearie."), _c('span'), _vm._v("You must survive. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Sie müssen überstehen")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Mutti appeared to be thinking, but Nell knew it was the pretence of thinking, and that what she would say next had been on the tip of her tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never tell all you feel, or better still, feel very little. And always know the price of flour and sugar. Coffee too for that matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She liked the old woman. The old woman fed her, lent her blankets for the night and let her sleep under the wagon . . . but Nell knew she could not live that way if that was what it took to survive.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§82")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The map she held was ancient. The newest map of Germany to be found in Klaus’s library dated from 1888, the year of the Kaiser’s accession. On the fourth day she felt she must be somewhat north of Wolfsburg, and close to the green squiggle Dekker had drawn on the map to show her roughly where Russian rule began.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Another dusty limestone track was leading her to another elusive pilgrim shrine—the iron gates and stone gateposts of a schloss—the castle itself being just visible beyond the trees, its roof peppered with missing tiles, and its slender, spiral turret sporting a shell-shaped hole.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Someone was singing:")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_vm._v("Oh the grand old Duke of York,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("’E ’ad ten thousand men.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("So they banged ’im up in Pentonville.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03"
  }, [_vm._v("An’ ’e won’t do that again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The singer was tuneless, and out of sight. As Nell rounded the gatepost he finally came into view. A small man, swinging a rifle about and marching up and down somewhat in the manner of Charlie Chaplin. His top half appeared to be a British Tommy of some sort. The lower half beggared belief. Pants as baggy as those Mutti was making out of flags, and in so many colours . . . blacks, greens, and reds . . . with stripes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was staring, and she knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He lowered the rifle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wot you looking at?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“At you, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wossamatter? Anyone would think you’d never seen a corporal of the Seaforth Highlanders before.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I haven’t. In fact I’ve never seen anyone dressed like you before.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can talk. I’ve never seen a battledress worn with a flowery frock before. At least mine’s legitimate.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “So’s mine. Issued to me by His Majesty’s Royal Army Medical Corps. And I’ve never seen rainbow-coloured pants before.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pants! These ain’t pants, these is trews these is!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shouldn’t you be in uniform?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is my bleedin’ uniform!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("From behind the Tommy a second appeared, dressed in the same outfit, but this one was clearly an officer of some sort, knocking the heads off thistles with his swagger stick as he approached.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sharpe! I thought I told you no more! Keep the buggers out!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sharpe, if that was his name, turned around and gave as good as he got.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t shout at me you stuck-up fucker! You’re not on the fuckin’ parade ground now. It’s just one more Kraut an’ a little one at that, no more’n a kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re up to our necks in fucking "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s. What is the point of you being on guard duty if you guard nothing?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He drew level with them now and either proximity or the recognition of Nell as being young or female caused him to lower his voice and change his expression. He was not quite smiling, but not frowning either.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The battledress threw him. Nell thought he might even be waiting for her to salute. She stared him out.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bill Dobbin,” he said at last. “Captain, 3rd Seaforth Highlanders. And my man, Beckwith Sharpe, corporal of the same. And you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Before she could answer Sharpe said, “I ain’t his bleedin’ man. Batman, birdman . . . all that malarkey . . . that all went out with the war. And the war’s over. I don’t answer to Sharpe no more. It’s Mister Sharpe to ’im and Becks to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I,” said Nell getting a word in between these bickering conquerors, “am Christina Hélène von Raeder Burkhardt.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wot a mouthful,” said Sharpe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Au contraire,” said a voice she had not heard before, “a very familiar name.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They all turned. An old man had come upon them silently, and was now leaning heavily on his walking stick, and he was smiling, really smiling as though pleased to see her. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My dear,” he took her hand and pressed his lips fleetingly to the back of her knuckles. “Graf Florizel von Tripps of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schloss Verrücktschwein")]), _vm._v(". I have known Klaus von Raeder all my life. Your grandfather perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My great-uncle, sir. My grandmother’s elder brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Has he lived through it all?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m afraid not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ach, so many dead, we must look to the living. Gentlemen, we have room for one more, another "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling ")]), _vm._v("for our ark.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So saying he offered her his arm and led her through the maze of thistle and nettle into his lost domain.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Another?” she heard Dobbin say. “Is he going to take in the whole of Germany?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Told yer,” said Sharpe. “An’ if he is there’s no point whatsoever in bleedin’ guard duty is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mustn’t mind the ‘heroes.’ They are both good men, they are merely frustrated,” von Tripps said to Nell. “They spent most of the war as prisoners. When the British freed them they were assigned to me as guards.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Guards against what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Oh, Poles mostly. Some French as well. Liberated slave labourers. In the spring the countryside was full of them. Taking what they wanted. Destroying what they wanted. Killing who they wanted. And who could blame them? Then . . . then someone in the Allied command had the bright idea of sending in British POWs to guard us. The displaced, the former slaves were rounded up or began the long walk home. You look rather like one yourself—they all wore bits of uniform, any uniform. A ragbag army, a barmy army. Perhaps that was Hitler’s ultimate achievement, to have abolished the status of “civilian” and to have put us all into uniform, any uniform . . . the pan-uniform of the Europe of 1945. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v(" “And then, after the fall of Berlin, the Prussians came west by the thousand. Dobbin would have me turn them away. That I cannot do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So saying he put his shoulder to a studded oak door and they entered the great hall of the schloss—a room designed to seat and entertain a hundred aristocratic guests and which now housed a hundred refugees—"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s, like her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("It reminded her too sharply of Belsen, a swelling sea of neglected humanity—an idea she fought at once. Many might be hungry, but none of these were starving, none of these were dying. Many waved or shouted greetings to von Tripps as they passed through, out of the far door and into the garden. More refugees, makeshift tents by the dozen, women cooking over open fires, children running naked, dogs lazing in the summer sun. What they had brought with them as they fled west amazed Nell. Fleeing for your life, you pack up a brass-ended double bed and a couple of long-armed bed-warming pans. Just a few kilometres ahead of the Russian horde, you load the portraits of your ancestors onto the cart.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For myself, and for the ‘heroes’ too, I keep half a dozen rooms. My own bedroom and the old kitchen. My bedroom would house a few dozen more I know, but there are limits to altruism.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Even as he said it she knew it wasn’t true. He didn’t mean a word of it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Were you in the last war?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was. Under von Kluck on the Western Front. I lost my leg at Soignies in August 1914. The war was scarcely three weeks old and it was over for me. There are no one-legged cavalry officers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So saying, he struck his left leg with his walking stick and Nell heard the clunk of wood on metal.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sawn off above the knee.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§83")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Von Tripps cooked for them all. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dobbin and Sharpe sat and bickered while he did so.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was her second decent meal that week. Chicken stewed with onions, tarragon, and garlic. Enough garlic to make Sharpe pull a face. He ate it all the same. Three of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s joined them—three men as old as von Tripps himself, which Nell put at sixty-something, silent beneath their Hindenburg moustaches, enduring the pidgin German of Dobbin and Sharpe, eating everything that was set in front of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As Nell cleared away, neither of the Englishmen so much as moving to help her, Sharpe set out a deck of cards on the vast, scarred kitchen table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wanna see a trick?” he said to the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Von Tripps translated.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They looked at each other. Faces breaking into grins as though nothing had amused them in recent memory.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is called ‘Find the Lady."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took only three cards from the deck—the eight of clubs, the three of diamonds and the queen of spades. Held up all three for everyone to see.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now yer see it, now yer don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell watched from the sink as his hands flew across the table, juggling the cards from left to right and back again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nun")]), _vm._v(",” said Sharpe. “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wo ist die Dame?")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("looked at one another again, a few mutterings Nell could not quite hear, then the old man in the middle put his finger down on the card on the far right with a look of utter confidence on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sharpe flipped up the three of diamonds. The other two laughed out loud at the consternation of the first, slapped him on the back, revelling in his mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wieder")]), _vm._v(",” they said to Sharpe, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wieder")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Nell sat next to von Tripps and watched the hand deceive the eye again.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling ")]), _vm._v("duly picked out the eight of clubs, and the laughter spread around the table. One voice startled her—amid the English, horsey snorts of Dobbin, the restrained chuckle of von Tripps, and the uproarious satisfaction of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s, one voice stood out, high and clear and unknown to her. It was her own. And she realised she had not laughed . . . had not laughed since some time in the autumn of 1944.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This cheeky, pushy, careless young corporal of the Seaforth Highlanders had made her laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He winked at her. One brown eye closing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two more rounds and no one found the lady.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Genug")]), _vm._v(". I am for my bed,” von Tripps said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Me too,” said Dobbin. And to Nell, “If you find yourself alone with Becks, young lady, don’t play for money. He’s a wide boy. Another bloody cockney wide boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Flüchtling")]), _vm._v("s gone too, she did indeed find herself alone with Beckwith Sharpe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What is a wide boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suppose Bill means that he thinks of me as someone not quite honest, not quite straightforward . . . a bit short of calling me a cheat or a crook. I don’t mind. We’re mates. At least mates while we’re here. Once we get back to Blighty . . . well . . . normal service will be resumed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You may not see one another?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We sure as hell won’t see one another. ’Cept maybe at a regimental reunion, but I don’t plan on attending many of those.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you cheat? Do you steal?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I cut corners. Corners I have to cut to get by. That’s all. It’s what I have to do to survive.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you always know the price of coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("This seemed to baffle Sharpe for a moment, then he grinned and said, “That’s the yardstick is it? That’s how you get the measure of a wide boy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s one way, so I’m told. And the three-card trick?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Harmless. Just a bit o’fun. Harmless. ’Ere. I’ll show you how it’s done.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Afterwards, ever afterwards, Nell would wonder at the charm, the spell this cockney “wide boy” had cast over her. Sharpe’s tricks were inconsequential and silly. They made her laugh. So little in her life had ever been allowed to be silly. Almost nothing had been inconsequential. She moved in a world of consequences, of action and reaction. Of responsibility. Quite possibly of guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Something as simple as making her laugh would always seem less than the whole, less than the truth. And at the time, she could not possibly have envisioned where this would lead.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§84")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("She stayed three days, longer by far than she had meant to. Sharpe taught her every variation on his card game—including playing it with shells or coffee cups—and how to shuffle a deck to deliver almost any hand you wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The ripple as he split the deck and integrated it card by card at the speed of light never ceased to make her laugh. Then he would deal her a perfect straight flush or a full house. It was a game, it was all a game. Every night a game. It was, as Sharpe kept saying, “harmless.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the days she walked the garden, picking her way through half the furniture of East Prussia, seeking out anyone from Berlin and finding no one. She craved news, she longed to know that 21 Pfefferstraße still stood, that her parents were alive and well.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And on the fourth day she told Graf von Tripps that it was time to go.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Von Tripps made her put down the knapsack and sit with him awhile, out between the greenhouse and the potting shed, between the Pomeranians and the Silesians.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can I not persuade you otherwise?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why would you wish to?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look around you. Everyone you see has fled from east of Berlin. Berlin is in Russian hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The British tell me they have a sector, a part of Berlin that they control. My home was in Charlottenburg. Charlottenburg is part of that sector, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They do, and so do the French and the Americans. But for how long?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s what I have to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell, who are you trying to save?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t understand. Why would I be trying to save anyone?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You tell me, but in all your conversation I have sensed a desire to . . . to put things back together again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was almost the same phrase she had used to Dekker all those weeks ago—“put them back together again.” Of course she was. It was just that the words would never pass her lips for fear of hubris.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You could go to England with Dobbin and Sharpe. They’ll be repatriated soon. They’d find a way. If it was left to Sharpe he’d pack you in his kit bag. England, Nell. England. You’d be safe for ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sure I would, but I’d never dare look in the mirror again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Von Tripps prised himself up off an outsized, inverted flowerpot and opened the shed door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For you,” he said. “It may cut a day or two off your journey.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And he presented her with a green Raleigh bicycle, complete with brass plate declaring “Made in England,” its tyres pumped and plump, its chain and Sturmey-Archer three-speed gears oiled and glistening.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It is—was—my son’s. Nothing has been heard of him since Stalingrad. And what use does a one-legged man have for a bicycle?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the panniers were two bottles of schnapps.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“You will have to be very careful crossing the green border. The Russians are thieves and rapists, but if we appeal directly to the former you may never meet the latter. If they stop you, make sure they find the schnapps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And while they drink it I make my escape?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§85")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On a dusty, deserted road somewhere between Tülau and Kunrau, just beyond a village named she-knew-not-what, where east and west now met, stood a lone Russian soldier by his lone wooden hut. Of His Majesty’s Forces there was ne’er a sign.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A skewed placard read, “You are now leaving the British Zone” in four languages, each looking as though scrawled in haste, and just below that, most certainly scrawled in haste, in English and in red chalk, “Watch yer arse!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And just beyond that another placard read “You are now entering the Soviet Zone” in four languages, looking handcrafted by a skilled signwriter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But the red-and-white-striped pole was cocked skyward and the lone guardian of the East looked tired and bored.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Велосипед")]), _vm._v(",” he said simply, his hands gripping the bars as though he might shake her loose.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Schnapps,” Nell said, even more simply.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He sank half the first bottle in what seemed to Nell to be a single gulp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a pause, a prolonged stillness of several minutes as he drank, belched, blinked, and eventually sat down sharply on his backside. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Some sense of duty returning to his rapidly clouding brain, he said, “"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Удостоверение личности")]), _vm._v(". "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Papiere")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took another swig from the bottle, belched again. Swigged once more and the bottle was empty. She marvelled at the man’s constitution. All the same, she handed him the second.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Спасибо")]), _vm._v(",” he said, with unexpectedly good manners. Then he fumbled for what he should be saying, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Pap")]), _vm._v(" . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Pap")]), _vm._v(" . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Papiere")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell reached down and picked up his rifle from where it had fallen as he had grabbed the schnapps and with both hands on the barrel spun herself around like a discus thrower and flung it as far as she could into the next field. Then she got back on her bike and rode away.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next challenge, she knew, would be crossing the Elbe. One lone idiot on a dusty road might be replaced by an entire squad at any of the Elbe bridges. So she pedalled south and east. Rather than take the bridge at Tangermünde—was it even still there? Either side could have seen fit to blow it up—she would gamble on the ferry at Rogätz—gamble that it was still working, gamble that the Russians thought it less significant than any bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Whole families seemed to be making the river crossing in both directions. The battledress hidden at the bottom of her knapsack, Nell tagged along with a family boarding the ferry—mother, father and three daughters, one of whom was also pushing a bicycle. Nell struck up a conversation with the girl, walked on with her side by side and the Russians scarcely looked at them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That evening, a warm, light August evening, she entered the American Sector of Berlin from the Potsdam side, passing both Russians and Americans, none of whom seemed to care that she did so.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§86")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Berlin")]), _vm._v(": August 1945")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Berlin had been bad when she left. Now it was worse. What had been damaged was ruined. What had been ruined was obliterated. Buildings stood eyeless and hollow, ribs without flesh—skeletal, slender fingers of brick pointing meaninglessly to a heaven that had forsaken them. They looked less like buildings than trees, winter trees. And the trees themselves were leafless and blasted—late August and not a green leaf to be seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And everywhere people. Berliners drifting as though blown by a wind none but they could feel. And the Allies, static, rooted to the street corners gazing around, hands in pockets, detached from the living scene, watching it all as though it were no more than sideshow entertainment . . . the hurdy-gurdy man at the corner of her childhood. The beggar at her childhood’s end.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Crossing Adolf-Hitler-Platz a Russian grabbed her bike by the handlebars, just as the border guard had done. He had a better vocabulary.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("To “"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Велосипед")]), _vm._v("” he added “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fahrrad")]), _vm._v("” and “Byike.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wasn’t alone. Only a few feet away his pals were standing around smoking. And in the other direction half a dozen Americans, smoking and flirting with every girl that passed. As the Russian tugged at her bike she could hear the constant refrain of “Frat? Frat? Fraulein?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She let go of the bike, gave the Russian a momentary taste of victory then clouted him round the ear with the flat of her hand as hard as she could. He let go, clapped a hand to his stinging ear and Nell clouted him on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Waaaaaghhhh!!!!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Every head turned. Nell took her bike by the handlebars and dared him to try again—not wholly sure now if she was fighting for her bike or her life.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Then it started, a deep rumble from the Russians that the Americans picked up. They were laughing, they were all laughing. Not at her . . . at him. She had thought “thigh-slapping” no more than a metaphor, but that is what Russians did, they all but doubled up and slapped their thighs. And she knew she’d got away with it when the man himself began to laugh.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She wheeled her bike forward, nodded politely at the Russian as he stepped aside and said, “"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Спасибо. Добро пожаловать в Берлин")]), _vm._v(".” Thank you. Welcome to Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of the Americans chased after her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fraulein, fraulein. Spreckenzy English?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She wheeled on, with him close behind her and did not turn around until she felt clear of the Russians. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Of course. What is it you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Er . . . I guess . . . y’know . . . Frat? I never seen anyone tackle a Russki like that. Lady, you got . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stopped short of an obscenity. But Nell no more wanted anything to do with him than with the Russian.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Buy you drink, hon? Buy you a meal? I got zigs, I got shockylade. Maybe a little jig-jig, y’know fick-fick?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How kind. But you must excuse me. I have to find my home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Along the Kaiserdamm every naked tree seemed to draw a crowd. As one thinned she could see the reason. Notes on card and paper, notes by the dozen, notes by the hundred pinned to the trunk. Men seeking wives, women seeking husbands. Pleas for the missing. Lost children, lost parents. Lost lives. Berlin was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Else, where are you? I am back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Matthias Bergman is alive and well and living at 71 Köpenicker Straße.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And one writ large that seemed almost aimed at her . . .")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("“Nell. I’m alive! Where are you? Joe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Common as the name was, she’d never known anyone called Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§87")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("She found 21 Pfefferstraße. What was left of it. Nos. 21, 23, and 25 had collapsed into their own cellars. One wall of 27 stood. Most of 19 was intact, but had neither doors nor windows. Halfway up its wall she could make out the floral wallpaper of what had been her bedroom. The fireplace was intact, jutting out into space, defying gravity, and on the mantelpiece a rag doll she had won playing hoop-la at the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Weihnachtsmarkt")]), _vm._v(" Christmas fair held in the Lustgarten in 1937. Berlin had blown away, swept up on a hurricane of high explosives—and her rag doll, light as a feather, still sat upon the mantelpiece.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A fence post had been stuck in the rubble of No. 21. Another note for Berlin lost nailed to it.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Marie Burkhardt now resides at No. 92.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So, her mother was alive. Other people “lived.” Her mother “resided.” She didn’t doubt that Marie had written it herself.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_c('span', [_vm._v("No. 92 had fared only slightly better than No. 21. The top two storeys had vanished. They had not collapsed into the cellar, the cellar was occupied. A stout if improvised door half a dozen steps down from the street, a stovepipe sticking out of a peephole window at ground level. On top of the broken wall, just beyond the reach of a human hand, three galvanised buckets of earth, sprouting with parsley, thyme, and a solitary, dusty tomato plant.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Tacked to the door was a card.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01 para-style-override-1"
  }, [_vm._v("Prof. Burkhardt—Teacher of Music")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-1"
  }, [_vm._v("Städtisches Konservatorium, Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-1"
  }, [_vm._v("Königlichen Konservatorium, Dresden")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And below that.")]), _vm._v(" "), _c('p', {
    staticClass: "letter para-style-override-1"
  }, [_vm._v("Piano wanted. Cash paid.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So the piano had died in the war. Her mother’s precious Broadwood.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The door was padlocked. Nell sat on the steps and waited. Dusk could only be half an hour away. Was her mother out teaching some child the piano? Could anything so normal be taking place in this desert of rubble?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Very few people passed. Those that did looked at her without concern, more interested in the bicycle than the girl. Ten minutes passed, and an old woman was coming towards her pushing a pram, her head wrapped in a scarf, her body swathed in layers of ragged skirts, her hands in thick leather gloves. A coating of ashen dust from head to foot. She got within ten feet of Nell before Nell recognised her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Could this old woman, this tramp, possibly be her mother?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie Burkhardt pulled off her headscarf in a shower of grit. Her face was brown and dry, her eyes dull, and her lips cracked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh God, Nell. Why have you come back?” ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§88")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Marie yanked on a string and the light flickered on. A single, unshaded overhead bulb. Nell had been expecting squalor. A hovel. It wasn’t. Her mother had turned some neighbour’s cellar into a home. Nell found herself trying to remember which neighbour—Herr Obermann who’d vanished into "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nacht und Nebel")]), _vm._v(" in 1942? Herr Schumann who’d been killed in an air raid in ’43? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She recognised none of the furniture. At least none of it as being the furniture she had grown up with. She recognised all of it obliquely. The sofa looked like the one Frau Wagner had had at No. 35. The spiky plant in the brass pot looked like Frau Graz’s and the table it stood on had surely been made by Herr Kaufmann for his wife’s birthday in 1939. Then she realised. All lives had been rearranged. The pieces were the same, they just weren’t in the same place on the board. And the lives that owned those pieces had been contained, discrete—now blown open, and blown apart. What lives had been spared salvaged what had been spared. One day perhaps, some enterprising child might procure a long stick and knock her rag doll off the mantelpiece and claim it as her own—and someone seeing this might wonder whatever happened to Frau Burkhardt’s little girl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But her eyes drew her inevitably from the trivia of memory to the one fact that mattered. It was a woman’s home—no trace of a man anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie was sitting on the edge of the sofa, head down.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When she looked up she answered the unasked question.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your father is dead. In all probability dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A Russian bullet most likely.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Somewhere near the Reich Chancellery. The last report I ever had of him was somewhere on Wilhlemstraße on May Day. The Volkssturm fighting off Russian tanks with cutlery and broomhandles. All in the name of a Führer who was already dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Nell, there is no body. No one saw him die. But who could live through that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s like this. I do what I have to do to get by. I stole the pram. The first thing I have ever stolen in my life, but not the last. The potatoes the British tip in the street in a free-for-all. I find a woman can punch as hard as a man. I give more black eyes than I get . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I get by.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("we")]), _vm._v(" shall get by.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh God—the inexorable logic of being Nell Burkhardt.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And her head dropped again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell knelt, wrapped her arms around her mother. Marie stayed rigid, flexed herself against the alienness of embrace, and as Nell squeezed the harder softened and relented, her arms around her daughter’s shoulders, her tears running down her cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When you were little,” she said between sobs. “When you were no more than nine or ten, and you were beginning to understand what was happening to Germany, to us all, to us as a family, there were no tears, no self-pity, just your resolve. You said ‘Mama, we will survive and we’ll be safe, we’ll be safe for ever.’ Is this surviving? Is this safety? Is this for ever?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And nothing would staunch her tears.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§89")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Two rooms in a cellar amounted to luxury. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie made up a bed for Nell on the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the morning she dressed in her protective layers again, wrapped the headscarf around her hair, put on her rawhide gloves.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrau")]), _vm._v(". I clear rubble. It gets me the highest ration the British will allow. The lowest ration Berliners call the death card. It is hard work, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can do it too?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You won’t have any choice. It’s compulsory. But, I can get you on a gang with me. You’ll need papers, you’ll need to register with the British for your ration card. See your Uncle Erno. He hasn’t moved. He’s survived everything. He’ll help you. I have no time now. I have cleared Kantstraße and Leibnizstraße . . . and Berlin runs out of philosophers . . . so I’m on Bismarckstraße. But I must go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After a cup of ersatz coffee—“always know the price of coffee” echoing in her mind—and a cold wash standing with her feet in a bowl—Nell set off in search of Uncle Erno. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As she crossed sectors at Lietzenburger Straße she could almost swear the sound of the wolf whistles changed. On the north side of the street it seemed to her that the Tommies whistled at least a semitone lower than the Amis on the south side.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno was not a blood relative. He was an old friend of her father’s. Nor was Erno Schreiber his real name. Long, long ago he had hidden his real identity, his Jewish name and ancestry and become a “ghost.” The Nazis had never found him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He lived on Grünetümmlerstraße in Wilmersdorf in the American Sector, surrounded by books, newspapers, and the tools of his trade—forger. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had no idea how old Erno was. He had always looked sixty, but it was likely that he was not much older than her father—who was a child of the nineties and dead at fifty-one. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On an August morning, the heat of the day already rising, Erno had the windows closed and a small fire going in the iron stove—always something to be burnt, always something incriminating to be disposed of. Always a light on, in a room that was pools of light and pits of darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He showed no surprise as he opened the door to her. Kissed her on the forehead, said, “I’d have known if you were dead. I should have felt it in my bones. I live, you live . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A ginger tomcat wove its way between her legs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And no one ate Hegel,” Erno added.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Over more acorn coffee Nell recounted the last nine months to Erno, and at the end reiterated, “I lied to the British about my age. It is a lie I wish to hold on to. It is a time to be a grown-up. Sixteen doesn’t seem grown-up. Eighteen does. Besides, I’m tall for my age.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite. But only a sixteen-year-old would say that. So . . . you want an identity card dating you to . . . when exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“January 14, 1927.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Consider it done.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mama says you will tell me how to register with the British for my ration card?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why bother. I can give you that as well. Will you be a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrau")]), _vm._v(" too? Then a grade two card.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who gets grade one?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you believe the Russians reserved that for artists? They cannot feed us, they cannot house us, they cannot flush away our ordure . . . but they’ve already put on their first opera.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§90")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("There was one trace of “man” in the cellar. Ferreting around she found her father’s best suit, not the one he had worn to the office—she assumed he had gone into battle wearing that, that he had died wearing it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On her first day as a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrau, ")]), _vm._v("Nell rolled up the trouser legs and drew the belt tight into her waist. The symbolism was not lost on her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Deutschland, Deutschland—who wears the trousers now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The British had laid track down the centre of Bismarckstraße, a miniature railway, tilting steel wagons that could be loaded from either side and then pushed along the East–West Axis all the way into the Tiergarten, where Berlin was being tipped.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("A morning of loading these and Nell was exhausted. Marie switched her to cleaning bricks, a job that could be done sitting down at the rate of twelve reichsmarks per thousand. Nell lost count within half an hour.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Arriving home, she craved sleep, which she would most certainly get, and hot water, which she most certainly wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The electricity was off. A candlelit meal of boiled potatoes and ­cabbage—seasoned with fresh parsley—and tinned beef stew. Nell eating slowly, but not as slowly as her mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mama—the beef. About the beef. Do you buy on the black market?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I told you. I do what I have to do to get by.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When I found the suit . . . well, there were six tins of beef.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie finished her meal in silence. Then . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you remember how Goebbels would warn us all about the Russians, the Slav beast, the Mongol horde . . . all that nonsense?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On the radio? Yes. Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It wasn’t nonsense. It was more of a self-fulfilling prophecy. The Russians took Berlin almost four months ago, the British did not arrive until six weeks ago. In between the Russians did as they wished. ‘"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Uhri, Uhri, Uhri")]), _vm._v(".’”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? I don’t understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It was the first word any of them uttered. Quite possibly one word in a vocabulary of only three. They were obsessed with watches. I know no one who now owns a wristwatch. I saw one Ivan roll up his sleeves and show off a dozen or more on each arm to his comrades.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell could see what was coming.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the other two words?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They were "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Frau")]), _vm._v(" and "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("komm")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I did what I had to do to get by.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Were . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie shook her head as though dislodging an insect, held her head up, lowered it to meet her daughter eye to eye.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One way, possibly the only way, to avoid being taken by force is to give yourself voluntarily. Yuri is my protector, Yuri is my carer, Yuri is my breadwinner, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Yuri ist . . . mein Mann.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri? Who’s Yuri?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§91")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The indeterminacy of his uniform was at odds with the brightness in his eyes. His eyes were deep sea blue. Was he green or was he brown? Nell decided he was green. A little green goblin of a man, with eyes that shone and laughter lines that could turn his face into a walnut, somewhere between a giggle and a guffaw.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was Friday night. They had a weekend to themselves. He sat on the sofa next to Marie, took her hand in both of his. The gentleness of the gesture was striking. It occurred to Nell that her mother had taken up with this man within days of her father’s death, but the obvious affection he had for her pushed the thought further back in her mind where it might linger without too much troubling her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His German was good. Her Russian was better.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He told her he was a major in the NKVD and came from a small village just outside Gorky, the city on the Volga some three hundred kilometres east of Moscow—hometown of the author in whose honour the USSR had renamed the city from its original Nizhny Novgorod. And no, he’d never met Maxim Gorky. He rather thought he might have died.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I love your mother. For my work I am often away, often in Moscow. But no Soviet soldier will touch her. No Soviet soldier will harm her or you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("From somewhere Yuri produced half a kilo of fresh loin of pork. It occurred to Nell to wonder what Prussian peasant might have been robbed of his pig to furnish this meal, but quite obviously it did not occur to her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Over dinner Yuri told her of his childhood in Gorky, how his father had died when he was ten, how they had given up the farm and moved to the city, how he had been twelve at the time of the revolution and already a party member. How at nineteen, shortly after the death of Lenin, he had been summoned to Moscow, taught English and German and told to get ready for the next German war.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Limited as the conversation was, there was also an apparent rough charm to the man. With the meal over, Yuri and her mother retired to the bedroom, and Nell made up her bed on the sofa and decided not to think about her father. Instead she dreamt of the old woman she had met on the road—Mutti at her sewing machine, turning Nazi flags into pantaloons. Doing what she had to do to get by.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Mutti drew the twin threads from under the silver foot of the machine, snipped them with her scissors, threw the pants into a wicker basket on top of a dozen others, and then held out her hand to Nell.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Gib mir Tabak")]), _vm._v(",” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§92")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The war was over. Everybody told her so. And still people died in their tens of thousands. Cholera, typhus, vengeance . . . starvation.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The winter of 1945–1946 in Berlin became known as Starvation Winter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Nell and Marie had cleared Bismarckstraße, had gone on to clear Kaiser-Friedrich-Straße and by December were on Brandenburgische Straße. Berlin would never run out of streets with high-sounding names, nor would it ever run out of rubble. Nell had heard one of the British officers say that it would take twelve or fifteen years to clear the streets and another twenty to rebuild. She had heard others say that Berlin would not be rebuilt, that Germany would be returned to a peasant economy without cities or industry. It did not strain the metaphor too much, brick after brick after brick, to say that Berlin had returned to the Stone Age.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was neither stone nor starvation that killed Marie Burkhardt. It was wood.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They would pile up timber found among the brick and concrete to take home and feed into the stove at the end of the day. It was dark before five, and the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrauen")]), _vm._v(" stopped work when the light went. Gathering up her pile in semidarkness a splinter pierced the grey muscle at the base of Marie’s right thumb, between the glove and the wrist. It went deep, the tip emerging on the palm of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Being unable to pull it out, she snapped off all but half an inch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll be fine,” she said to Nell. “I’ve had worse than this. We’ll get home, find the tweezers and you can pull it out. Remember how you used to cry when I pulled thorns from your hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell could not get it all out. The splinter had fragmented inside the wound. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the morning Marie felt unwell, but insisted she would go to work.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By five in the evening she was weak and delirious. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell got her home, put her to bed, and ran to Erno’s.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He came back with every medicine he had and a thermometer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thirty nine point nine. My dear, your mother is seriously ill. This is beyond aspirin. We need a doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are there any left?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Köhler, in Pestalozzistraße. I’ll get him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dr. Köhler seemed to Nell to have survived by being too old to have attracted any attention from either side. She thought he must be over eighty.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marie felt nothing as he opened the wound, removed the fragments, and cleaned out the pus. Her brow ran with sweat, and her head rolled from side to side, and she felt nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Köhler and Erno went into a huddle of whispers, which Nell would not allow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not a child. You must tell me whatever it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Köhler took off his spectacles, made a show of wiping the lenses.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Without treatment, your mother will die.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What treatment?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There are new drugs. The British have them, the Amis too. Antibiotics. Fungal cultures that kill bacteria. Your mother has a bacterial infection. It must be stopped before it reaches her heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All that . . . from a splinter?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. The body does not discriminate between a splinter and a bullet, although a bullet might have been cleaner. I don’t have such drugs, no German doctor has. They keep them for themselves. There’s no point in even asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her mother groaned loudly. Nell looked at her and had one thought. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do the Russians have these drugs too?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know,” Köhler replied. “I really don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And if they did? Nell had not seen Yuri for at least three days, and had no idea where to find him. She stayed home. Erno went in search o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Yuri and could not find him. He asked every black market "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(" he knew, German, American, British, for the “miracle-drug penicillin” and found no sellers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Thirty-six hours later, around six in the morning, Nell was woken from her sleep on the rug beside the bed by the sound of her mother’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Max.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell lit the candle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Her mother was sitting on the edge of the bed, bolt upright, eyes wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Max,” she said again, stretched out her arm to Nell and died.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§93")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("They buried her at the Luisenkirchhof, on the far side of Sophie-­Charlotten-Straße—yet another street that Marie had cleared of rubble. Rubble would be her only memorial.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell thought she had prepared for this. Death had never lost its mystery or its sting, but it had lost its novelty the first day she set foot in Belsen. And from that day until the day she had seen her mother wheeling her pram down Pfefferstraße she had been aware that she might never see either of her parents again. She had crossed Lower Saxony on foot and by bike, with no expectations beyond the unquenchable simplicity of hope.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hope, she found, had died with her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She lay on the sofa, inert. Nothing moved but the blinking of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When at last he spoke she realised she had no idea how long she had lain like this or how long Erno had been in the room. Had he stepped into her dream or she into his?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell. Let us go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t stay in this cellar. The room above me is now empty. One room, but a big room, on the top floor where there is light and air. Don’t stay in this cellar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Inertia ruled. She let Erno do as he wished. Let him grant her light and air. Far from the back of her mind she knew why he was moving her. If she stayed in the room where her mother had died then death would be forever clutching at her skirt. And hope would really die.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§94")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was two weeks later, a week before Christmas, Nell installed on the top floor at Grünetümmlerstraße but scarcely settled, when Yuri reappeared in all his greenness. The goblin at her threshold. His blue eyes clear and sad.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He handed her the gift he had always brought her mother. A "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v("—a food parcel.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She wondered if men had no visible emotions. She could not remember that she had ever seen one cry before Belsen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri wasn’t crying. He stood, it seemed to her, respectfully—holding his hat in both hands.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Erno has told me all,” he said. “"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Прошу прощения")]), _vm._v(". I am sorry. I was in Moscow.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell set the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v(" down on the table, held her hands clasped in front of her. They were mirrors now. Two respectful strangers with no clear idea of where the boundary lay.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I will not leave you. I will not see you go hungry. I will not leave you. I will bring you "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v("s.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was more than a statement—it was his manifesto. The terms of the relationship. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are kind, Yuri. But I am not my mother. I will not sleep with you for this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I will not ask you to.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below para-style-override-17"
  }, [_vm._v("§95")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT para-style-override-18"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Berlin")]), _vm._v(": 1947")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was love at first sight. He and Berlin were made for each other. He took to it like a rat to a sewer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the new year of 1947 Burne-Jones met him for breakfast in the Atlantic. Between the crisp bacon and the reconstituted scrambled egg Burne-Jones slid a military buff envelope and another strip of wool across the table to him—corporal’s stripes—the mark of Beelzebub.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ve earned them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought he’d earned a damn sight more than that.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He tore open the envelope. A travel warrant to Berlin. The Silk Stocking Express.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s the job?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“More fuckin’ fragebogeys?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Inevitably so, but nothing like the pile you’ve just gone through. And this time you’ll be number one. But you’ll be doing a lot more interpreting . . . and some driving.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I still haven’t passed a test.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . you managed not to prang my MG in Cambridge, didn’t you? Mind you, a lot more gears on a Land Rover.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was goading. They hadn’t mentioned the MG in ages.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness decided not to take the bait and said simply, “But that’s not all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, it’s not. I’ll be requiring your special talents from time to time. Not that you can or should regard everything else as a cover . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’S’OK. I get the picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§96")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The Silk Stocking Express was crowded that Saturday afternoon. He almost wished he’d put on his Welsh Guards outfit and been able to demand a seat, but it was too precious, too useful to risk getting busted over a railway journey and a warrant and a uniform that did not match, so he sat on his kit bag in the corridor with a thousand other erks. If the train was heated he couldn’t tell. He’d hung on to the flying jacket Johnnie Blackwall had given him on the flight out to Hamburg, slipped his arms inside it and shoved his hands into his armpits. With depressing regularity someone would fart or belch, the corridor would stink, and Wilderness began to wonder if he was the only person whose guts were in tune—but then, lavatories being frozen as well as everything else, once in a while a window would go down, the cold, clean air would knife in and a bag of shit got thrown out, proving that he wasn’t. “First we bomb your cities flat, then we shower you in shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A stout, misleadingly miserable-looking lance bombardier of the Royal Artillery met him at the Charlottenburg station.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Welcome to Bizonia,” said Eddie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Marx Brothers, right? Groucho singing ‘Hail Bizonia."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That was Freedonia, Joe. This is Bizonia, as of last week. A fairy-tale kingdom. Look out for dwarves, unicorns, and a thousand tons of ’ooky fags. I’m your driver. Been sent to take you wherever you want to go, seeing as you are now a high and mighty corporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What a turn up for the book. How long have you been in Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Since last August.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That was galling. Wilderness knew he’d drawn the short straw with Hamburg—but somehow Eddie got posted to Berlin. A city where you could smell money on the breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was not a breeze. This was a wind that cut to the bone. Suddenly the train seemed like warmth. It was far below freezing, all extremities tingled with cold and his breath hung in the air in billowing nimbus clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I got the canvas up, but the car’s still like an iceberg on wheels. The sooner we get to our digs the better.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Our digs?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, we’re sharing till the next lucky sod gets posted home. We could walk from here, it’s that close, but we’d be like abominable wotsits by the time we got there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Eddie drove them along Kantstraße and into Fasanenstraße at the north end, under the railway bridge to a battered five-storey apartment block.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had no reaction to the state of the city, except “you’ve seen one ruin, you’ve seen ’em all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As they passed another gang of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrauen")]), _vm._v(" Wilderness said, "), _c('span', [_vm._v("“")]), _vm._v("‘If seven maids with seven mops swept it for half a year, do you suppose,’ the Walrus said, ‘that they could get it clear?"), _c('span', [_vm._v("’")]), _vm._v("” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Eddie said, “My old dad used to read that to me at bedtime. And I think the answer’s no. Come back in ten or twenty years’ time, there’ll still be gangs of women sweeping away bits of Berlin. I don’t think there’s a hole big enough to tip it all into. There are three words that sum up life in Berlin, and for all I know in the whole of soddin’ Germany—")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmer")]), _c('span', [_vm._v(", ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("kaputt")]), _c('span', [_vm._v(", and ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Ersatz")]), _c('span', [_vm._v(". Everything is either rubbish, broken, or fake.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The room they shared was on the top floor. As Wilderness gazed around, Eddie went on, “D’you know, they drink tea made from apple peel and coffee made from acorns. They call the coffee "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Muckefuck")]), _vm._v(". It’s the only German word I know of that needs no translation.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Muckefuck")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And that also describes the taste pretty well. Fortunately . . .” ­Eddie picked a plain brown paper packet off the dresser. “Fortunately we have . . . best NAAFI dark roast, none of your instant and none of your acorns. I’ll put the kettle on.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He disappeared behind the wooden partition that separated the two beds. Wilderness looked at the room. It was a jolt down from the Atlantic Hotel, but it was warm—a sputtering gas fire set into the chimney breast—and clean—anywhere Eddie lived would be, he lived by order, everything in its place—and light—tall, slender windows that stretched almost floor to ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness dropped his kit bag on the bed, sloughed off the sheepskin and his blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was staring at the shoulder holster.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wossup?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never seen one before. Standard issue, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I got it from the armourer, so I suppose so. In Hamburg everyone carried a gun outside the base.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not here they don’t. It’s compulsory in theory, but the MPs don’t give a toss about interpreters and medics. Just the combat blokes. I haven’t carried a gun since November. Just as well. Too many opportunities to start World War Three.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good. I was never crazy about having it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pulled at the top drawer in the tallboy. It was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This one mine?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wrapped the straps around the holster and dumped the gun in the drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Makes you wonder what Burne-Jones has in mind for you doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had and it did, but Wilderness was never going to say that.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suppose you’re hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. There was nothing on the train, and if there had been—no way of getting to it short of throwing blokes off the train.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pilchards on toast?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t want to pinch your ration, Ed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ration. Bollocks. I don’t do rationing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He disappeared behind the partition once more and returned with a pot of aromatic black coffee and a sixteen ounce can of pilchards.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Toast is doing. Won’t be a mo’.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As Eddie sliced the lid off the pilchards, Wilderness said, “You got a source then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have I got a source?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he let the short sentence rest as an enigma. Loaded pilchards onto toast, swilled coffee and looked like what he was inside—happy. The miserable exterior, Wilderness had long since concluded, was simply a way of repelling boarders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Food was good, but Wilderness would never be able to find in it the consummate pleasure that Eddie did. He ate quickly, Eddie savoured.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Coffee’s good,” he said, hoping to break Eddie’s mealtime self-absorption. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Used to sell for a bob or two back in Hamburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Does here too. Get your hands on a few packets and you’ll make . . . a packet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So, there’s fiddles, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“O’course. Didn’t you have fiddles in Hamburg?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing I could get at. All based out at the airfield, and I was in the city. Just like I am now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was shaking his head. Wilderness could almost swear he was grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, no, noooo. Sources? Do I have sources? Fiddles? Do I have fiddles. Just sit tight for a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Again he ducked behind the partition, only to reappear wearing his army greatcoat and humming a daft tune.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da da daaa dah. Da da daaa dah.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And as much as a little fat bloke could this little fat bloke was dancing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The greatcoat opened and closed on the beat, and Wilderness realised he was doing the Royal Artillery’s version of a fan dance—Eddie’s own "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Folies Bergère")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the inside of his coat, from buttons to armpit, was a network of string and safety pins from which hung all manner of goodies.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie pulled off a pair of frilly knickers, tossed them over Wilderness’s head and onto the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da da daaa dah.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A matching bra.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da da daaa dah.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A small bottle of Chanel perfume.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da da daaa dah.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A bar of pink Cadum soap.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bump, da bump, da bump”—as he turned, stuck his arse out and lobbed half a pound of coffee beans onto the bed without even looking at his aim.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The music stopped, the grin was teetering on girlish giggles.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do I have fiddles? Do I have fiddles? My greatcoat is a box of earthly delights, Berlin is our paradise regained, the NAAFI our cornucopia. Joe, we’re going to make a bob or two together.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Joe grinned back at him, and did not say what he was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A bob or two might be only the beginning. He and Berlin were made for each other.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§97")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Eddie took him to the Marrokkaner Club—a tiny entrance in a side-street cut between Savignyplatz and Uhlandstraße, that opened up into a vast, low-ceilinged cellar, too low ever to disperse the fug of tobacco and the lager-miasma that hung suspended above the tables.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tomorrow we’ll go down the Tiergarten. The "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schwarzmarkt")]), _vm._v(", they call it now. Even the tram conductors call it that. They just yell ‘"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schwarzmarkt")]), _vm._v("."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“An open secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“It’s like Berlin, a secret without a roof and mostly without walls. All out in the open. In all weathers. You could sell gumboots in June, deckchairs in December if someone else thought they could sell ’em on at a profit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But tonight, Eddie introduced him to his “partners.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face—so called because he had a big round moonface and a flat nose, as though he’d gone a few rounds with Freddie Mills. Pie Face was from southwest Essex, Hornchurch. Once Wilderness had ridden to Hornchurch, at the furthest reach of the District Line on London’s Underground and thought it the edge of the world. It was a county corner that was all but indistinguishable from urban East London, and Pie Face had much the same accent as Wilderness. A corporal, and Royal Army Service Corps clerk, he was attached to the NAAFI/EFI stores on Adolf-Hitler-Platz.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud—so called because he looked like a King Edward, his face pock-marked with “eyes”—was from the top end of Essex, a farm boy from the Stour Valley, with a lyrical East Anglian accent—a lance corporal, with the 62nd Transport and Movement Squadron, he worked in the Army’s “garage” and kept countless jeeps running.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Eddie did not need to explain, but did. They were the perfect partners. Pie Face had access to all the stuff in the NAAFI—every fiddle and theft began with him, and Spud had the means to get them around Berlin.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was wondering what Eddie’s role might be in this wide-boys’ fraternity, and as if mind-reading Eddie said, “And I’m the brains of the outfit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness smiled even as his heart sank. He liked Eddie, and it was no exaggeration to say that he was probably the best friend he’d ever had. He was a gentle man, bright as a button . . . but a criminal mastermind he wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I do a lot of driving,” Eddie said, with a fingertip tap to the side of his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought you were on Fragebogeys like me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Burne-Jones said I was crap at it. Took me off it. So I drive brass around in me jeep, translate for them and report back to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean you’re a spy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie began to grin, the grin became a giggle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s all bollocks isn’t it? I never hear a damn thing worth remembering let alone reporting. I drop posh blokes off at meetings, pick ’em up again an hour two later, and in the meantime . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You do yer fan dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Absolutely. Go out with a full greatcoat, come back with an empty one and pocket full of kraut money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We all do,” Spud chipped in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Always room for one more,” said Pie Face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Eddie was smiling. And Wilderness realised he had just joined a club he hadn’t even applied to.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§98")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Sunday morning in the Tiergarten rewrote Wilderness’s idea of Germany. The Tiergarten in winter was bleak. On a day when an English family would be at home listening to a variety show on the radio or sleeping off Sunday lunch, Berliners were out en masse. It was insect-like, a swarm from the hive. The sky was grey, the buildings were grey, the world was grey. The people were . . . yellow . . . a poxy, wasted, vitamin-deficient yellow.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He and Eddie stood not fifty yards from the hollow shell of the Reichstag—in a sense they were at the heart of Germany, at the urban pulse of Berlin, stamping their feet against the cold where a million jackboots had goose-stepped . . . a patch of bare frozen ground that Berliners had now turned into an allotment to raise vegetables. Someone had planted gooseberry bushes. Goosestep to gooseberry in only twelve years. An imperial city to . . . a madman’s folly. Wilderness wondered if Berlin would leave the Reichstag as it was—a permanent memorial to that folly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The scale of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schwarzmarkt")]), _vm._v(" was almost unbelievable, the number of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schiebe")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("r")]), _vm._v("s"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("uncountable"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")]), _vm._v(" Everyone sold, everyone bought or bartered, hence everyone was a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The thing that most struck Wilderness was the number of prams and pushchairs. He reckoned about one in a hundred actually carried an infant—the rest were full of contraband. The odd copper moved among the crowd, but the sudden cessation of trade seemed to him be an act of caution and respect rather than convincing concealment—“let’s not flaunt it, let’s not fling it in his face.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Of course most of it’s barter. Kettle, toaster, portrait of Frederick the Great that’s been in the family for a hundred years . . . all up for swapsies. All tradeable for anything you can eat or drink. I don’t know what the German is for junk . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Ramsch")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’ll do nicely. There is no such thing as "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Ramsch")]), _vm._v(" any more. Every piece of crap has a value. I met a bloke just before Christmas selling his mother’s false teeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Did you buy ’em?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie’s point was being made in terms of tragedy not twenty feet away. A man held a violin in one hand and a cardboard and crayon sign in the other.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Once owned by Adolph Busch. Will trade for shoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Busch had been one of Rada’s favourites. She had wound up the gramophone and put on Busch playing Brahms or Schubert and made him listen. Of course it could be a lie . . . he might as readily have written Josef Kreutzer, but the expression on his face and the state of his shoes said otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The coppers don’t care much about swapsies. In fact they don’t care much about cash deals until someone back at the nick orders a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Razzia")]), _vm._v(", and then they’ll round up every man woman, kid, and dog. A show of force, mostly amounts to nothing . . . until the next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s in demand?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Right now . . . spuds. Last year’s stocks are running out about now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And we don’t do spuds?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah . . . we’re in a different league. Follow me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie picked his way through the crowd to a van that sold hot drinks and soups. The chalked-up menu announced a choice of potato, parsnip, or pea soup. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The proprietor nodded as he saw Eddie approach and moved to the back of the van.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When they got round the back, the door opened and Eddie said, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wie viele willst du heute, Fritzi")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Fritzi replied, “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Zwölf")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie opened his greatcoat, like a bat spreading wings and Fritzi unhooked twelve bags of coffee from the cat’s cradle. A fat envelope full of reichsmarks vanished into Eddie’s pocket and they moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t count it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nope. Trust matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So does money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Which is why we agree a price every Wednesday. Price o’coffee changes all the time. And it never gets any cheaper. We agree a price and we stick to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How many do you have left?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Six. We’ll get rid of them between here and home. Not a day to be bothering with frilly knickers and perfume.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is Fritzi your biggest buyer?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One of ’em. I’ve three or four blokes who buy big-time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Big time was a troublesome phrase. Nothing about the Tiergarten "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schwarzmarkt")]), _vm._v(" struck Wilderness as big time. He thought again of insects.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t think I can do this, Ed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t have a greatcoat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? You lost it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I gave it away to a bloke in Hamburg looked like he was about to freeze to death. You’d have done the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A lie. Eddie, he knew, would have given away his shirt and trousers as well.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’S’OK. Pie Face can get you another out of stores.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So that was that, he was a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(". A nickel-and-dime, under-the-greatcoat "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(". An insect.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§99")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On the Monday morning, Wilderness reported to 45 Schlüterstraße—with no real idea to whom he was reporting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No. 45 was a few hundred yards from his digs, in a short stretch of Schlüterstraße, overlooking both the Kurfürstendamm and ­Lietzenburger Straße. It was a big, turn-of-the-century apartment building in the bourgeois style, five or six storeys high—a boastful, bulging frontage as though the building could not quite contain itself, and had blossomed into bay windows and roof dormers. It looked to have come through the war largely unscathed—a few chips and bullet scars on the columns either side of the row of steps leading up to the door, a street that had not been hard-fought.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the lobby he was surprised to find an ornate ceiling arcing overhead and a panelled staircase hinting at art nouveau origins. It was the most undamaged piece of Germany he’d yet encountered. Something the RAF had missed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The office of Information Services Control was on the ground floor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knocked at the secretary’s door and walked in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A good-looking blonde in a severe charcoal grey two-piece was ripping paper from the roller of her typewriter. She paused with the pages mid-air, looked at him, then screwed them into a ball, carbon and all, and lobbed them over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Butterfingers,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Very witty. You must be the colonel’s bright boy. We’ve been expecting you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Am I going to be Burne-Jones’s bright boy wherever I go?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. There’s not a lot of competition round here at the mo’. But you could always try "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("not")]), _vm._v(" living up to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She picked up two pages and a carbon and fed them into the typewriter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know I could have stayed at home, done the deb thing and married a Guards officer. I didn’t have to learn to type, and on days like these when I wake up with ten thumbs I wish I hadn’t. But, alas I didn’t know all that many Guards officers. Back down the corridor, second on the left. There’s a desk for you, and a pile of Fraggywotsernames to be going on with. I’ll finish the major’s letters and be with you in about half an hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The major?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Major Frampton. He’s in charge. He’ll want to see you at some point, but as you answer to Colonel Burne-Jones it’s not all that urgent he sees you today. I can brief you. As I said, second on the left.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a large, light room—bigger than the room that housed him, Eddie and two cots. The desk was a monstrosity in carved oak, at least seven feet wide and three deep. Designed to intimidate. It intimidated him until he remembered, it was "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("his")]), _vm._v(" desk. He wasn’t sharing with anyone. Just as well, he did not share with easy grace.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A foolscap envelope was on the desk, addressed to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He shook it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two pamphlets slid out onto his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Control Council Directive No.24: Concerning the Removal from Office and Positions of Responsibility of Nazis and People Hostile to Allied Purposes. January 1946.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And . . .")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Allied Kommandatura Order No.10: The Elimination of National Socialism and Militarism from Public and Economic Life. March 1946.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness almost sighed out loud. But, on the back of the latter Burne-Jones had scribbled. ")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Wouldn’t bother reading these if I were you, but it might be as well if you left them lying around on your desk. Might intimidate the natives and fool our side into thinking you actually have read them. ABJ.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then there was the pile of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(", forty or so—131 X 40 = 5,240 soddin’ questions, and 5,240 soddin’ answers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was one consolation: it was bollock freezing outside, and he was indoors and a damn sight warmer than any German.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There were two consolations: the secretary was a looker, a bit of posh with, it seemed, no snooty ways about her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d read a dozen "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(" by the time she reappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are they all musicians? How many second violins did the Berlin Philharmonic have?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not all . . . no . . . but the list will be skewed that way. In theory you have the right to pick up any Fraggey you wish and recall its author. In practice almost everything we do is geared to the archive the Nazis abandoned upstairs, the files of the Reichskulturkammer. Somehow, in the two months the Russians had this building they managed to miss it. Any artist who wanted to continue working under the Nazis filled in a German version of a Fraggey. Now they all want to work again, indeed we want them to work again, and it doesn’t matter if they’re Fred Schmidt or Wilhelm Furtwängler, they all have to be assessed. Hence we have in this building the Spruchkammer für Entnazifizierung, which is a kind of court that will exonerate, but only if we, in this case you, say so. That would amount to official denazification. Once whitewashed they are eligible for certain perks in the way of rationing. A leading actor may well qualify for a class-one card, the same as a chap doing heavy labour or a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrau")]), _vm._v("—by the by we didn’t think this one up; the Russians did, we just sort of levelled it a bit—and the choice they make is between, say, the German equivalent of Sir Cedric Hardwicke and some music hall comic who’s just had a walk-on in a Will Hay comedy. All a bit of a farce really.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And of course we have a pretty wide brief. Class one is artists and scholars but also engineers and the like. Who, after all, is to say that an engineer is not an artist? So somewhere in that pile you may stumble across an architect or bloke who designed bridges. But the bottom line is this. It doesn’t matter if a chap has traded in poetry for plumbing—if he filled in a Nazi "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(", and they’re the basis of the 250,000 files in the Reichskulturkammer upstairs, he fills in one of ours.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . we also have the Kulturbund zur demokratischen Erneuerung Deutschlands. And please don’t ask me to repeat that. Dozens, no hundreds of chaps mill around here every day to get fixed up with cards by one lot and then the other tries to keep them gainfully employed in the propagation of non-Nazi art. And then it all turns into a rather thirdrate coffee-house-cum-arts-club and you summon the chucker out. It’s all a communist front, of course, but there’s nothing we can do about it. They’re on the floor above. You’re bound to come across them but there’s no real reason to have much to do with them. You deal with the Spruchkammer, and they’re pretty much at your mercy. No "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" from you, no privileges, no work. They’re absolutely full of it of course, so try not to get stuck in a lift with any of them. And I’m Rose Blair, by the by, thank you for asking. And thank you for not flirting. I’m at least ten years older than you, and not interested. Now, any questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wanted to laugh. He could not tell from her expression whether she expected him to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There wasn’t a lot in the envelope Burne-Jones left me. Did he say anything specific to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeeees. He did rather. Work your way through the pile. There’ll be more over the next couple of days. Your first interview isn’t until Thursday, and you’re only interviewing in the mornings. In the afternoons the colonel asked that you, and I quote, ‘Get to know Berlin, you’re—"), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _vm._v("‘No use to me if you don’t know Berlin."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Exactly. His very words.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§100")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("His days achieved a pattern of tolerable dullness. He read "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(", he rubber-stamped Berliners back into gainful employment by issuing "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("s"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(". ")]), _vm._v("He would have said he was attentive, but this long after the war, in a country where everyone and no one had been a Nazi, he could see little point in the job. Burne-Jones had warned him not to regard the job as a cover. So he tried to see it that way. Burne-Jones had had him issued a spy’s gun, not a soldier’s. Had him trained to use it. What was it Weatherill had said? “I’m sure you don’t need me to teach you to die. I’m here to teach you to kill.” He tried that on too. And when added up it all came to one question: “When will Burne-Jones reappear?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the afternoons he walked Berlin as Burne-Jones had requested, wondered at the ease with which he could cross from one sector to another unmolested, strolled the length of Unter den Linden, trying to reconstruct it in his imagination. To see it draped with Swastikas in black and red. To see it at the turn of the century, as it had been in the Kaiser’s day. Late afternoon, in the twilight hours, he would meet Eddie in either Eddie’s jeep or his own and they would unburden themselves of coffee, soap, perfume, tinned fish . . . whatever . . . on the eager citizens of Berlin. A people starving, on the ration or off it. The stick insects.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He could not deny it made money. He, Eddie, Spud, and Pie Face were no more short of money than they were short of food. They weren’t starving. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But it was a diversion at best. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The real game was somewhere else.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had to be.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§101")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was the second week of February. Wilderness had just issued a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" to a bloke with a badly damaged hand. Afterwards he could remember little about the man—they all tended to blur into one single importuning German—but he held a cigarette in a little black holder stuck between the stumps of the fingers on his right hand, and had old-fashioned good manners. Perhaps because he wasn’t scared of Wilderness. It brought a reciprocal response. Against habit Wilderness had shown him to the door, chatted about so much nothing in the lobby, only to see a young woman fly down the stairs and hug the man—he in turn had embraced her with his good, left arm as she chattered away in faster German than Wilderness could keep up with.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He watched as she walked him to the front door. Small. Slim. Beautiful. Long black hair, piled up and pinned up for the office. A bottle-green dress that seemed far too summery for the time of year. She could be anything between sixteen and twenty.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So, you’ve noticed?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He turned. Rose Blair was standing in her office doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Noticed who?” he lied.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Our Fraulein Burkhardt. Or rather, their Fraulein Burkhardt. Works for the Kulturbund upstairs. Gorgeous, isn’t she? You don’t stand a chance. All the actors try it on with her—at least all those that aren’t queer. Come to think of it, maybe you do stand a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her door was about to close.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “You know her? I don’t suppose . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Burne-Jones pays me to keep an eye on you Corporal Holderness, not to fix you up with dates. You want a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schatzi")]), _vm._v(", find her yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§102")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He did not find her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She found him.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§103")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Nell had known Werner Fugger all her life. His father was her godfather, and had worked for the city of Berlin alongside her own father, alongside Berlin’s mayor-elect Ernst Reuter. Werner was two years younger, and playing with him when she was ten had seemed like an ordeal and required coercion. Not much had changed. Unlike her he’d been in the Hitler Youth—the natural scepticism of his father had not been enough to get him out of that—and while she’d been away, with Great-Uncle Klaus, with Nicolas Dekker, Werner had served with the Volkssturm, and at the age of fourteen had fought in the streets outside the bunker, had taken out a Russian tank with a crude but effective weapon known as a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Panzerfaust")]), _vm._v(". The Führer had surfaced from his bunker, perhaps for the last time, to pinch cheeks and pin medals on Werner and a dozen others. Only one of them had been younger than Werner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of Werner’s comrades-in-arms had slung his iron cross into the rubble when news of Hitler’s death emerged, saying it would become a curse upon them. He urged Werner to throw his away too. Werner wouldn’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell could respect Werner’s experience, without respecting his opinions. Werner veered between denouncing Germany and denouncing the Allies, without ever denouncing the Reich. His mental footwork lacked skill as it lacked years. And he and Nell had the same argument over and over again in cafés and bars across the city centre.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Auschwitz was Russian propaganda. The camp and its gas chambers hastily faked by the Russians in January 1945.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell would counter this by telling him what she had learnt firsthand talking to survivors of Auschwitz in Belsen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Scarcely conceding her point with a “for the purposes of argument only, let us suppose you are right . . .” Werner would then argue strongly for Hitler having been surrounded by a “conspiracy of silence . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Surely you can see that if the Führer knew about such things, he would have put a stop to them at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why would he? It was everything he believed in, the summation of every policy he ever espoused, every speech he ever made. Everything he did and said from the day he got out of the army was destined to end with Auschwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("If Werner insisted that the Führer had known nothing, sooner rather than later, he could kill an evening. Their mutual friends would drift off, exasperated and bored by him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell regretted that she had asked him along this evening, but to leave him to his own devices only meant that he would fall in with more idiots who thought as he did—and God alone knew how many of those there were. Half Berlin was only too eager to wrap itself in the stars and stripes, and half would fly the hakenkreuz if only they had the nerve. Perhaps her choice of bar was a mistake—the Marrokkaner Club in Grolmanstraße? Perhaps any bar was a mistake when dealing with a war hero not yet seventeen?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner had moved on to the subject of the Nuremburg Trials. Two of their friends had left already, leaving only Nell and Franz, a thoughtful, near-silent young man of nineteen, an undecorated, unheroic, unbelieving veteran of the Volkssturm, to listen to Werner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The idea of collective guilt is nonsense . . . an entire country cannot be guilty . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then,” Nell said. “Perhaps guilt is the wrong word. Not "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schuld")]), _vm._v(" but "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Haftung")]), _vm._v("—responsibility.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you saying we are all responsible, responsible for things of which we knew nothing, for things you say were done by our parents’ generation? We were children . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Some children fought and some of us won medals,” Franz said softly without a hint of sarcasm. “Or is this where you tell me you and I were only following orders?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. I followed orders, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And where Werner was concerned clauses beginning with “but” could last all night.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("From the other side of the partition she could hear the voices of the occupiers. Another reason not to bring Werner here. It was a favourite with the Allied troops—it was in the eastern end of the British Sector where Charlottenburg met the zoo and the Tiergarten, only walking distance from her work in Schlüterstraße, a short hop from the American Sector, which began only a few metres south of No. 45.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("An English voice was holding forth. A little louder than conversation might permit. Not a lecture, not a raised voice . . . a game.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Right gentleman . . . now yer sees it, now yer don’t . . . all you have to do is find the lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sharpe!")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The quickness of the ’and deceives the eye . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sharpe!")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She stood up, in the middle of whatever rubbish Werner was uttering and walked around the partition to the other banquette.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sharpe!")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Three British soldiers were sitting around the table with half-drunk beers and scrappy piles of reichsmarks in front of them, poised as a fourth in the pale blue of the Royal Air Force worked his huckster’s magic, hands flashing across the cards.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("One of the soldiers was Swift Eddie Clark, who’d worked at Schlüterstraße from time to time. She didn’t know the other two, and the man in RAF blue wasn’t Beckwith Sharpe. Too young, too handsome, too tall. He simply sounded like Sharpe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was about to apologise for the interruption when he looked straight at her. Fair hair and light blue eyes. A beguiling rogue’s smile. Were all cockneys charming rogues? Was Sharpe simply a blueprint for the London millions?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“May I?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie pulled out a chair for her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can’t beat Joe, Miss Burkhardt. He’s the gaffer at this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Silently adding “gaffer” to her English vocabulary, she took the deck of cards the one called Joe was holding out to her, picked out the queen o"), _c('span', [_vm._v("f")]), _vm._v(" hearts, a seven and a nine and held them up for all to see.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Nun, meine Herren. Mal sehen, wer die Dame finden kann")]), _vm._v(".” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Cockney spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In English, Miss. Eddie and I are OK, but Pie Face here hardly speaks English let alone German.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell concluded the one not laughing was Pie Face. Besides, he had a face like a pie. Flat and puffy at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Entschuldigung")]), _vm._v(". And that will be my last word in German.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("She held the red queen and the seven in her left hand, the nine in her right, palms up. Palms down and her hands moved faster than a Paganini variation.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face said, “It’s Toy Town money after all. Five doodads on . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He put his folded note on the card nearest to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie followed suit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The third man said, “An’ I’m Spud” as he put his note on the centre card. How aptly the English applied their nicknames. Spud, indeed. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kartoffelgesicht")]), _vm._v(" was clumsy by comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That left the blue-eyed Cockney.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The blue eyes were fixed on her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had no wish to give him ideas, and looked in turn at all the others, waiting for him to place his bet.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At last, like a ball decelerating on the rim of a roulette wheel, her eyes came to meet his, the imaginary ball jumping from slot to slot, clicking like a ratchet until their eyes locked. He would get the wrong idea. She knew he would.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His hand poised over the cards, then dropped a 5RM note onto the centre card.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She flipped the outside card, heard Pie Face sigh in defeat as the seven showed. Stared back at Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He moved first, flipped the centre card, nine up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Bloomin’ ’eck. Joe, she beat you. I’ve never seen anyone beat you at three-card monte.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell flipped the queen and raked in her winnings.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now, Joe was not looking at her, he was looking up and over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She turned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner was standing behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We should go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, I want to stay. This is fun. You go if you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The she heard Joe say, “Or you could join us. Doesn’t have to be three-card monte. Doesn’t have to be for money. Just a game.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She didn’t want this. She didn’t want to be left alone with the Englishman, but she didn’t want Werner as her chaperone either.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner spoke as though he’d been slapped in the face and challenged to a duel with sabres.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I do not care to sit down with the Allies, Herr Corporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had not even noticed Joe’s rank. The sneer as Werner said “corporal” was impossible to miss.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now, don’t you go bashin’ corporals. We may be a bunch of numskulls but some of us go on to run empires that last a thousand years.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner turned on his heel and was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The three soldiers were giggling like schoolboys. Nell was not laughing, nor was Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, is he a friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes. We do not deny our friends, do we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Probably not Miss Burkhardt, but I don’t have any friends that deny Auschwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Oh God, had Werner talked that loud?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell,” she said. “My name is Nell.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§104")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Nell. I’m alive! Where are you? Joe.")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt para-style-override-19"
  }, [_vm._v("§105")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Can I drive you home?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Thank you. But I live only walking distance from here. In the American Sector. In Wilmersdorf. Near the Ludwigskirche. On Grünetümmlerstraße.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Bit by bit there was too much detail for this to be a brush-off. Everything short of a zip code. Somewhere in there, amongst the longitude and latitude, he was certain, was an implicit invitation. Coupled to an equally distinct “not now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then I could walk you home.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you, Joe. Where do you live?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fasanenstraße.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Near the synagogue?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Down the street from it, or from what’s left of it. I think the RAF got there before me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sure they did, but in this instance they bombed a ruin. Goebbels’s SA sacked the synagogue on Kristallnacht in 1938. My father saw it burn. I went inside once. When I was a girl. It was beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He ought to say “good night” now. He knew it. But couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then she said, “Why don’t I walk "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("you")]), _vm._v(" home. You can pick up your jeep later. I’d like to see the synagogue again, even as it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a variation on an old adage. Advice given to young ladies back in London. “It is easier to walk out of his place than to have to throw him out of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The walk was not long enough. A matter of minutes. They stared at the gaping cavern that had been the synagogue. He felt nothing and had no idea what she was feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He showed her the block he and Eddie, and fifty other erks, lived in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She kissed him lightly on the cheek and walked back down towards the Ku’damm without another word.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§106")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m moving out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I got that bit. It’s the moving in bit I can’t quite grasp.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Admit it, Eddie. You’d love to have the place to yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How long has this been going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know, we try hard enough we could have this whole conversation in song titles. About six weeks. Since the night she took us on at three-card monte in the Marrokkaner"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Fraulein Breakheart has asked you to move in?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. How many ways do you want me to say it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I wouldn’t have said she was the type.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is there a type?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . she’s not like us, is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do you think she is?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Honest.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness went on packing. Eddie scratched his head with an invisible hand, not moving a muscle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How old is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Older’n you, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I lied about me age.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Great start, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness hefted his kit bag under his right arm, wrapped his left around Eddie’s shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eddie, we’ll be fine. You, me, Nell—fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s for real is it, Joe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s very real, Ed.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§107")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Top floor. Tucked under the eaves. Flaking whitewash. Moonlight on broad elm floorboards. A brass bed held together with bent bits of wire that had creaked embarrassingly the first time they had made love and on every occasion since. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She lay curled in the crook of his arm. Mouse small.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why do they call you Joe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s me name.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not your real name.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Never really been a John. Hated being called Wilf. Joe was the compromise. The English love nicknames.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We like . . . diminutives.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like Hansel and Gretel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like Nell?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh Nell. She is the grown-up. The little girl was Lenchen. To my father I was always Lenchen. Christina Hélène von Raeder Burkhardt is such a mouthful. So I am Nell.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One woman called me Wilderness. I don’t think she could quite pronounce my surname. So she called me Wilderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sounds . . . savage. You know . . . like Kaspar Hauser.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe. Wild child. But I doubt it. Eddie calls you Fraulein Breakheart when he’s trying to make a point.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Up on one elbow now. Eye to eye. Almost nose to nose.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Breakheart?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is that who we are? Wilderness and Breakheart.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah . . . but we’re nowhere near as bad as it makes us sound.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She slumped into the curve of his arm again. Fell asleep. Oblivious to all the things that kept him awake. Since he arrived in Berlin not a single night had passed without the sound of gunfire. And when he nodded off, the pungent smell of carbide lamps drifting up from the street could penetrate any depth of sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She stirred. Up on one elbow once more. One eye opened, one eye closed. He touched the scar beneath her left eye with his fingertips.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My . . . war wound.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tell me about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So she did.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§108")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Nell kept a journal. Fat, ochre-coloured with coarse onion-skin pages. It sat upon a writing slope, which in turn sat upon the small table that passed for her desk. It would not have occurred to Wilderness to look inside, curious or not. What intrigued him most was not the possibilities of content, but the pencils she used. Different colours worn to different lengths. When she had finished writing whatever it was she wrote, she would arrange the pencils on her desk in order of length. If he moved one, sooner or later he would find she had moved it back. A creature of some disorder himself, he could admire order—he admired Eddie’s sense of order, a man who matched up socks and rolled them into balls; an act for which Wilderness thought life too short—but Nell’s order prompted questions, questions without form or language. An elusive sense of belonging and not belonging, of wondering where he fitted into this woman’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He thought of all the women in his life—the few. His drunken, feckless mother, who had died with a gin and lime in her hand, who had scarcely seemed to know he was alive. Mercurial, beautiful, utterly amoral Merle—a woman without a care in the world because she cared for no one and nothing, who had seduced him on a whim. Rada—a demanding, generous mind, the biggest influence in his life—trapped in her own memories even as she narrated them to him, nurturing an inconsolable, unarticulated grief that had killed her. Nell—charming, severe, funny, humourless, driven . . . above all else driven—the weight of the world on her shoulders. Standing straight, standing tall in a city which lay in pieces at her feet. A one-woman moral storm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He came to realise that her distinction between guilt and responsibility was vital. The apartment was one room—cooker and sink at one end, bath at the other, bed and all else in the middle. It was too big for one woman by the standards of Berlin in 1947. As he learnt on their second “date,” Nell had no living relatives—a condition Wilderness thought much of Berlin might be in—and felt that to live alone, in a room of one’s own was wrong. However desirable, wrong. But for this he doubted she would have let him move in after so short a courtship.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The nearest thing she had to a relative, she told him, was the man who lived on the floor below. Erno Schreiber, an old friend of her parents. A man in his late fifties, or thereabouts. A Jew.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How did he survive?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hid his identity. Changed his name. Forged all his papers. And forged them for others. I should think there are over two hundred Jews in Berlin who owe their lives to Erno’s skill as a forger. His masterpiece was the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Bombenschein")]), _vm._v(". Rather like your "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(". It was a catch-all document stating that all other papers had been lost in an air raid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("This intrigued him. This was his territory, far more than it was hers.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Arriving home ahead of her one day, the door to Erno Schreiber’s room was ajar. He knocked, the door swung inward on its own weight and Wilderness found himself looking at a small, white-haired man in an unravelling cardigan, hunched over a desk, writing by the light of a twenty-five watt lamp, surrounded by junk—piles of newspapers, overburdened bookshelves, the paraphernalia of the practised hoarder. Nowhere to sit, no way to move. Walkways through the junk, like looking down on the pattern of a maze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The ginger tomcat perched on the highest shelf looked down at ­Wilderness. Erno did not look up.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Just said, “Ah, the boyfriend. I had wondered when you might call.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” Wilderness said. “And you’re the forger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now he looked up. His glasses unhooked from the right ear to dangle by their brass loop from the left.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you’re the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“She told you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My dear "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(". We’re talking about a woman whose honesty may well be her only vice.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, we’re all "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schiebe")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("r")]), _vm._v("s of one sort or another aren’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Indeed, it is the norm. I cannot think of any other reason why Nell would tolerate one let alone . . . admit one. She is so earnest, so adamant about sharing in the common fate.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not so long ago, thinking like that would have got you killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite, so easy to die of obedience or conformity. Now, what can I do for you Herr Schieber?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“An identity card.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What kind of identity card?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A pay book. British army regiment. Welsh Guards.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He picked up a pencil now, ready to take notes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Date of birth and name?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Thinking on his toes. If he made his doppelgänger older, what was his war record?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“August 3 . . . 1926 . . . Rupert . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Most officers were Ruperts or Tobys.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rupert Charles . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Most officers had three Christian names. You weren’t a proper toff without three initials. Most officers had a posh surname hyphenated with a common one. Burne-Jones sprang to mind to be readily dismissed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rupert Charles Montgomery Tatten-Brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Montgomery. Hmm. How patriotic. And the rank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Second Lieutenant. No . . . make that first lieutenant.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You want pips with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You got pips?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the wall above Erno’s desk was a cabinet of fifty tiny drawers, something out of an apothecary’s shop—the chemical symbols in gold leaf that had faded into near-nothingness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Welsh Guards . . . Welsh Guards . . . let me see.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A few seconds rummaging in CuSO4 and two shoulder pips were placed on the desk in front o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You got pips for everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“More or less. You want to pass for a tram inspector or an SS Standartenführer, I’m your man, although the tram inspector will cost you more. And if you really were an SS Standartenführer wanting to pass for a tram inspector you can double any figure you might be thinking of. And I’d still call the police. Now, you want the tree to put on your cap?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tree?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno held out a Welsh Guards cap badge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s not a tree, it’s a leek. And I already got the cap and badge.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s a leek?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sort of like an onion.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How quaint . . . no swords or daggers . . . just vegetables. Food is so much more important, you will agree. Were you thinking of paying me in food, Herr Schieber?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you like. What do you want? Chocolate? Tinned stuf"), _c('span', [_vm._v("f")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Consider it done.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Coffee is the one thing Yuri never puts in a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v(". Far too precious.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri? Who’s Yuri?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§109")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Who’s Yuri?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were seated at opposite sides of the little table in the portion of Nell’s room that passed as “dining.” A close parody of the prim and proper. Once in a while this seemed to be what Nell wanted. And the rest of the time she was content to sit on the floor or sprawl on the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He had brought fresh eggs. Nell had scrambled them and served them with tinned broad beans she had been saving. She stirred the egg on her plate slowly and looked up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri was . . . is . . . my mother’s protector. An NKVD major.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Was? Is? You mean he’s your protector?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think he is, although he does not visit as regularly as he used to and the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _vm._v(" are fewer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Pajok")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Food parcel. You bring "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _vm._v(". You just didn’t know the word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Protector?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A man who took you on board in ’45, who brought you "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _vm._v(" and told every other Russian that you were his was a protector. If he did none of those things he was a rapist. My mother avoided rape by accepting his patronage, his sexual exclusivity . . . and his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yet still he brings you "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For which he receives nothing but my lasting gratitude. He hasn’t been here in weeks. It is his habit just to vanish from time to time.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§110")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Yuri showed up the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When Wilderness returned late in the afternoon a small man in a nondescript uniform was sitting with Erno, drinking the coffee he had given Erno yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He did not know how to read Russians in uniform. He’d passed them in the street every day. One or two even came to the Marrokkaner. Laughing loudly, never breaking their circle, wanting to know no one. But, then, he’d never tried. And if those who spoke Russian never tried talking to Russians who would?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were raggy men in baggy pants and jackboots. Some of them were even raggy women. Collar flashes could be blue, could be yellow, but, as with Yuri, were mostly dirt-coloured. The only thing that broke up the muddiness of his battledress was a row of medal ribbons in all the spectrum of the rainbow, the single gold star of a major on each shoulder, and the shiny brass button on the flap holster that held his seven-shot Nagant revolver.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d lost track of the initials too. The Soviet Union and the Third Reich had this in common—they’d invent a new organisation and a new acronym on the spot to cope with contingencies. Nell had said he was NKVD in 1945. It was easiest to go on thinking of him that way.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri hoisted his cup of coffee, by way of toast, by way of greeting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good,” he said. “Is yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri swirled the coffee in his cup and downed it in a single gulp. Erno poured a cup for Wilderness, muttered an apology about the lack of milk. Yuri cradled the empty cup in hands that seemed huge, out of all proportion to his body, with fat fingers, broad flat thumbs and tiny slivers of fingernails—brown hands peeking out of brown sleeves, hands that had been calloused and scarred and tanned. And in the sunburnt, Asiatic face, nut-brown and wrinkled like a walnut, when his deep blue eyes opened from their narrow slits, they twinkled with mischief. He held out the cup for more.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Good good,” he said again, and Wilderness realised he had not answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes,” he said. “Part payment. Erno is doing a little job for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was one way of flushing the fox out. Major Myshkin would hardly be sitting there if he too were not “one of us”—a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(" of one kind or another.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The cup was laid gently down on one of the piles of old newspapers that seemed to serve Erno as furniture. The right hand slid across his midriff to flip the button on his holster.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness’s gun was in a drawer in Fasanenstraße. He wasn’t even sure which drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri withdrew his hand and Wilderness found himself looking down the barrel of a saxophone-shaped Hungarian pipe, as Yuri gestured with it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps you can do a little job for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The left hand rummaged in his jacket pocket, pulled out a worn, square tin of Ogden’s Walnut Plug.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That might be possible,” Wilderness said. “How much would you like?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The tamping and the lighting up, the sucking and the puffing slowed the conversation to a tortoise crawl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fifty pounds. I can use fifty pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can get your brand of tobacco too, if you like. It’s English.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da, so. My own private "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Suck, puff, breathe out a cloud of smoke, suck puff, puff puff. Wilderness had never found this unpleasant—it had been Abner’s choice of brand too—but he had concluded in childhood that men smoked pipes only to make other men wait.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“From Leeverrpol, da?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da,” said Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . you must bring to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What? In the East?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da. I cannot always come West. And I can hardly stand in Tiergarten like a Berlin "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Hausfrau")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where in the East?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That should be a moveable feast. We’ll move around. Points east, east of Pariser Platz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A hundred.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is that your price?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. The quantity. It has to be worthwhile if you want me to shift stuff over the line, and run the risk of your cops as well as ours . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My people will leave you well alone, believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And ours are at their nosiest at the line . . . a hundred pounds of coffee and I’ll deliver to you in the East.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Suck, puff, cloud.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Okeydokey, Englishman. A hundred pounds a time. Now, can we talk money or had you forgotten that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had not forgotten the money any more than a dog forgets to eat, but he was worrying about something just as vital—where could he get a hundred pounds of coffee?")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§111")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Later that night, in the Marrokkaner"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You said what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A hundred pounds of coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus wept,” Pie Face said. “You silly sod.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All the same, my character not withstanding . . . you can get a hundred pounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Possible. Risky. Someone might notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s the most you’ve ever got out at one time?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sixty. Week before last.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So you’ll try?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. I’ll try.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was Eddie’s habit to hear everyone out before speaking. He spoke now.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How are we going to shift it? I can’t manage twenty pounds under me greatcoat, let alone a hundred, and we’re almost out of greatcoat weather. Any minute now the MPs’ll be able to nick the black-marketeers by pulling in anyone daft enough to be wearing an army greatcoat in the sunshine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “We motorise. We have three staff jeeps at our disposal. Mine, Eddie’s, and Spud’s. And once we cross the line we’re free of our blokes—they’ve always been the real threat, not the Russians. We’ve always had more to fear from our own lot just selling by the bag on the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Vehicles get pulled just like blokes on foot,” Spud said. “An’ that’s a fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We won’t have it on display.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“MPs know the hiding places. And they got mirrors to look under the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jerry cans,” Wilderness said. “How many jerry cans does a staff jeep carry?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Four,” said Spud. “But there’s fixings for six.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Capacity?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Twenty litres each.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can we pack a hundred pounds of coffee into that space?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just. Only just. But it would mean no spare petrol.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And when have you ever run out of petrol driving around Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud smiled the smile of acceptance.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Brilliant, Joe. Bloody brilliant.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness nodded and waited. Watched Spud improvise.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I slices the bottoms off the cans in me workshop, bit o’ spot welding, fit ’em back with an inner sleeve, and bob’s yer uncle—six giant coffee cans undetectable to the nosy copper.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was smiling too.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Might work,” he said. “You never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Walking back to Fasanenstraße, Eddie said, “And the money? You never mentioned it and they never ask. They’re like a pair of schoolboys. They care more about the lark than the profit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’ll pay over the odds, and I insisted on Western marks. No minus money. For all I know he prints his own.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“How can coffee, how can anything be worth more in East Berlin than it is in the West? We’re getting four hundred reichsmarks a pound as it is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Cos it don’t stay in East Berlin. Leastways that’s my feeling. Yuri is big time. Party apparatchik. Commissar during the early part of the war. I reckon anything we sell him will go to the arselickers and the comrades back in Moscow.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ruins yer faith in humanity, doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. I’ll never vote Commie again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Big time? This Yuri is . . . big time?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are we big time now, Joe? Bulk orders? A hundred pounds at a time?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There’s sod all profit and sod all pleasure in selling half a dozen bags at a time to the stick insects.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or do we just not know what we’re getting into?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Y’know I’d go right off you if you ever turned into an optimist, Ed.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§112")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The first time, they met in "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Das Eierkühlhaus")]), _vm._v("—the egg-cooling house—in Osthafen. This part of the city, on the north bank of the Spree, had been Wehrmacht property. A prime target, with one of Berlin’s largest goods stations—the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Ost-Güterbahnhof")]), _vm._v("—smack in the middle of it. The RAF had pasted it, and somehow managed to miss a warehouse with 75,000,000 eggs and the opportunity to create the biggest omelette in history.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri delighted in telling him this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It surprised Wilderness not half as much as the fact that the Russians—having shipped anything that wasn’t nailed down, to say nothing of much of what was nailed down, back to the Soviet Union—were once again using the egg house for its intended purpose and storing eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two silent Slavs unloaded one hundred pounds of coffee, looking slightly baffled by the whole process of concealment. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri counted out fifty thousand reichsmarks.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness flipped through them looking for plus signs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t trust me? That’s OK. I wouldn’t trust me either. Here, a present for Nell.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He handed Wilderness a dozen eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two hundred and fifty marks in the Tiergarten. Now, perhaps you will trust me a little?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two hundred and seventy five. And we’ll take trust one day at a time, shall we? Like giving up fags or booze.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri laughed out loud at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da, da. The Alkononics Anonomy. We are a pair of junkies! Addicted to the deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri slapped him on the back. A lot of force for such a little man.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “We could speed things up a bit, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Get hold of six more jerry cans—they’re everywhere in Germany, it’s why they’re called jerry cans after all—and fix them up the same as mine. Then, instead of waiting while your blokes empty them out, we just swap cans. Dammit, we could park side by side on Unter den Linden and be away in thirty seconds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Risky. I prefer some cover.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just a figure of speech.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“And I would have to trust you about what was really in the cans.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’d be free to open any one of them at any time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Okeydokey. Good good. I get one of my ‘blokes,’ as you call them, to do the job. Next time, eh? One day at a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness drove back across the Brommy Bridge, into the American Sector. Fifty thousand reichsmarks was a small fortune if exchangeable into dollars or sterling, but it wasn’t. The trick, if such, was not be caught holding the parcel when the music stopped. And it would surely stop one day?")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§113")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness did the next run himself too. It took Pie Face a fortnight to get one hundred pounds of coffee. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He grumbled endlessly. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri grumbled endlessly. So much so, Wilderness bought time by insisting Yuri meet the team at the Marrokkaner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The rough and wrinkled peasant had all the diplomatic skills of a candidate for the US presidency. If there had been babies he would have kissed them. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was well aware that few people Spud and Pie Face had ever met could represent the “unknown” as fully as Yuri. Leaving the square mile of their birth had been a major step, going overseas a life milestone, setting foot in a French brothel a total violation of their upbringing . . . something to be remembered, relished, and never spoken of again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was different. Eddie was an imaginative man in a dull exterior. It was a brilliant defence. Who would ever suspect the little fat bloke who exuded dullness and misery? He had always reminded Wilderness of a bumblebee—unlikely, one of nature’s freaks . . . but when the creature chose to fly . . . ?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Besides, Eddie had been through the same course of Cambridge indoctrination that he had himself—and he spoke better Russian. Spud might be charmed as Yuri bought him beer after beer and they compared notes on childhoods spent on farms in East Anglia and rural Russia, Pie Face might be bemused by it all, but little would dent Eddie’s cynicism. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As ever, he saved his critique until they were alone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You think he’s dodgy, don’t you?” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dodgy? More like downright bloody dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s in the same game we are, Ed—that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Before I was in this ‘game’ I was a driver and interpreter and you flogged china on a market stall in Whitechapel. Spud’s a farmboy-cum-mechanic, as happy chewing straw as smuggling coffee. Pie Face is part of the great East End diaspora, living on the Thames estuary, living off memories of Limehouse or Wapping and less than happy with anything else. Wogs begin in Kent as far he’s concerned. But what about our new pal? What did Yuri do in the war? For that matter what did Yuri do before the war? He’s twenty years older than us. He’s an apparatchik, an NKVD officer, a former military commissar for fuck’s sake. He doesn’t deal in coffee he deals in death. In either capacity, commissar or NKVD . . . how many deaths is he responsible for? You don’t know and neither do I.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yet, he took care of Nell and her mother in ’45.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Doesn’t make him St. Francis.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So, Wilderness made Eddie do the run with him. Just to set his mind at ease.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The venue was another industrial relic, the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Eisfabrik")]), _vm._v(" on Köpenicker Straße, again just spitting distance from the American line. It reminded Wilderness of nothing quite so much as the illustrated pages of his School Cert history book—Chapter 7, the Industrial Revolution. It was like the interior of a Lancashire cotton mill—although the pages of his history book were the closest he’d ever been to one—an iron jungle of boilers and flywheels and overhead cams. Pleasing, it its way. Languishing, under a few years of dust. It probably hadn’t turned out a block of ice since the war turned against the Reich in 1943. One day it might make ice again—until then it seemed to be Yuri’s warehouse. One of many.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri’s bloke—Yuri offered no introduction, and the man never spoke—set six jerry cans in front of them. Identical to the ones they’d brought in with them, even down to the British Army stencilling on the side and the little red and green flashes, copied from memory without comprehension.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good,” said Yuri. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness handed him a tin of Ogden’s Walnut Plug.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On the house,” he said, and as Yuri looked both pleased and baffled by phrase and gesture, added, “A present, from us to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good. So . . . kind. New tin. So pretty. Mine is so worn. So pretty pretty. And I . . . have present for Eddie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri summoned one of the silent men, and with a bold hint of ceremony a bottle of “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Pugachev")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("перцовка")]), _vm._v("” vodka was handed from him to Yuri to Eddie. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was bright red, a fact readily explained by the sketch of a cluster of red peppers on the label. But not as red as Eddie. Eddie was blushing, as though he’d blundered into the Olympic arena after a casual stroll in the park only to break the tape ahead of the marathon winner. An unexpected honour.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bottled in 1932,” said Yuri.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One hundred twenty proof.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m touched.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Made from capitalists’ blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The slap on the back that followed almost made Eddie drop the bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness laughed, which brought a nervous smile to Eddie’s lips, but Yuri was roaring hysterically at his own joke. He drew breath long enough to translate for his blokes and then half a dozen of them were laughing together.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Next time?” Wilderness said to bring them back to earth.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Next time, zoap.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What kind of soap?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Lady zoap. Pink and smelly. As much as you can get.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Driving home, clutching the bottle between his knees, Eddie said, “He’s a bundle of bloody laughs isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I rather think that was the price you paid for your all-too-obvious suspicion.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So now we need a mountain of soddin’ "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("zoap")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We can get a mountain of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("zoap")]), _vm._v(". Might not be pink but it’ll be smelly. Whatever the NAAFI has in stock. In fact from now on it’s open orders . . . we sell him whatever we can. And we split the driving. You, me, and Spud. Different faces, different jeeps, different locations . . . all lowers the risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And our regulars?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Regulars?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The blokes at the back doors of all the caffs we supply, the blokes in the Tiergarten.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Small change, Ed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’re still "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("our")]), _vm._v(" regulars.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There’ll be enough to go round, trust me, there’ll be enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re driving Pie Face potty, you know that don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then maybe we need another source.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§114")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Eddie got home to Fasanenstraße after a day of chauffeuring, interpreting, and dealing to find Wilderness in shirt and underpants. Wilderness was pressing his Welsh Guards outfit. Adding a second pip to the shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“High time I got promoted.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh bugger. You’re going out in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Damn right I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe this isn’t London. This place is crawling with MPs.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you go down the Marlborough Club . . . suppose someone recognises you? It’s officers only. You’d be had up for impersonation. You want a night out, what’s wrong with the Winston Club. It’s only two streets away. We could both go.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eddie, you’re worrying about nothing. I just want to see how the other half lives. I’m not going down the Winston—all those pompous NCOs would make my blood boil.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mine too but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I’m not going down the Marlborough. The other half I want to see is American. I’m off to Harnack-Haus.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Harnack-Haus was out in the suburb of Dahlem, at the southern end of the American Sector. It had been commandeered as a social club for US forces in 1945. At some point during the war, according to Peter-Jürgen von Hesse in one of his interminably rambling confessions, Germany’s nuclear physicists had met here with a view to building an atomic bomb. They had been indecisive. Now, the most lethal thing mixed here was a green St. Patrick’s Day cocktail, relying heavily on chartreuse and lager.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness paid off the cab opposite Harnack-Haus—remembering that officers tipped. Patted the pocket, where Erno’s fake ID nestled. It was immaculate. The work of a master craftsman. He just might be Lt Rupert Tatten-Brown.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Harnack-Haus was a monstrosity, worse by far than the Victory Club in Hamburg—a Prussian bludgeon of a building—but on the same vast ocean-liner scale. A bar the size of a ballroom—and packed, Friday night revellers, in spick-and-span uniforms, on pleasure bent. It was not, and this surprised him, “Officers Only”—America being a democracy, by the people for the people of the people, its distinction was not between classes but colours.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He wasn’t at all sure why he’d come. He stood at the bar, ordered a Krombacher Pils and began to think he’d made a mistake. He’d not been sure what he wanted—a taste of the high life, a sense of being at the centre rather than the edge. But that was the British condition post-war—to be on the periphery. Groups of Americans, mostly airmen out of Tempelhof, looked like closed societies, sealed units. It would have been quite impossible to intrude with a “hello chaps” and a handshake, impossible to penetrate that level of laughter and inclusive fellow-feeling. His childhood had set him up. He wanted to mingle with Americans for no better reason than that they were the people who’d appeared on-screen at the Troxy cinema in the Commercial Road. He was looking at servicemen in olive green, when really what he wanted was Carole Lombard or Melvyn Douglas—better still, he wanted a glimpse of Myrna Loy and William Powell, seated at a round table swirling cocktails, swapping gags, the dog at their feet just waiting to nip your ankles.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d have another beer and call it quits.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d just raised a hand to signal the barman, when a voice on his right said, “Let me get this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("This was a big one. An American army captain as tall as he was himself, but bulking up at twice his size, barrel chest, a jaw like Desperate Dan.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Krombacher, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thanks, old man. Awfully good of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Even as he spoke them the words sounded fake. The whole venture sounded fake. He could kick himself. Having opened his mouth as a toff he’d have no choice now but to keep it up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With two glasses of Pils set in front of them, the American hoisted his with, “Mud in your eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could think of nothing more English than “Cheers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Haven’t I seen you somewhere before?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Oh shit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t think so, old man. Tatten-Brown. Welsh Guards.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. At the . . . oh hell . . . my German is complete crap . . . Kult . . . Kult . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kulturkammer")]), _vm._v(" . . . nah, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Kulturbund")]), _vm._v(", that was it . . . what a mouthful . . . the place on Schlüterstraße. The DeNaz place. Where the Krauts come to get their "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("s.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Shit, shit, shit.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked back at the greeny-brown eyes. The half-wry smile on his lips. He didn’t look hostile. Perhaps he wasn’t hostile.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just a game, mate,” he said. “Just a bit of fun. Seeing how the other half lives. A dressing-up game. No harm in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. I mean. Why not? Tell you what. Let’s see if we can find a quiet table to ourselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness decided that if this bloke was going to shop him, he’d have done it by now, and most certainly would not have said, “Run a tab” as they picked their beers and made their way to the far corner of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As they drew back chairs, a huge, soft hand shook his.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank Spoleto, Captain, US Army Intelligence. Been here since ’45. Came in with the 82nd Airborne.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe Holderness, Corporal, Royal Air Force Intelligence. Came here on the Silk Stocking express this winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, I guess you are just a kid at that. Ever see combat?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I got drafted . . . after.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tough. But . . . but . . . just a kid is as maybe. I hear you’re the man.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The")]), _vm._v(" man?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why not just spit it out, Captain?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah, it’s a tale to be told not a fleck of phlegm to be coughed up. I got here with the first American troops in July ’45, when the Russkis drew back to the line. You think Berlin’s badly off now, but that’s nothing compared to ’45.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why are you telling me this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stick with me, kid. In ’45 everything was up for grabs. Everything was up for sale. Stuff we took for granted back home was priceless here.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cigarettes, cigarettes were obvious. I mean. They had a whole army of kids picking butts off the ground, begging them off you before you could even flip them onto the sidewalk. Rolling up fresh ones from the dregs was a cottage industry. Even a gasper finished off with toilet paper was worth five reichsmarks back then when the real thing was worth twice that. The places that made them weren’t factories . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know all this. I’ve had this lecture.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hear me out . . . they weren’t factories . . . they were the Bank of England, they were the Federal Reserve, they were Fort Knox, because cigarettes were currency. I gave up smoking. I ask you, would you set fire to money and stick it in your mouth? But what really wised me up was a date with a German girl I was sweet on. I’d taken her out a couple of times. Third or fourth date I was hoping to improve my score, maybe get to third base if not a home run. Gave her a box of Fairy soap. Nothing special. Just ordinary soap, some white, some green. She fucked me stupid and sold the box for three hundred marks. I knew then. The guy with the key to the PX was Rockefeller, Carnegie, Pierpont Morgan. Goddammit, he’s Errol fuckin’ Flynn.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said again, “Why are you telling me this? I know all this.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Because we could do business.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We could?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m the man with the key to Fort Knox. And from what I hear, you’re the man. The man with a tame Russki in his pocket. The last couple of years have been sweet, but it can get sweeter. In ’45 you could exchange marks for dollars and wire them home. More’n ten million bucks went home that way. Then that got capped, and then stopped altogether. Since then . . . the smart money ain’t been in money at all. It’s been in commodities. Hard stuff. The stuff you and I deal in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wondered how much he knew, and concluded he probably knew everything. How was another matter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I still don’t see where you’re heading with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aw, c’mon. You have a network, I know you have a network. Most guys in this room are selling cigarettes and nylons, one to one. Dodging the MPs in the Tiergarten or Alexanderplatz. Penny-ante stuff. You’re not selling on the streets to desperate Krauts, you’re selling in bulk to the Russians. You got the network. I got the supply. I got the PX at Tempelhof sewn up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I’ve got the NAAFI stores on Adolf-Hitler-Platz sewn up. Why would I need you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What can you steal from the NAAFI? A hundred pounds of coffee at a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Remarkably, this was disturbingly accurate.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Last week one transport alone, just one, flew in fifteen hundred pounds. And I can make half of it vanish just like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A snap of his finger in the air to make his point.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I pay off the guy who processes the paperwork. They ship fifteen hundred, but who counts, all that matters is the paperwork, and on paper the manifest says seven-fifty so only seven hundred and fifty arrives. The rest . . . well.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That must cost.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He ain’t greedy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re businessmen. We’ll come to an arrangement. There’ll be enough for everybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I have partners.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. Three of ’em. We’ll cut ’em in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This bloke knew too much. Safer by far to have him on the inside pissing out than on the outside pissing in.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§115")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Nell and Wilderness made a point of not arriving at Schlüterstraße at the same time. Undoubtedly Rose Blair, the woman on the ground floor (“matron,” as Wilderness called her behind her back), knew, but Nell was confident no one else did. The one disadvantage of pretending not to know each other was that it eased Wilderness’s disappearing act—some days he would be gone after breakfast and not reappear until past midnight. Knowing about his rackets was a finite fact—it was the sum total of what she wished to know. Detail would not help. He was a ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _c('span', [_vm._v("—the common condition of life in Berlin in 1947. That much she knew, that much she accepted. If she could accept ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajoks")]), _c('span', [_vm._v(" from Yuri Myshkin, she could accept Wilderness and all he got up to. Detail did not matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But, today, she had not seen him for two nights, and presumed he had slept back at Fasanenstraße. It was not that she worried—he had all the qualities of a survivor—but she missed him. She missed his jokes. She missed his deftness with words and hands. She missed his unguarded affection.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When she got home a teapot was on the landing outside Erno’s door. An agreed sign. He was at home and was inviting her to take tea with him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh, Lenchen?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("As ever he was at his desk. Conjuring up one of his magical pieces of card and paper, the forger’s origami that put space and freedom between the unfortunate individual and the powers of Occupation. Her “two hundred” souls saved by Erno’s forgeries once the deportation of the Jews had begun was, in all probability, an understatement. Her own papers were Erno fakes. Having added two years to her age to bluff Nicolas Dekker, she had kept them—otherwise she might not even have the job she had.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know, lately I have seen more of Herr Schieber than I have of you, my dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She sat by the iron stove, flicked open the door—an orange glow upon her, as far as the hem of her skirt—her­ legs as disembodied as Erno’s hands under his spotlight.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“His name’s Joe. I call him Wilderness. But . . . read nothing into that. It’s just a rhyme in English. He calls me Breakheart.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah. And I shall read nothing into that either.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wanted to talk. That was why the teapot was there. But he seemed to be saying nothing. The hands moving slowly and delicately across a page she could not see, his face and eyes hidden. They were legs talking to hands. And suddenly it seemed easier that way, a memory of a lapsed Catholic girlhood, of the very few times she had ever confessed to anything . . . or nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Child. Have you sinned?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No. Not this week.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But everyone sins!")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not me. Not this week.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("To the hands she said, “He disappears. Just like Yuri, but never for as long.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The racket?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The racket. But . . . we’re all in a racket. That is Hitler’s legacy. But . . . he says it’s the ‘only game in town’ . . . an English phrase that seems clear enough . . . But . . . there are times I think the game matters more than the end result . . . and that it matters more than me. Then I start to wonder, and so I suppose it all comes down to one question. Why am I with this man?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The hands did not stop moving, the angle of the head did not shift.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What was it your mother used to call you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was her ‘po-faced little angel."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As true today as it was in 1936. Lenchen, yours is a structured life. It was ever thus. At the age of four you would put everything in your doll’s house back in place before you went to bed. Your doll’s house is now your mind, as ordered as your desktop. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you know the old Greek tale of the Hedgehog and the Fox? The hedgehog knows one big thing. The fox knows many smaller things. ‘"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Πόλλ’ οἶδ’ ἀλώπηξ, ἀλλ’ ἐχῖνος ἓν μέγα")]), _vm._v(".’ You are the hedgehog, Joe is the fox. In your structured life he is the random element your unconscious craves. He is the unpredictability you will not quite surrender. Remember, you told me how you met him? What was he doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cardsharping.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Exactly. A game of chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“At which I beat him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All the same he personified the random element. It was why you sat down with him in the first place. It was what . . . drew you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In . . . in this tale of yours. Are the hedgehog and the fox always opposed? Do they fight? Does someone lose and someone win? Is there any chance of a happy ending?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ach. To tell you the truth I cannot remember. Let us not make too much of a simple analogy.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§116")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He introduced Frank to Eddie, Spud, and Pie Face in the Marrokkaner"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “This is a dive. Let’s go somewhere better.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He drove a 1942 Plymouth painted up in drab, a white star on each of the rear doors.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They followed him as far as Gänsefettstraße, in the American Sector, a couple of blocks from the Soviet line.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Why don’t we make cars with roofs?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud said, “Because the army wants you to freeze yer bollocks off in a jeep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank had parked opposite a nightclub—Paradies Verlassen. There wasn’t much left of the upper storeys. It didn’t matter, the midnight blue staircase wound down and down. By the time they stopped in front of a pair of quilted and buttoned, pitted and gashed, scarlet velvet doors that looked as though they’d withstood an attack by the SA, Wilderness estimated they were three floors below ground level.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was deceptive. He knew it would be bigger and better than the Marrokkaner"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("—he would not contend Frank’s assertion that the Marrokkaner"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("was a dive—but he’d anticipated nothing so wide, so high, so . . . well preserved—this place had survived the SA, the RAF, and the Russian infantry. It wasn’t a low-ceilinged smoky room, crammed with tables. It was spacious, galleried, with a dance floor that would allow a hundred couples to take to the floor if they so desired. It was a slice of Weimar-era Berlin in aspic.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A waiter greeted Frank like an old friend and showed them to a table two steps up from the dance floor. Frank stuck money in his hand and ordered beers all round.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was almost spinning on his heels, with his eyes turned up to the star-painted ceiling. Spud gazed around and uttered a simple truth, “Fuck me. The Dog and Duck it ain’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a telephone in the centre of the table, and a serpentine network of tubes wound overhead to end in an art nouveau snake’s head, its jaws gaping over a small black net, rather like the ones on the side of a billiard table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness picked up the phone, but it was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “Before the war they all worked. You could dial anyone at any table. Or if you preferred you could write a message, stick it in the snake’s head, yank on the handle and the pneumatic tube would whisk it up to the top gallery and they’d redirect it to the right table.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pointed up to a swirl in the tubing a few feet above their heads, from which dangled an enamelled plate with their table number inscribed on it—a stylised 21 in a familiar, arty font dating back to the 1890s.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The tubes still work.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . it was a . . . pick-up joint?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Still is . . . you just can’t whisper your sweet nothings any more. You got to write ’em down.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . a single woman at another table . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not decadent enough, Joe. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Any")]), _vm._v(" woman at "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("any")]), _vm._v(" table.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The room was filling up. The noise level was rising.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Cabaret’s about to start. We’ll talk after.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A faux maître d’ walked to the front of the stage, a young woman with slicked back hair and a greasepaint moustache applied somewhat more delicately than Groucho Marx’s, clicked her heels in the Prussian style and announced in heavily accented English, clearly knowing only too well who her audience were, “Und now. A liddle diddy entitled ‘I Sold My Heart for a Peanut Budder Cubcake."), _c('span', [_vm._v("’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The song was not great lyrically or musically—what it was was daring. Whoever wrote for these girls had avoided the strictures on not poking fun at the Allies, by holding up a mirror to Germans themselves—and inevitably Britain and America were reflected in it too.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A dozen scantily clad "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tanzgirls")]), _vm._v(" slipped in and out of the lights, striking angular poses, thrusting pelvises, dangling arms, chanting in a sinister whisper:")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Folgers . . . Hershey . . . Hellman’s . . . Heinz. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Folgers . . . Hershey . . . Hellman’s . . . Heinz.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Just when Wilderness was beginning to think it was a form of hypnotism, two lead singers took centre stage and alternated couplets in English.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("In ’43 we won the war, ")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("In ’45 we lost it.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("We’ve no more room for Lebensraum.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("What we want is Spam.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("Hershey bars and Camel fags,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("We’ll trade for blow jobs and for shags.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("The Millennial Reich for coffee beans,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("This is all our empire means.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("We’ll sell you Prussia if you like")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("For fifty packs of Lucky Strike.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("You can have the spires of Worms and Mainz")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("For 57 brands of Heinz.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("And thank you for the Marshall Plan,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("But we’d rather live in Michigan.”")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("And again . . .")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03"
  }, [_vm._v("“Folgers . . . Hershey . . . Hellman’s . . . Heinz.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hissed out like snakes, the breathy h’s and sibilant s’s making it seem like a witch’s curse from some updated version of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Macbeth")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “If they’d seen Michigan . . . they wouldn’t want to live there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t think anything else rhymed with plan,” said Eddie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I guess not. But . . . if that’s their shopping list who are we not to give it to ’em?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “It’s as if they knew we were coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Kinda brings us to the point, doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could feel Eddie bristling with discontent. Pie Face and Spud simply slurped beer and waited for fate to take its course.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“To put it in a nutshell . . . you guys need me. I could be so good for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud spoke first, “Joe told us. Just one thing. You’re an officer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank grinned the grin of startled innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re not. We don’t like officers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean you don’t trust ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. That too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank turned to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You have this problem too?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“No . . . no, I don’t. Listen up all of you. Frank’s an officer, but he’s an American officer. Not the same thing at all. There’ll be no tugging on the forelock. I mean, look at him. Does he even look like any officer we’ve ever jumped for? Time to think big, lads. Time to think bigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank was grinning now, chock-full of bonhomie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But so was Spud.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pushed his empty glass across the table to Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“So, Frank, you’re one o’ the boys now. Get ’em in, why don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank’s grin erupted into a hoot of laughter. He wheeled around in his chair, hand raised for the waiter’s attention.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Several beers and one lewd, suspender-belted, braless cabaret act later, Spud and Pie Face had headed for the Gents, Eddie was staring at the murals trying to separate one writhing female body from another, and Wilderness found himself the sole object of Frank’s gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Next time bring the Russian.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§117")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Yuri raised not a murmur.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why not?” was all he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Paradies Verlassen had its fair share of all the occupying powers. One more little Russian was hardly out of place, hardly remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud and Pie Face had copped out, leaving Eddie to speak for their interests. Frank had spent like a sailor and persuaded the club to raid its cellars for a Duhart-Milon Rothschild ’34. Not that he even knew the name, he’d just asked for “a bottle of the good stuff.” The waiter had held it up to him and in stage whisper informed him that it had been “liberated” from the cellars of the Adlon Hotel in 1945 and sold on to them by a Russian infantryman. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, whatever,” was all this elicited from Frank. And to Wilderness, “The kind of guy who’d try and sell me Boadicea’s knickers on London Bridge.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All the same, Frank never even asked the price. Generosity was a powerful weapon in his armoury. The soft sell in the hard shell. He’d had no difficulty winning over Spud and Pie Face. Wilderness had no doubts he’d click with Yuri either. Clicking seemed to be what Frank did. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stood and shook Yuri by the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Said, “What can we get you, Major?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri looked at the bottle, turned the label towards himself.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good,” he said, as he always seemed to.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Red’s OK with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course, red’s OK with me; 1934 was verrrry good year for claret.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Better red than dead, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("If there’d been ice to break this shattered it into a thousand pieces. Frank was grinning, pleased at his own joke. Yuri was laughing his croaky laugh and gave Frank one of the spine-cracking slaps on the back that Wilderness reckoned to be his stamp of approval.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank poured. Yuri did the entire routine of sniff, taste, swirl, and swallow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Better than your Coca-Cola. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Рвотная масса в бутылке")]), _vm._v(".” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank’s smile dropped a degree. He looked to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “He says Coke is bottled vomit. And he’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The smile winched itself back into place.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Am I gonna start World War Three over Coca-Cola? Am I fuck!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then they were laughing again, like old friends.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It would have been a relief to leave them to it. The negotiation was simple. The negotiation was non-existent. They merely had to see each other for what they were. Not trust each other—that would be asking too much—but to recognise the common interest. As Frank would have said, “just two businessmen.” As Wilderness did say, “two more buggers on the make.” But Yuri’s English faltered too often, and Frank’s Russian got no further than "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Da")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Niet")]), _vm._v(","), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(" and Nemnozhko")]), _vm._v(". To leave it all to Eddie did not seem quite fair.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They’d reached a point where he could just duck out. Yuri had heard Frank’s pitch and had placed his shopping list—what was hot, what was not. Frank had enough savvy not to ask where half the contents of the PX eventually ended up. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now they were on to the third bottle. And on to Joe Stalin. Wilderness was not entirely sure how they’d got to him, but they were all three of them, Frank, Eddie, and Yuri, the worse for the booze.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In Russia we have saying. Lenin wore soft shoes, Stalin wears high boots.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Like jackboots?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite so, little fatty. Jackboots.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “You mean Lenin kinda soft-shoe shuffled his way through things—and Joe Stalin just tramples on everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “Stride, Frank. Stride would be a better word than trample.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. Seven league boots—you can stride over everything. Like in the Brothers Grimm.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Enough with fuckin’ Krauts,” Yuri said. “We were talking Russia.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank could not resist a joke, a little dig.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I hear Joe Stalin smokes Edgeworth. How about a few tins of Edgeworth for the next time you see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri smiled, not enough for pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Edgeworth is foul. Like smoking dried shit. I like Walnut Plug. Get me more Walnut Plug and let Stalin find his own tobacco.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was startled by what sounded like a rush of air above his head and looked up to see a brass cylinder land in the net of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Rohrpoststation. ")]), _vm._v("Frank reached up and got the cylinder. Inside was a folded sheet of paper.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the scrawl on the page, “Table 21. RAF.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He unfolded it, puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m across the way at table 13. Buy a girl a drink. LT.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He looked out across the deserted dance floor. The girl at table 13 wasn’t a girl. She was a woman in her thirties wearing the uniform of an NKVD major. Neater than Yuri’s. Looking as though she had it cleaned and pressed once in a while, but the same gold star upon the shoulders. Two NKVD majors in one night seemed like one too many. Pickup or setup? All the same, he made his excuses, leaving Eddie to interpret, all sense of fairness evaporating rapidly, and walked across the floor to her table.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had her nose stuck in a book. Her eyes left the book and her hands closed it with pleasing thump when he was about six paces away.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With her right foot she pushed a chair out for him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness sat down, glanced back at Frank and Yuri who scarcely seemed to notice he’d gone. Eddie glared at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the major. A good-looking blonde with big, brown eyes and a perpetual pout to her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why are you sitting here on your own? You could join us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The big eyes opened wider.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why am I sitting here?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("An accent like Frank’s when he was expecting one like Yuri’s.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why am I sitting here? Because I don’t want to know what Yuri’s up to. He hardly ever comes West. Not since his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schatzi")]), _vm._v(" died. And I’ve certainly never seen him in here before. Yuri’s a nice guy, but he’s . . . how to put this . . . bound by the limitations of his origins, and I say that regardless of how far he’s come.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Meaning?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s still a peasant. He knows what he knows and so far, and while he has imagination, it leads to a pretty low horizon. He distrusts what he doesn’t know. Makes him a good intelligence officer. Everyone’s an enemy. He still has peasant barter as his model for any exchange. He’s just switched from chickens and beets to cigarettes and whisky. Makes him good at whatever racket it is you guys are running.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why are you so sure it’s a racket?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Cos you’re sitting over there with Frank Spoleto, that’s why.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Frank’s a wrong ’un?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course he is. A charming, beguiling rogue. Mr. Personality. Another New York smart-ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know New York?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You think I picked up this accent at Berlitz? Gimme a break, kid. New York, London . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“London? Then you probably have a take on me too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Indeed I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m all ears.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . your Russian’s not bad, but the accent’s atrocious, so I figure you’ve been trained up by the British. A crash course in Russian and German, and you speak both with the accent of a cockney wide boy. You should work on that, by the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Funny. I had prided myself on being a good mimic.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Oh, so you can do London posh, can you? The arf arfs and the tally-hos? You just haven’t mastered the Russian version? Look, when it comes down to it you’re not that different from Yuri. Bound by your origins. But you’re a city kid. Gives you an edge. Gives you more imagination and more chances. You have a bigger horizon. Yuri will always be a peasant. You may not always be an East End gutter rat. But, whatever they promised, whatever the British told you, you’re still a low-grade NCO. Intelligence hasn’t made you Bulldog Drummond. You interpret, you eavesdrop and that’s about it. And you’re bored. And when you’re bored you look for a new game. And the black market is the only game in town.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness aimed for motionlessness. Not a muscular flicker to tell her how well she’d hit home. How the hell did she know all this?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m impressed. Brains and beauty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stop trying to flirt with me. I’m thirty-six years old and an officer. You’re a corporal and you’re what twenty-two, twenty-three?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nineteen. Twenty next month.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sheeeit. Green as cabbage. Kid, stop flirting and start looking out. Guys like Frank and Yuri land on their feet. An’ speaking of feet. You ever notice the size of their hands?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, I had as it happens. Frank’s are in proportion . . . Yuri’s . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Portion shmortion. They both have hands like shovels. All the better to grab with. They land on their feet with their hands full. Guys like you . . . touch and go. But guys like Swift Eddie. They fall on their faces. They’re life’s victims. Don’t make him one. Don’t put a guy who’s worth two of you and a dozen of Frank or Yuri at risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah, you know Eddie?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Everybody in Berlin knows Swift Eddie. And right now he’s out of his depth. He just doesn’t know it. Tell me, kid. Did you just introduce Yuri to Frank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dynamite, match . . . match, dynamite.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness let this sink in, wanting to give her the impression that he understood regardless of whether he agreed with her or not. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can I buy you that drink now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus. Is your flirt-mode on automatic?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fine. Buy me a martini.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In all his masquerading as an officer in the restaurants of London, Wilderness had played safe, stuck with scotch without ever acquiring a taste for it. It was what “me” drank. He’d never ordered another cocktail since the day he downed a sickly Tom Collins in the Ritz bar to please Merle. It must have shown.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s the matter? Out of your depth already?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. And I think you knew I would be.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No big deal. You ask the waiter for what you want. Doesn’t matter that you haven’t a clue what you’re saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As if by magic a waiter appeared at their table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("She had him wait a moment as she pitched questions at Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can have a martini with vodka or gin. Needless to say I prefer vodka. The only other ingredients are vermouth, ice, and a twist of lemon. So what’s it to be?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No sugar?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jeez! Who in hell would want to put sugar in a martini?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then make it vodka . . . can I drink with a Russian and not have vodka?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, you can’t. Now, shaken or stirred?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Er . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It doesn’t need any thought. Nobody shakes a martini. Martinis are stirred. Only a complete "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("shmo")]), _vm._v(" would shake a martini.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m in your hands, Major.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Damn right.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She turned to the waiter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Zwei Wodka Martinis, bitte. Gerührt nicht geschüttelt. Wenig Eis.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Es tut mir leid, gnädige Frau. Wir haben kein Eis.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You hear that? No ice. Berlin in summer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you adam and eve it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a pause as the meaning of the phrase surfaced for her, then she started to giggle, and the giggle became an outright laugh. Wilderness saw Frank and Yuri look over for a second to see what the joke was and turn back to business abruptly. Eddie still glared.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was tiny, she was funny, she had deepest-brown eyes like a pair of conkers, a laugh like Ethel Merman, a bosom like Jane Russell. She was gorgeous, she was Russian, and she was unobtainable. And that was fine with him. Flirtation was one thing, and Nell was all the others.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe we should introduce ourselves. John Wilfrid Holderness. Corporal, Royal Air Force. Known as Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She caught her breath as the laughter subsided.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nice to meet you, Joe. I’m Larissa Fyodorovna Toskevich. Major, NKVD. Known as Tosca.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§118")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("As Nell had predicted, from time to time Yuri would simply vanish. Eddie was content supplying their regulars. Once in a while Wilderness would work the Tiergarten with him, watching as another sadistic winter got Berlin in its fist, watching as the calorie count in the ration dropped as quickly as the mercury in the thermometer and the stick insects got brittler and brittler. And it seemed blacker—was there an overcoat in Berlin that wasn’t black? Had an entire age been reshot in monochrome? Had all the colour been looted and shipped back to Moscow?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness concluded that it was during absences like this that Yuri went back to Moscow. All the stuff he was piling up in the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Eisfabrik")]), _vm._v(" at last went to meet orders. An apparatchik having a Christmas party at his state-owned dacha in the woods outside Moscow might be in need of fifty tins of Californian bluefin tuna, twelve bags of Jamaican Blue Mountain Coffee . . . a couple of thousand Pall Mall cigarettes. And the party favours . . . for the Representatives of the People, a dozen bottles of Laphroaig whisky . . . and for the wives, a few dozen bars of Cadum soap. All of which Wilderness had sold to Yuri over the weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They spent a quiet Christmas. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had no more belief than Wilderness but loved the traditions of a German Christmas. Erno remarked that he had “sampled” most religions in his time and thought Hinduism appealing—what other faith encouraged you to take off all your clothes and jump in a river? Wilderness remarked that the Spree was frozen over, but that he was welcome to try.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Christmas Eve tradition of eating carp was honoured. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the absence of carp, or anything resembling carp, Nell shaped a fish out of mashed potato and onion, cut slices of carrots for the glassy eyes, baked it in the oven and added the last sprigs of dill from her window box to make a tail and fins.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno laughed out loud when he saw it, and duly ate his share.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On Christmas Day Wilderness waved his magic "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v("’s wand and produced a fresh chicken—for which he had bartered twelve bars of Palmolive and three hundred cigarettes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("On Boxing Day Nell insisted they walk somewhere, anywhere. Along the snow-covered path of the Landwehr Canal, across the far corner of the Tiergarten and through the Brandenburg Gate, where the Soviet Sector began, to Pariser Platz at the western end of Unter den Linden.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A hurdy-gurdy man had taken to the streets once more. Wilderness had not seen one in all his months in Berlin. He thought that perhaps this was why Nell had come here. For this glimpse of her childhood. For this cranked-out, barely recognisable tune and the colours—the rich colours, the deep reds and the vivid golds of the music box in a city of blacks and whites. Like everyone else in Berlin, the hurdy-gurdy man’s mode of transport was a pram, in which the hurdy-gurdy sat askew, like a cinema organ in miniature. A balding toy monkey perched on top, paw outstretched with a tin cup. Nell opened her purse and dropped coins into his cup.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Something like a column of soldiers was advancing down Unter den Linden. Like, in that it was a slow, unrhythmical march, more of a dead-foot shuffle, a column without discipline or dogged by exhaustion.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A couple of GAZ jeeps swung into Pariser Platz and half a dozen Russian soldiers, rifles at chest height, gesturing wildly with the butt end, cleared a space in front of the remains of the US embassy with what was probably one of only half a dozen words in their German vocabulary—“’"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Raus,’raus")]), _vm._v(".” It went with "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Uhri")]), _vm._v(" and "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Frau")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The hurdy-gurdy man stopped turning his handle. Syncopated Strauss running down like a watch spring.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Let’s go,” Wilderness said. “If these silly sods are up to something I don’t need to see it. They’re unpredictable at the best of times, and this looks like a stunt they mean to stage. We don’t have to be their audience.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell was staring down the street, past the broken stumps of the linden trees at the shuffling group of men and their bored, impatient escorts.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wait for what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She looked up at him, anxiety in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. Just a feeling. An awful feeling.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They put on shows like this just to scare us . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not this time . . . this is . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He did not press her to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("More jeeps drove down the sides of the column, more infantrymen got out, marking out a defended square between the embassy and the Adlon Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After an age that seemed to pass in frosted silence fifty or sixty dishevelled, gaunt men reached the square. A voice behind them boomed out, “Halt!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("They stood, not even looking around. Men in rags that had once been Wehrmacht uniforms—flashes of colour, flashes of rank peeping out from the universal mud hue they had acquired—waiting upon the next order.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next order never came, with balletic speed and coordination the Soviet troops got back in their jeeps, circled the square they had made, and with engines roaring shot off back down Unter den Linden. Several of the men simply fell to earth, into the filthy slush of trampled snow. The crowd that had stood back began to drift forwards staring in disbelief. The eyes of the prisoners did not look back. It seemed to Wilderness that they had been beaten lifeless while still living—when all responses were met with blows it was best to have no responses.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell, let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A hand upon her arm. She wrenched free, ran down the column, around the back to meet Wilderness coming the other way. Six feet from him she stopped. Her hand to her mouth suppressing whatever cry was bursting from her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Right in front of her one of the skeletal men sank to his knees, sat back buttock to heel, still staring out at nothing. His hair a dirty, white unkempt haystack. His clothes, the wreckage of a pinstripe suit. A tin cup on a string around his neck his only possession—all worldly wealth in a dozen cigarette butts. The monkey was richer by far.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell put a hand on his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The man looked at her, as it seemed to Wilderness, without seeing her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Now she knelt, grabbed Wilderness’s hand and pulled him down next to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Daddy, Daddy. Don’t you know me? It is Lenchen—your Lenchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§119")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Max Burkhardt looked about five ten. Wilderness reckoned he weighed less than eight stone. He’d got him naked on the bed and could count his ribs. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had the gas burner roaring and every ring on the hob boiling pans of water.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the absence of any doctor Erno looked him up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No open wounds, no rashes . . . his feet are a mess of sores and blisters. God only knows how far he walked. With his club foot, without the offset shoe, they might have crippled him for life.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell said, “Why doesn’t he speak?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps he doesn’t want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why doesn’t he look at me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can see his body. Battered but intact. I cannot see his mind. Let us just say that too is battered.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno and Wilderness lowered him into the bath. The warmth of the water seemed to seep into him. For a moment his eyes focussed, flashed with recognition at the sight of his daughter. Then they closed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next time Max Burkhardt opened his eyes, they had him in bed, in between the sheets, blankets piled deep.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Clean,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Erno nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Clean is good,” he said. “Clean can be ecstasy. Up there with food and orgasm.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt para-style-override-20"
  }, [_vm._v("§120")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell and Wilderness slept on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her father made hardly a sound. His breath no more than a distant sigh. The beat of a moth’s wing on air.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought he was dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why do they do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Russians?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. Keep men so long. The war is over. What is my father to them? A man they found on the street defending Berlin with a pitchfork and a potato peeler?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There are millions. The speed at which they let the POWs go, there’ll still be men in Soviet camps in 1967.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why him? Why now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know,” he lied.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§121")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On the twenty-ninth, Max sat up in bed. On the thirtieth, he sat at the table for breakfast. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness made porridge. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He liked porridge the Scottish way, with salt. Max needed calories. He spooned a hefty tablespoon o"), _c('span', [_vm._v("f")]), _c('span'), _vm._v("Tiptree raspberry jam—a NAAFI perk reserved for officers—into Max’s bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Max finished it slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Stared down into the bowl, then looked intently at Nell and Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Und wenn du lange in einen Abgrund blickst, blickt der Abgrund auch in dich hinein,")]), _vm._v("” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Later Wilderness quoted Max’s words to Erno.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s that arse Nietzsche again,” he said. “You gaze into the abyss and the abyss gazes back. Who knows what he meant? Abyss, shmabyss. It was Germany, it was Russia? Ach.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It was just a bowl of porridge.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§122")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On New Year’s Eve, the small, darkest hours of January 1, Wilderness awoke to a blast of freezing air that was coiling itself around him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The window was open. And the bed was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pulled on his shirt and trousers and climbed out into night and cold and winter.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The building next door had a flat roof. At the far side a figure sat, wrapped in a blanket, gathering a coat of snow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When he touched Max, he knew he was dead. The life had leeched out of him a couple of hours ago. He was in the first stage of rigor. Ice in his hair. Ice on his eyelashes. ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§123")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“This has happened before. In 1945. My great-uncle. I still don’t know how he died. Only that he did it himself. He dug his grave. He lay down and he died. It seems odd that people can just choose to die. But he did and so did my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My father killed himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh my God. Why did you never tell me? How . . . how did he die?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He died much as Max died and for much the same reason. He took off his clothes and walked out into the North Sea one day in 1946. If he hadn’t drowned, the cold would have killed him in minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He had been in the war from start to finish. He survived everything. Everything but what he saw in himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is that the abyss? Our selves?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“I don’t know. You’ve heard me speak of Rada? Rada Lyubova? She killed herself the same year. I know of no one who looked deeper into herself than Rada. Two world wars and a revolution had not driven her to suicide. But something did. Some accumulation of grief, some final straw.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And yet you did not tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Everything takes time. It takes years for people to get to know one another. I know your body far better than I know your mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have we got years, Wilderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§124")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_vm._v("January 1948")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("A cremation without service in Wilmersdorf—in the American Sector. Secular to the point of silence. Nell did not even ask to receive and scatter the ashes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri turned up in full dress uniform. Bright blue against the snowbound cemetery. Nell hugged him. Wilderness stood with Erno a respectful distance away. Watched one of the huge hands gently patting her on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then she came over to Erno. Hugged him. Then Wilderness. Stood back looking up into his eyes. He’d never seen her cry and this occasion would be no different.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing has changed,” she said. “This changes nothing. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir? Was sind wir?")]), _vm._v(" We are what we were. We are as we were. A man who was dead came briefly back to life and now is dead again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is Yuri waiting?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. He waits for one of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then let me be the one.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Go home with Erno. I won’t be long.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri was sitting at the wheel of a huge pre-war Krasny, painted up in field green, a Red Army star on each door, a plume of white smoke trailing from the exhaust.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness got in beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you drop me back at Grünetümmlerstraße?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Конечно")]), _vm._v(", of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The car moved off, passing Erno and Nell. She did not look at them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You did this, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you told Nell to be in Pariser Platz on the twenty-sixth?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you didn’t tell her why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. Suppose it had all gone wrong? Supposing Max Burkhardt had not been among those set free for Christmas?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Suppose he had died on the march? He must have walked two hundred miles.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Over that I had no control. Joe, do not overestimate my power. I did what I could. I got Max bumped to the top of a list of prisoners of war who could be released. I could not commandeer a jeep or a railway train.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or a decent pair of shoes?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or even a decent pair of shoes. I had no contact with Max. I rearranged names and dates on pieces of paper back in Moscow. Once they had set off I knew what would happen. My people would escort them as far as the Gate and then abandon them. And, believe me Joe, they were the lucky ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How long?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Что как долго")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How long have you been setting this up? How long were you planning this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Since May 1945. Since the day Marie told me her husband had vanished in the Battle of Berlin. Of course, he could have died in that battle. And if he didn’t, a Volkssturm member is twice as hard to find as a Wehrmacht soldier—no uniform, no rank, no number . . . no papers. When Marie died I did not stop looking. Only from then on I was ­doing it for Nell.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For Nell?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Yes, Joe . . . for Nell. You and I have this in common. We do for Nell.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All for Nell? Wilderness could not bring himself to believe this for a single second. It just added to the complicated mixture that was Yuri. “Who is Yuri?” had run through his thoughts a thousand times this last year. He came back to Nell’s phrase, the same one Peter-Jürgen von Hesse had used back in Hamburg—turned it over in his mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir? Was sind wir?")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§125")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("That night Nell said, “He never asked about my mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She curled up in the curve of his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do you want of life, Wilderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I want . . . to watch sunset all day . . . to see forty-four sunsets in a single day.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s nice. You make that up?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I wish I had.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There are times I think my life has scarcely begun . . . and then I think of all that is gone and gone for ever . . . and then with a twist of my mind I am back at the beginning . . . I am Max Burkhardt’s little Lenchen again . . . back at the jumping-off point . . . and my feet have never left the ground.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jumping-off point. That was the phrase Rada had used. What is a place of birth but a jumping-off point?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You came back to your jumping-off point.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where else could I go?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anywhere on a map of geography. We are talking maps of the heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I know . . . you told me, you are a Berliner.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t make me sound corny, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I wasn’t. But loyalty to a city is like loyalty to anything else. It may exact a price. Loyalty can be like a ball and chain. People can be like a ball and chain. They can drag you down into the grave with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are we talking about my father?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, we’re talking . . . in the abstract.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you telling me neither people nor place matter to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. But what matters most are ideas.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Am I an idea?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re every idea I’ve ever had. Or shall ever have.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That sounds so sweet, so romantic . . . but it’s bullshit isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A plane turned in the sky above them, and the roaring heart of piston engines smothered the sound of the beating heart of the woman lying next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§126")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Nell insisted they return to work the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Grief is pointless. Grief kills. Grief is what drags you down into the grave.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He awoke to find her fully dressed, even to her topcoat. A pot of coffee cooling on the gas ring.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She stood by his bed, nimble fingers doing up her buttons, and said again, “Nothing has changed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He grabbed a cup of coffee and took it back to bed with him. She’d want at least a quarter of an hour between her arrival at Schlüterstraße and his. He fell asleep and when he woke up again it was half past nine.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness got to Schlüterstraße late. Another fragment of a morning Fraggy-bashing, punctuated by the refined sarcasm and acid disdain of Rose Blair. It was gone ten and some. In time to find her cobbling together her tenses or elevenses, toasting bread and making coffee on the tiny paraffin stove she kept on top of a steel filing cabinet. She did not, ever, offer to share her coffee with him. He might well have declined anyway—the smell of NAAFI coffee had become like body odour over the last year. It clung to Spud and Pie Face. He wondered if it clung to him. The olfactory stigmata of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re late,” he heard as he passed her door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Late for what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You have a visitor,” Rose Blair replied with heightened emphasis on the “or.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He opened the door to his office.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones was in the visitor chair—which showed some respect—with his feet up on the desk, which didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had been a year, almost to the day it had been a year.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just in from Blighty, are we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones swung his long legs to the floor and stood.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“By all means, let’s not stand on formality. No salutes. No hint of recognition that we might both be in His Majesty’s service.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I get all the sarcasm I need from the bird in the next office. In fact she exceeds my ration. And you didn’t come to Berlin to swap salutes and handshakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have I called at a bad time?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“You know damn well you have, or Miss Blair isn’t doing her job.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Y’know, Joe. I think becoming a corporal might have gone to your head.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then make me a sergeant and see if it goes to me feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Glasshouse, Joe. Never forget where I found you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A pause that might be deemed respectful on Burne-Jones’s part.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I had heard about your girlfriend’s father as it happens. Sounds dreadful. As though the war never ended for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Him and thousands like him. If the Russians get you they can string that war out into infinity.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones rummaged in his briefcase and slapped a folder on the desk. Game over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why don’t we both sit down? There are things you need to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness pulled the file towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Inside were three typed sheets and a mug shot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jean-François de Villefranche. Civilian attached to the French Military Government. What we have on him is all in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness flipped through the pages.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the problem is?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We think he might be one of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Queer?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Commie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Working for the Russians or just sympathetic?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The former.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do the French know?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. And if they did they’d handle it with all the delicacy of a man trying to make tea while wearing boxing gloves. Broken china all over the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“To know. To be certain.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not for you to know. We turn him, we turn him in. Entirely down to circumstances. His address is in there. Apartment in the French Sector. Turn him "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("over")]), _vm._v(". Tell me what you find.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For a minute Wilderness read on in silence. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then said, “There’ll be a shopping list.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fire away. I’ll take notes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two sets of lockpicks. Half a dozen screwdrivers in all sizes. A penknife with a carbon steel blade. Black trousers. Black shirt. Pea jacket. One of those peaked caps every other German bloke seems to wear. Rubber-soled shoes, size ten. A canvas bag. A blanket. Scissors to slice it up. A couple of rolls of sticky tape. Pigskin gloves, as thin as they come. A jar of concentrated nitric acid and an eyedropper . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bloody hell . . . slow down. What’s the acid for?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You surely don’t want me to use gelignite?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, I don’t want you to leave any trace!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It may be necessary. Why don’t we get it just in case?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you can’t crack a safe the way you did Rada’s then don’t try. No one must ever know you’ve been there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. All the clothing should be secondhand and looking like it, except the gloves. Get them new.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sounds like I’m kitting you out as a cat burglar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fassadenkletterer")]), _vm._v(". That’s what Berliners call them. But the English has more poetry.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And a camera.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And take your gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rose tells me you never carry it. Take it when you do this job, and any other job that comes up.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness nodded, wondering how much dust it might have gathered after twelve months in a drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And a vehicle? You can hardly do this using a jeep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Public transport.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ve seen too many Scotland Yard films. Thieves escaping in a fast car. It’s bollocks. Easiest way to lose any tail is on foot and on an underground train. He lives in Blaumontagstraße. There’s a U-bahn station quite close. And if it restores your faith in the traditions of the Yard . . . throw in a magnifying glass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My, you really have got to know Berlin, haven’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s what you asked for.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. You’ll have all this by tomorrow morning. You do the job tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I do the job tomorrow afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What in broad daylight?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’d do it in narrow daylight if I knew what it was. You just tell me what I’m supposed to be looking for and leave it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§127")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness had not pulled a job since Cambridge. Just putting on the gloves was pure delight. Picking the lock was too easy. Not leaving a mess took more time than robbery. He photographed every document in the apartment, and he searched for anything hidden. Few people had imagination when it came to hiding anything. Under the mattress, ­under the bath, in the cistern, behind the gas fire. Villefranche had papers from the Allied Kommandatura at the back of his shoe rack. Wilderness photo­graphed them and then put them all back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones smiled as he took the film from Wilderness. He did not tell him what it was he’d found. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He never did.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness burgled a dozen apartments over the next few weeks in every sector except the Russian.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’d love to turn over one of the bastards. But what’s the point? We know who they work for.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was thinking more of Germans living in the East.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Too risky. You get picked up on the far side of the line . . . you’d be gone for good. Not a damn thing I could do about it. You said it yourself . . . ‘if the Russians get you . . .’ As things are you get picked up this side of the line, I’d still find myself disowning you.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§128")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT"
  }, [_vm._v("March 1948")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Not a moment too soon,” Rose Blair said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Burne-Jones phoned. I rather think he expected to find you here. Instead—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The telephone rang. She picked it up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness heard her say, “Yes. He’s here now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then she thrust the phone at him without a word and went back to making toast.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones said, “Get over to Elssholzstraße. You’re interpreting for General Robertson. My sources tell me Sokolovsky is up to something. You don’t just translate. You take mental notes. I want to know everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then Wilderness heard the click as Burne-Jones rang off. No goodbye, nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s at Elssholzstraße?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Rose Blair had a mouthful of toast and gulped it down to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Allied Control Council. Or did you think Germany ran itself?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m their interpreter, it seems.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then you’d better get over there. They start at half past two.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Surely Eddie Clark’s their English–Russian interpreter?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course, I stood him down not half an hour ago. Burne-Jones wants "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("you")]), _vm._v(" there. After all, you’re supposed to be some sort of spy aren’t you? So, try spying for a while—at least you won’t be needing your kid gloves and your rubber-soled shoes. And they probably won’t want to buy any coffee either. I imagine Eddie’s sold them a lifetime’s supply by now. It’ll be a change for you on both counts I should think.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Elssholzstraße lay in Schöneberg, in the American Sector—a little over a mile away—in a Prussian palace that had been the Central Court before the war, the Kammergericht.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When Wilderness got there General Clay’s Cadillac, its Stars and Stripes fluttering in the March breeze, was already parked in front of the palace. So was General Robertson’s Rolls-Royce—a happy little fat man leaning on the bonnet, nose-deep in a volume of Penguin "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New Writing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie smiled when he saw Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sent for you have they? Must be serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How often you done this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Done what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Interpreted for Robertson.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Lots. Every time I drive the general, I do the chatting too. Not much to it. Stenographers take down everything in three languages after all. Anything Sokky says in Russian, you pass on to the general in English. You never translate what he says into Russian. Leave that to the other side. Stick to that and you can’t go wrong. Personally, I think Sokky speaks English, and for that matter probably French too, but he’ll not utter a word except in Russian. And afterwards they throw a nosh-up that makes us look like beggars. Caviar, cream cheese . . . you name it. Other ranks included. And they get narky if you don’t eat. I quite fancy an afternoon off, as long as you bring me out some grub. I’d miss the grub.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness saluted and introduced himself to Robertson. He was seated just to the right and just behind the general. He rather thought he might be the only man in the room without a row of ribbons on his chest. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then Marshal Sokolovsky walked in—“Hero of the Soviet Union” with five Orders of Lenin to his name, and to his chest. Forty or more medals, not as symbolic ribbons but real medals, pinned to his tunic. Marshal Sokolovsky reminded him of nothing quite so much as a Christmas tree. Or a walking scrapyard. Wilderness wondered how the man breathed. Wilderness felt . . . naked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ten minutes later Marshal Sokolovsky rattled out. No caviar, no cream cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§129")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Eddie was still leaning on the Rolls, still reading.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness came up running.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look sharp, Ed. Robertson’ll be out in a second and in a stinker of a mood.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sokolovsky just bunked off.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . he’s Russian. That’s what they do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It had all the hallmarks of permanence. A great fuck-you, ‘"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Xуй тебе")]), _vm._v(".’ Meet me at Paradies at six. I have to report to Burne-Jones, and I have to find Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§130")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Just like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He let General Clay get as far as currency reform before he walked out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do you mean by ‘let’?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He was bristling. From the moment he walked in he was never not going to do this. He wasn’t listening to Clay or Robertson or the French bloke. He was playing with them. He’d no intention of staying. Whatever the plan is it’s in place. And I took a gander at the reception room as I was leaving. Normally they lay on a feast. There was nothing. They’d no expectations of entertaining anyone. No more free lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The line went quiet, so quiet Wilderness wondered if they’d been cut off.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then Burne-Jones said, “That’s it then. It’s over. Nobody’s kidding anybody any more. As you so aptly put it, no more free lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§131")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“What did he mean by ‘over’?” Frank asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quadripartite rule of Berlin is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quadri what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Four sectors, four military governments trying to act as one. That’s over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh is that all? Well . . . fukkit . . . I thought you meant the peace was over.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t hear any tanks rolling.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank . . . try rolling with this. The Russians have given up. The temperature has changed . . . it may not be a raging hot war . . . but it might be, to paraphrase Harry Truman, a bollock-freezing cold one.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And that affects business how exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. Depends on what the Russians do next. They’ve got us surrounded after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You think they’d cut us off?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud and Pie Face had sat silent throughout, as had Eddie—but it was Eddie’s turn.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They can cut us off Frank, and they will.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah . . . they wouldn’t dare . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But Wilderness was nodding.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aw shit, kid . . . just when life was getting so fucking sweet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Geld schmeckt süß")]), _vm._v(",” said Eddie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, whatever,” said Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§132")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On April 1 Russian troops stopped every American train on the ­Frankfurt–Berlin line at Marienborn on the Eastern Zone border, citing “technical problems” and introducing new “temporary regulations.” Despite the date it was not a joke. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On April 2 General Clay ordered USAF C-47s to begin airlifting supplies into Tempelhof. He wasn’t joking either.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That evening the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _vm._v("s gathered at Paradies Verlassen. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Spud was last to arrive. He put a plain, off-white packet in front of them, like a cardsharp letting the punters see the full deck before he shuffled. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wossat?” Pie Face asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud tipped out two cigarettes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Try one.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face stuck one in his mouth and lit up. Frank picked one up with a muttered, “Why not? First in two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud was poised and smiling now.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face exploded, red-faced and coughing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fuck me! What is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank coughed once and stubbed the cigarette out in the ashtray.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus H. Christ!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Spud said, “They’re called Droogs, the tobacco’s Bulgarian, and they’re everywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face took another drag.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suppose you could get used to ’em but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But it tastes like dried shit?” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah. It does. Dried dog shit to be exact. Where d’you say you got ’em, Spud?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tiergarten, where else?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How much?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Twenty-four reichsmarks a pack. But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“The bloke selling ’em will tell you the price in marks but only takes dollars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness admired the way Spud had strung this out.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Any chance you recognised the bloke?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno his name, but he was one of"), _c('span'), _vm._v("Yuri’s ‘Silents.’”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “So the bastard’s undercutting us? In our own briar patch?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hardly the point, is it?” Wilderness replied.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK Corporal Smart-ass, what would be the point?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“The point is . . . he’s taking only dollars . . . but he’s paying us in reichsmarks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So,” Frank mused. “He’s building up a stash for something.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’d guess he has no intention of getting stuck with any reichsmarks when the big day dawns—our marks or their marks.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Weeeell . . . fuckim.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think we need a word with Major Myshkin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("They thinned out at the cabaret—little of it was to the taste of Spud or Pie Face. (“Wot’s the point of strippers who never get their bleedin’ togs of")]), _c('span', [_vm._v("f")]), _c('span', [_vm._v("?”)")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s the plan kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What Spud said just confirms what I’ve been thinking. We need to change tack.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I been thinking the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Me too,” said Eddie.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now . . .” Frank went on. “I’ve said all along that we should be in commodities. I was right, and that was then. But right now, I’d say we need to be in cash.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Eddie answered, “It’s perfectly clear to me, Joe. Currency reform’s definite. It’s going to happen. It changes the game. They mean to control inflation, get rid of rationing, get rid of the black market—above all else, get rid of the black market. What it all adds up to is an end to barter of any kind. The economy normalises . . . nothing is scarce . . . nothing is hooky . . . and those of us who take easy pickings off it all are out of business.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had sounded to Wilderness like the opening of one of Eddie’s not infrequent “Workers’ Educational” lectures. The result of reading Penguin books and the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Manchester")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Guardian")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ed’s right,” Frank said. “We’re better off out of goods and into cash. Means we take a loss at conversion, but we’ll ride it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness made them pause. Sat silent while Frank got more drinks in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Spit it out, kid. I feel like we’ve just suggested skinning your grandmother and tanning her hide.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” said Wilderness. “It’s not going to happen that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sez you. Currency reform’s just a matter of time. Goddammit, we flew the bills in by the million as long ago as January.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t believe in coincidence. Everything happens for a reason. Yesterday, the Russians cut us off . . . today they flood the West with cheap, dodgy fags.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah . . . and tomorrow they’ll plug us back in. It’s just a stunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No it’s not. It’s a teaser. It’s a foretaste of what they’ll really do come reform. They’ll turn this place into a fortress. West Berliners will get their deutschmarks . . . they’ll revel in having real money for a day or two . . . the shops will fill up with all the stuff that’s been hoarded for months till the price was right . . . then the gates of hell will slam shut again . . . West Berlin will become an island in a Soviet Sea and stuff will become as scarce as it was in 1945. So . . . I say we stay in goods.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jesus H. Christ. Ed, pass the bottle. The kid is frying my brain.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie, pushed the bottle towards Frank, looking at Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So, what do we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“First, we stop taking reichsmarks altogether.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That cuts our market.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And we spend what we have. Start offloading reichsmarks now. Buy anything and everything you think we can sell. And when we sell we take only dollars. Pay over the odds if it gets rid of reichsmarks. Let’s have nothing left to convert when conversion comes . . . because we’re going to be in no position to convert . . . that’s when all the questions will be asked and we’ll find ourselves nicked. From now on we’re a dollar economy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just like Yuri, huh kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As I said, we need to talk to Major Myshkin.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt para-style-override-20"
  }, [_vm._v("§133")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“Bastards. Fokkin’ bastards!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri, you’re raking in every dollar West Berlin has with your crap fag racket. You don’t want to get stuck with worthless currency, and nor do we. From now on it’s dollars. You pay us in dollars.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s not a threat. It’s just terms of business. We supply you with very good stuff. For your dollars you get Pall Mall and Lucky Strike. For their dollars West Berlin gets Droogs. Think about it. We’re not a flea market . . . Fortnum & Mason.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri was sitting on a case of Jack Daniel’s. The "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Eishaus")]), _vm._v(" was stacked with booty. They’d brought the whiskey in by padding their jerry cans. Forty-eight bottles a trip—trips beyond counting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look under your own ass, Yuri. You’re sitting on twelve bottles of the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri didn’t look as angry as he sounded, and it seemed to Wilderness to be merely tactical to be angry with them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK, bastards. But there is a scratchy-my-back here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What kind of scratchy your back?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Penicillin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Penicillin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure . . . we got clap running riot in Red Army. Everybody pissing razor blades. Hadn’t you heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They’d never dealt in drugs or medicines of any kind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness turned to Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can we get penicillin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I guess so. Turns out we’re stockpiling everything against the day these guys cut off the West . . . you and the top brass seem to think alike on that score . . . so it stands to reason we’re stockpiling Band-Aids and aspirin . . . and probably penicillin.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you guys do mean to cut us off don’t you, Yuri?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Da, da . . . but the English have a phrase for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They do?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Business as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§134")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Driving back Wilderness said, “You’d better act as banker from now on.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“I need to rake in every reichsmark we have. It’ll all be easier if you take everything, spend it, stockpile . . . and collect the dollars off"), _c('span'), _vm._v("Yuri.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jeez . . . you think our guys will go for that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’ll do what I tell ’em. Besides, the pickings will be too good to resist.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Still thinking big, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is there any point in thinking small?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How long do you think this Russian stunt will last?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. But maybe you’re right, maybe it’s a stunt—I prefer to call it a dummy run. Could last a week, could last a month. They’re testing us. But when currency reform comes in it’ll be real.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§135")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The little blockade fizzled out in ten days. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Two months later, on June 18, the deutschmark was introduced by the Western zones of Germany. It was to be valid in all the sectors of Berlin, but the Russians refused to accept its validity. Something resembling panic preceded this, as Berliners went on a forty-eight hour spending spree—paid every bill, bought any object to unload the potentially worthless reichsmark. By then, Frank had divested the ")]), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Schieber")]), _c('span', [_vm._v("s of most of their reichsmarks, and had sheds out at Tempelhof filled to the rafters with what he called “the solid stuff,” as opposed to “the folding stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On June 24 the Russians blockaded Berlin for real. No stunt. No dummy run. Road and rail links to the Western sectors closed and only the air lanes remained open.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("On June 26 the airlift began. The British and the Americans flew in everything. From coal to candy. RAF Yorks and USAF Dakotas buzzed by Russian fighters in the biggest game of “chicken” since the end of the war.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The sound of planes landing and taking off replaced the sound of gunfire as the ambient noise beneath Berlin skies, and the black market rose from the dead and exploded like an atomic bomb.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§136")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Nell had none of this and dutifully accepted her free allocation of deutschmarks and exchanged her reichsmarks at the set rate. It exasperated Wilderness. He had grown accustomed to her po-face, it was part and parcel of her unshakable virtue, but he could not understand the lack of self-interest.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Gypping yourself is just stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell did not understand the word.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Gyp . . . from Gyppo . . . you know, Gypsy? Swindling yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How quaint. Does English use other races as derogatory verbs?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . yeah . . . Jew means much the same thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell was appalled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . I Gyp and Jew myself. So fucking what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d never heard her swear in English before.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The same day, round about seven in the evening he got home to find a meal prepared from civilian rations. Meagre and unsustaining, but corresponding roughly to what Berliners now had to live off. Less than they had before the blockade. All the canned food Wilderness had brought her was piled up on the dresser.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“From now on,” she said. “We live like Berliners. We eat like Berliners. We are Berliners.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Every Berliner buys hooky stuff on the black market. You don’t eat hooky food and buy hooky clobber, you’re not a Berliner. Everybody has a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v(". Everybody!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The word hit home. It was tempting to ask her what she’d do if"), _c('span'), _vm._v("Yuri turned up with a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("pajok")]), _vm._v(" of Russian goodies off-ration, but he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell said, “Very well. You may bring me eggs.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So po-faced, so patrician, even as her virtue admitted a vice.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eggs? Bleedin’ eggs, is that all?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That night as she slept and he didn’t, he could smell the scent he had given her—L’Aimant by Coty. When she stopped wearing that he’d believe her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the morning he woke to find thin ersatz coffee, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Blumenkaffee")]), _vm._v(", a confection of roast acorns and who-knows-what, bubbling gently on the hob.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He tipped it away and made Java.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt para-style-override-17"
  }, [_vm._v("§137")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was late July. Almost a month into the new game with the new Russian rules. Demand was high. They could have sold anything and everything twice over in the West, and still the demand from the East to be satisfied. The taps ran dry, the coal ran out and the electricity came and went like the man in the weather house. Still, they made money.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was hard not to feel complacent.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Drinking alone was a strange pleasure. Wilderness hardly ever chose it—it arose if others were late and if no one in Paradies pinged him through the pneumatic tubes. That, after all, is what they were there for, and more often than not used not person to group or group to group but solitary individual to solitary individual. He had come to think of it as civilised. When the social code, the sexual code, dwindled to a tongue-tied mess, this was clear and direct. He’d even heard of men receiving notes as simple as “"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Möchten Sie ficken?")]), _vm._v("” Fancy a fuck?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He heard a cylinder land and reached up for it.")]), _vm._v(" "), _c('p', {
    staticClass: "letter para-style-override-21"
  }, [_vm._v("Still creaming it, kid? You have to admit your Uncle Joe is good for business. The business of the USSR is business . . . ah. No that was some other guy, some other country. LT.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The club was half-empty, he could see clearly to Major Tosca’s table, her face buried in a book. She must have known he’d got the message by now, but didn’t so much as glance back, so he concluded she’d said what she had to say. If she wanted him to come over, she’d look up, smile, blow him a phony kiss. She didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank arrived. He was getting fatter. Sweating through that beautifully tailored uniform in the summer heat. Perhaps Frank’s pleasure was strictly food and drink. After that first girl he’d bought with soap, there’d never been so much as a mention of a woman, and if you couldn’t get picked up in Paradies, you couldn’t get picked up anywhere. He made tough-guy, “we’re all men of the world,” almost backslapping crude jokes about Wilderness and Breakheart, as he insisted on calling Nell—as though somehow the sexuality, the scent of their relationship had spread to him and those around him, like the undisguisable, acrid smell of a lubricated condom—but that stance just masked his celibacy. Wilderness figured Frank was one for hookers. Since everything was a commodity to Frank, he probably preferred to buy his women. It was neat and business-like. He would enjoy haggling. And no messy emotions to contend with. Eddie? Eddie was a different case. Women would just clutter up his ordered life. There were times Wilderness thought that he and Frank might well be the worst things that had ever happened to Eddie. They’d taken his little fiddle and . . . and Eddie had been quite happy with the scale on which he’d fiddled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank summoned a waiter. Beer and wurst. Pile on the pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re not eating?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Too hot to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s that you’re drinking?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“White wine. An Orvieto from Italy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where in Italy?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought you were an Italian-American?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Every American’s a hyphenated American. Don’t mean diddly. So happens Spoleto used to be Spoletowski or some such gobbledygook. Who gives a fuck? I’m a damn Yankee. Let me taste.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pity. I was about to tell you this was made only twenty-five miles from Spoleto.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Showing off your Reader’s Digest "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Book of Facts")]), _vm._v(" again, eh kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah. I’m educated I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness pushed the glass across the table. Frank sipped at it and pulled face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How can you drink this piss? Tinted water. Goes to show . . . if they don’t make it in Milwaukee.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . but you’re not a social climber, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank missed or ignored the irony, just as Eddie sauntered in. A smile upon his face, glee withheld, a surprise in the offing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank got the waiter’s attention and held up two fingers, doubling his beer order.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s got you?” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What day is it today?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I dunno, twenty-fifth or twenty-sixth.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No . . . today is the day we all enter cloud cuckoo land . . . the dwarves and unicorns have finally landed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He held up a 5RM note. Something white stuck to it. No bigger than a postage stamp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is the new Russki Mark. "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Новая валюта")]), _vm._v(". "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Novaya")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Valyuta")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Issued today. Already got a nickname . . . "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Tapetenmark")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Through his first mouthful of bread and wurst, Frank said, “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wallpaper, Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was grinning like a Cheshire cat as the punchline hove in sight. He waved the note in front of them—a mother’s hankie shaken in the direction of a departing train and child. The white sticker fell off and floated down onto the table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("First Wilderness and then Frank, swallowing hastily to avoid choking but still showering them with crumbs, burst out laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie grinned from ear to ear.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They just took the crappy old ostmark and stuck a coupon on it. You know what they make the glue from?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could not speak for giggles. Frank was spraying out crumbs and wurst faster than a Maxim gun.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Taters,” Eddie concluded. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took another dozen notes from his pockets and waved them in the air and a shower of confetti covered the table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Tosca looked up from her book. The stern librarian annoyed by a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness snatched a note out of the air.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t believe it. I don’t bloody believe it. It’s pure Mickey Mouse. What a bunch of clowns. Potato paste. I don’t bloody believe it. I used to make that to stick pictures in my scrapbook when I was a nipper. They all fell off too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then, the merest shift of gear, a moment of high seriousness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, we’re not accepting this crap are we?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you kidding. Dollars only. You think I don’t listen to you? Dollars only, you said. On the nail. Yuri wouldn’t dare offer us shit like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§138")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Nell had known Ernst Reuter as long as she could remember. He and her father had worked alongside each other at City Hall. Since she returned to Berlin she had not seen him, but then, who had she seen? He had been elected mayor, but the Russians had refused to acknowledge this. He was de facto mayor of West Berlin—a place that didn’t quite exist. The Russians could obstruct and divide—they could in all probability assassinate him or simply kidnap him off the streets as they did with hundreds of others, but they didn’t . . . and short of that they could not shut him up.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That summer, the summer of the roaring planes and the power cuts, Reuter addressed Berlin in the open air half a dozen times. Each time the crowd was bigger. In a crowd it is impossible to tell whether you are one of three thousand or thirty thousand. Later on newspapers will tell you—and none of them will agree.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Late in August, Nell stood at the eastern end of the Tiergarten in front of the Reichstag. She had learnt of this meeting from one of the American RIAS vans that toured the British and American sectors, using loudspeakers to create street-corner radio.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Reuter was not wearing his beret—his trademark as recognisable as Churchill’s cigar and FDR’s cigarette holder. Today he looked less like a bohemian and more like a leader, even to the carnation in his buttonhole.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“People of this world, people in America, in England, in France, in Italy! Look at this city and recognise that you must not give up this city, you must not give up its people . . . Berliners don’t want to be an object of exchange . . . we can’t be traded in, we can’t be negotiated and no one can sell us . . . In this city a bulwark, an outpost of freedom has been erected, which nobody can give up with impunity. Anyone who would give up this city and its people would give up a whole world and even more he would give up himself . . . People of the world! You also should do your duty and help us through the times that lie ahead of us, not just with the roar of your planes . . . but with the steadfast and indestructible guarantee of the common ideals that can secure our future and secure yours. People of the world, look at Berlin! And people of Berlin, be assured we will win this fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("“Völker der Welt, schaut auf Berlin! Und Volk von Berlin, sei dessen gewiß, diesen Kampf, den wollen, diesen Kampf, den werden wir gewinnen!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The crowd did not simply drift away. Inspired by what they read between the lines, they surged towards the Brandenburg Gate, through the arches and into Pariser Platz, just as a routine Russian patrol was heading the other way.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Russian GAZ jeep was surrounded. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At first the four soldiers sat still as though waiting for the tide to pass.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stalin ’"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("raus")]), _vm._v(", Stalin ’"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("raus")]), _vm._v("”—a cry soon taken up by hundreds of voices. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell followed and found herself edged aside as British soldiers forced their way in from the Western side.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then the Red Flag of the Soviet Union floated down from the top of the arch—someone had climbed up the internal staircase and cut it loose from the quadriga. As symbolic a gesture as the day in May 1945 when the first Russians to reach the Brandenburg Gate had put it there.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What Red Army soldier worth his ration could sit by and watch? All four got out of the jeep and tried to retrieve the flag—using the butts of their rifles they forced protesters aside only to find they had waded into jelly, an amorphous, amoebic mass that parted around them only to flow on and enclose them once more. And still they were no nearer the flag—and the flag was ripped to shreds and a cloud of red confetti blew past their heads in shards of fury.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No one would ever know who fired the first shot.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A stone thrown into a pond.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The crowd spreading out in ripples.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And at the epicentre was not one jeep but two.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The second jeep was British, and the driver lay slumped facedown over the wheel with blood gushing from the wound in his side.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§139")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("They were talking only of something and nothing. Passing the time at Paradies Verlassen. Chewing the fat as Frank put it in a tasteless image.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was doing a crossword—in German. Frank was on his fourth or fifth beer and holding forth or fifth on baseball—as with any sport Frank launched into, Wilderness tuned out and nodded at regular intervals.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“God didn’t mean anyone to be left-handed. Ain’t natural. I mean, you look at the number of home runs Bill Dickey scored in the 1940 season compared to DiMaggio . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Pie Face burst in. Saved Wilderness from throttling Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We got trouble!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Some argy-bargy in Pariser Platz. Spud blundered into it and got himself shot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “Cool it, kid. Just sit down and just tell us what happened. Who shot Spud?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But Pie Face was not in any mood to be cooled. It seemed to Wilderness that his rage was hungry and needed to be fed, and was better fed standing, looming over them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. There was plenty of Russkis about, but our blokes were there too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Americans?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah, Frank. You was late again, just like 1914 and 1939. Never there when you’re fuckin’ needed.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness felt Frank stir and kicked him under the table. Frank said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is he OK?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. He ain’t dead. Our blokes got an ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who got the jeep?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fuckin’ Ada, Joe. Is that really the next question? Who got the jeep? The Russians got the jeep, din’t they? It was in the Russian fuckin’ Sector wasn’t it? But you needn’t worry. Spud had delivered. All they’ll find are empty jerry cans. He was on his way back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, can you find out which hospital?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. A couple of phone calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A stony silence. No one spoke and Pie Face did not sit. Turned around like a slowly spinning top, as though searching for words that eluded the tip of his tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “You need a drink, mate.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Maybe I do, Joe. But not with you lot. You blokes are playing too fast and loose for us both. Joe, Joe . . . the way you’re going on you’re going to get us all killed. We’ve been lucky till today . . . but if you think about it for half a minute we could have been busted any time. It’s a bleedin’ miracle the MPs have never turned us over. We just sailed by right under their noses. There’s blokes been banged up in the glasshouse for a fraction of what we’ve done. We’ve got away with everything short of bloody murder. But it ain’t searches now . . . it ain’t even some copper too stupid to do a proper search or who’ll turn a blind eye for a bung. It’s guns and bullets. And it’s poor bastards getting shot. And it’s over. It’s all over. So, sorry an’ all that, but include me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness spoke to get in ahead of anything stupid Frank might say.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“That’s OK. I understand. We’ll divvy up and you’ll get your share.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah, mate. You keep it. I don’t want it. I won’t touch it. It feels like dirty money all of a sudden.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§140")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("When Pie Face had gone, Frank said, “Did he just tell us to go fuck ourselves?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, but there was another point to what he said.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m all ears.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We need another way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We do?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One day they’ll stop us going into the Soviet Sector altogether. One day quite soon. Our MPs have already stopped going in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They can’t do that. It’s not part of the deal. Yalta or Potsdam or Timbuktu, whatever. They come over here whenever they like. We get to do the same. OK, so there’s more checks and more barbed wire. We’ve always passed checks. No one was wise to us. Even Pie Face admits that. It’s not as if they’re going to rip a British jeep apart is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It occurred to Wilderness that “they” might be doing that right now, but he let Frank finish.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’ll frisk all the civilians they want. I’d be amazed if they bother with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I meant our own people will stop us. It’s beginning to look dangerous. They won’t want to provoke incidents. Spud getting shot is already an incident.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So what are we looking for? A flying carpet?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” Wilderness said. “A tunnel.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§141")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("“What I need is . . . a tunnel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“God I hate irony.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where’s the irony?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We cremated a man who could have shown you every tunnel under Berlin last January.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your father?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Berlin City Engineer. Until the Volkssturm that is. He knew Berlin belowground better than he knew the streets above.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell turned over to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “But . . . Berlin can’t do without a city engineer. So . . . who has your father’s job now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She turned back to him, tired or exasperated or both.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It hardly matters, does it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course it matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Drop it, Wilderness. Just let this one go.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You won’t help me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why should I help you with your . . . rackets?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’ve always known what I did. And . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s only money. We don’t hurt anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell lay back on the pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As I said. I hate irony. The current city engineer is my father’s old deputy. Andreas von Jeltsch-Fugger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“It’s no sillier than your Smythe-Brownes or your Bentinck-­Cavendishes. He’s the father of Werner Fugger, the boy you so annoyed the night ")]), _vm._v("we met and on every occasion since, unless I’m very much mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not much irony in that. He’s a prick.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Up on one elbow now, flicking tiredness away with a jerk of her head and an errant lock of her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Wilderness. That’s not the irony. The irony is that after the war, the British being so suspicious of men with aristocratic names, all those "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("von")]), _vm._v("s and "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("zu")]), _vm._v("s, made the assumption that they were all Nazis and for nearly two years Andreas could not work, until he got his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("—got his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" from you! Because, after all, you’re not a snob are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The sarcasm and the irony fought to the death in his mind in less than a second, and he said, “Can you get him to meet me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I want nothing to do with your rackets. I told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I told you. We’re harmless. Honestly.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Harmless?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She squirmed nearer to him, nudged his left arm with her head until he wrapped it around her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hold me, stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do I need a reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not. But you have one all the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I saw a man shot today. A Tommie. Just like you. Harmless, just like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§142")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He was surprised the name had not stuck in his mind. But the man had. He’d been one of the first he’d interviewed at Schlüterstraße, in the first or second week of February in 1947. The face was the face of an aristocrat, the sort to drive the Pooters and Yatemans of England to seething, silent fury—the long, aquiline nose, not unlike the late SS Obergruppenführer"), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("Heydrich, the domed forehead, the fuller top lip, the pale blue eyes. And the middle two fingers and the top joint of his thumb on the right hand were missing—a war wound from the Russian front in the First World War. The arm rose weakly, hand to his lips, every so often as he dragged on a cigarette from a small black holder wedged between the stumps of the missing fingers. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It had its upside,” he had told Wilderness. “I cannot hold a rifle, cannot pull a trigger or shoulder a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Panzerfaust")]), _vm._v(". Hence I was of no use to Hitler, even when he rounded up the old men and boys in ’45.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("He’d been a member of the party, for the token reasons any employee of the city would give and had hung Hitler’s portrait on his office wall as instructed. At the time, Wilderness had not sought to enquire further and had certainly never logged the precise nature of the man’s occupation.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With no Yateman-Pooter to stand over him and argue the toss, Wilderness had granted him his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" and wished him well. He had warmed to the man—it was, perhaps, his asking him if he liked Berlin that tipped the balance—as though he’d been talking to a welcome visitor of his own age and interests, not an interrogator half his age with the power to lock him up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And then, a ludicrous sense of courtesy had led Wilderness to show Andreas von Jeltsch-Fugger out, and he had caught his first glimpse of Nell. As Jeltsch-Fugger reached the staircase, Nell had dashed down from the next floor, pecked him on the cheek and he had embraced her with his good arm.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It flashed by him now like a silent film upon a dusty scrim.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell had been the memory. A memory so strong she had erased the context, just like the old Dick Powell song from before the war, “I Only Have Eyes for You,” and for a year or more Jeltsch-Fugger had been just one more German, a German he had happened to be seeing out when the vision that was Nell first hit him. Were the stars out tonight?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How pleasant to see you again, Herr Holderness,” Jeltsch-Fugger was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness gently freed himself from the starless daydream. And the Nell of memory merged with the Nell who was in the room with them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The room was a small, empty café in a side street off Potsdamer Platz where three of the four Allied sectors met—three not four, but who bothered much about the French? Once, a year or two ago, there’d been a painted boundary criss-crossing the cobbles and the tram lines of Potsdamer Platz, demarcating the sectors, British, Russian, American. They had been scuffed out of existence by a million feet, and no one had bothered to repaint them. Wilderness was not wholly certain which sector the café sat in, the British or the American. Ambiguous. And anonymous—but for the name, Der Kater Murr.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had thought better of inviting Frank and Eddie. If this worked they’d find out then. If it didn’t, they’d never know.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell was effusive. Her reservations were not overcome, but Wilderness knew she’d never be less than demonstrative. Things—no, people—­mattered too much to her. Jeltsch-Fugger was, after Erno and her father, only the third person he’d met who’d known her as a child—or, as she put it herself, “before,” and before what need never be stated.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("She hugged him to embarrassment, both arms around his chest—Jeltsch-Fugger smiling politely at Wilderness over the top of her head.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Breaking loose she said, “This is my godfather. One of nature’s gentlemen. And this is my lover. One of nature’s rogues.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Au contraire, Hélène. The last time we met Herr Holderness was courtesy itself.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And the broken right hand was extended for Wilderness to shake.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They sat at a corner table. A round of small talk as the waiter set coffee in front of them. The smell alone was telling, best NAAFI dark roast. Eddie had sold it to the proprietor personally.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How can I help you, Herr Holderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m trying to . . . to ease the tension between East and West . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s a smuggler, Andreas,” Nell chipped in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Difficult times, Hélène. The man who finds you half a pound of butter today may go down in history as well regarded as any man who fought at Austerlitz or Waterloo. I say again, how may I help you, Herr Holderness?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I need a tunnel under Berlin. There are things I need to get from West to East without interference.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Things?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness tapped the side of his cup gently with a teaspoon.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . I see . . . baccy for the parson, brandy for the clerk, and coffee for the commissar?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Who would have thought a German aristocrat knew Kipling? All the same it saved Wilderness precious words.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell tells me you know the tunnels better than anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jeltsch-Fugger tilted his head slightly, the merest nod, a sip of coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Nazis flooded Berlin’s tunnels as the Russians advanced in ’45. Breached the Spree and let the river in. I assume you knew this? So, we are looking at something deeper. Something below the swamp on which my ancestors built Berlin, below the impermeable clay. I believe there is such a tunnel. I was with Max Burkhardt the last time he inspected it in 1939. I didn’t make the descent, but I was there. I cannot vouch for the state of the tunnel after . . . after . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“After what the RAF did to Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Quite. But I know the two entrances.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And it crosses the line?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Runs under the Spree at the island, from Monbijou Park to the zoo, just by the flak tower. I’d say it crosses the line pretty well under Pariser Platz. About a hundred and fifty feet under Pariser Platz.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s as deep as the Piccadilly Line.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“It is indeed. I had the pleasure of inspecting your London Underground in 1932. But this was built without boring shields or machines of any kind. Neither I nor Max were able to find out precisely when it was built. But that in itself made the subject all the more fascinating. One can weave fantasies around such a structure. We think it was built most likely in the reign of Frederick Wilhelm II, which would be the last decade of the 1700s. Certainly no later than 1805. That’s the year Monbijou Palace ceased to be a royal residence for spurned wives and ageing dowagers. After that I cannot think why anyone would have bothered to build it . . . and only royals would have had the money. In fact, even allowing for the folly of kings it’s both amusing and impossible to imagine why it was built. It goes nowhere.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought you just said it went to the zoo?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In 1800 that was nowhere. Just an obscure corner of the Tiergarten. The zoo has been there scarcely a hundred years. It would have made more sense if the tunnel ended at Bellevue. The construction of palace and tunnel would have been undertaken at roughly the same time. An escape route for queens and princes? But who knows? An error in navigation? Unlikely. But there it is, ending nowhere. And since the RAF all but flattened Monbijou in ’43, beginning nowhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you can find it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A pause, the kind that might be called pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You were kindness itself the last time we met, Herr Holderness, and it pains me to have to ask something of you in return. But—the devil drives.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ask away, thought Wilderness. Coffee, butter, sardines in tins. Whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ask away,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You can still issue "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("? I need a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" for my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No problem. I’ve met your son. We don’t bother much with people that young.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, Herr Holderness. My other son.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell might have been stung. She swung around to face Jeltsch-Fugger in an instant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Andreas! No!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jeltsch-Fugger smiled his smile of well-bred tolerance and said to Wilderness, “Might you give us a moment alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No,” Nell said. “You give us a moment alone. Joe, outside!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing as they scraped back their chairs. Jeltsch-Fugger signalled the waiter for another coffee, unperturbed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the pavement, anger made Nell seem suddenly bigger than she was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I won’t let you do this, Wilderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Andreas had three sons. Kurt died over England flying for the Luftwaffe. Werner you know. It is Otto he’s talking about now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . we don’t take it out on kids. There’s even a category called youthful indiscretion or some such. God knows, even Hitler’s secretary got off scot-free under that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Otto isn’t a kid. He’s the eldest. He served throughout the war.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was obvious where this was headed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So tell me the worst.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Andreas wants you to issue a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(" in the name of SS Obersturmbannführer Otto von Jeltsch-Fugger.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He worked for Heydrich in the SD. It’s a miracle he isn’t on trial or in prison already, but he isn’t. And if you give him a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v(", he’ll get away with everything!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Get away with what exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. Do I need to know? We all know what the SD did. Wilderness I cannot, I will not let you do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness’s “no” was accepted graciously. They finished their coffee discussing books and music, Wilderness’s fondness for Brahms, Jeltsch-Fugger’s love of English metaphysical poetry. As they parted on the pavement, Jeltsch-Fugger deemed the meeting most enjoyable, hoped they would all have the opportunity to get together under different circumstances soon, and handed Wilderness his card.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at the sky, remarked that it “might come on to rain later,” doffed his hat to Nell and walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It might come on to rain? How bloody English can a German get?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I told you, Wilderness. He’s the most civilised man alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She kissed him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thank you. Thank you, thank you, thank you. I know what it cost you. Joe Holderness resists temptation. I should get that chipped in stone.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§143")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("That night, in bed, Wilderness said, “If his big brother was in the Gestapo . . . how can Werner go on saying what he says? Talking the kind of bollocks he talks. How can he go on denying what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You said it yourself. He’s just a kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So were you during the war.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But I saw Belsen with my own eyes. Werner fought the Russians when he was fourteen in the Volkssturm. He too believes what he saw. That the Russians were a savage enemy. It’s a short hop from that to wanting to believe they faked Auschwitz. Though I flatter myself I’ve knocked that one out of him, he still wrestles with the same question they all do. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir? Was sind wir")]), _vm._v("? If you were French or Dutch, the Nazis occupied your country. If you were German they occupied your mind. Try to think of Werner that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So . . . all the same, he’s just a kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. He’s harmless, as you say of yourself. Only difference is I really believe he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And you don’t believe I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She turned over to sleep, squirmed her backside against his hip.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Wer sind wir? Was sind Wir")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A whisper and a mantra.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nell. I’m alive! Where are you? Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A scrawl upon a thousand walls.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§144")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He called"), _c('span', {
    staticClass: "char-style-override-17"
  }), _vm._v("Jeltsch-Fugger from the office in Schlüterstraße. Arranged to pick him up in the staff jeep by the Adlon Hotel, opposite the gigantic picture of Josef Stalin, in benign, paternal pose and festooned with medals. The Russian welcome to the Soviet Sector. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was pouring with rain, the wettest summer in thirty years, battering down on the canvas roof of the jeep, and rivulets that coursed down Stalin’s face—the tears he’d never shed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You have the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You have the map?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Indeed. I shall show you the eastern end, Monbijou. I doubt you need me to direct you to the zoo, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just one thing. Nell is never to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course. We are criminals bound together by a dark and dirty secret. Over the Schloss Bridge and left on Burgstraße.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The S-bahn overground metropolitan railway was no respecter of history or architecture. It sliced the “heart” of Berlin in two at Alexanderplatz, and it clipped the corner of Monbijou Park en route from the Börse station to Friedrichsstraße Station, passing close enough to have detracted from what had been a fairy-tale palace at the time the S-bahn had been built just after the Great War. After the new war it wasn’t quite a ruin, but Wilderness could not think of a single word to describe the state it was in. Once it had fronted the river, much as the Naval College at Greenwich had done, with a garden of topiaried pine trees leading down to a shining white balustrade at the water’s edge. It was an easy leap of imagination to see gilded barges moored at the steps, waiting upon the pleasure of queens and princesses.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At some point during the war, the Germans had bricked up its high windows. At some point during the war the British had caved in much of its roof.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He parked the jeep under the S-bahn between the stilts that propped up the elevated track. It was dark under the S-bahn, illuminated only in flashes—sunlight through the latticework, sparks from the electric line running overhead. It was like looking at an old-fashioned magic lantern show. And what he saw by the light of the lantern was an ornate cast-iron kiosk, rather like a Parisian pissoir—bigger, more elaborate and capped by a small spire that resembled nothing quite so much as the spike on a pickelhaube. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How did that survive?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I would imagine,” Jeltsch-Fugger replied. “That the railway line provided cover. Otherwise it might be in the same state as the palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re a Berliner?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Through and through. Apart from summers spent reliving the last shreds of the ancestral-country-house-life to please my parents, I’ve never lived anywhere else.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then you must be appalled by what has happened to the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m an engineer not an architect or an historian. You are asking me to mourn Monbijou? Fine, catch me one night with half a bottle of schnapps inside me and I might. Indeed if the palace appeals to your taste for the rococo, take a good look. The Russians mean to demolish it—the Kaiser’s schloss too. If they stay here ten years I predict they will flatten every structural symbol of imperial Berlin. But what is a flattened city to an engineer but a chance to build? And if you want my professional opinion, the survival of this absurd piece of cast iron under the S-bahn throughout six years of war is less surprising than it making it through the previous hundred and fifty years in one piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’d almost think no one had noticed it was there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s more true than you could know. I think you’ll find curiosity is not second nature to Germans. Once its purpose had been forgotten it probably never occurred to anyone to ask. It was there. That would be enough for most. What "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("is")]), _vm._v(" is.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why didn’t they knock it down when the S-bahn was built?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They didn’t have ‘permission’ would be my guess—if they had they would have done—permission from God knows who, and in the absence of a god they left things as they found them . . . and as I just said, what is is. Curiosity has no part in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jeltsch-Fugger produced a ring of oversized keys, some of them six to eight inches long. They approached the kiosk.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“One of these should fit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The third key turned the lock. The door swung open, groaning for oil.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Remarkable,” Jeltsch-Fugger said. “No one has opened this for the best part of ten years. Until Max and I came here just before the war, I doubt anyone had opened it in more than a century. Even then it opened without effort.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked inside. A wide spiral staircase, winding around a central void.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A hundred and fifty feet you said?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Give or take.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jeltsch-Fugger lobbed a pebble down the shaft. It seemed an age before Wilderness heard the clunk.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Point taken.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Will you be going down?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I want to see both ends first.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Jeltsch-Fugger handed the ring of keys to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You might let me have it back, when you have finished.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They spread a map across the bonnet of the jeep. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Berlin as it had been in 1938. Five years into The Thousand-Year Reich."), _c('span', {
    staticClass: "char-style-override-3"
  }), _vm._v("A monument in the making.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("A few drops of rain spotted the grey-white paper. Jeltsch-Fugger glanced up at the tracks above and held out a hand. Nothing more fell.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You will appreciate, the original map on which Max found the tunnel is in a state not unlike confetti, and far too precious to bring out in a storm.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took a red crayon and traced the course of the tunnel on the pre-war map.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("It followed the route of the S-bahn under the Spree and the island as far as Friedrichsstraße, then curved south directly under Pariser Platz, and then ran parallel to the Charlottenburger Chaussee as it sliced under the avenues that radiated out from the central circle like the strands on a spider’s web to end just north and slightly west of the Zoo Flak Tower.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness said, “It passes under an awful lot of lakes in the Tiergarten.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All of them artificial and quite shallow. Max walked the length of the tunnel in ’39. Nothing would stop him—not even his club foot. It was as though he had been given the key to Pandora’s box. And he assured me it was dry. But, of course the flak tower didn’t go up until ’41. If anything was likely to affect the tunnel it’s the tower. I’ve no idea how deep it goes. I’ve never been in it. When your people blew it up this summer they blew up only what was visible. The damn thing could be like an iceberg. For all I know it goes down all the way to hell. But . . . I am alarming you unnecessarily. The tunnel and the tower are at least a hundred metres apart and the tunnel, as you can see, curves in from the north.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can I keep the map?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can I keep the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Why are you doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("The abrupt change of subject did not dent von Jelscht-Fugger’s sangfroid.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you think I can write off a son, Herr Holderness?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think many a German has written off the family Nazi.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The family Nazi. Like the idiot son sent into the church, or the importuning uncle hourly expecting a cheque in the post? The skeletons in all our dynastic cupboards. And I cannot. I cannot write off my family Nazi. Why I accept my son—note I do not say forgive—is none of your concern. Let us merely agree that I do. You should concentrate on what does concern you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And that is?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nell Burkhardt, Herr Holderness. She should concern you more than the internal strife of my family. Give no more thought to my sons. Think of Nell. You are all she has.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§145")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The Zoo Flak Tower was formidable—at a height of one hundred and twenty feet, and with walls thirty feet thick, quite possibly the densest concrete structure on earth. With its own internal reservoir and diesel generators, it had resisted a Russian siege in the April of 1945 somewhat in the manner of a Norman keep, and had been taken only by a negotiated surrender. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Built to prevent the RAF from dominating the skies over Berlin, it had become a hospital, a repository for Berlin’s art treasures and the looted gold of"), _c('span'), _vm._v("Troy, and finally a shelter. It was thought that up to thirty thousand people had taken refuge there in the last weeks of the war. Meanwhile, the antiaircraft guns mounted on the upper storeys lowered their sights and continued to harass the Soviet forces as far away as the Reichstag.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was too significant to leave standing, visible above the treetops for miles around. The smaller tower to the north had succumbed to dynamite in the June of 1947. Later that summer attempts to blow up the main tower had failed. At last, at the end of July 1948, after drilling and packing more than thirty tons of dynamite the British had managed to blow it up. And down. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It could not be worse, thought Wilderness, but he did not say it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie did.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, bloody Norah. How the effin’ ell are we going to shift that lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the detritus of the flak tower. Countless tons of shapeless concrete and twisted steel. A small mountain of rubble bulldozed up at the spot von Jeltsch-Fugger had indicated for the tunnel entrance, a far corner of the Tiergarten, tucked away between the Landwehr canal and the S-bahn, mud-caked and rain-spattered. Another hundred yards and his tunnel would have achieved perfect symmetry with both ends under the elevated railway tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “Do you think Jelly-Fucker got it wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked at the map, at the small red x that marked the spot like pirate treasure, looked from the map to the small army of British sappers clearing, carting off the remains of this vast symbol of Hitler’s power, dumping it here there and everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I don’t think he did. I think the entrance is under there and I think he didn’t know all this had been dumped. He hasn’t been back to look. He just knew we’d finally blown up the flak tower. And how many times have we tried to blow it up and failed?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He led off in the direction of the tower, across ridged tracks of mud that sucked at his shoes, through a sparse, balding forest of blasted, leafless trees—everything the Berliners had not fed into their stoves last winter, but would chop down at the next turn in the seasons. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank keeping up, Eddie slouching behind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You got a plan, kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, when do I not have a plan?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The tower lay on its side, looking to Wilderness like a ship run aground, tilted on its keel—or a giant top hat that had been sat upon, its five storeys of solid concrete concertinaed and crumpled as though made of something far less substantial.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As they reached the site, a Royal Engineers sergeant had his back to them, barking orders at the unfortunate bunch of erks who’d drawn this particular short straw.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sergeant?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The man turned. A little, red-faced bloke, his gut straining his belt, his arms bulging with muscle, all but bursting out of the leather, sleeveless jacket that, it seemed, only the sappers got to wear.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked at Wilderness with irritation, and just about saluted when he recognised rank on Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sir,” he said, without a hint of deference. “An international delegation, p’raps?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nope,” said Frank. “We’re what you might call private enterprise.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“His kind of enterprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was pointing past them. They turned. Eddie had caught up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hello, Stanley.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eddie. These blokes with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes, Stanley. My business partners.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t need any coffee today, mate.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s not about coffee,"), _c('span', [_vm._v("” ")]), _vm._v("Wilderness said, hoping to get them to the point before they started on news from home or the price of sausages. “We want you to tip your rubble somewhere else, and clear a way through that lot for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mind telling me why?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. I do mind. We’ll make it worth your while. You can be sure of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like I said. I don’t need no coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then tell me what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“To open up that lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“To clear a way to the middle. You can leave a circle of rubble for cover. Somewhere in the middle is a . . .” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For a moment Wilderness could not think what to call it. The last word he wanted to utter was tunnel. And pissoir might be meaningless to the man.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hole. We need access to a hole.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nole? You gotta nole?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How much?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Stanley feigned thought, then said far too readily, “Soap. I wants a hundred bars of Lux, the good stuff with a nice niff to it, and twenty apiece for my three lads wot drives the diggers and dumpers. Take it or leave it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Stanley, clearly, saw himself as a wheeler-dealer. Wilderness hoped he was not smiling. The man had named an astonishingly low price. He asked for a minute, stepped back with Frank and pretended to confer.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The man’s a clown.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. What we do now just mumble till it looks kosher? Like we’ve actually discussed it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They went back, Stanley and Eddie were indeed discussing news from home and the price of sausages.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “Soap’s OK. I can get soap. S-O-D.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“S-O-D?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Soap on delivery. I need to know you guys can do what you promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do what we fuckin’ promise? We’re British sappers not some nancy American outfit in pressed trousers and shiny shoes! We’re muck and boots we are. We built Pentonville nick. We built the Albert fuckin’ Hall! An’ if yer believe Rudyard Kipling, Noah used our blueprints for his fuckin’ ark!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So you can do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“")]), _vm._v("’Course we can fuckin’ do it!”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§146")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It took less than a day. The following morning Wilderness, Frank, and Eddie stood in a ten-foot-high circle of rubble, Hitler’s Stonehenge, staring at their “hole.” Once there’d been a cast-iron kiosk on top, just like the one still standing in Monbijou. There were fragments of it scattered everywhere. The pickelhaube aslant in the mud as poignant as the feet of Ozymandias.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bloody rotten luck,” Eddie said. “We should have got here six weeks ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Six weeks ago we didn’t need it,” Wilderness replied. “Spilt milk, Eddie.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("He looked down the shaft. The spiral staircase seemed to be intact, but really, there was only one way to find out. He flicked on his torch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK, follow me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They both shook their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah,” said Frank. “Not me. This isn’t me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do you mean, it isn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie said, “Small dark spaces. Never could abide them. Like being locked in the cupboard under the stairs. Me grandad used to do that to me when I’d been naughty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure,” said Frank. “Small dark spaces. Give me the creeps. Hell, I don’t even ride the New York subway.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean you’re leaving it all to me? I’m on me tod? You pair of bastards.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("All the same he set off.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s going to take me about two hours to get to the other end and back. I reckon it’s about two miles each way. If you aren’t coming then you’re on guard duty. You watch my arse, right? You don’t leave this spot till I get back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’S’OK,” Eddie said. “I brought sandwiches and a thermos.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was surprisingly dry. Everything about it was a tribute to German engineering, a hundred or more years before the phrase was famous. He could stand up in it at the centre, right between what seemed to be the stone version of railway lines cut into the floor. The tunnel was pretty well the same shape as the tunnels on the London Underground, but smaller, and arched in dressed stone rather than steel panels. It was easy to imagine that whatever the original purpose of this tunnel, some sort of wagon or carriage had run along here, hauled by donkeys or pit ­ponies—if, that is, it had ever been used. It was old, but it was pristine, no signs of wear. As von Jeltsch-Fugger had said, who knows who or what it was meant to convey and where? Ending at the zoo looked like error or abandonment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The tunnel curved without any sharp bends. Nothing had collapsed, despite everything the RAF had dropped on the city above, despite the Nazis last-ditch attempts at scorched and flooded earth. The worst he had to contend with was the occasional puddle, lots of dust and countless cobwebs. He felt much the same about rats as Eddie did about the cupboard under the stairs, but he saw no rats. The spiders had the place to themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It took about forty-five minutes to reach the other end, to stand a hundred and fifty feet below the kiosk von Jeltsch-Fugger had shown him. The ascent was tiring, and the reward was the light cutting through the iron mosaic of the kiosk, the dappling pattern it made on his uniform and the smooth click of satisfaction as the key von Jeltsch-Fugger had given him turned in the lock.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was going to work. The adrenaline surge of certainty carried him back to the zoo end in half an hour, to catch Frank and Eddie each trying to fleece Stanley at pontoon.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Find what you was after?” Stanley said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“More or less,” Wilderness equivocated. “I need one more favour.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’ll cost yer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t know what it is yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’ll cost yer whatever it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you rig up a pulley, something like a block and tackle down the shaft, and another one at the far end?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. Where is the far end?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Monbijou.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Russian sector?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Russkis is extra. It’ll cost you another fifty bars.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank slapped down his hand of cards and feigned exasperation.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jeez, do you think I’m made of soap?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness said, “If that’s your price. But I want a trolley, something like a small railway maintenance wagon. You can throw that in for the price.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wot? Like a push-me-pull-you? Suppose I can. What gauge? Did you measure it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I did. Nought point seven of a metre.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nought point bleedin’ seven of a soddin’ metre? That’s wot I hate about "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Le fuckin’ Continent")]), _vm._v(". Everything’s fuckin’ metric. What’s wrong with an honest-to-God gauge like four foot eight and a half?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There being nothing to say to this, Wilderness said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took a pencil from his pocket, scrounged an old envelope off ­Eddie, and drew what he wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Flat bed, optional sides, right? Something that can be left off if needs be. Between the wheels, so the centre of gravity stays low, I want a motorbike battery. Light enough to haul up the shaft for recharging. Big enough to do the job. At either end I want a pair of brackets on the uprights, I want headlamps on the brackets that can be swapped over front to back for the return journey. Across the uprights at both ends I want a bar at this height.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He held a hand at nipple height to make his point.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t want to have to bend all the time. Wrap these bars in something soft, like leather. OK?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pullman class?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“S-O-D again?” Stanley concluded.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Damn right,” said Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§147")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("In Paradies Verlassen that night Frank said, “What is the plan, kid? Pulleys? Railways? Are we the Union Pacific now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think you’ll find they went West, Frank. We’re going East. But, yes, we are indeed a railroad. An underground railroad. Think of it as a literal underground railroad. This time it’s soap, coffee and scent not runaway slaves.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank understood him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We could . . . we could move more shit than we ever did on the surface. There was I thinking we’re fucked, and . . . and y’know . . . we just moved into the big league.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Yep. The tunnel’s dead flat. A wagon well oiled should roll at a touch. We could move a thousand pounds of coffee as easily as a packet of fags.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie emerged from his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Bierstein")]), _vm._v(" sniggering and blowing bubbles of lager.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If we could get a thousand pounds of coffee!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, you leave that one with me,” Frank said. “Things are hotting up, things are really hotting up nicely.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was almost magical timing. At that point Larissa Tosca walked by, smiled at Joe and Eddie, stuck her tongue out at Frank. Wilderness hadn’t even noticed she’d been sitting there, and he relied on the constant buzz of Paradies to render any conversation private. But where had she been sitting. How close? At her usual table or closer?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Half an hour and two beers later Yuri joined them. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness brought him up to scratch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good,” he said. “Good good.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll need a bloke or two at the other end, whenever we send something through. Pick a couple of big buggers, they’ll have to haul the load up the shaft.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good good,” said Yuri, and Wilderness began to think it might be all he would ever say. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he said, “Sugar. As much as you can carry.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank looked perplexed, “Sugar? Just like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sugar I can shift. Sugar I can sell. Either you have sugar or you haven’t. If not I go elsewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stepped in, “No, Yuri, you can’t. No one else will sell to you in the quantity we can. Anybody else will be taking the risk of passing the checkpoints, and if your blokes find sugar they’ll just confiscate it in Joe Stalin’s name, sell it back to West Berliners and you won’t get so much as a shufty.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shufty? What is shufty?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “What Joe is trying to tell you is that we’re a partnership, Yuri. You, me, Joe, Eddie. We’re in this together. Why would you even think of looking elsewhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yuri croaked out a sour little laugh. “Partnership? All you dogs want is my dollars.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he swilled beer, wiped his lips, and as his hand passed over them he began to smile.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The old team, eh? OK, comrades. How soon can you get my sugar?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank and Joe exchanged glances. Wilderness took a punt.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Friday. We can do this Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When Yuri and Eddie had left Frank said, “I can get him two hundred and fifty pounds by Friday, but will Stanley have us up and running by then?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§148")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("In the absence of Spud and Pie Face it occurred to Wilderness that there were risks and gains in recruiting afresh, and that the risks outweighed the gains. The gain would have been labour—helping hands, to shift the equivalent of one fat man in sugar across Charlottenburg, into the zoo park, onto the pulley and down the shaft. Instead, Frank declining to dirty his hands with manual labour, it was left to a wheezing, sweating Eddie to lower the sugar down the shaft to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Fat Stanley had knocked up a Heath Robinson masterpiece. A solid oak deck, greased bearings, steel wheels. A flick of a switch and the tunnel was filled with light. A touch of the leather-bound bar and the trolley rolled. But Wilderness had not allowed for heat. Pushing was not like walking. After a mile of pushing the “one fat man” on the trolley, Wilderness stripped down to his underwear. Hotter, but also slower. He’d allowed forty-five minutes for a journey that took ninety. What would happen if Yuri ever asked for 250 pounds of butter? It would be close to rancid mush by the time he got to the other end . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When he flashed his torch up the Monbijou shaft Yuri’s voice echoed down in anger.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Черт возьми, где ты был")]), _vm._v("?” Where the hell have you been?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He got quicker.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The next Sunday it was back to basics—coffee again. An all-embracing smell that seemed to fill the tunnel. And a lighter load. He got the trolley to Monbijou in just under an hour, his back and thighs aching like a galley slave’s.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It occurred to him that he had grasped the shit end of the stick.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He said so to them both in Paradies.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can’t be helped,” Frank said. “I ain’t fakin’. Nor is Ed. Small, dark places, kid. Small, dark places.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pushed a vodka martini across the table to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A little of what you fancy. You earned it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This, Wilderness thought, was condescending crap. Eddie could not, would not lie about claustrophobia, but Frank?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just tell me it’s worth it Frank and stop soft-soaping me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank leaned back smiling hugely, the paterfamilias, all-but-hugging in his bonhomie and so full of . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Greenbacks, Joe. On the nail every time. Yuri pays up. Good as his word. We’re creaming it. Gotta hand it to you, when Uncle Joe started his blockade I thought we were screwed.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His voice dropped to a stage whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But we’re richer than ever. If this blockade lasts all winter, we can retire to the Ba-fuckin-hamas.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The grin was infectious. Wilderness sipped at his vodka, and couldn’t help smiling back at the gleaming, white, all-American teeth Frank was flashing at him. That was the awful seduction of the con man—you wanted him to be real, you wanted to like him and him to like you.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bahamas,” he repeated to himself, swirling the martini, looking back at Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bahamas?” said Eddie. “I think I’d prefer Skegness.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§149")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-13"
  }, [_vm._v("Wilderness knew better than to boast or say “I told you so,” but one day towards the end of August, as he and Frank were trying in vain to get to Der Kater Murr, a surge of schadenfreude proved almost irresistible.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The scuffed and faded line that had marked the meeting of sectors at Potsdamer Platz had become a fortress of barbed wire and steel posts. Some poor bugger was on his knees sloppily painting the white line back where it had been and being barked at by a British corporal. As for the MPs, there were more than he could count.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said for him, “Well kid, you were right. It’s our side cutting us off. I think you found your tunnel just in time. Sure as fuck . . . no more jeeps.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§150")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Smuggling became like adultery. A secret that would never trouble the conscience, but which required a strategy to avoid detection. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness kept a complete change of uniform, “bought” from RAF stores at the cost of three bottles of Courvoisier, at the bottom of the zoo shaft, but hardly ever had recourse to it in full. He pushed the trolley wearing only his underpants and took to bathing back at Fasanenstraße, with the same brand of soap that Nell favoured in the bathroom at her flat—an unadorned Palmolive green, with, luckily, no particular scent to it. It was soap that smelt of soap. A household rather than a boudoir item. The trick was to meet Nell of an evening exuding the right combination of cleanliness and grime. Never with wet hair, the biggest giveaway of all. Never soaked in the stinking sweat of hard labour . . . the merest glow of manly aroma that might have been acquired in a dishonest day’s graft.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Tinned food was the worst, it bulked small but weighed heavy. Frank would dump five hundred tins of tuna at the top of the shaft and somehow imagine that this would be moved as readily as five hundred bags of ground coffee whilst weighing more than four times as much. Tinned food worked up a sweat, tinned food knackered him. Booze slowed them all down. Bottles of scotch needed careful handling. If Eddie dropped a case of tuna, they just dented. When he dropped a case of Lagavulin all twelve bottles shattered at the bottom of the shaft and showered Wilderness in single malt whisky—a smell that took three baths to get off him and lingered in the tunnel for the best part of a month.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The oddest load of all was caviar.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness hefted a tin in his hand before Eddie dropped two hundred more down the shaft.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have you read the label?” he asked Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank was ever nonchalant, hand in pockets as if to demonstrate that nothing would make him get them dirty, standing around while others toiled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah,” he said. “You know I don’t read Russian.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness counted to ten waiting for Frank’s brain to kick in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shit! I get it! This fish paste came from Russia in the first place.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Fish "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("eggs")]), _vm._v(", Frank. Sturgeon roe from the Black Sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank picked up a tin as though knowing what it really was had somehow improved his grasp of a foreign language.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, whaddya know? What’s that phrase you guys have? Coals to Newgate.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Newcastle, you fucking idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“French soap, Scotch whisky, Californian tuna . . . Russian caviar. There are times I reckon we could sell ice to Eskimos.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Most days had a run along the tunnel. He would count it a bad day if he made the run twice, and would feel like bollocking Frank, but that necessity never arose. Eddie would always get his two penn’orth in first.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank would say, “So? I do all the driving. I take the biggest risk of all. I drive a car from Tempelhof to the zoo, loaded down with stolen crap, past my guys, past your guys and past the Kraut cops. You two have a concrete wall ten foot high around you and Fat Stanley and his guys watching your ass. I take all the risks!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eventually, a month or so into their new venture, Wilderness replied with, “And you collect all the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank leaned in closer for confidentiality, “And he’s still paying on the pop. We might have to open a bank account or something kosher. My mattress is bulging with mazuma. Bahamas here we come.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With consummate timing a message cylinder clunked down from the celestial network of overhead tubes. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“For Joe. Table 21.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Inside was a note. “I still say he’s a rogue. LT.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked across the room. She was sitting at the table where he had first met her, sipping another martini, smiling but not beckoning. All it would take was a wave.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§151")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It might have been said that Ernest Bevin was a surprise appointment as Britain’s Foreign Secretary in 1945. He had been Minister for Labour throughout the war, a post for which, as a former trades union leader, he would seem to have been eminently qualified. But Foreign Secretary? To understand Mr. Attlee’s choice would require recourse to terms such as “rough diamond” and “autodidact”—although Mr. Bevin’s didact was probably auto enough for him not to grasp the meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was a man who would call a spade a spade, and deem it so in an unwavering West Country accent. Part of the shock to the national, if not international, system, was that he followed in office Anthony Eden, a sophisticated, if neurotic old Etonian, former army officer and trusted lieutenant of the recently rejected prime minister Winston Churchill. A man who spoke fluent French, German, and Russian—to say nothing of Arabic and Farsi. Those there were who said that Bevin was not even fluent in English. Eden was the kind of figure of a man who’d grace a Noël Coward comedy on the West End stage with a gin and it in hand, not the saloon bar of the Dog and Duck with a pint of mild.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But . . . there might be another reason, another model of the statesman to which Ernest Bevin conformed—Vyacheslav Molotov, the USSR’s Commissar for Foreign Affairs since Russia entered the war in 1941, the hammer in Stalin’s right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They were two of a kind. No one in the British cabinet looked more like a Russian than Ernie Bevin. Indeed, swap Molotov’s pince-nez for Bevin’s horn-rims, draw a moustache on Bevin . . . and they might have been separated at birth—the rough bruisers of the diplomatic boxing ring. Although to be fair to Molotov he had kept better control of his waistline.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They hated each other.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Berlin had been the dominant issue of Bevin’s time in office. Nothing loomed larger, and with the onset of the Russian blockade it became inevitable that he would turn up in Berlin. He had flown into Gatow for a brief appearance only days into the blockade, had been chauffeured to meetings with the democratic politicians of the Western sectors, visited the other airfields gearing up for the airlift and flown out again. It was understood, under no circumstances would Mr. Bevin travel into the Soviet Sector, meet any representative of the Soviet Union or its puppet Berlin Communist Party, and as for Comrade Molotov, “’E can go an’ shag ’isself.” No one understood this better than Bevin’s chauffeur—Lance Bombardier Edwin Clark RA.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("For such as the Foreign Secretary, for visiting royalty (not that royalty ever did), and for the Military Governor of the British Zone of Occupied Germany—General Sir Brian Robertson—the usual rough and ready staff car (often just an open top jeep) was replaced by a black and grey 1935 Rolls-Royce Phantom II, complete with a tiny flagpole and tiny Union Jack. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie counted driving the car as a treat. It was worth polishing the damn thing just to be able to sit behind the outsize steering wheel on a calfskin seat, facing a rosewood dashboard and burl-walnut door panels. And when no one else was around he could sit in the back, open the cocktail cabinet, put his legs up on the pull-out footrest and dream of the life of Riley.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The July visit had been hectic, but tolerable. To call it “fun” would be a word too far. Bevin had been civil to him, only a touch shy of friendly, and had warmed a fraction of a degree when Eddie had found a moment to tell him that his dad had belonged to Bevin’s trades union. He was pleased at the prospect of Bevin’s unscheduled visit at the end of November, even though he’d been given only twenty-four hours’ notice. He polished the car again, told Frank and Wilderness that, for once, duty called and he would be unavailable until Bevin left. Telling Frank and Wilderness was a mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§152")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("It was six o’clock of a November night, a month away from the longest night. Berlin felt sharp and cold. The kind of night when the warmth of the tunnel might seem almost welcome. The kind of night when Berliners retreated to their beds and piled on every layer of bedding and clothing they possessed—and then got up at three in the morning to iron or cook as the stop-go supply of electricity permitted. Wilderness had suggested to Nell that they move into Fasanenstraße—since the whole building was occupied by British soldiers the electricity was more ­reliable—but Nell saw this as betrayal. Solidarity with Berliners demanded they feel the cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Besides,” she had said. “They’ll cut us all off sooner or later. Occupiers and occupied. And here we have the advantage of an iron stove. We can burn anything we can find. Anything we can bear to part with.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the coldest nights—twenty degrees of frost—they would drag their bedding down to Erno’s apartment and sleep in front of his stove. Erno always had something to burn. An archive to feed into the iron stove. A tightly bound pile of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Völkischer Beobachter")]), _vm._v(" from the 1930s would smoulder a whole night long. Words into smoke. Fiery rhetoric into heat and light.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank and Wilderness had hit Paradies early. The waiters were still clearing up from last night, rearranging chairs and wiping tables. They all but had the place to themselves. One of the singers was at the piano going over the verses to a new song with her piano player, again and again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Something was on Frank’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri came looking for us at lunchtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In uniform?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nah. Anonymous. Civvies and a dirty old rain slicker. He’d come over on the U-bahn. Didn’t seem to have any problem with our guys. Even seemed to enjoy the sneaking in and out. I’d never take him for a Kraut with a face like that, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aha.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Found me. Seemed pissed off not to find you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Anything that won’t keep?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah—that’s kind of his beef. He wants to up his order tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’S’OK. I can handle a few pounds more.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thing is. He wants to more than double it. In fact, I did the math . . . he wants to sextuple it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He has this big deal going down back in Moscow in a couple of days. He wants a thousand pounds of coffee. Tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You didn’t tell him we’d do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank, even if we had a thousand pounds of coffee . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We have. Took some doing but I rounded up another three hundred pounds this afternoon . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I couldn’t shift it. The biggest load we’ve ever done in a single run was that first load of sugar, and it was crippling. That was only two hundred and fifty pounds. Mostly I push about a hundred and eighty pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jeez, I was sitting right here when you said it . . . we could move a thousand pounds just like . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Figure of speech, Frank. A thousand pounds is a half a ton! Even if we could get a thousand pounds of coffee down the shaft, you’re looking at five or six runs. I’d be down there all night. Eight to ten hours. And loading all that onto the trolley would give Eddie a heart attack.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Somebody call?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie appeared, spick-and-span in his cleaned and pressed Royal Artillery uniform, fresh from his stint as a chauffeur.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought you were driving Ernie Bevin?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was. But he’s buggered off back to Blighty. If there’s one thing our Ernie hates more than Russians, I reckon it’s Germans. I did the usual rounds with him, we’d two more calls to make and he gets on the speaker tube and says, “Sod this for lark, tek me to Gatow.” Next thing I know he’s on a plane home and I’m sat there with an empty Roller. It’s parked outside now. We can all go out for a spin a bit later. Motor Pool aren’t expecting it back till midnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was staring at him now.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Wossup? What’d I say?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Outside now?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“O’ course. Who’s gonna have the nerve to nick a Rolls-Royce the size of the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Queen Mary")]), _vm._v(" with a Union Jack flying off the roof?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness switched his gaze to Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“Ever seen a Phantom II, Frank? The boot is the size of the Albert Hall, the footwell in the back is longer than even my long legs will stretch.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m with you, kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m not,” Eddie said. “What the hell are you on about?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rolls-Royce made armoured cars during the last war, the back axle’s as tough as any tank.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just flippin’ tell me!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank’s brought us a big deal, too big to pass up. The grand slam. We have to get a thousand pounds of coffee to Yuri tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So? What’s that got to do with me and me Roller?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We can’t shift a thousand pounds of anything by hand, but we could pack it all into the Rolls. In the boot, in the back, in the front footwell. We fill up every spare corner, and I reckon we’ll get it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, bloody Norah. No. No. No. It’s too risky.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank said, “Where’s the risk? You said yourself no one’s dumb enough to steal the car. On the same principle no one would be dumb enough to pull it over for a search with Ernie Bevin sitting in the back and the flag flying.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But Ernie Bevin won’t be sitting in the back. He’s gone. Flown. Buggered off. Scarpered.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then the penny dropped. As Wilderness continued to stare him down, the bad penny rattled around in his skull.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But I don’t look anything like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry Ed, but you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m forty years younger!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s dark. All anyone will see is a short, fat bloke in a homburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If I dress up as Ernie, we’ve no driver!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How do you fancy being driven to the other side by a lieutenant of the Welsh Guards?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh my God. Oh my God. Joe, you complete and utter bastard. You’ve got it all figured out haven’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. No one will dare stop us on our side and sure as eggs are eggs none of"), _c('span'), _vm._v("Yuri’s blokes will. We drive across the river, we go to Monbijou as usual, unload, drive back and the car gets returned to the pool by midnight. Pumpkin time. After all, who knows Bevin left early? Half a dozen people? Certainly none of the Russians know. They might be gobsmacked to see him, but stop him? It’d be like asking to start World War III. They simply wouldn’t do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Across the room at table 13 Wilderness caught sight of Tosca. No one had been sitting there fifteen minutes ago. He hadn’t seen her come in. But she had her head down in a book. Almost her habitual manner when there was no company. He’d seen it once or twice. A big battered hardback, but he’d never seen the title. She stuffed it in her bag as soon as he approached. One day he’d ask her what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§153")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It might have been a mistake, to go to Schlüterstraße that day. He never wanted Rose Blair to think he was out of touch. And if Rose Blair thought he was in touch, so did Burne-Jones. If he didn’t log in with her in the morning, he’d find five minutes in the afternoon. Enough to let her know he was not the loose cannon she might think he was. Rarely had it been this late, gone seven, when he appeared at her door. The grubby, inky, once-transparent cover was on the typewriter. Her kid gloves were out on the desk. Her Liberty headscarf was tied. She was buttoning up her overcoat.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“God, you cut it fine. He’s been calling all afternoon. You’re on tonight with your tomcat act.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can’t be.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She tore the top page off her notepad.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suggest you call him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a Berlin number.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s in town?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What did you tell him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That you’d done a couple of hours’ paperwork this morning and I was expecting you back any minute. I don’t think he realises that you haven’t so much as looked at a fucking Fraggy in months.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He hadn’t. Once the Russians had stormed out they’d stopped reviewing "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Fragebogen")]), _vm._v(", so his doing so was close to pointless. He’d rubber-stamped everything without reading a word, and his office hours could be measured in minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thanks, Rose.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Miss Blair to you. I lied for you Corporal Holderness. First and last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness pocketed the page from her notepad. He did not call Burne-Jones. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d think of something. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He always did.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§154")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("They loaded the car by the flak tower, hidden behind the giant molehills that Fat Stanley seemed to delight in making. Wilderness had scrounged a homburg, a black overcoat and a pair of bleary glasses off Erno. Eddie strained the front of the coat, the button-shanks taut as tightrope, but the hat fitted perfectly.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("As Frank packed coffee into the last available corner, Wilderness donned his Guards uniform.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You look the business,” Eddie said. “I just feel a prat. A fat prat in a daft hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ed, you’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And . . . I get superstitious.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That damn uniform. It’s a jinx.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Name me a single thing that’s gone wrong when I’ve been wearing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie whispered, “First time you wore it here, you came back with ’im!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, “Stow it, Eddie. I’m not listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank liked the sound of the boot closing so much he did it twice.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hear that. British perfection. Not a clunk or a click, more like a kiss. Listen. Swish . . . pop . . . kiss. One day soon I’m gonna own a Rolls.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness heard a sotto voce “Bloody Norah,” from Eddie and said, “Are we ready, Frank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rolling,” said Frank. “Rolling.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness followed the route he’d taken with Andreas von Jeltsch-Fugger. Direct and prominent. The route a car that flew the Union Jack might be expected to take, if anyone ever expected such. Along the Nazi fantasy that was the east–west highway called Charlottenburger Chausee to the Brandenburg Gate. Police and troops from both sides—British and Russian—were clustered around the Gate. Wilderness slowed down, assuming that any diplomatic driver would, hoping that he’d not have to stop entirely. The British stood to attention, saluted, pulled back a makeshift wire barrier without a word and let him cruise through at less than ten mph. The Russians just stood back and stared.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Halfway along Unter den Linden a raspy whistle, a dusty raspberry, sounded by his right ear. The speaking tube.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can yo’ smell coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course I can smell coffee, what’s your point, Ed?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My point is it’s fuckin’ amazing "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("they")]), _vm._v(" couldn’t smell coffee!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness glanced in the mirror and smiled. But what he saw was a perturbed face not smiling back. This was not a happy little fat man.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the Schloss Bridge the tube rasped again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pull over, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pull over!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not on the bridge, Eddie. Give me ten seconds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stopped the car in the square in front of the remains of the Kaiser’s palace. Eddie was out before he’d even yanked on the handbrake, stuffing the overcoat and the homburg through the window to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can’t do this, Joe. I’m sorry. I really can’t do this. Impersonating an officer’s one thing. I’m impersonating a bloody cabinet minister. You’ll get me sent to the Tower!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness got out. Looked around. A couple uniformed coppers on the far edge of the square, stamping their feet and hugging themselves in the cold. No matter. The damage was done now. But he was almost there, and unless the coppers came over and started shooting it was not enough to stop him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie just kept saying he was sorry. Wilderness saw the coppers touch heads to light up cigarettes and knew they didn’t give a toss. The night and the cold and the inherent cop-laziness weighed more than duty or curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Take the coat, Ed. Or you’ll freeze to death.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He shook the overcoat and helped Eddie into it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Meet me at Paradies in an hour. Get a couple of drinks inside you and calm your nerves. I’ll slip my RAF uniform back on in the gents’, and take the car back. You won’t have to do a thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sorry, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It doesn’t matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Our biggest score.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It really doesn’t matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He watched Eddie head back towards the bridge, telling himself that no harm could possibly come to a little fat man in an ill-fitting overcoat between here and Paradies Verlassen. He’d just be waved through at the Gate. At most asked to present his ID. And if they knew him, they’d ask about the going rate for a bag of coffee or ladies’ lacy underwear.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As he passed the two coppers, they hid their cigarettes behind their backsides, cupped in the palm of the hand, just like a British Tommy would do, and made a sloppy effort at standing up straight. Wilderness raised a hand to his forehead in semblance of a salute and drove on.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He parked under the S-bahn. Facing out, back to the iron kiosk on top of the shaft. He was only about fifty yards from it, but there was no sign of"), _c('span'), _vm._v("Yuri, no sign of any other vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He followed the S-bahn down to the kiosk. A train screeched overhead. Loud enough to drown out Armageddon. The iron door was locked. It made no sense at all for Yuri to be inside, let alone to lock himself in, so Wilderness concluded he was simply late.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As he walked back to the car another train passed, a shower of dust and rust falling, an immersion in noise that felt like drowning.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he saw them, slipping out from the cover of the columns that supported the steel lattice of the elevated railway. Half a dozen of them. Young men with guns. Young men with wartime Lugers. And the one aiming straight at him was Werner Fugger.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He still looked sixteen. About as scary as Minnie Mouse armed with a feather duster. But at fourteen this kid had hoisted a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Panzerfaust")]), _vm._v(", taken out a Russian tank, and had a medal pinned on him by Hitler in person. Wilderness did not so much raise his hands as merely spread them, enough to show he had no gun.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Open the trunk, Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He did as he was told. The waft of coffee was more a blast as the boot door swung down. Kiss . . . pop . . . swish.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The teenagers spread out behind Werner in a semicircle. None of them seemed quite comfortable with their guns. They looked at each other, when they should have been looking at him. Their hands wavered, the guns aimed nowhere. Werner kept his aimed at Wilderness’s midriff. If any of them had it in mind to shoot him it would be Werner—and then the rest would scatter like chaff to the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner’s left hand motioned a tall, spotty kid forward. The kid laid his gun on the open boot door, took out a penknife and slit a packet of coffee. The smell of roasted coffee beans even stronger as he held out the packet to Werner.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Werner sniffed and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’ll be taking the car too. You’ll get it back sooner or later.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But Wilderness was looking past Werner, past the dilatory half-moon of half-attentive kids, to the iron kiosk. The door was open and a ragged "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Trümmerfrau")]), _vm._v(" had appeared, her head wrapped in a scarf, her skirt trailing in the mud, moving in and out of the moonlight shadows of the S-bahn, cutting a curious path towards them, clutching a piece of trash she had found—a wooden crutch, or a broken chair leg—almost as though she was circling them but somehow getting closer with every twist and turn.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then he saw the broken chair leg for what it was. The familiar stunted T shape. A Mark V British Army Sten gun.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The first burst of fire took down five of the kids and Wilderness. The second killed the one kid who had managed to run. Shot in the back before he’d gone a dozen paces.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness fell against the boot, a bullet in his side. A slow, wet wave, seeping towards his legs. Werner’s dead eyes staring up at him. The spotty kid’s gun lay where he had put it, flat on the boot door, only inches away.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As he reached for it, a hand picked it up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh, Joe,” Yuri said. “You won’t need that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He pulled off the tatty grey wig, tore the ragbag blue dress off his chest, smiled his nicotine smile at Wilderness as Wilderness slid to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Does it hurt?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Such a strange question. But it didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It will,” Yuri said. “Here. Take this. For the pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took the spotty kid’s penknife. Held up a packet of coffee. Showed Wilderness the bottom, with a red sticker slapped across it. Then he slit the packet. No fresh waft of coffee beans. A talcum-trickle of white powder. A hefty pinch of it perched on the end of the knife. He shoved the knife at Wilderness’s mouth. Wilderness opened up and swallowed. A vile, bitter taste. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Morphine. A little morphine for the pain. Sweet dreams, Joe. Sweet dreams.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§155")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness was staring at the ceiling. They didn’t want him to move. He asked if he could sit up. They said “tomorrow.” He asked for a book. Any book. They said they’d bring one. They didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wondered if there was a guard on the door. He wondered where he was. German nurses who spoke to him in good English. A prefabricated building. The not-too-close, not-so-far sound of planes taking off and landing. A hospital in the British or American zone. One of those they threw together in the summer of ’45. All plywood and tarred felt. Looking shabby now. Out towards Gatow or Tempelhof. At least they hadn’t left him to die in East Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("He closed his eyes. He’d counted every crack in the sagging ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("When he opened them Frank was standing by the bed. Wrapped for winter. Or travel or both. A bulky, lined, green army mackintosh, a Gladstone bag in his gloved hand. A bigger, bursting suitcase at his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t have long,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If I could get out of the fuckin’ bed you wouldn’t have five seconds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I didn’t know, Joe. Honestly.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Which bit didn’t you know? That I was smuggling drugs as well as coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . of course I knew that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you didn’t bother to tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you have done the job if I had?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“When exactly did we become dope dealers Frank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“In April. You told me not to convert to the new marks and to put everything into commodities. I bought all the coffee I could, and when that ran out I bought morphine. You didn’t want to know. All you cared about was not getting stuck with old marks by the time currency reform came around. I tried telling you. We had US depots all across the sector packed out with penicillin, vaccines, morphine—you name it—Band-Aids, Q-tips, and suppositories to shove up your ass. We’d been stockpiling ever since the day Sokolovsky walked out. And once I’d got Yuri his penicillin, it was a piece of cake to get morphine. All it took was a little paperwork. I tried telling you. You just weren’t listening.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“It was three nights ago. You been out for a while. Docs reckon you took enough dope to knock out a Percheron. Yuri said he wanted it all now. I told you that. You know how impulsive he can be. He had a buyer. It was sell it or lose it according to him. The risk seemed low. Bury the dope in the coffee, and then you came up with the idea of using the Rolls. Brilliant. What could go wrong? Except I didn’t figure Yuri for a rat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’d no idea?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course I’d no idea. You think I’d of sent you and Eddie into a trap? We none of us knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank set the Gladstone bag on the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I have to be at Tempelhof in less than an hour. Uncle Sam wants me out of here. This is a third of everything we had left. Your cut. I gave Eddie his. It was like I scalded him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We have slightly less than seventeen thousand dollars. In April you told me to spend all the marks and take only dollars from then on. Seventeen grand is the balance of what we took in dollars since April. The marks are gone with the coffee and the dope. Some of the dollars too. I had to spend to make up the last load. Yuri didn’t pay up front. Yuri didn’t pay at all. Winners keepers. "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Siegerrecht, ")]), _vm._v("as the Krauts say"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v(".")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Good grief, Frank actually knew a word in German.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How much did we lose?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Thousands. About eighty grand.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You still got five and a half. Close to six. That’s two thousand of your quids.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had no idea if Frank was lying. The idea that Frank did exactly what he told him was a novelty. “I was only obeying orders” with a new, comical twist. But . . . he could have kept the eighty grand for himself. And it wasn’t scalding either of them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe. I gotta fly. Literally. I’m on a flight back to London.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. Leave the money and fuck off why don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe. Believe me, kid. I didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His head turned as the door opened. Burne-Jones standing in the doorway. Not smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank saluted. Burne-Jones returned it without a flicker of expression.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I was just leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Frank turned to Wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So long, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness hoped it would be long. Right now he didn’t care if he never saw Frank again. And then he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones lifted the Gladstone bag to the floor, Wilderness praying he did not open it . . . but he showed no curiosity. Just pulled up a chair and faced him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Repeat after me . . . I am a total fucking twat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I am a total fucking twat.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good. Glad we got that established. You make a twat of yourself if you want to. But you will not make a twat out of operations run by me and above all you will not make a twat out of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can’t be helped now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’ll have to be. Now . . . what was in the Rolls?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Coffee, maybe a thousand pounds of it. And morphine. I don’t know how much.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Russian got it all?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is the car empty?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Russians found it about a mile away. Came back to us spotless.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then he got the lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Any witnesses?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They were all dead when I looked. I was only conscious for a few minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Captain Spoleto.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What are you asking?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m asking you what he knows.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good. Perhaps you’d care to stick to that line. There are some of Spoleto’s colleagues who’d love to court-martial him. But they’ve no witnesses. Except you that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you want me to testify against Frank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. I want to save what can be saved.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How do we do that?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“First, I think you know nothing of anyone else’s involvement . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness thought of Eddie, not Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course, I acted alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good . . . good. And you acted under orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you say so. What were those orders?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No one needs to know. Spoleto’s being posted to England. Your Russian chum has vanished . . . we just need to cook up a cover story . . . you can leave that to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I repeat. You will not make a twat out of me. And to avoid that I have to exonerate you. Right now I’d prefer to lock you in the glasshouse and throw away the key. But that would not be expedient. I need you as spotless as that car.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What . . . I get me own "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Persilschein")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How aptly you put it, Holderness. Yes . . . in this case a promotion. Don’t even think you’ve earned it. It’s for show. A show we put on to save my arse not yours. And, Joe, there are no second chances. Fuck up again and I’ll let them have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones pushed back the chair, ready to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Promotion? Lieutenant? Second lieutenant?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, I can’t and won’t make you an officer. I told you a while back that you’d be no use to me as an altruist—you’d be even less use to me as an officer. I need you as you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You mean as you found me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“I was rather hoping for an improved version. I’ll settle for a live one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Start living in the real world, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Sergeant")]), _vm._v(". You almost made it into the next one. If it hadn’t been for that woman you’d have bled to death under the S-bahn.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That woman? What woman? Nell?")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt para-style-override-20"
  }, [_vm._v("§156")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Another night and most of a day passed. It was dark by four now. He’d realised that Burne-Jones’s scheme required that there be no guard outside his door—he could leave whenever he liked, except that he couldn’t walk. On the other hand he’d forgotten what day it was . . . for that matter, what month it was. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A woman appeared at his bedside at last. He’d been waiting for the woman. It just wasn’t the right woman.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Another fine mess you’ve gotten me into, Stanley.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For more than a moment he did not recognise her. The uniform was wrong. An American WAC. A sergeant.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Is that . . . is that . . . a disguise, Major Tosca?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sure. Like they’d let me swan in here in full Moscow spook outfit. It’s mine. Had it for years. If I can get into it when needs must then I figure the years aren’t being too unkind to my ass. Which kinda brings me to the point. I saved your ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How? Thank you, but how?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’S’OK. I didn’t come here for thanks. I came to give you the explanation you’re asking for. Yuri was up to something big that day. Cat that got the cream. Suppressed glee just oozing out of the little bastard. I set one of my guys to follow him. No interference, no action. Just follow and report. He saw Yuri gun down those kids, take your car. Make off with your stash. Then he came and got me. Another five minutes you’d have bled to death. We staunched the wound, drove you here and dumped you on the doorstep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I say again, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("De nada")]), _vm._v(". So long as you get it and you do get it don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yuri left me to die?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep? And Frank?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Frank wasn’t there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“My point to a T. When the shit hits, when the bullets start flying is Frank ever there?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said nothing to this. He was in for a lecture and accepted it. God knows if one more person showed up with a moral or a caveat it could be a Toynbee Hall series for the improvement of the workingman.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Kid, you got mixed up with a couple of bastards. Your one spark of redemption is that Eddie Clark wasn’t there too.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have you seen Eddie?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, but I can if you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Tell him nothing’s going to get out. We’re clean as Persil. It’ll all be covered up. I’m even getting promoted to sergeant to make it look kosher. He’s nothing to worry about. He should just . . . carry on regardless. Ask him to come and see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll tell him, but if he asks me my opinion, which is not unknown, I may have to tell him he needs you like he needs an extra belly button. And you . . . you don’t need Yuri . . . you don’t need Frank. You never did need ’em. You probably never will see Yuri again. The big score was brought on by him being posted east. He was cleaning up and clearing out with his pockets lined. Hell, he’s probably a full colonel with a desk in Dzerzhinsky Square by now. But if you see Frank again, consider yourself unlucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After she’d gone, he squirmed a little, a spasm in his left arm—felt it come up against something solid. He reached his hand out of the sheets and picked it up. A book. Her book. He tilted the spine and tried to focus bleary eyes upon it: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Huckleberry Finn")]), _vm._v(". He knew the tale. Read it when he was twelve. He got the joke.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§157")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Nell came. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Two days later. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In all the misleading ambiguity of grey, crepuscular light. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Stiff little legs and her po-face.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A stellar constant in the gloom.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Said nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Just held out her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knew what she wanted and pointed at the slim tower of utility drawers next to the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Top one,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She took back the keys to her apartment and left.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wasn’t even sure she’d looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("He thought that perhaps it was the strongest sense of certainty he’d ever known. He’d never been quite so certain of anything in his entire life.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was over.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§158")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was almost Christmas. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie was leaning against the staff jeep out at Gatow Field. He had another volume of Penguin "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New Writing")]), _vm._v(", an anthology that he could dip in and out of, half a dozen pages at a time without ever losing track, but his eyes had drifted off the text to an inner focus. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d joked with Joe—“You’ll be the death of me.” But he knew it wasn’t a joke. Part of him, a large part of him, was relieved that Joe was banged up in hospital. He could interpret the promotion, as Joe surely could. Part reward, part punishment in that it meant Burne-Jones had him by the balls and his magnanimity was merely a demonstration of this. Whatever it was Burne-Jones had in mind, Eddie hoped it would take Joe far away from Berlin, as far away as possible. He liked Joe. Joe had been fun, but the fun was over. Joe was pure trouble. He had to be free of Joe. He wasn’t sure how they might remain friends. And he didn’t give a toss if he never saw Frank or Yuri again.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He could be happy again, just flogging coffee and nylons from under his greatcoat. The simple life and the safe. And no more London wide boys.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Yet, here he was, his greatcoat lined with ladies’ underwear meeting a London copper off a plane. What was worse—that he was a copper or that he was from London?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie looked up. There was a lost-looking geezer. No bigger than he was himself, too short to be a copper, almost an elf. He was trailing an RAF flying jacket. This had to be the bloke.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie approached him. Gave him the instant once-over as he did so. This was no Joe, this was no East End wide boy. The overcoat was Regent Street or Savile Row, the shoes and the gloves were handmade . . . and he could hear the accent before the bloke even spoke . . . latent, immanent . . . it was going to be King’s English, pure bloody toff.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Excuse me, sir. I think I might be your driver.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The little chap turned jet-black eyes on him, stuck out his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Troy,” he said. “Frederick Troy, Scotland Yard.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Eddie’s heart sank at the sound of the public-school vowels. The presumptuous, world-is-my-oyster-so-fuck-you RP of the English upper class. This bloke smacked of trouble too. It could no more work out than had life with Joe. But at least it would only be for a couple of days. Then he’d be free of this prick as well.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§159")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT-w-location"
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("London")]), _vm._v(": Summer 1955")]), _vm._v(" "), _c('p', {
    staticClass: "CT-location"
  }, [_vm._v("The offices of Drax & Kornfeld, Maiden Lane WC2")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Arthur Kornfeld was used to letters like this. A thin brown paper envelope with HM Prison stamped in the corner. There would not be much inside, the briefest, the most courteous of notes—a request or a thank you. He slit the top edge with a paper knife and watched the flake of another’s life fall onto his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As a publisher he received up to a hundred letters a day. The other ninety-nine could wait.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01 para-style-override-15"
  }, [_vm._v("HM Open Prison")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-15"
  }, [_vm._v("East Blathering")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-15"
  }, [_vm._v("Essex")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-22"
  }, [_vm._v("June 11, 1955")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("My dear Arthur,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02"
  }, [_vm._v("I hope you will have time to visit in the next month or so. I am in receipt of full remission and expect to be released in about six weeks. I have to make plans, but, alas, I have put off making plans. I would find it all so much easier if I could talk things through with you beforehand.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02-indent para-style-override-21"
  }, [_vm._v("Your loving friend,")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02-indent"
  }, [_vm._v("Karel Szabo")]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-23"
  }, [_vm._v("convict no. 11197523")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Kornfeld flipped open his desk diary. Friday the twenty-fourth was largely blank—if he could just shuffle off a couple of meetings with those tedious creatures . . . authors . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stuck his head through the open doorway of the adjoining office, where his junior partner, and senior music and biography editor, sat working far harder than he ever did himself.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Aurie?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nowak looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Last chance to see the inside of an English prison next week.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Aurelius Nowak had long ceased to find this funny. Arthur, a Viennese, had seen the inside of several English prisons as an interned enemy alien during the war. He spoke of it often. It had not been wholly without pleasure. Nowak, a Pole, had been “interned” too, in Auschwitz and in Belsen. He scarcely mentioned either. They had been wholly without pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nowak returned his eyes to the manuscript he was marking up, pencil in hand, darting down the margin in a sequence of squiggles that for some reason always proved a source of delight to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “You will understand, Arthur, if I say that I shall pass on that wonderful opportunity and hope I do not live to regret it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. Would you mind taking a couple of meetings for me next Friday?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Of course not . . . am I to understand Dr. Szabo is about to be released?”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. He’s in a bit of a funk about it all. I really ought to nip down to Essex.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("How English these phrases sounded to Polish ears—“bit of a funk,” “nip down.” The art of understatement.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Seven years is a long time. You and I did not serve that long between us. And think how difficult the readjustment was.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("It had taken Kornfeld less than five minutes to adjust to freedom. As far as the bar in the nearest railway waiting room, in fact. Nowak, he knew, would never adjust. It showed in the way he reacted to meeting strangers, to sudden intrusions into his office, to any encounter with a man in uniform. From the postman to the beat bobby. If he lived to be a hundred Nowak would never ask a policeman the time, whatever the old song said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Part of Arthur had wanted the company. Down by train as far as Chelmsford, and then a long cab ride out into the flat Essex countryside past villages with names that ended in Bumpstead and D’Arcy, thereby summing up what Arthur thought of the county, via West Blathering and Much Blathering to Little Blathering and Blathering-next-Dyke to arrive at last at Her Majesty’s Open Prison, East Blathering—home for most of his sentence to Karel Szabo, spy.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A little ringing round among those few friends that had found space in heart or mind to forgive and Arthur soon had the company of fellow physicist Marte Mayerling. Personally, in the time Arthur had worked with Marte before the war, when physics had been their mutual passion, he had found her passionless about anything else and pretty well humourless. That said, the one soft spot in that heart of pure maths seemed to be for Szabo. She had dismissed his treason with, “Frontiers, nations . . . are for smaller minds than ours . . . we are citizens of the world.” A world they had damn near blown up. At the end of the war Arthur had not wanted to work in physics any longer. He was happy as a publisher—who ever heard of a physicist with luncheon expenses—how many mathematical geniuses took breakfast at Simpson’s-in-the-Strand and charged it to the firm? ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marte had flown far nearer the sun than he and had worked at Berkeley on the bomb that destroyed Nagasaki. She had stayed with physics, resumed her place at Imperial College, London, and declined ever after to work on weapons of any kind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A train ride with Marte, and she had travelled down to Essex with him many times, always left Arthur feeling that he had been brought up to date in his former interest. She saved him having to read the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New Scientist")]), _vm._v(". Anything of import in it was at the tip of her tongue waiting to be imparted. Occasionally he wished she had learnt the knack of talking about the weather, but you can’t have everything, and more often than not he relished her intensity and the glut of knowledge that threatened to overwhelm him, and, had East Blathering been closer to Colchester than Chelmsford, would most certainly have done so. An English summer’s afternoon, a hip flask, a half-bottle of Chassagne-Montrachet ’48, a little French bread and foie gras in his briefcase, the company of one of the smartest women on the planet . . . what was not to like?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I do wish you’d learn to drive, Arthur.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stop being a sourpuss, Marte. You’re so much more beautiful when you smile.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Indeed she was. He doubted she was much over forty, and still a bit of a looker. But she was immune to flattery.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s so tiresome. All the changes. Tube, train, cab, and back again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She had learnt “tiresome” early on in their time as adopted English. It alternated with “ghastly” as one of her habitual upper-class moan words.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look at it from Karel’s point of view. What do you think he prefers, Blathering or Pentonville?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“At least I can get to Pentonville just by flagging a cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But such a ghastly place.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She knew he was taking the mickey, and changed the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Does he have plans?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Dunno. That’s rather why we’re here.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Does he have . . . options?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You tell me. Would any British university have him back?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course not.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then he must find something else to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Surely he must leave England?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He may not have to. He’s still a citizen after all. Technically Karel is a traitor not a spy. They never took citizenship away from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Good God, why on earth not? There are times I think we have landed down among lunatics. After what he did?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps they just forgot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He gave the atom bomb to the USSR. That, surely, is unforgettable?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sure it is. But it won’t be a matter of what the English forget but what they’ll forgive.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marte pondered this. Looked out at the passing countryside without seeing any of it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Then she said, “He should leave. In fact, he must leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Her certainties, once uttered, were as fixed as Aristotle’s Laws. He knew she’d say it to Szabo as readily as she had just said it to him, and she did.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Szabo looked sad. In all the years Arthur had visited him, he had never wanted to discuss the old country—any of them, not Hungary, not Germany, not Austria—and seemed to have most affection for the country he had betrayed. In part, Arthur thought, because he could not see the betrayal for what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Leave England? Where would I go?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There will be people, the muckraking journalists, the die-hard Tories who will expect you to go to Russia,” Arthur said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But I’ve never been to Russia. I don’t speak a word of Russian beyond ‘das vidanye’ and ‘spasibo’ and I only learnt those to be polite to Russians in the camps.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What would you like to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you like to work for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. I mean . . . that’s very kind of you . . . but do you even know if you’d be allowed to employ me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you stay, the authorities cannot stop me. It is, as they tell you at every turn, a free country.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If I stay?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Karel, they’re not going to throw you out. I have this on some . . . authority. There that word again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What authority?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I talked to Rod Troy. He’s shadow Home Secretary now. I’ve known him for years. We were interned together. He had a private word with the Home Secretary. They’re not going to throw you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marte had not spoken for several minutes. Arthur had been conscious of the grinding of the millwheels of her mind—or to do her more justice, the scattering of her alpha particles.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Arthur. Would you be so kind as to give me a moment alone with Karel?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Kornfeld looked at the impassive prison warder. Back against the wall by the door, hands clasped behind him, eyes focussed on nothing, deaf to the room, and realised that they could as well be alone and that whatever she wished to say in private might just remain that way. After all, all they had to do was switch to German.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course. I’ll be just outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§160")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Karel Szabo was released on August 27. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On September 3—the anniversary of the war that had made refugees of both of them—he and Marte Mayerling caught the Dover to Calais ferry, and from Calais a train for Paris, Gare du Nord.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On arrival in Paris they vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Four months later, in January 1956, they were reported seen in Dresden, now part of the German Democratic Republic—commonly referred to as East Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below"
  }, [_vm._v("§161")]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT-w-location"
  }, [_vm._v("London Summer 1955: Campden Hill Square W8")]), _vm._v(" "), _c('p', {
    staticClass: "CT-location"
  }, [_vm._v("The home of Lt Colonel and Lady Margaret Burne-Jones")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Wilderness had been to Burne-Jones’s home many times. He was almost certain it was against all military protocol to mix socially with other ranks, but if protocol had mattered much to Burne-Jones he would have fired Wilderness in 1948, and for that matter in 1950, 1951, and 1954. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It had been 1949 the first time. They were both back in England. Wilderness had recovered from the bullet Yuri put in him at a BAOR hospital in München Gladbach. He had been there, he thought, long after his health required it and had concluded it was Burne-Jones’s way of locking him up without the need of a key. It was January ’49 before they granted him a clean bill of health and a travel warrant back to London. He landed back in Blighty in civvies, silently adamant that he’d “never wear a fuckin’ uniform again.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness got off the bus in the Commercial Road and walked the length of Sidney Street. Much of it lay in ruins, much as it had when he had left in 1946. The bombed-out, roofless houses and the gutted factories. A gang of rowdy boys came haring out of a ruin and stopped just short of colliding with him, frozen with guilt about nothing worse than being boys. Another boy stared silently down at him from the first floor window, his face framed in jagged glass. Wilderness caught a glimpse of the boy he used to be—but this was a dog-eat-dog world, every boy for himself. He bid them “good morning” and walked on. Twenty paces on, the jeering and catcalling resumed to the sound of breaking glass.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Near the south end of the street a funfair was being dismantled—there was something visually startling about multicoloured wooden horses and scarlet and orange bunting in the grey, washed-out, scorched landscape. Nothing else had colour. Everything was ash.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He passed familiar landmarks that had survived the Blitz—the lemonade factory, with its towers of bottles, the brewery and the haze of hops and horseshit that seemed to emanate from it, the newsagents that sold rationed fags, rationed sweets, and under-the-counter pornography . . . the monumental masons, creating the only record most East Enders ever got, a tombstone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He stopped at the railings and peered through, as fascinated by dates and death as he had been at the age of fourteen. Novellas written in solid stone . . . wife of . . . and also . . . of the above . . . aged six weeks . . . aged eighty-seven years.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was their sole marketing ploy to stick a row of stones in a dozen different styles where they could be read from the street. He’d often wondered if they made up the names or if they simply made advertisements out of the stones no one had ever come to collect. Now he knew—the second from the right read far too tersely:")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01 para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Abner Riley")])]), _vm._v(" "), _c('p', {
    staticClass: "letter-03 para-style-override-1"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("1884–1944")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What was Merle playing at? Why had she left him here? Why hadn’t this been put up at the head of his grave in St. George’s churchyard months—no years—ago?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He arrived on Merle’s doorstep to find his key did not fit the lock. A woman he vaguely recognised opened the door to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Young Joe is it? My, you’ve filled out.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stared.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You don’t know me do you? Molly. Molly Riley. Married to your grandad’s second cousin Paddy? Anyway, don’t stand there freezing to death. Come on in.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was cleaner by far than it had ever been under Merle’s care. Some of the furniture was the same—the old, clumpy Victorian stuff that had belonged to Abner, and before that to Abner’s father. Some of it was new—the lightweight, make-do-and-plywood look that was known as “Utility”—the Morrison shelter had gone, and in its place stood a folding Utility table as substantial as an orange-box. The most familiar object in the room was Abner’s armchair next to the range. It had lost much of its stuffing even in 1941—and judging from the array of safety pins holding the rest in, it was something Molly meant to survive. He could almost see Abner sitting there, easing off his boots, complaining about his corns, saying, “Make us a cuppa, Merle.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Merle. Where the fuck was Merle?")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where’s Merle?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh my God, don’t tell me you didn’t get her letter? She’s married again. Paddy and I took over the lease from her at the end of the summer.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Not for one moment did Wilderness believe Merle had written to him. No more than she’d bothered to collect Abner’s stone.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do you have a forwarding address?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well,” said Molly. “I did. But the last couple of weeks things have started coming back to me as ‘not known at this address.’ All the same you can have it if you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She picked up an envelope from the table and with a stub of a pencil scribbled down an address in Devonshire Place.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Near Regent’s Park?” Wilderness asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes. Posh. She married a bit o’ posh. Alistair or Angus or something. And one of them double-barrelled names.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And my . . . things?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Your things?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Books mostly. I left a lot of books. In my room, that is the attic room.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh, yeah, I’m with you now. Well. We got four kids—you got four little cousins now, three girls and a boy—all at school right now or else they’d be here asking you a million questions—so we, like we needed the space. It’s young Doris’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s fine, Molly. I don’t want the room. It’s your house now. I just wanted the books, well some of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Like I was saying. Merle took all your stuff and left it with that pal o’ hers over in White Horse Lane.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness could not think who.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know. That blonde woman there used to be all the gossip about. Bit of a looker. Married to that grumpy old Jew who runs the tailor’s opposite the Underground.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Judy Jacks?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s ’er. Anyway, she’s got all your stuff safe and sound.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As he stood on the doorstep, under a January sky, breath freezing in the winter air, knowing he was standing on this threshold for the last time in his life, deciding to avoid ascribing any meaning to it, Molly said, “We could put you up on the sofa, just for a couple of nights, if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And meaning took him regardless. “I’ll be fine Molly. What’s gone is gone. What’s done is done.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He walked over to White Horse Lane, following much the same route he had walked with Abner eight years ago when the old man had collected him after the air raid that had killed his mother—across the top of Jubilee Street, down Redman’s Road—thinking Stepney looked worse than Berlin—did no one clear up after a war?—and hoping Billy Jacks was not at home.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He wasn’t. Judy Jacks answered the door. A flimsy, flowery summer dress as though they were not in the depths of winter. A Maginot Line of goose pimples running up her arms. He’d had the hots for Judy when he was a priapic sixteen. He didn’t know a Stepney lad that hadn’t. Blue eyes, blonde hair, hourglass curves . . . never seemed to age. Rumour had it that Billy had caught her and a young copper in flagrante across the kitchen table, but he’d never believe that. Billy Jacks would have killed both of them if that really had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was looking at him now, waiting for him to snap out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe? You gonna speak or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She was gorgeous, he thought, coming up to fifty and still fit to turn a teenager’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mrs. Jacks.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think you’re old enough to call me Judy. I suppose you’ve come for your stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She walked back into the house, a silent invitation to follow hanging in the air between them.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the living room, a meagre coal fire. You could count the lumps in the grate. On the mantelpiece an array of photographs, some framed, some merely postcard-sized, wedged into the frame of something bigger by one corner. In one of the frames, a man in the uniform of the Great War, a Tommy Atkins, he recognised as a younger version of one of the old men of his childhood. Mr. Jacks Sr. The man in the postcard, in the uniform of the Second World War, a REME corporal, he knew well—Danny Jacks, son and heir of the irascible Billy Jacks, tailor of Stepney Green. He was six or seven years older than Wilderness himself. One of the wide boys of the Green. He doubted Danny wanted to be heir to a tailor’s shop. Then it dawned on him. He’d no idea if Danny had survived the war or not. The last year he was in England—the year of the great demob—had been such a roller coaster he’d never thought to ask about what people didn’t volunteer to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“He’s a schoolteacher in Leytonstone now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Judy was standing in the kitchen doorway, a kettle hissing in the room behind her. Wilderness found he was holding the photo of Danny, and gently wedged it back in the frame with the boy’s grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who’d have believed it? My Danny a schoolteacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Billy. What did Billy have to say about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A big fat yes was what Bill had to say. Almost smiled. War changed him, you know. Changed everyone I shouldn’t wonder. He’s a local councillor now, solid Labour. Got himself a safe seat for Westminster next time around. Imagine, Billy Jacks MP. And you, young Joe. Has it all changed you? You were such a strange one, always with your nose in a book, always takin’ the piss when you thought no one could hear you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It was the books I came about.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeah, but there’s no hurry. Have a cuppa and catch up. You been gone a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Two and a half years. Long enough for Merle to do a bunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well . . . I can tell you about that. If you let me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He did.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He sat and sipped at tea. Let her top him up. And heard how Merle had married a toff—the whore’s equivalent of a stage-door johnnie. How they had lived in Devonshire Place until Christmas, when he had inherited a castle in Scotland. Judy wasn’t sure where, but Merle was bound to surface sooner or later.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("And all Wilderness could think of was the money—he and Abner had stashed hundreds, possibly thousands, between 1941 and the old man’s death, and Merle had trousered the lot. He and Frank had made a packet in Berlin, and Yuri had trousered the lion’s share. Would he never get lucky?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She showed him up to the top floor, the room that had been ­Danny’s. His books, his wood"), _c('span', [_vm._v("en model of a Lancaster, the remains of his Meccano kit, his striped belt with the snake-S buckle, his penknife, his Eveready torch missing bulb and batteries, his wristwatch missing the ")]), _vm._v("winding wheel, his dog-eared copy of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Health and Efficiency")]), _vm._v(" from March 1938 . . . Rada’s clipping files . . . all his worldly possessions were in three wooden orange-boxes under the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Judy flopped onto the bed, watching as he sifted through his childhood. She picked up "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Health and Efficiency")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You cheeky devil. I used to confiscate these off Danny.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As I recall it was Danny gave it to me. Or, more precisely, he sold it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“How much?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A bob.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She held the cover out to him—an arty black-and-white nude, eyes averted, head back, stretching her tits flat against her ribs. A marked resemblance to Merle’s Hollywood namesake, Miss Oberon.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You were robbed. She’s not all that much to look at. Mine are better than hers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He didn’t doubt it. His adolescent fantasies had encompassed that. He rummaged through his Mark Twains and his R. M. Ballantynes, found his copy of Belloc’s "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Cautionary Verses")]), _vm._v(", his "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Diary of a Nobody")]), _vm._v(", heard the swish as her dress hit the floor, saw it puddle next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked up; she was unhooking her bra.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“See. Bloody good they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The weight of one in each hand, as though she were buying fruit down the market. Then she put her thumbs in her knickers and pushed them down to her knees.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where’s Billy?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Catford dogs. Won’t be back for hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§162")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("She ran her fingers over his belly. Found the scar, a softer, clearer skin.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bullet wound.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I thought you missed the war. I thought you got called up after.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I did. And it’s a long story. And I’d hate to be here when Billy gets back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was pitch dark on the doorstep. The shimmering gas lamp on the other side of the street did nothing to light them up. She looked both ways then kissed him a real smackeroo.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You take good care of yourself John Holderness. No more bullets!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Sometimes he did get lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He rang Burne-Jones at home.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What chance you could rustle up a chit for a billet?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sorry, Joe. Don’t quite follow you there.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know, some sort of order that’ll get me a bunk in barracks somewhere in London. Just for a couple of nights. I find myself suddenly homeless.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a whispering on the other end. A soft discussion with Mrs. Burne-Jones no doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In a phone box on Stepney Green.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Look, why don’t you come here. Campden Hill Square. We’re marginally nearer Holland Park than Notting Hill Gate. Just hop on the tube at Mile End, you’ll be here in half an hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And so it began—a shift in Wilderness’s geography from East to West. Holland Park was not “up West,” it was beyond the up and was just West.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§163")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Mrs. Burne-Jones turned out to be Lady Margaret Burne-Jones, daughter of some toff or other. She stuck him in another attic. The bedroom of her eldest daughter, Judith. Judith was away at Cambridge, Newnham College, her first year studying for a degree in English Literature. The other three daughters, ranging from seven to fourteen, were in residence. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones led him up a seemingly endless, tortuous staircase to the top of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“We’re very proud of Judy,” he said. “Of course Madge went to Newnham too, but one can never take anything for granted.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I went to Cambridge,” Wilderness said. “Are you proud of me?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You know Joe, you can always sleep in the dog kennel if you’d rather.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A plain, British ration-book dinner after which Wilderness pleaded the travails of the day and excused himself for an early night.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He lay back on Judy Burne-Jones’s bed and inhaled . . . Judy Burne-Jones . . . breathed in the trail of scent she had left behind. He knew what it was. He just couldn’t name it. Vanilla, more than a hint of vanilla. It hung in the air as though she’d been in the room minutes not days before. It was a girl’s room—not in the sense of frills and fluffs, pinks and pincushions, it was if anything a simple room—but you’d no more mistake it for a man’s room than a woman daft enough to walk into the gents’ lavatory in a London bus station by mistake would ever think that that was other than what it was. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The scents entwined.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The new perfume of Judy wrapped itself around the . . . ah, two ­Judys in one day . . . the new perfume of Judy Burne-Jones wrapped itself around the sweat of Judy Jacks, mingled with the sharpness of his own semen, and the memory of Merle.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He might sleep well so ensconced in scents, as soon as the unresolved woman invoked by this olfactory assault let him go. With two Judys in his senses, Merle in his memory, he thought of . . . Nell Burkhardt. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He told her to go. She wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He breathed in Judys. Still Nell persisted, her lips on his, her hair tumbling over his face . . . enveloping him in scent. That was it . . . the trail Judy Burne-Jones had left was the same scent Nell wore . . . L’Aimant—the magnet—by Coty. Orchids and vanilla. A cheap one, as scents go. Frank had knocked them off, and he and Eddie had shifted bottles by the hundred in 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Taxonomy was a good game, but an obsessive one that tended to induce insomnia. But it was Coty, and now he knew it was Coty he would probably sleep. If he could name the word, he could dismiss the woman. Idea would always beat feeling as surely as scissors cut paper and paper wrapped stone . . . and stone blunted scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§164")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("At breakfast he met the other three daughters—Eliza, Olivia, and ­Dorothea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“This is Sergeant Holderness,” Burne-Jones said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Call me Joe,” Wilderness said to the girls. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And to Burne-Jones, “Official then, is it? I’m a sergeant now.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. And as I keep telling you . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Rank doesn’t matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And the youngest girl said, “People are always finishing Daddy’s sentences. He’s so slow.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After porridge and a cup of coffee that reminded him there were many things he’d miss about Germany—and that while morphine had its moments he’d rather start the day with a good cup of Java—he said, “I’ll look for a room today. I was thinking of Notting Hill. Cheap enough, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I think you mean shabby. And I wouldn’t bother just yet. I need you in Vienna at the end of the week.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§165")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Vienna led to Paris, Paris led to Lisbon.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was 1952 before he felt need of a home of his own.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He and Burne-Jones arrived in Campden Hill Square late one warm Monday evening in May. Madge had left beer and sandwiches on the kitchen table.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness said, as he had said before, “I’ll look for a room in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And for once Burne-Jones did not contradict him by mentioning a posting he had previously forgotten to mention.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Why not?” he said. “Meanwhile I gather Judy made up her bed for you personally, before she went back to Cambridge this morning. Nice to know she’s learnt something as a result of a very expensive education. I seem to see bugger all else by way of benefit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones was picking up chutney jars and peering through his half-moon reading glasses at the labels, looking for something that might go with beef. A letter propped between a proprietary Bengal Spicy and a homemade 1950 plum and bramley fell over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Forwarded from your cousins in Stepney. Postmarked last Tuesday.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness opened it. Rarely, if ever, did he get letters, and almost never on headed notepaper.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s from a firm of solicitors in Chancery Lane. Etherington, Graham, and Yooll. Would I be so kind as to contact them at their office, ‘where you may hear something to your advantage.’ What the fuck does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It means something very dear to your heart, Joe. Money.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Money, even more than taxonomy, could cost him dear sleep. But as he rearranged the pillows a second letter addressed to him fell to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-01"
  }, [_vm._v("Joe Holderness! Did you ever see "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Sunset Boulevard")]), _vm._v("? Gorgeous, yummy William Holden plays a scriptwriter, and the script he never gets to finish before Gloria Swanson shoots him depicts two people who share a room—I think they even share a bed—and they never get to meet as one works days and the other nights. Isn’t that us? Don’t you think that’s us? Three years now, and we’ve never met.")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02-indent"
  }, [_vm._v("I graduate next month. I’ll be around a lot more. That’s a hint. You know how to take a hint, don’t you Joe? You know how to whistle, don’t you Joe? You just put your lips together and . . .")]), _vm._v(" "), _c('p', {
    staticClass: "letter-02 para-style-override-15"
  }, [_vm._v("Judy")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§166")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He found Etherington, Graham, and Yooll in Chancery Lane. Mr. Etherington (junior) saw him. An impossibly tall man of seventy or so, which begged silent questions as to the age of Mr. Etherington Sr., with a shining brown pate and a halo of stiff white hair.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Concerning the will of the late Mrs. Alistair Carnegie-Little . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I believe her maiden name was Mary-Ann Evans.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ah! Merle! So she was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mr. and Mrs. Carnegie-Little died as a result of an incident involving Mr. Carnegie-Little’s Bentley and a Scots pine on the banks of Loch Lomond in the small hours of New Year’s Day.”\t")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Drunk, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That would . . . er . . . appear to be the case. Mr. Carnegie-Little died instantly. Mrs. Carnegie-Little lingered a week or so . . . long enough to have a new will drawn up. As Mr. Carnegie-Little predeceased her, she was, of course, the beneficiary of his not insubstantial estate, and while Mrs. Carnegie-Little saw fit to pass on the bulk of that estate to her stepson, she made a provision for you, Sergeant Holderness. The not inconsiderable sum of five thousand pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness wondered at the man’s pointlessly complicated use of double negatives, but said simply, “Five grand?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I believe that is the vernacular, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness’s thoughts rapidly cycled through “fuck me,"), _c('span', [_vm._v("” ")]), _vm._v("“so she’s spent all she nicked and bungs me few grand from her toff husband,” “fuck me” (again), and “five grand? That’s a fortune!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“If you’ll just sign here, I can make out the cheque forthwith.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was a presumption. RAF NCOs didn’t have bank accounts. Working blokes didn’t have bank accounts. Wilderness did. Burne-Jones had made him open one years ago. He banked with the armed forces’ bank, Glyn Mills. Their main branch was in Lombard Street. He could walk there in a matter of minutes and deposit the cheque. Five grand. A sum so big he did not think cockney slang even had a euphemistic term for it. He’d have to invent one. Five grand—a load of sand? Five grand. Fuck me. And fuck Rotting Notting Hill. He’d buy in . . . Hampstead. Hampstead, lovely Hampstead, where he had begun his career as a thief.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§167")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It was more than he wanted to spend. It was all he had inherited and more. It swallowed the last of the Berlin stash, although spending the stash was a way of burying it for good, of legitimising the last of his ill-gotten gains—sardines and soap, coffee and morphine . . . turned into bricks and mortar.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Perrin’s Walk was an unpaved track, a hundred yards downhill from the Everyman Theatre. The house looked as though it might have been mews for one of the far larger houses in Church Row at some point in its life. Three floors of narrow, neglected rooms stacked over a garage. He didn’t need the garage. He’d find another use for it. If it had been mews then the chauffeur had never come back from the war. On first scent the house smelt of mice and emptiness—emptiness at a time when London was desperately short of housing, at a time when the new were not getting built and the old and bombed were scarcely patched up. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His no chain, cash offer was accepted at once.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He spent six weeks in a boardinghouse in Camden Town and moved in the day the paperwork was completed. He retrieved his boxes from Judy Jacks, emptied them out and they, with the one item abandoned in the mews—a striped deck chair—became his first items of furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d never had this much space in his life. He’d never felt particularly exposed. For all that he had been, and nominally still was, a serving member of Her Majesty’s Armed Forces, the only time he’d ever spent in barracks was his abortive basic training out in Essex. He’d had his own room in Cambridge, and in Hamburg . . . he’d shared with Swift Eddie for a while in Berlin . . . and after that it had been beyond question, no one had ever suggested he share a room again—sergeants did not share, spies did not share—but no room had ever been his in any sense that mattered. He was always passing through. He might be in one city, in one room for a year or more, but he was always passing through. That was part of the devil’s pact he had signed with Burne-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("This was his. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Every square inch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("About noon the same day there was a banging on the door, down on the ground floor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones stood in the lane, clutching a magnum of Veuve Clicquot. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Got to launch the ship in style, you will agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Next to him, a small, beautiful blonde, hair in a ponytail, no makeup, slacks and a sloppy sweater, flat heels—what he thought of as woman’s mufti.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t have any glasses,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The girl held up a brown paper bag, shook it gently so that he could hear the chink of glass on glass.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“House-warming present,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones didn’t wait to be invited in and set off up the stairs with “You know Judy of course” tossed over his shoulder, and Wilderness found himself face-to-face with Judy Burne-Jones for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Known her for years,” he said to Burne-Jones’s ascending rump—and to her, “I’ve read all your books. Almost the same as knowing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Really? Which was your favourite?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Vanity Fair")]), _vm._v(". I found I could really identify with the heroine.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . but it’s a novel without a hero. You may not have noticed, but I have better manners than my father. Do invite me in, Sergeant Holderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do come inside, Miss Burne-Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She kissed him on the cheek and ran up the stairs after her father.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§168")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Burne-Jones gave him a year in London. Wilderness did not think of it as a favour. He had enough work to do to prove that was not the case, and much of it was mundane observation work. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("As rationing fizzled away to nothing and Britain began to recognise that it wasn’t really broke after all,"), _c('span'), _vm._v("Wilderness acquired furniture—including a double bed all to himself. It was another symbolic freedom—to stretch out his long legs and feel the bed go on for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones had made him get a phone, indeed had expedited his getting a phone by pulling strings to get around the GPO waiting list. Nor did he have to a endure a party line—“Can’t have every bugger in London listening in, now can we? National security has to mean something.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("About once every six weeks an invitation to eat at Campden Hill Square would arrive. The phone would ring, at home or in the office—­occasionally Burne-Jones would appear in person, with the habitual phrase, “Feel like taking pot luck with me and Madge tonight?"), _c('span', [_vm._v("”")]), _vm._v(" He never got more notice than that. And he never said no. Odds on Judy would be there, and on the nights when Judy cooked, good food replaced Madge’s rather perfunctory pots of luck.")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("Judy was a devotee of the work of Elizabeth David, and smiled like arrayed artillery when her father greeted a "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("navarin printanier")]), _vm._v(" with “Mutton stew again,” or "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("beignets de sardines")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("avec pommes anna")]), _vm._v(" as “Fish and chips.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness ate everything she put in front of him. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He learnt to like olives.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He learnt to like garlic—that it was not something you rubbed around the inside of a salad bowl to impart the ghost of flavour—it was something you mashed with the flat side of the knife and threw in by the handful.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He learnt to like Judy.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was aware of the line. However much Burne-Jones rubbed at it and blurred it, and he had been doing that since 1945, it was still there.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It seemed to him that he could blow everything if he made a play for Judy Jones. So he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He was preparing for a posting to Helsinki . . . (“Finland? Why are we spying on the Finns? What did the fucking Finns ever do to us?” “Think of their next-door neighbours, Joe, think of one of the most heavily defended boundaries in the world.”) when Judy rang him in Hampstead, about a week after the coronation of the new queen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, I finish my BBC traineeship next month.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Congratulations.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, I mean . . . I’ll have a proper job and a proper salary.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I say again congratulations.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Do try and get the point,"), _c('span'), _vm._v("Joe! I mean . . . I don’t have to go on living with Ma and Pa.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Great, but I don’t want your old room back.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No, but I want yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Pa tells me you’re being posted abroad by the not-so-secret service. Joe, rent me your house. I’ll be Madge and Alec’s little girl for ever if I stay with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But that’s what they want you to do. Stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And I can’t rent you the house. If your father has told you anything about what we do, then the uncertainty of it all must be apparent. I don’t know when I’ll be back. I never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then just rent me one room. The box room if you like. The big bedroom can stay as it is, and you can turn up whenever you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He did not return to London for over eight months. One night in the spring of 1954, he paid off a cab at midnight, let himself in to find the house empty, fell into bed, fell asleep and woke around seven to find Judy Jones sleeping next to him—her clothes scattered across his all over the floor, as though they had embraced instead of the flesh within.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He made coffee. Brought the tray back to bed and nudged her into waking. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Have you been sleeping in my bed all the time I’ve been gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. Tit for tat. You slept in mine for however many years.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Are you going to make a habit of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Fraid so. Been a long time coming hasn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Talk about hard to get. You were almost impossible to get. I left books for you, I left billets-doux, I cooked for you, I got you playing blindman’s buff at the old ’uns Christmas party just so I could get you to feel me up . . . short of just taking off all my clothes and making a complete fool of myself I did everything I could to get your attention, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness looked over the top of his coffee cup at the bra that had landed on top of his shirt, at the stockings trailing across the carpet, the suspender belt clinging like cobweb to the doorknob.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But . . . you did take all your clothes off.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I suppose I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then call me Wilderness. Every woman in my life has.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§169")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The next night, still without her clothes, wrapped around him in post-coital sloth, Judy said, “What exactly is it you do for my dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m sure if he wanted you to know he’d tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But, sweetest, it’s you I’m asking. You’re no more an RAF sergeant than my dad’s still a Guards officer . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“’Cept when it comes to pay. Your father’s motto is ‘rank doesn’t matter’ and mine is ‘pay does matter.’ But . . . since you ask. I’m MI6’s resident cat burglar.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She hit him, laughed and hit him with a pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was an old one but a good one. Tell the truth and defy belief.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§170")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("And so, on this day in the early August of 1955 Wilderness was to be found making his way from Notting Hill Gate Underground station to Campden Hill Square to test the line to destruction. It might resist like concrete and tungsten, it might vanish in a puff of smoke, when he asked Lt Colonel Burne-Jones for the hand of his eldest daughter in marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones said, “What kept you?” as soon as Wilderness had asked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Madge said, “I think I’ll leave the two of you to it” and headed for the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness had not thought that it would be otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A quarter of an hour later with a couple of shots of Burne-Jones’s 1939 Laphroaig single malt inside him he went in search of Madge and found her indulging in one of her bad habits—smoking a king-size cigarette and knocking the ash off into the saucer of a half-drunk cup of tea.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well, Madge.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know whether to read respect for tradition or a bit of a mickey-take into your rather old-fashioned way of doing things, but I can guess at Alec’s response. He met you word for word, tit for tat, and asked if you could ‘keep Judy in the manner to which she is accustomed,’ didn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And what did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I told him that what I was paid was known to him to the last farthing, as it was set by him. I’m on a sergeant’s pay, plus some. But I’m unencumbered by debt, everything is paid for, and he knows that because he’s been privy to my house buying since the day I first saw Perrin’s Walk. I was slightly better off when Judy paid me rent, almost needless to say. But what’s mine is hers.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“And what is yours, Joe? Quite the question to be asking a professional thief you will agree. But I don’t think the answer matters all that much. ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, if I were to say to you that you were not what I wanted for my daughter it would be because one never ceases to want, to yearn, to dream on behalf of one’s children. One learns early on that it is impossible not to make plans but also to bend when they don’t work out. Not to bend is to invite frustration. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And if you were to ask me what it was I did want for Judy, I doubt I could answer you. My mother did what her parents asked of her, expected of her. Married well. Married into the aristocracy. Married an absolute shit. And the fact that my father was a shit became a family shibboleth. It was never mentioned. But if I’d brought home a prospective who was an habitual drunk and far too free with his fists, I think Ma would have shot him dead. I was not to do as she had done. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps all I want for my daughter is for her not to marry a shit. I didn’t marry a shit. And I know you’re not a shit. But I also know what you do for England. What you do for England is legitimised by the fact that you do it for England—but tell me, what else do you do that might not be for England?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d expected this, not perhaps expected it to be phrased so well, for the private and public lives to be intertwined so neatly, but sooner or later she would be the one to ask the questions Burne-Jones couldn’t be arsed with.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I haven’t pulled a private job in years. Not since Cambridge in fact, and even then it was matter of vengeance rather than profit. My rather peculiar talents are, for the time being, at the service of Alec and Her Majesty. Many things are tempting. I still size up opportunities, I mentally ‘case the joint’ rather a lot. It’s almost impossible not to walk into a room and look for the safe or tot up the value of the silverware. But that’s just a hobby, keeping my mind sharp. And of course it’s all temptation, but I’m not Oscar Wilde. I can resist temptation.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Madge smiled at this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Can you resist temptation, Joe, can you really? And why do you say ‘for the time being’?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I won’t be doing this for ever. Sooner or later Secret England will be through with me or I with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And then, what will you do then?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know. That’s the risk I take, and the risk Judy shares.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Berlin, Joe. What was Berlin all about?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At last.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh . . . that wasn’t thieving . . . that was . . . that was like watching a horse race and knowing it wouldn’t be interesting without a bet on the side . . . Alec had left me on my own for a year . . . it was simply the only game in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A game that ended with you getting a bullet in your belly.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Don’t worry about that, Madge. No one will ever get the drop on me again. From now on I shoot first and ask questions later.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hmm,” she said. “Is that Roy Rogers or Hopalong Cassidy you’re quoting?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("At that they both burst out laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Madge stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Joe, give your new mother-in-law a hug.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And not once had she asked about his “people.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§171")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("He bought a ring from a Piggy-wig—they took it away and were married next day by the Turkey who lives on the hill. That was the way it seemed to Wilderness—they had set sail for unknown shores, young lovers in a pea-green boat, and landed as Mr. and Mrs. Holderness. It was all dream-like, too dream-like to be quite believable as real.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§172")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("The honeymoon was brief. A single weekend. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("On the morning of Monday September 5, the telephone at the side of the bed, installed at Burne-Jones’s insistence, rang until Judy picked it up and shoved it at Wilderness with a muttered “Pa,” and sank back beneath the sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Get out to Heathrow, you’re booked on the eleven o’clock to Orly.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Karel Szabo got out of prison last week. He got on a ferry to Calais on Saturday. No problem with that. Full remission after all. From there he caught a train to Paris. French lost him at the Gare du Nord. Silly sods at the Deuxième were looking out for a single man—and he’s travelling with a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“All in the file. There’ll be a courier on your doorstep in five minutes. Chop-chop, old man.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness leaned over Judy and dropped the phone back into its cradle. Whispered in what he thought might be her ear, hidden by the sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“I think we might really be married after all. He just called me ‘old man.")]), _c('span', [_vm._v("’")]), _c('span', [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well,” said in an irate if muffled voice. “Perhaps one old man ought to give a bit of a break to another old man and leave him alone on his fucking honeymoon!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“There’s worse. He’s sending me to Paris.”"), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He headed for the bathroom, just as she threw back the sheets and yelled, “Well, fuck you . . . old man!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He read the file in the back of a cab, on the way to Heathrow.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He knew a lot about Szabo. Thanks to Rada. He, and the other creators of “the bomb”—Fermi, Szilard, Oppenheimer, Teller, Borg, et al—had fascinated Rada. They had, she said, made the world anew in unleashing the power to unmake it. Their lives and deeds had formed the bulk of the fattest file she had given him: the one marked “Armageddon.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Marte Mayerling was less known to him. Hardly even a name. Just the hint of a memory and the appeal of coincidence. Her file, like Szabo’s, had several photographs, group and solo. Marte in middle age, a blurry photograph from a shaky surveillance camera told him next to nothing, but Marte in her twenties . . .")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He called Judy from the airport. A security risk he thought, but a small one.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Would you go into my study—”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That pit you laughably call a study.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And dig out one of my old folders. One of those Rada Lyubova gave me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Now. There’s a name we haven’t heard in a while. You used to talk about her so much I almost felt I’d met her. Which file?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Armageddon.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. Might take a couple of minutes. Just hang on?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She took more than five.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Really Wilderness, you must learn to be tidy, just a bit more ordered.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you found it?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. What is it in particular?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A photograph Rada clipped from the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("New York Times")]), _vm._v(". 1937. The Bohr Institute Particle Physics Conference. There should be an identical photograph I added myself. But the text on that will be in Danish.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“OK. Got ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Front row centre. Niels Bohr, seated. Am I right?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That’s what it says on the card, so to speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And Bohr being a bit of a gent, he has the only two women in the photo seated either side of him?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yep. Old-fashioned manners. The blokes stand and the ladies get to sit. And no one gets to put their foot on the tiger’s head.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On his right . . . a woman of about sixty. Lise Meitner?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nothing wrong with your memory so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And the woman on his left? Much younger, about twenty-five or so? Seated in front of a skinny young man called Peter-Jürgen von Hesse. What’s her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A long pause he found all but intolerable. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“It’s really rather worn. Folded, faded . . . you know . . . but it looks like Mayerling. Let me check on the Danish one. Yes. Marte Mayerling. Name rings a bell. Does it do that for you too?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Oh yes, the whole Nine Tailors clanging in my ears.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Jolly good. Now, how am I?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just ask me, Wilderness. Go on, try!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But I saw you not three hours ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("She put the phone down on him.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§173")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("It meant nothing. It was coincidence. He was flattered that his memory had been good enough to spot her, annoyed that he had never quite bothered to learn her name.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Nothing in her file told him why she had set off for who-knows-where with Szabo. Like him she was a naturalised British citizen and Wilderness could not see the necessity to flee or the profit in it.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Burne-Jones had said, “It’s just a tail. Follow. Observe. Make no approach. You’re not out to arrest them. We have no power to arrest. For all we know they’re off to Monte Carlo for the roulette or Klosters for the skiing. Just stop the French from making more of a hash of it than they usually do. Oh, and take your gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He’d packed his .25 Baby Browning—a gun Burne-Jones told him wouldn’t stop a dopey rabbit—successor to his Sauer 38H. The Browning tucked neatly beneath his jacket, more so than the Sauer. A generous cut by his tailor and you’d never know he was wearing a shoulder holster with the Browning in it. And then . . . he’d never had to fire it. He kept in practice—service regulations demanded that—but he’d never had to shoot a dopey rabbit or anything more vicious than a cardboard target.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The flic who met him at Orly in an old black Citroën had good news.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’re in a small hotel in the Marais. Rue du Temple. Third arrondissement. Mr. and Mrs. Schmidt, would you believe?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("What was it Groucho Marx had said? Smythe is just Smith with a Y and fooled nobody? Surely the same applied to Schmidt? But if they had seen fit to bluff their names, then it was indicative—they were running away, not sauntering on. And if they had fake passports . . . then someone was assisting.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He spent a dull Monday afternoon watching Szabo and Mayerling play at being tourists. Sat outside Le Mistral bookshop for an hour while they browsed. Made himself inconspicuous behind a copy of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Paris Match")]), _vm._v(", half a dozen tables away in a barn-sized restaurant in Montparnasse.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("By the time he had gumshoed them back to their hotel, the flic was waiting for him in the black Citroën. He’d been inside and questioned the proprietor.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“They’re only collecting bags. They’re booked on this evening’s Orient Express to Venice. They’ll probably just get a cab to the Gare de Lyon.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What time?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Leaves at ten thirty. They’re in compartment twelve, coach four.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ll get a cab there now. You follow them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Way ahead of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He handed Wilderness an envelope with a Wagon-Lits reservation in his name. Held up a receipt for him to sign.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Who do I bill?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t care,” Wilderness replied. “So long as it’s not me.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I need a name for the chit.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Winston Churchill.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . that will annoy everyone very nicely. Sign here, Winston.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Were you followed today?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No. And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Not that I could tell. But if they are travelling as Smith or Smythe, or whoever next, sooner or later someone, the someone who provided the passports and made the bookings, is bound to show up. Watching his investment after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Perhaps he will put in an appearance in Venice?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Perhaps. But I doubt very much whether Venice is their final destination.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Observation work had always bored Wilderness. So often it led nowhere. Too often it meant a dusty, disused flat, a tape recorder and a pair of binoculars. First-class sleeper on the Orient Express was at least a step up. Just a touch of Graham Greene or Agatha Christie . . . “and ze murderer is . . . all of you!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Long before they reached Milan he was bored stiff.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Szabo and Mayerling were all but unfathomable. As fleeing spies they seemed not to know how to play the game. They had neither caution nor suspicion. Noddy and Big Ears could have trailed Szabo and Mayerling. As runaway lovers they seemed not to know the game was even afoot—they neither canoodled nor did they smooch. Not so much as a stolen kiss or a peck on the cheek. Paris was made for lovers, arguably so was the Orient Express. Instead they talked intensely in German, and they talked shop—physics, physics, mathematics, mathematics, physics. He longed for Charles Boyer or Margaret Lockwood to enter stage left and put a cat among the pigeons, strike love to spark among the particles.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In Venice they boarded a vaporetto, heading clockwise along the top curve of the Grand Canal’s lazy S. It was slow enough for him to follow on foot, but the Grand Canal was hardly the Seine with a walkable bank—yet the vaporetto was big enough for him to board the same vessel and lose himself at the back.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The boat stopped within sight of the Accademia Bridge and suddenly he knew where they were heading, it made sense and nonsense. He’d heard that the old Russian embassy had been turned into a hotel—he’d not set eyes on it since his one visit towards the end of 1949. Another fleeting, inconsequential Burne-Jones mission. But as the vaporetto glided past he knew the building at once. A beautiful piece of faded glory. Too nice to be an embassy, and far too nice to be a Russian embassy. An iron-fenced canal frontage and a leafy courtyard of climbing vines that simply cried out for little round café tables and a beaker full of the warm south. Someone in the KGB had a sense of humour.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("To follow them into the hotel would be a gamble. He found a café and thought through his options over a couple of shots of espresso—would there be anyone watching at this stage, what chance that whoever it was would spot him for what he was, and who should he be? He riffled through his collection of passports. Concluded his best fake was to be a colonial. No hammy accent, just a bit of plum in his voice and a South African passport. He phoned the hotel and booked a room. Assuming they were still playing the tourist, he’d give them an hour or so to clean up and get out into the warmth of a Venetian summer evening.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The signature above his in the book as he signed in read “Prof. Heinrich Behrmann & wife,” and gave Dresden as a home address. He handed over his South African passport. As the desk clerk looked through it, Wilderness scanned the pigeonholes looking for the blue cover and yellowy-gold lettering of a DDR passport, paler than a British one, as flimsy-looking as an American. There it was. Room number 4. The paper trail had been set up rather well. A new identity with every change of hotel, and the latest told him where they were going next. He’d no idea why such a roundabout route had been chosen, when there were trains that went direct—perhaps for no better reason than pleasure, after all Szabo had spent seven years in prison—but without doubt, tomorrow or the day after Professor and Mrs. Behrmann would be on a train for Vienna, via Villach and Graz, and he’d put his money on them crossing the Iron Curtain at Bratislava. Bratislava was spook paradise. Austria and Czechoslovakia met there, a bridge across the Danube—Hungary was a short drive away—it was a jumping-off point for the Soviet bloc. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A quick search of their room confirmed most of this—two tickets for Vienna the day after tomorrow and a reservation at the Imperial. Time to fade into the background. He’d leave a day ahead, follow from the front, call Burne-Jones from the embassy in Vienna and be at the Imperial by the time they arrived. Anyone looking out for him in Vienna, and he was fairly certain that that was where their man would show up, would not be expecting him to arrive first. He’d spend just the one night in Venice and keep as far away from them as possible. A night off in Venice would scarcely be a hardship. All he had to do was lose Szabo and Mayerling for a few hours.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He crossed over to Cannaregio, to the old Jewish ghetto. It was the last place anyone seeking the sights would ever go. It no more got tourists than the Mile End Road, and with any luck the food would be much the same. Kosher food wasn’t a mystery—he’d eaten at Blooms in the East End of London countless times. You could keep your champagne and caviar, he was happy with chopped liver and matzoh ball soup. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Over the menu pasted to the window of a small restaurant, past the knishes and the pastrami, he caught sight of them, seated at a table along the back wall. All he had to do was lose them for a night.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wrong, wrong, wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He lingered a fraction too long, long enough to be intrigued by the fact that Mayerling’s habitually sour puss was approaching something that resembled a smile. For a moment they were looking straight at one another. Then her head turned away, one hand reached out and covered Szabo’s, and he realised that he might have misread them all along, might have mistaken the nature of their tangible intensity, that logic, argument, and discourse whilst lost on him might in themselves be expressive of feeling—the romance of formulae—and that rather than defecting they might simply be eloping.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He walked back in the direction of Dorsoduro and settled for "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("menu turistico")]), _vm._v("—rubbery pasta and half a bottle of overpriced Chianti.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§174")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_c('span', [_vm._v("Vienna, like the rest of Austria, had about a month to go before its independence was finally re-established. After the Anschluss, conquest, occupation . . . reparation . . . aid . . . treaties . . . any day now, the zones—American, British, French, and Russian—which had lasted more than ten years would be abolished, the forces of occupation, down to less than a hundred thousand, would withdraw and Austria would become the odd man of Europe . . . neutral by common consent, outside any sphere of influence . . . the ambivalence of aggressor/victim finally shuffled off into history.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Gus Fforde was a rogue. Wilderness spotted him as a rogue at first sight. Gus Fforde was also First Secretary at the embassy in Vienna. His office was chaos, a warren of packing cases and cardboard boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Please excuse the mess. I only got here a few days ago myself. We’re going legit,” he said. “No more delegations or military commissions . . . a full-blown embassy . . . diplomatic bags, cocked hats and sashes . . . the whole caboodle. It’ll just take a little time.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Wilderness produced his warrant, said he needed to see the duty Intelligence Officer.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Well,” said Fforde. “Until one actually gets here I rather think that might be me. What can I do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“A secure line to London, perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Ah . . . you may find us not exactly up to scratch on the cloak-and-dagger stuff yet. I can get you on the scrambler but it would be as well if anyone you refer to is called Smith . . . in fact . . . if you could talk in riddles . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness was put through to Burne-Jones in his office.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Vienna? Via Venice?” Burne-Jones sounded mildly incredulous.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Just what I was thinking,” Wilderness said. “They might just be two lovers running away. But for one thing . . . someone’s laid out a good paper trail for them, and someone’s paying for all this.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“What do you propose?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“That I stick with them until I know who. If I’m right they’ll get on a train across to Bratislava in a day or two. And their banker will make contact before they do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I agree. But that’s where it ends. If they get on a train to Bratislava don’t follow. Only if they don’t get on a train or they get a train to somewhere else do you follow. And if their man surfaces, you make no contact with him. Understand me, Joe. No contact.”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§175")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("Fforde said, “Let me buy you dinner. You may be wholly unexpected, but you are my first diplomatic guest. Besides, it’s all the same bloody pot isn’t it? I put in a chit or you put in a chit. Six of one half a dozen of the other.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They went to Café Landtmann. A traditional Viennese dinner of boiled beef, over which Wilderness filled him in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Of course I remember Szabo. Who could ever forget him? Did us no end of harm with the Americans. I thought they’d never shut up about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yet,” said Wilderness. “Wherever he goes no one seems to recognise him.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Mind you. Can’t say I remember her at all. What did you say her name was?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Marte Mayerling.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Nope. Not so much as a tinkle in the old brain box. Now, what exactly are we supposed to do with this pair?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v(" “Just watch. It’s all I’ve done since they left Paris. They have every right to travel.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“On false passports?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Hardly our problem. We’re watching for the simplest of reasons. Every­thing Szabo knows he told the Russians just after the war. Almost everything Mayerling knows is academic and can probably be accessed in any one of half a dozen journals that have published her work. They can’t teach the Russians anything they don’t already know.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Then why are we even watching?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“The Russians can have them, that’s a given. It’s any third party that bothers London. Burne-Jones has sent me to see who’s paying for the joyride, that’s all he wants to know. If it’s Russia he’ll just say fine . . . and if it’s not . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness shrugged away the end of his sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But who?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Gus, name me a country that doesn’t want the atom bomb.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Iceland, San Marino, Andorra . . . the Vatican.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“No Gus, a real country, not a provincial town masquerading as a country . . . and I think the Vatican probably does want the bomb.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So what are we talking about? The Arab bomb? The Chinese bomb? Or just the highest bidder?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve no idea and I couldn’t give a damn. But the highest bidder? No. Money doesn’t interest this pair. They act on principle.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“So what you’re saying is that your job is to see them safely into the hands of our enemy.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes. That sums it up nicely.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And Fforde said, “Supposing the Russians don’t get that?”")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§176")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("On the way back to the Imperial, Fforde said, “I could get you into the Sacher. They’re just about up and running again. We’ve had it since the end of the war. Of course, the Russians had the Imperial. They’ve not been gone more than a matter of weeks, and it stands to reason they’ll have packed the place with bugs.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_c('span', [_vm._v("“Then I’ll be wary of that. But, no thanks. I need to be where I can see them. This is a snark hunt. It’ll be over in a day or two. I’ll hang up my gun and we’ll prop up a bar together. Meanwhile . . . I might need a camera.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Three mornings, three breakfasts later Szabo and Mayerling checked out of the Imperial. Wilderness anticipated and bagged a cab to the Nord­bahnhof ahead of them. No one, as far as he had seen, had yet made contact, and turning over their room had yielded nothing new—who after all would bother to book for the thirty-minute train ride to the border? It could only go wrong if he had guessed wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He hadn’t. Ten minutes after he had arrived, Szabo and Mayerling got out of a cab at the station to be met by a short, stout, Slavic-looking man. At last. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It seemed to Wilderness that Russia made its KBG-niks on a production line. This bloke was just a younger version of Yuri Myshkin—the same peasant sturdiness, the same look of joy in cunning and mistrust. Smiling as he stripped the rings off your fingers. Another apparatchik thug.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There was a formal handshake—Wilderness didn’t think they’d ever met him before—then they were briskly escorted through the barrier to the 11:40 morning train for Bratislava. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He kept back, and with the little pre-war Leica II he’d borrowed from Fforde got half a dozen clear shots of the man in profile as he put Szabo and Mayerling on the train. As he clicked for the last time, the man turned full-face, and for a second Wilderness thought he had seen him. But he turned back to Szabo. Shook hands a second time. Waited as the train pulled out of the station. A fond uncle packing the kids off home after a month in the country. It was nothing. He’d seen nothing. Wilderness flagged a cab and went back to the embassy. If Burne-Jones’s team back in London couldn’t find a match in their records, so what? He’d no doubts. The bloke was KGB. Written all over him. He should know. He’d never forget that pudgy little face, with its almond eyes and ruptured blood vessels, looming over him—the impish grin, the bitter taste of morphine.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The job was over. All that knowledge, all that destructive, subatomic power safely delivered into the hands of an enemy who had no further use for it. Priceless and worthless. ")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§177")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Fforde gave every impression of being bored. A new job, a new country and he seemed to crave company.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness handed over the Leica, said, “Let’s get it developed and the prints off to London in the bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Fforde dropped it into the middle drawer of his desk and said, “I’m famished. Let’s nip out for lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("They had lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After lunch he said, “Do you fancy dinner at Landtmann’s again? Bags of stuff on the menu I haven’t tried yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("He was like a kid in a sweetshop the day toffee came off the ration.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness went back to the hotel. Stripped off his jacket. Caught sight of himself in the wardrobe mirror. Shoulder holsters looked absurd, a cross between a straitjacket and a bra. The job was over. He slung the holster into his suitcase. He couldn’t do that with the gun. It was a Burne-Jones rule. If you’re not carrying it, it’s still your responsibility. You do not lose it, you do not let it get stolen or otherwise mislaid.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("In the bathroom was a mirror-fronted medicine cabinet, set flush with the wall. Neat enough for him not to have realised it was a cabinet until his second night there. Inside were the first-aid basics—aspirin, cotton wool and Elastoplast.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He tore off two long strips of Elastoplast and taped his Baby Browning to the back of the mirror. The maid would not be back until after he checked out in the morning, and if he couldn’t spot that there was a cupboard, why would anyone else? He wiped his own fingerprints off the mirror with bog roll.")]), _vm._v(" "), _c('p', {
    staticClass: "CT-intext-S-25pt"
  }, [_vm._v("§178")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para"
  }, [_vm._v("Over fish soup and grilled venison, Fforde missed England.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“But you’ve only been here a fortnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("“Not the point, old man. It’s a matter of how long I’ve spent in ­England. Welsh Guards during the war. A spell in Washington, two years in Lisbon, a year in Ankara . . . there are times I feel I’ve lost touch with the country I’m supposed to represent.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’ve not been there too much myself the last few years, but I was there most of ’52 to ’53.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Lucky bugger! You were there for the coronation?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yes . . . but if you let me finish. You’ve missed nothing. England’s . . . stuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Stuck?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Moribund.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Yeeees . . . awfully good word, ‘moribund.’ I had rather come to the same conclusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_vm._v("“They’re still fighting a war that ended ten years ago . . . in their minds at least . . . and on the cinema screen . . . and when they win that war, the war inside the head, they expect to find England just as it was in ’39.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', [_vm._v("This set Fforde off. A thesis on an unlamented, lost England. Against all appearances Fforde was a bit of a radical and had used his serviceman’s vote in 1945 to vote Labour, to vote against class and tradition, for the New Britain whose birth seemed to require a gestation longer than an elephant’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness listened. It wasn’t boring. It reminded him of the conversations he had with Burne-Jones, but once he’d shot his bolt with “moribund” it was not an argument to which he felt he could contribute much. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Over the course of the meal, they moved from red wine to white, to Tokay, to brandy. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Outside the embassy, Fforde suggested they breakfasted together. Wilderness wondered if he could cope with the intensity of another Fforde meal and Fforde thesis, but he liked Gus so he said yes and walked on to the Imperial.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I am not drunk, he told himself, with a drunk’s acute sense of euphemism, I am tipsy. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Perhaps it was the booze. Perhaps it was the innate connection between being off duty and off guard. The first blow to the belly doubled him up, and the second to the face sent him to the floor scarcely conscious. He’d just about taken in the fact of the attack when he found himself dragged by his shirt collar to the bathroom. His eyes returned to focussing in time to see the bath full of water before his head was plunged in.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("When he thought he was dying, hands yanked him back up, he sucked in air and as his head went down again a voice uttered one of the few words that was common to most European languages, “Idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("After the third ducking, the hands let him go, and he fell against the side of the bath wheezing.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He looked up. The little Russian was sitting on the painted wicker chair by the bathroom door—a semiautomatic in his right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Идиот")]), _vm._v(",” he said again. “You treat me like an idiot.” ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness got to his feet. Stripped off his sodden jacket. He felt blood on his face and in his mouth. He leaned over the basin, spitting. The gun stayed on him.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“At the Gare du Nord, you are out in the open as though you think you are invisible. On the Orient Express you linger over your meals and gaze out of the window as though you have nothing better to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness stuck two fingers in his mouth and wiggled a loose tooth. Then he cupped water in his palm and rinsed a pink trail into the basin. He looked in the mirror. This bloke wasn’t wearing gloves, and there were no prints on the mirror. He’d been very careful in his search and wiped it down—or he hadn’t looked.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“In Venice you . . . you English have a bird word for it . . . you "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("swan")]), _vm._v(" around like a tourist . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Bamdid,” Wilderness said.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Что")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Band-Aid.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Russian just waved the gun. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness opened the cupboard. His Browning was still taped to the back of the mirror. The Russian could have found it. He could have emptied the magazine. He could have stuck the gun back up. But, then, the point of taping it up had been that any movement of the tape would probably show. It looked to be as he had left it, but there was really only one way to find out. He’d know by the weight as soon as he had it in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He took out the roll of Elastoplast and closed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Russian set down his gun in his lap and lit up a cigarette. Cocky, casual, but he could grab the gun in a split second.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“And in the Nordbahnhof this morning, you practically waved a camera in my face. And still you think I do not notice you. English, you treat me like an idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wilderness tore off a strip, slapped it on the cut on his right cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The discourse rattled on. “Idiot, amateur, dilettante, "), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("бабочка.")]), _vm._v("” Accomplished bore finds captive audience. Indeed, it occurred to Wilderness that the bugger might have gone to the trouble of sandbagging him simply to be able to give him a piece of his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He opened the cupboard door, put the roll of Elastoplast back, pulled the Browning free and aimed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Russian just grinned—cigarette in his left hand, fingertips of his right resting on his gun. He took another long drag on his cigarette, exhaled a plume of utterly contemptuous smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You’re doing it again. Treating me like an idiot. I know you English. You’re all just amateurs. Play the game chaps, play the game. Sticky wicket, googly, a maiden over. You think of Agincourt and cannot begin to imagine Stalingrad. What an absurd nation you English are. I know all about you. Gentlemen and players. Professionalism is vulgar, practice is cheating. Gentlemen and players? Ha! You won’t shoot. Your kind never does.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Wrong, wrong, wrong.")])])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780802193087',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(106)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(108);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 108 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.116cc513364a5620091e.js